/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.3.0.0 (NJsonSchema v10.1.11.0 (Newtonsoft.Json v9.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AdminServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getEnvironment(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Admin/GetEnvironment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnvironment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnvironment(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetEnvironment(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    getConnectionString(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Admin/GetConnectionString";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConnectionString(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConnectionString(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetConnectionString(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    runDbMigrations(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Admin/RunDbMigrations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunDbMigrations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunDbMigrations(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processRunDbMigrations(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    getPolicies(): Observable<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/services/app/Admin/GetPolicies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPolicies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPolicies(<any>response_);
                } catch (e) {
                    return <Observable<{ [key: string]: string; }>><any>_observableThrow(e);
                }
            } else
                return <Observable<{ [key: string]: string; }>><any>_observableThrow(response_);
        }));
    }

    protected processGetPolicies(response: HttpResponseBase): Observable<{ [key: string]: string; }> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<{ [key: string]: string; }>(<any>null);
    }
}

@Injectable()
export class BinCodeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadBins(body: UploadBinDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/BinCode/UploadBins";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadBins(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadBins(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUploadBins(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: BinDto | undefined): Observable<BinDto> {
        let url_ = this.baseUrl + "/api/services/app/BinCode/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<BinDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<BinDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<BinDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BinDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BinDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: BinDto | undefined): Observable<BinDto> {
        let url_ = this.baseUrl + "/api/services/app/BinCode/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<BinDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<BinDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<BinDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BinDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BinDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BinCode/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<BinDto> {
        let url_ = this.baseUrl + "/api/services/app/BinCode/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<BinDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<BinDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BinDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BinDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BinDto>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<BinDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/BinCode/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<BinDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<BinDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BinDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BinDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BinDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class CabifyOrderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendOrders(body: CabifySendOrderRequest | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/CabifyOrder/SendOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendOrders(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processSendOrders(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    event(body: CabifyNotificationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CabifyOrder/Event";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEvent(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processEvent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param baseUrl (optional) 
     * @return Success
     */
    enableWebhook(baseUrl: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CabifyOrder/EnableWebhook?";
        if (baseUrl !== undefined)
            url_ += "baseUrl=" + encodeURIComponent("" + baseUrl) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnableWebhook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnableWebhook(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processEnableWebhook(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    disableWebhook(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CabifyOrder/DisableWebhook";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableWebhook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableWebhook(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDisableWebhook(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getLabelByOrderId(orderId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CabifyOrder/GetLabelByOrderId?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLabelByOrderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLabelByOrderId(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetLabelByOrderId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param parcelId (optional) 
     * @return Success
     */
    getLabelByParcelId(parcelId: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CabifyOrder/GetLabelByParcelId?";
        if (parcelId !== undefined)
            url_ += "parcelId=" + encodeURIComponent("" + parcelId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLabelByParcelId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLabelByParcelId(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetLabelByParcelId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CabifyOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/CabifyOrder/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<CabifyOrderDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CabifyOrderDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CabifyOrderDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CabifyOrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CabifyOrderDto>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CabifyOrderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CabifyOrder/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<CabifyOrderDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CabifyOrderDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CabifyOrderDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CabifyOrderDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CabifyOrderDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class CarrierServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CarrierDto | undefined): Observable<CarrierDto> {
        let url_ = this.baseUrl + "/api/services/app/Carrier/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<CarrierDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CarrierDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CarrierDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarrierDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CarrierDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CarrierDto | undefined): Observable<CarrierDto> {
        let url_ = this.baseUrl + "/api/services/app/Carrier/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<CarrierDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CarrierDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CarrierDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarrierDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CarrierDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Carrier/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CarrierDto> {
        let url_ = this.baseUrl + "/api/services/app/Carrier/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<CarrierDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CarrierDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CarrierDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarrierDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CarrierDto>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param shippingTypeGroupId (optional) 
     * @param storeCode (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filters: string[] | null | undefined, shippingTypeGroupId: number | null | undefined, storeCode: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CarrierDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Carrier/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (shippingTypeGroupId !== undefined)
            url_ += "ShippingTypeGroupId=" + encodeURIComponent("" + shippingTypeGroupId) + "&"; 
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<CarrierDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CarrierDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CarrierDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarrierDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CarrierDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class CarrierDriverServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    enableCarrierDriver(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CarrierDriver/EnableCarrierDriver?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnableCarrierDriver(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnableCarrierDriver(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processEnableCarrierDriver(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    disableCarrierDriver(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CarrierDriver/DisableCarrierDriver?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableCarrierDriver(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableCarrierDriver(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDisableCarrierDriver(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CarrierDriverDto | undefined): Observable<CarrierDriverDto> {
        let url_ = this.baseUrl + "/api/services/app/CarrierDriver/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<CarrierDriverDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CarrierDriverDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CarrierDriverDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarrierDriverDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CarrierDriverDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CarrierDriverDto | undefined): Observable<CarrierDriverDto> {
        let url_ = this.baseUrl + "/api/services/app/CarrierDriver/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<CarrierDriverDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CarrierDriverDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CarrierDriverDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarrierDriverDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CarrierDriverDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CarrierDriver/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CarrierDriverDto> {
        let url_ = this.baseUrl + "/api/services/app/CarrierDriver/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<CarrierDriverDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CarrierDriverDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CarrierDriverDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarrierDriverDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CarrierDriverDto>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CarrierDriverDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CarrierDriver/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<CarrierDriverDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CarrierDriverDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CarrierDriverDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarrierDriverDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CarrierDriverDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class CityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CityDto> {
        let url_ = this.baseUrl + "/api/services/app/City/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<CityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CityDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CityDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CityDto>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CityDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/City/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<CityDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CityDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CityDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CityDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CityDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class ClaimServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    totalReturnOrder(body: ReturnOrderRequest | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Claim/TotalReturnOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTotalReturnOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTotalReturnOrder(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processTotalReturnOrder(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    partialReturnOrder(body: PartialReturnRequest | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Claim/PartialReturnOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartialReturnOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartialReturnOrder(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processPartialReturnOrder(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    totalDeliveryFailOrder(body: TotalDeliveryFailRequest | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Claim/TotalDeliveryFailOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTotalDeliveryFailOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTotalDeliveryFailOrder(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processTotalDeliveryFailOrder(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    partialDeliveryFailOrder(body: PartialDeliveryFailRequest | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Claim/PartialDeliveryFailOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartialDeliveryFailOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartialDeliveryFailOrder(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processPartialDeliveryFailOrder(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    orderNotDelivered(body: OrderNotDeliveredRequest | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Claim/OrderNotDelivered";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrderNotDelivered(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrderNotDelivered(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processOrderNotDelivered(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    orderItemReplacement(body: ItemReplacementRequest | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Claim/OrderItemReplacement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrderItemReplacement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrderItemReplacement(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processOrderItemReplacement(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getCsv(filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Claim/GetCsv?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCsv(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetCsv(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ClaimDto | undefined): Observable<ClaimDto> {
        let url_ = this.baseUrl + "/api/services/app/Claim/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<ClaimDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ClaimDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ClaimDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaimDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClaimDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ClaimDto | undefined): Observable<ClaimDto> {
        let url_ = this.baseUrl + "/api/services/app/Claim/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ClaimDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ClaimDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ClaimDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaimDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClaimDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Claim/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ClaimDto> {
        let url_ = this.baseUrl + "/api/services/app/Claim/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ClaimDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ClaimDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ClaimDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaimDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClaimDto>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ClaimDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Claim/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ClaimDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ClaimDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ClaimDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaimDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClaimDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class ClaimTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAll(): Observable<ClaimTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaimType/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ClaimTypeDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ClaimTypeDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ClaimTypeDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ClaimTypeDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClaimTypeDto[]>(<any>null);
    }
}

@Injectable()
export class CommersiaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param nroFactura (optional) 
     * @param codigoCaja (optional) 
     * @return Success
     */
    getOrder(nroFactura: string | null | undefined, codigoCaja: string | null | undefined): Observable<OrderDto> {
        let url_ = this.baseUrl + "/api/services/app/Commersia/GetOrder?";
        if (nroFactura !== undefined)
            url_ += "nroFactura=" + encodeURIComponent("" + nroFactura) + "&"; 
        if (codigoCaja !== undefined)
            url_ += "codigoCaja=" + encodeURIComponent("" + codigoCaja) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrder(<any>response_);
                } catch (e) {
                    return <Observable<OrderDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrder(response: HttpResponseBase): Observable<OrderDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDto>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @param isVtex (optional) 
     * @return Success
     */
    checkStatus(orderId: string | null | undefined, isVtex: boolean | undefined): Observable<ComerssiaOrderStatus> {
        let url_ = this.baseUrl + "/api/services/app/Commersia/CheckStatus?";
        if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        if (isVtex === null)
            throw new Error("The parameter 'isVtex' cannot be null.");
        else if (isVtex !== undefined)
            url_ += "isVtex=" + encodeURIComponent("" + isVtex) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckStatus(<any>response_);
                } catch (e) {
                    return <Observable<ComerssiaOrderStatus>><any>_observableThrow(e);
                }
            } else
                return <Observable<ComerssiaOrderStatus>><any>_observableThrow(response_);
        }));
    }

    protected processCheckStatus(response: HttpResponseBase): Observable<ComerssiaOrderStatus> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ComerssiaOrderStatus.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ComerssiaOrderStatus>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @param isVtex (optional) 
     * @return Success
     */
    updateOrder(orderId: string | null | undefined, isVtex: boolean | undefined): Observable<ComerssiaOrderStatus> {
        let url_ = this.baseUrl + "/api/services/app/Commersia/UpdateOrder?";
        if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        if (isVtex === null)
            throw new Error("The parameter 'isVtex' cannot be null.");
        else if (isVtex !== undefined)
            url_ += "isVtex=" + encodeURIComponent("" + isVtex) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrder(<any>response_);
                } catch (e) {
                    return <Observable<ComerssiaOrderStatus>><any>_observableThrow(e);
                }
            } else
                return <Observable<ComerssiaOrderStatus>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateOrder(response: HttpResponseBase): Observable<ComerssiaOrderStatus> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ComerssiaOrderStatus.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ComerssiaOrderStatus>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @param storeCode (optional) 
     * @param isVtex (optional) 
     * @return Success
     */
    relocateOrder(orderId: string | null | undefined, storeCode: string | null | undefined, isVtex: boolean | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Commersia/RelocateOrder?";
        if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        if (storeCode !== undefined)
            url_ += "storeCode=" + encodeURIComponent("" + storeCode) + "&"; 
        if (isVtex === null)
            throw new Error("The parameter 'isVtex' cannot be null.");
        else if (isVtex !== undefined)
            url_ += "isVtex=" + encodeURIComponent("" + isVtex) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRelocateOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRelocateOrder(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processRelocateOrder(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @param orderSourceCode (optional) 
     * @param storeCode (optional) 
     * @param sourceCode (optional) 
     * @return Success
     */
    sendTransaction(orderId: number | undefined, orderSourceCode: string | null | undefined, storeCode: string | null | undefined, sourceCode: string | null | undefined): Observable<ComerssiaOrderStatus> {
        let url_ = this.baseUrl + "/api/services/app/Commersia/SendTransaction?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        if (orderSourceCode !== undefined)
            url_ += "orderSourceCode=" + encodeURIComponent("" + orderSourceCode) + "&"; 
        if (storeCode !== undefined)
            url_ += "storeCode=" + encodeURIComponent("" + storeCode) + "&"; 
        if (sourceCode !== undefined)
            url_ += "sourceCode=" + encodeURIComponent("" + sourceCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTransaction(<any>response_);
                } catch (e) {
                    return <Observable<ComerssiaOrderStatus>><any>_observableThrow(e);
                }
            } else
                return <Observable<ComerssiaOrderStatus>><any>_observableThrow(response_);
        }));
    }

    protected processSendTransaction(response: HttpResponseBase): Observable<ComerssiaOrderStatus> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ComerssiaOrderStatus.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ComerssiaOrderStatus>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    isInvoiced(orderId: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Commersia/IsInvoiced?";
        if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsInvoiced(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsInvoiced(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processIsInvoiced(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    allowedToReasignOrders(orderId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Commersia/AllowedToReasignOrders?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAllowedToReasignOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAllowedToReasignOrders(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processAllowedToReasignOrders(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendInvoice(body: InvoiceDto | undefined): Observable<InvoiceResponse> {
        let url_ = this.baseUrl + "/api/services/app/Commersia/SendInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendInvoice(<any>response_);
                } catch (e) {
                    return <Observable<InvoiceResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<InvoiceResponse>><any>_observableThrow(response_);
        }));
    }

    protected processSendInvoice(response: HttpResponseBase): Observable<InvoiceResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceResponse>(<any>null);
    }
}

@Injectable()
export class CustomValueServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param countryCode (optional) 
     * @param filters (optional) 
     * @param reference (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(countryCode: string | null | undefined, filters: string[] | null | undefined, reference: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomValueDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomValue/GetAll?";
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&"; 
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (reference !== undefined)
            url_ += "Reference=" + encodeURIComponent("" + reference) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<CustomValueDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomValueDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CustomValueDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomValueDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomValueDtoPagedResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CustomValueDto | undefined): Observable<CustomValueDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomValue/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<CustomValueDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomValueDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CustomValueDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomValueDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CustomValueDto | undefined): Observable<CustomValueDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomValue/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<CustomValueDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomValueDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CustomValueDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomValueDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CustomValue/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CustomValueDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomValue/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<CustomValueDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomValueDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CustomValueDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomValueDto>(<any>null);
    }
}

@Injectable()
export class DeliveryScheduleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: DeliveryScheduleDto | undefined): Observable<DeliveryScheduleDto> {
        let url_ = this.baseUrl + "/api/services/app/DeliverySchedule/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<DeliveryScheduleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DeliveryScheduleDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DeliveryScheduleDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeliveryScheduleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryScheduleDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<DeliveryScheduleDto> {
        let url_ = this.baseUrl + "/api/services/app/DeliverySchedule/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<DeliveryScheduleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DeliveryScheduleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DeliveryScheduleDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeliveryScheduleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryScheduleDto>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param countryCode (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filters: string[] | null | undefined, countryCode: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<DeliveryScheduleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/DeliverySchedule/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DeliveryScheduleDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DeliveryScheduleDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DeliveryScheduleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeliveryScheduleDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryScheduleDtoPagedResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: DeliveryScheduleDto | undefined): Observable<DeliveryScheduleDto> {
        let url_ = this.baseUrl + "/api/services/app/DeliverySchedule/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<DeliveryScheduleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DeliveryScheduleDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DeliveryScheduleDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeliveryScheduleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryScheduleDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DeliverySchedule/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class DispatchOrderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param storeCode (optional) 
     * @param readyToShip (optional) 
     * @param shippingTypeGroupId (optional) 
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getCountByShippingTypeGroup(storeCode: string | null | undefined, readyToShip: boolean | null | undefined, shippingTypeGroupId: number | null | undefined, filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/DispatchOrder/GetCountByShippingTypeGroup?";
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&"; 
        if (readyToShip !== undefined)
            url_ += "ReadyToShip=" + encodeURIComponent("" + readyToShip) + "&"; 
        if (shippingTypeGroupId !== undefined)
            url_ += "ShippingTypeGroupId=" + encodeURIComponent("" + shippingTypeGroupId) + "&"; 
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountByShippingTypeGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountByShippingTypeGroup(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetCountByShippingTypeGroup(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: OrderDto | undefined): Observable<OrderDto> {
        let url_ = this.baseUrl + "/api/services/app/DispatchOrder/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<OrderDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<OrderDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: OrderDto | undefined): Observable<OrderDto> {
        let url_ = this.baseUrl + "/api/services/app/DispatchOrder/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<OrderDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<OrderDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DispatchOrder/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<OrderDto> {
        let url_ = this.baseUrl + "/api/services/app/DispatchOrder/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<OrderDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OrderDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDto>(<any>null);
    }

    /**
     * @param storeCode (optional) 
     * @param readyToShip (optional) 
     * @param shippingTypeGroupId (optional) 
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(storeCode: string | null | undefined, readyToShip: boolean | null | undefined, shippingTypeGroupId: number | null | undefined, filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/DispatchOrder/GetAll?";
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&"; 
        if (readyToShip !== undefined)
            url_ += "ReadyToShip=" + encodeURIComponent("" + readyToShip) + "&"; 
        if (shippingTypeGroupId !== undefined)
            url_ += "ShippingTypeGroupId=" + encodeURIComponent("" + shippingTypeGroupId) + "&"; 
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<OrderDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<OrderDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class DistrictServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<DistrictDto> {
        let url_ = this.baseUrl + "/api/services/app/District/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<DistrictDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DistrictDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DistrictDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DistrictDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DistrictDto>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<DistrictDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/District/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DistrictDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DistrictDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DistrictDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DistrictDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DistrictDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class DocumentsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param orderId (optional) 
     * @param documentId (optional) 
     * @param draftNumber (optional) 
     * @return Success
     */
    setDraftNumber(orderId: number | undefined, documentId: number | undefined, draftNumber: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Documents/SetDraftNumber?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&"; 
        if (draftNumber !== undefined)
            url_ += "draftNumber=" + encodeURIComponent("" + draftNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDraftNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDraftNumber(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetDraftNumber(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendDraft(body: SendDraftRequest | undefined): Observable<DocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/Documents/SendDraft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendDraft(<any>response_);
                } catch (e) {
                    return <Observable<DocumentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentDto>><any>_observableThrow(response_);
        }));
    }

    protected processSendDraft(response: HttpResponseBase): Observable<DocumentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendDraftsInvoicesToSap(body: SendDraftRequestList | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/Documents/SendDraftsInvoicesToSap";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendDraftsInvoicesToSap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendDraftsInvoicesToSap(<any>response_);
                } catch (e) {
                    return <Observable<number[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<number[]>><any>_observableThrow(response_);
        }));
    }

    protected processSendDraftsInvoicesToSap(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendDraftsInvoicesToSapProcess(body: SendDraftRequestList | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Documents/SendDraftsInvoicesToSapProcess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendDraftsInvoicesToSapProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendDraftsInvoicesToSapProcess(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processSendDraftsInvoicesToSapProcess(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param documentId (optional) 
     * @return Success
     */
    retry(documentId: number | undefined): Observable<DocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/Documents/Retry?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetry(<any>response_);
                } catch (e) {
                    return <Observable<DocumentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentDto>><any>_observableThrow(response_);
        }));
    }

    protected processRetry(response: HttpResponseBase): Observable<DocumentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: DocumentDto | undefined): Observable<DocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/Documents/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<DocumentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DocumentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: DocumentDto | undefined): Observable<DocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/Documents/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<DocumentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DocumentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Documents/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<DocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/Documents/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<DocumentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DocumentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentDto>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<DocumentDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Documents/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DocumentDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DocumentDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class DocumentTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAll(): Observable<DocumentTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DocumentType/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DocumentTypeDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentTypeDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DocumentTypeDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DocumentTypeDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentTypeDto[]>(<any>null);
    }
}

@Injectable()
export class ExampleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param message (optional) 
     * @return Success
     */
    helloWorld(message: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Example/HelloWorld?";
        if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHelloWorld(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHelloWorld(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processHelloWorld(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    creatProcess(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Example/CreatProcess";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatProcess(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreatProcess(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    runProcess(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Example/RunProcess?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunProcess(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRunProcess(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param code (optional) 
     * @param message (optional) 
     * @param body (optional) 
     * @return Success
     */
    sendNotification(code: string | null | undefined, message: string | null | undefined, body: string[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Example/SendNotification?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendNotification(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class FailedDeliveryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getItems(orderId: number | undefined): Observable<FailedDeliveryItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FailedDelivery/GetItems?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetItems(<any>response_);
                } catch (e) {
                    return <Observable<FailedDeliveryItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FailedDeliveryItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetItems(response: HttpResponseBase): Observable<FailedDeliveryItemDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FailedDeliveryItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FailedDeliveryItemDto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<FailedDeliveryDto> {
        let url_ = this.baseUrl + "/api/services/app/FailedDelivery/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<FailedDeliveryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FailedDeliveryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FailedDeliveryDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FailedDeliveryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FailedDeliveryDto>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param orderId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filters: string[] | null | undefined, orderId: number | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FailedDeliveryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/FailedDelivery/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "OrderId=" + encodeURIComponent("" + orderId) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<FailedDeliveryDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FailedDeliveryDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FailedDeliveryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FailedDeliveryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FailedDeliveryDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class FlyerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: FlyerDto | undefined): Observable<FlyerDto> {
        let url_ = this.baseUrl + "/api/services/app/Flyer/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<FlyerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FlyerDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<FlyerDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FlyerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FlyerDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: FlyerDto | undefined): Observable<FlyerDto> {
        let url_ = this.baseUrl + "/api/services/app/Flyer/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<FlyerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FlyerDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FlyerDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FlyerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FlyerDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Flyer/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<FlyerDto> {
        let url_ = this.baseUrl + "/api/services/app/Flyer/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<FlyerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FlyerDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FlyerDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FlyerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FlyerDto>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FlyerDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Flyer/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<FlyerDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FlyerDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FlyerDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FlyerDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FlyerDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class FlyerDistributionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param source (optional) 
     * @param postalCode (optional) 
     * @return Success
     */
    getFlyers(source: SourceValue | undefined, postalCode: number | undefined): Observable<FlyerDistributionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FlyerDistribution/GetFlyers?";
        if (source === null)
            throw new Error("The parameter 'source' cannot be null.");
        else if (source !== undefined)
            url_ += "source=" + encodeURIComponent("" + source) + "&"; 
        if (postalCode === null)
            throw new Error("The parameter 'postalCode' cannot be null.");
        else if (postalCode !== undefined)
            url_ += "postalCode=" + encodeURIComponent("" + postalCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFlyers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFlyers(<any>response_);
                } catch (e) {
                    return <Observable<FlyerDistributionDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FlyerDistributionDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetFlyers(response: HttpResponseBase): Observable<FlyerDistributionDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FlyerDistributionDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FlyerDistributionDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFlyers(body: FlyerUploadDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/FlyerDistribution/UploadFlyers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFlyers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFlyers(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUploadFlyers(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param countryCode (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getCsv(filters: string[] | null | undefined, countryCode: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/FlyerDistribution/GetCsv?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCsv(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetCsv(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: FlyerDistributionDto | undefined): Observable<FlyerDistributionDto> {
        let url_ = this.baseUrl + "/api/services/app/FlyerDistribution/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<FlyerDistributionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FlyerDistributionDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<FlyerDistributionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FlyerDistributionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FlyerDistributionDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: FlyerDistributionDto | undefined): Observable<FlyerDistributionDto> {
        let url_ = this.baseUrl + "/api/services/app/FlyerDistribution/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<FlyerDistributionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FlyerDistributionDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FlyerDistributionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FlyerDistributionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FlyerDistributionDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FlyerDistribution/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<FlyerDistributionDto> {
        let url_ = this.baseUrl + "/api/services/app/FlyerDistribution/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<FlyerDistributionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FlyerDistributionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FlyerDistributionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FlyerDistributionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FlyerDistributionDto>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param countryCode (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filters: string[] | null | undefined, countryCode: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FlyerDistributionDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/FlyerDistribution/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<FlyerDistributionDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FlyerDistributionDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FlyerDistributionDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FlyerDistributionDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FlyerDistributionDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class GeneralAuditServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getGeneralAuditDetail(orderId: number | undefined): Observable<GeneralAuditOrderDetail[]> {
        let url_ = this.baseUrl + "/api/services/app/GeneralAudit/GetGeneralAuditDetail?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneralAuditDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralAuditDetail(<any>response_);
                } catch (e) {
                    return <Observable<GeneralAuditOrderDetail[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GeneralAuditOrderDetail[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetGeneralAuditDetail(response: HttpResponseBase): Observable<GeneralAuditOrderDetail[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GeneralAuditOrderDetail.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralAuditOrderDetail[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<GeneralAuditDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneralAudit/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<GeneralAuditDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GeneralAuditDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GeneralAuditDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralAuditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralAuditDto>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param countryCode (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filters: string[] | null | undefined, countryCode: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<GeneralAuditDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneralAudit/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<GeneralAuditDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GeneralAuditDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<GeneralAuditDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralAuditDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralAuditDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class HubDeliveryMappingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upload(body: UploadHubDeliveryMappingDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/HubDeliveryMapping/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param countryCode (optional) 
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getCsv(countryCode: string | null | undefined, filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/HubDeliveryMapping/GetCsv?";
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&"; 
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCsv(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetCsv(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: HubDeliveryMappingDto | undefined): Observable<HubDeliveryMappingDto> {
        let url_ = this.baseUrl + "/api/services/app/HubDeliveryMapping/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<HubDeliveryMappingDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HubDeliveryMappingDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<HubDeliveryMappingDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HubDeliveryMappingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HubDeliveryMappingDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: HubDeliveryMappingDto | undefined): Observable<HubDeliveryMappingDto> {
        let url_ = this.baseUrl + "/api/services/app/HubDeliveryMapping/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<HubDeliveryMappingDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HubDeliveryMappingDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<HubDeliveryMappingDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HubDeliveryMappingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HubDeliveryMappingDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HubDeliveryMapping/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<HubDeliveryMappingDto> {
        let url_ = this.baseUrl + "/api/services/app/HubDeliveryMapping/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<HubDeliveryMappingDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HubDeliveryMappingDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<HubDeliveryMappingDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HubDeliveryMappingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HubDeliveryMappingDto>(<any>null);
    }

    /**
     * @param countryCode (optional) 
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(countryCode: string | null | undefined, filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<HubDeliveryMappingDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/HubDeliveryMapping/GetAll?";
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&"; 
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<HubDeliveryMappingDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HubDeliveryMappingDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<HubDeliveryMappingDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HubDeliveryMappingDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HubDeliveryMappingDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class ICGServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param invoiceNumber (optional) 
     * @return Success
     */
    getOrder(invoiceNumber: string | null | undefined): Observable<OrderDto> {
        let url_ = this.baseUrl + "/api/services/app/ICG/GetOrder?";
        if (invoiceNumber !== undefined)
            url_ += "invoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrder(<any>response_);
                } catch (e) {
                    return <Observable<OrderDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrder(response: HttpResponseBase): Observable<OrderDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDto>(<any>null);
    }
}

@Injectable()
export class LandingInfoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param countryCode (optional) 
     * @return Success
     */
    getByCountryCode(countryCode: string | null | undefined): Observable<LandingInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LandingInfo/GetByCountryCode?";
        if (countryCode !== undefined)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCountryCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCountryCode(<any>response_);
                } catch (e) {
                    return <Observable<LandingInfoDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LandingInfoDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetByCountryCode(response: HttpResponseBase): Observable<LandingInfoDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LandingInfoDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LandingInfoDto[]>(<any>null);
    }
}

@Injectable()
export class MeliServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getResourceAr(input: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Meli/GetResourceAr?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetResourceAr(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResourceAr(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetResourceAr(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getResourceCo(input: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Meli/GetResourceCo?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetResourceCo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResourceCo(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetResourceCo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param shipmentIds (optional) 
     * @param orderId (optional) 
     * @return Success
     */
    getShipmenLabelsZebra(shipmentIds: string[] | null | undefined, orderId: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Meli/GetShipmenLabelsZebra?";
        if (shipmentIds !== undefined)
            shipmentIds && shipmentIds.forEach(item => { url_ += "shipmentIds=" + encodeURIComponent("" + item) + "&"; });
        if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShipmenLabelsZebra(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShipmenLabelsZebra(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processGetShipmenLabelsZebra(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param shipmentIds (optional) 
     * @param orderIds (optional) 
     * @return Success
     */
    getShipmenLabelsZebraMulti(shipmentIds: string[] | null | undefined, orderIds: string[] | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Meli/GetShipmenLabelsZebraMulti?";
        if (shipmentIds !== undefined)
            shipmentIds && shipmentIds.forEach(item => { url_ += "shipmentIds=" + encodeURIComponent("" + item) + "&"; });
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(item => { url_ += "orderIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShipmenLabelsZebraMulti(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShipmenLabelsZebraMulti(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processGetShipmenLabelsZebraMulti(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param shipmentIds (optional) 
     * @return Success
     */
    getShipmentLabels(shipmentIds: string[] | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Meli/GetShipmentLabels?";
        if (shipmentIds !== undefined)
            shipmentIds && shipmentIds.forEach(item => { url_ += "shipmentIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShipmentLabels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShipmentLabels(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetShipmentLabels(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    uploadInvoice(orderId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Meli/UploadInvoice?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadInvoice(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUploadInvoice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class MeliNotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: AddMeliNotification | undefined): Observable<AddMeliNotificationResponse> {
        let url_ = this.baseUrl + "/api/services/app/MeliNotification/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<AddMeliNotificationResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddMeliNotificationResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AddMeliNotificationResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddMeliNotificationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddMeliNotificationResponse>(<any>null);
    }
}

@Injectable()
export class OrderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param selectedColumns (optional) 
     * @param storeCode (optional) 
     * @param countryCode (optional) 
     * @param readyToShip (optional) 
     * @param readyToHandle (optional) 
     * @param orderIds (optional) 
     * @param includeSupplyingOrders (optional) 
     * @param excludeGiftCardsOrders (optional) 
     * @param filters (optional) 
     * @param search (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(selectedColumns: string[] | null | undefined, storeCode: string | null | undefined, countryCode: string | null | undefined, readyToShip: boolean | null | undefined, readyToHandle: boolean | null | undefined, orderIds: number[] | null | undefined, includeSupplyingOrders: boolean | undefined, excludeGiftCardsOrders: boolean | undefined, filters: string[] | null | undefined, search: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetAll?";
        if (selectedColumns !== undefined)
            selectedColumns && selectedColumns.forEach(item => { url_ += "SelectedColumns=" + encodeURIComponent("" + item) + "&"; });
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&"; 
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&"; 
        if (readyToShip !== undefined)
            url_ += "ReadyToShip=" + encodeURIComponent("" + readyToShip) + "&"; 
        if (readyToHandle !== undefined)
            url_ += "ReadyToHandle=" + encodeURIComponent("" + readyToHandle) + "&"; 
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(item => { url_ += "OrderIds=" + encodeURIComponent("" + item) + "&"; });
        if (includeSupplyingOrders === null)
            throw new Error("The parameter 'includeSupplyingOrders' cannot be null.");
        else if (includeSupplyingOrders !== undefined)
            url_ += "IncludeSupplyingOrders=" + encodeURIComponent("" + includeSupplyingOrders) + "&"; 
        if (excludeGiftCardsOrders === null)
            throw new Error("The parameter 'excludeGiftCardsOrders' cannot be null.");
        else if (excludeGiftCardsOrders !== undefined)
            url_ += "ExcludeGiftCardsOrders=" + encodeURIComponent("" + excludeGiftCardsOrders) + "&"; 
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<OrderDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<OrderDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDtoPagedResultDto>(<any>null);
    }

    /**
     * @param customerDocumentNumber (optional) 
     * @param customerEmail (optional) 
     * @param fromDate (optional) 
     * @return Success
     */
    getAllWithItems(customerDocumentNumber: string | null | undefined, customerEmail: string | null | undefined, fromDate: moment.Moment | null | undefined): Observable<OrderDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetAllWithItems?";
        if (customerDocumentNumber !== undefined)
            url_ += "CustomerDocumentNumber=" + encodeURIComponent("" + customerDocumentNumber) + "&"; 
        if (customerEmail !== undefined)
            url_ += "CustomerEmail=" + encodeURIComponent("" + customerEmail) + "&"; 
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWithItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWithItems(<any>response_);
                } catch (e) {
                    return <Observable<OrderDtoListResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderDtoListResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllWithItems(response: HttpResponseBase): Observable<OrderDtoListResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDtoListResultDto>(<any>null);
    }

    /**
     * @param selectedColumns (optional) 
     * @param storeCode (optional) 
     * @param countryCode (optional) 
     * @param readyToShip (optional) 
     * @param readyToHandle (optional) 
     * @param orderIds (optional) 
     * @param includeSupplyingOrders (optional) 
     * @param excludeGiftCardsOrders (optional) 
     * @param filters (optional) 
     * @param search (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllByColumns(selectedColumns: string[] | null | undefined, storeCode: string | null | undefined, countryCode: string | null | undefined, readyToShip: boolean | null | undefined, readyToHandle: boolean | null | undefined, orderIds: number[] | null | undefined, includeSupplyingOrders: boolean | undefined, excludeGiftCardsOrders: boolean | undefined, filters: string[] | null | undefined, search: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetAllByColumns?";
        if (selectedColumns !== undefined)
            selectedColumns && selectedColumns.forEach(item => { url_ += "SelectedColumns=" + encodeURIComponent("" + item) + "&"; });
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&"; 
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&"; 
        if (readyToShip !== undefined)
            url_ += "ReadyToShip=" + encodeURIComponent("" + readyToShip) + "&"; 
        if (readyToHandle !== undefined)
            url_ += "ReadyToHandle=" + encodeURIComponent("" + readyToHandle) + "&"; 
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(item => { url_ += "OrderIds=" + encodeURIComponent("" + item) + "&"; });
        if (includeSupplyingOrders === null)
            throw new Error("The parameter 'includeSupplyingOrders' cannot be null.");
        else if (includeSupplyingOrders !== undefined)
            url_ += "IncludeSupplyingOrders=" + encodeURIComponent("" + includeSupplyingOrders) + "&"; 
        if (excludeGiftCardsOrders === null)
            throw new Error("The parameter 'excludeGiftCardsOrders' cannot be null.");
        else if (excludeGiftCardsOrders !== undefined)
            url_ += "ExcludeGiftCardsOrders=" + encodeURIComponent("" + excludeGiftCardsOrders) + "&"; 
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByColumns(<any>response_);
                } catch (e) {
                    return <Observable<OrderDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllByColumns(response: HttpResponseBase): Observable<OrderDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDtoPagedResultDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getShippedOrder(id: number | undefined): Observable<OrderDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetShippedOrder?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShippedOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShippedOrder(<any>response_);
                } catch (e) {
                    return <Observable<OrderDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetShippedOrder(response: HttpResponseBase): Observable<OrderDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getNotDeliveredOrders(id: number | undefined): Observable<OrderDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetNotDeliveredOrders?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotDeliveredOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotDeliveredOrders(<any>response_);
                } catch (e) {
                    return <Observable<OrderDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetNotDeliveredOrders(response: HttpResponseBase): Observable<OrderDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: OrderDto | undefined): Observable<OrderDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<OrderDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<OrderDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    dispatchOrder(body: DispatchOrderRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/DispatchOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDispatchOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDispatchOrder(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDispatchOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param selectedColumns (optional) 
     * @param storeCode (optional) 
     * @param countryCode (optional) 
     * @param readyToShip (optional) 
     * @param readyToHandle (optional) 
     * @param orderIds (optional) 
     * @param includeSupplyingOrders (optional) 
     * @param excludeGiftCardsOrders (optional) 
     * @param filters (optional) 
     * @param search (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getCsv(selectedColumns: string[] | null | undefined, storeCode: string | null | undefined, countryCode: string | null | undefined, readyToShip: boolean | null | undefined, readyToHandle: boolean | null | undefined, orderIds: number[] | null | undefined, includeSupplyingOrders: boolean | undefined, excludeGiftCardsOrders: boolean | undefined, filters: string[] | null | undefined, search: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetCsv?";
        if (selectedColumns !== undefined)
            selectedColumns && selectedColumns.forEach(item => { url_ += "SelectedColumns=" + encodeURIComponent("" + item) + "&"; });
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&"; 
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&"; 
        if (readyToShip !== undefined)
            url_ += "ReadyToShip=" + encodeURIComponent("" + readyToShip) + "&"; 
        if (readyToHandle !== undefined)
            url_ += "ReadyToHandle=" + encodeURIComponent("" + readyToHandle) + "&"; 
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(item => { url_ += "OrderIds=" + encodeURIComponent("" + item) + "&"; });
        if (includeSupplyingOrders === null)
            throw new Error("The parameter 'includeSupplyingOrders' cannot be null.");
        else if (includeSupplyingOrders !== undefined)
            url_ += "IncludeSupplyingOrders=" + encodeURIComponent("" + includeSupplyingOrders) + "&"; 
        if (excludeGiftCardsOrders === null)
            throw new Error("The parameter 'excludeGiftCardsOrders' cannot be null.");
        else if (excludeGiftCardsOrders !== undefined)
            url_ += "ExcludeGiftCardsOrders=" + encodeURIComponent("" + excludeGiftCardsOrders) + "&"; 
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCsv(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetCsv(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param selectedColumns (optional) 
     * @param storeCode (optional) 
     * @param countryCode (optional) 
     * @param readyToShip (optional) 
     * @param readyToHandle (optional) 
     * @param orderIds (optional) 
     * @param includeSupplyingOrders (optional) 
     * @param excludeGiftCardsOrders (optional) 
     * @param filters (optional) 
     * @param search (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllDashboard(selectedColumns: string[] | null | undefined, storeCode: string | null | undefined, countryCode: string | null | undefined, readyToShip: boolean | null | undefined, readyToHandle: boolean | null | undefined, orderIds: number[] | null | undefined, includeSupplyingOrders: boolean | undefined, excludeGiftCardsOrders: boolean | undefined, filters: string[] | null | undefined, search: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderCsvDashboardDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetAllDashboard?";
        if (selectedColumns !== undefined)
            selectedColumns && selectedColumns.forEach(item => { url_ += "SelectedColumns=" + encodeURIComponent("" + item) + "&"; });
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&"; 
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&"; 
        if (readyToShip !== undefined)
            url_ += "ReadyToShip=" + encodeURIComponent("" + readyToShip) + "&"; 
        if (readyToHandle !== undefined)
            url_ += "ReadyToHandle=" + encodeURIComponent("" + readyToHandle) + "&"; 
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(item => { url_ += "OrderIds=" + encodeURIComponent("" + item) + "&"; });
        if (includeSupplyingOrders === null)
            throw new Error("The parameter 'includeSupplyingOrders' cannot be null.");
        else if (includeSupplyingOrders !== undefined)
            url_ += "IncludeSupplyingOrders=" + encodeURIComponent("" + includeSupplyingOrders) + "&"; 
        if (excludeGiftCardsOrders === null)
            throw new Error("The parameter 'excludeGiftCardsOrders' cannot be null.");
        else if (excludeGiftCardsOrders !== undefined)
            url_ += "ExcludeGiftCardsOrders=" + encodeURIComponent("" + excludeGiftCardsOrders) + "&"; 
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDashboard(<any>response_);
                } catch (e) {
                    return <Observable<OrderCsvDashboardDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderCsvDashboardDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllDashboard(response: HttpResponseBase): Observable<OrderCsvDashboardDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderCsvDashboardDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderCsvDashboardDto[]>(<any>null);
    }

    /**
     * @param selectedColumns (optional) 
     * @param storeCode (optional) 
     * @param countryCode (optional) 
     * @param readyToShip (optional) 
     * @param readyToHandle (optional) 
     * @param orderIds (optional) 
     * @param includeSupplyingOrders (optional) 
     * @param excludeGiftCardsOrders (optional) 
     * @param filters (optional) 
     * @param search (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getCsvOL(selectedColumns: string[] | null | undefined, storeCode: string | null | undefined, countryCode: string | null | undefined, readyToShip: boolean | null | undefined, readyToHandle: boolean | null | undefined, orderIds: number[] | null | undefined, includeSupplyingOrders: boolean | undefined, excludeGiftCardsOrders: boolean | undefined, filters: string[] | null | undefined, search: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetCsvOL?";
        if (selectedColumns !== undefined)
            selectedColumns && selectedColumns.forEach(item => { url_ += "SelectedColumns=" + encodeURIComponent("" + item) + "&"; });
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&"; 
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&"; 
        if (readyToShip !== undefined)
            url_ += "ReadyToShip=" + encodeURIComponent("" + readyToShip) + "&"; 
        if (readyToHandle !== undefined)
            url_ += "ReadyToHandle=" + encodeURIComponent("" + readyToHandle) + "&"; 
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(item => { url_ += "OrderIds=" + encodeURIComponent("" + item) + "&"; });
        if (includeSupplyingOrders === null)
            throw new Error("The parameter 'includeSupplyingOrders' cannot be null.");
        else if (includeSupplyingOrders !== undefined)
            url_ += "IncludeSupplyingOrders=" + encodeURIComponent("" + includeSupplyingOrders) + "&"; 
        if (excludeGiftCardsOrders === null)
            throw new Error("The parameter 'excludeGiftCardsOrders' cannot be null.");
        else if (excludeGiftCardsOrders !== undefined)
            url_ += "ExcludeGiftCardsOrders=" + encodeURIComponent("" + excludeGiftCardsOrders) + "&"; 
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCsvOL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCsvOL(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetCsvOL(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param selectedColumns (optional) 
     * @param storeCode (optional) 
     * @param countryCode (optional) 
     * @param readyToShip (optional) 
     * @param readyToHandle (optional) 
     * @param orderIds (optional) 
     * @param includeSupplyingOrders (optional) 
     * @param excludeGiftCardsOrders (optional) 
     * @param filters (optional) 
     * @param search (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getCsvQuadmin(selectedColumns: string[] | null | undefined, storeCode: string | null | undefined, countryCode: string | null | undefined, readyToShip: boolean | null | undefined, readyToHandle: boolean | null | undefined, orderIds: number[] | null | undefined, includeSupplyingOrders: boolean | undefined, excludeGiftCardsOrders: boolean | undefined, filters: string[] | null | undefined, search: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetCsvQuadmin?";
        if (selectedColumns !== undefined)
            selectedColumns && selectedColumns.forEach(item => { url_ += "SelectedColumns=" + encodeURIComponent("" + item) + "&"; });
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&"; 
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&"; 
        if (readyToShip !== undefined)
            url_ += "ReadyToShip=" + encodeURIComponent("" + readyToShip) + "&"; 
        if (readyToHandle !== undefined)
            url_ += "ReadyToHandle=" + encodeURIComponent("" + readyToHandle) + "&"; 
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(item => { url_ += "OrderIds=" + encodeURIComponent("" + item) + "&"; });
        if (includeSupplyingOrders === null)
            throw new Error("The parameter 'includeSupplyingOrders' cannot be null.");
        else if (includeSupplyingOrders !== undefined)
            url_ += "IncludeSupplyingOrders=" + encodeURIComponent("" + includeSupplyingOrders) + "&"; 
        if (excludeGiftCardsOrders === null)
            throw new Error("The parameter 'excludeGiftCardsOrders' cannot be null.");
        else if (excludeGiftCardsOrders !== undefined)
            url_ += "ExcludeGiftCardsOrders=" + encodeURIComponent("" + excludeGiftCardsOrders) + "&"; 
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCsvQuadmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCsvQuadmin(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetCsvQuadmin(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param selectedColumns (optional) 
     * @param storeCode (optional) 
     * @param countryCode (optional) 
     * @param readyToShip (optional) 
     * @param readyToHandle (optional) 
     * @param orderIds (optional) 
     * @param includeSupplyingOrders (optional) 
     * @param excludeGiftCardsOrders (optional) 
     * @param filters (optional) 
     * @param search (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllOL(selectedColumns: string[] | null | undefined, storeCode: string | null | undefined, countryCode: string | null | undefined, readyToShip: boolean | null | undefined, readyToHandle: boolean | null | undefined, orderIds: number[] | null | undefined, includeSupplyingOrders: boolean | undefined, excludeGiftCardsOrders: boolean | undefined, filters: string[] | null | undefined, search: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderCsvOLDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetAllOL?";
        if (selectedColumns !== undefined)
            selectedColumns && selectedColumns.forEach(item => { url_ += "SelectedColumns=" + encodeURIComponent("" + item) + "&"; });
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&"; 
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&"; 
        if (readyToShip !== undefined)
            url_ += "ReadyToShip=" + encodeURIComponent("" + readyToShip) + "&"; 
        if (readyToHandle !== undefined)
            url_ += "ReadyToHandle=" + encodeURIComponent("" + readyToHandle) + "&"; 
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(item => { url_ += "OrderIds=" + encodeURIComponent("" + item) + "&"; });
        if (includeSupplyingOrders === null)
            throw new Error("The parameter 'includeSupplyingOrders' cannot be null.");
        else if (includeSupplyingOrders !== undefined)
            url_ += "IncludeSupplyingOrders=" + encodeURIComponent("" + includeSupplyingOrders) + "&"; 
        if (excludeGiftCardsOrders === null)
            throw new Error("The parameter 'excludeGiftCardsOrders' cannot be null.");
        else if (excludeGiftCardsOrders !== undefined)
            url_ += "ExcludeGiftCardsOrders=" + encodeURIComponent("" + excludeGiftCardsOrders) + "&"; 
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOL(<any>response_);
                } catch (e) {
                    return <Observable<OrderCsvOLDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderCsvOLDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllOL(response: HttpResponseBase): Observable<OrderCsvOLDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderCsvOLDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderCsvOLDto[]>(<any>null);
    }

    /**
     * @param selectedColumns (optional) 
     * @param storeCode (optional) 
     * @param countryCode (optional) 
     * @param readyToShip (optional) 
     * @param readyToHandle (optional) 
     * @param orderIds (optional) 
     * @param includeSupplyingOrders (optional) 
     * @param excludeGiftCardsOrders (optional) 
     * @param filters (optional) 
     * @param search (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllQuadmin(selectedColumns: string[] | null | undefined, storeCode: string | null | undefined, countryCode: string | null | undefined, readyToShip: boolean | null | undefined, readyToHandle: boolean | null | undefined, orderIds: number[] | null | undefined, includeSupplyingOrders: boolean | undefined, excludeGiftCardsOrders: boolean | undefined, filters: string[] | null | undefined, search: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderCsvQuadminDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetAllQuadmin?";
        if (selectedColumns !== undefined)
            selectedColumns && selectedColumns.forEach(item => { url_ += "SelectedColumns=" + encodeURIComponent("" + item) + "&"; });
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&"; 
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&"; 
        if (readyToShip !== undefined)
            url_ += "ReadyToShip=" + encodeURIComponent("" + readyToShip) + "&"; 
        if (readyToHandle !== undefined)
            url_ += "ReadyToHandle=" + encodeURIComponent("" + readyToHandle) + "&"; 
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(item => { url_ += "OrderIds=" + encodeURIComponent("" + item) + "&"; });
        if (includeSupplyingOrders === null)
            throw new Error("The parameter 'includeSupplyingOrders' cannot be null.");
        else if (includeSupplyingOrders !== undefined)
            url_ += "IncludeSupplyingOrders=" + encodeURIComponent("" + includeSupplyingOrders) + "&"; 
        if (excludeGiftCardsOrders === null)
            throw new Error("The parameter 'excludeGiftCardsOrders' cannot be null.");
        else if (excludeGiftCardsOrders !== undefined)
            url_ += "ExcludeGiftCardsOrders=" + encodeURIComponent("" + excludeGiftCardsOrders) + "&"; 
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllQuadmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllQuadmin(<any>response_);
                } catch (e) {
                    return <Observable<OrderCsvQuadminDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderCsvQuadminDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllQuadmin(response: HttpResponseBase): Observable<OrderCsvQuadminDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderCsvQuadminDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderCsvQuadminDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendToQuadmind(body: SendToQuadmindsDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Order/SendToQuadmind";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendToQuadmind(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendToQuadmind(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processSendToQuadmind(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param key (optional) 
     * @param storeCode (optional) 
     * @param countryCode (optional) 
     * @param creationTime (optional) 
     * @return Success
     */
    getStatusCount(key: string | null | undefined, storeCode: string | null | undefined, countryCode: string | null | undefined, creationTime: moment.Moment | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetStatusCount?";
        if (key !== undefined)
            url_ += "Key=" + encodeURIComponent("" + key) + "&"; 
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&"; 
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&"; 
        if (creationTime !== undefined)
            url_ += "CreationTime=" + encodeURIComponent(creationTime ? "" + creationTime.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatusCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatusCount(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetStatusCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    returnAssignedOrder(body: OrderUpdateReturnAssignedRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/ReturnAssignedOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReturnAssignedOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReturnAssignedOrder(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processReturnAssignedOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @param highlighted (optional) 
     * @return Success
     */
    setHighlighted(orderId: number | undefined, highlighted: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/SetHighlighted?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        if (highlighted === null)
            throw new Error("The parameter 'highlighted' cannot be null.");
        else if (highlighted !== undefined)
            url_ += "highlighted=" + encodeURIComponent("" + highlighted) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetHighlighted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetHighlighted(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetHighlighted(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAssignedStore(body: OrderUpdateAssignedStoreRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateAssignedStore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAssignedStore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAssignedStore(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAssignedStore(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCarrier(body: OrderUpdateCarrierRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateCarrier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCarrier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCarrier(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCarrier(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateStatus(body: OrderUpdateStatusRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatus(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateLogisticStatusProcess(body: OrderReturnedStatusRequest[] | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateLogisticStatusProcess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLogisticStatusProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLogisticStatusProcess(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateLogisticStatusProcess(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateLogisticStatus(body: OrderReturnedStatusRequest[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateLogisticStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLogisticStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLogisticStatus(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateLogisticStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateHeader(body: OrderUpdateHeaderRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateHeader";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateHeader(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateHeader(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateItems(body: OrderUpdateItemsRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateItems(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateItems(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param orderIds (optional) 
     * @param sourceIds (optional) 
     * @return Success
     */
    getPrintableOrderNote(orderIds: number[] | null | undefined, sourceIds: string[] | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetPrintableOrderNote?";
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(item => { url_ += "orderIds=" + encodeURIComponent("" + item) + "&"; });
        if (sourceIds !== undefined)
            sourceIds && sourceIds.forEach(item => { url_ += "sourceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrintableOrderNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrintableOrderNote(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetPrintableOrderNote(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param orderIds (optional) 
     * @param sourceIds (optional) 
     * @return Success
     */
    getInternalPrintableOrderNote(orderIds: number[] | null | undefined, sourceIds: string[] | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetInternalPrintableOrderNote?";
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(item => { url_ += "orderIds=" + encodeURIComponent("" + item) + "&"; });
        if (sourceIds !== undefined)
            sourceIds && sourceIds.forEach(item => { url_ += "sourceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInternalPrintableOrderNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInternalPrintableOrderNote(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetInternalPrintableOrderNote(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param orderIds (optional) 
     * @param sourceIds (optional) 
     * @param countryCode (optional) 
     * @param isInternal (optional) 
     * @return Success
     */
    getPrintableOrderNoteInner(orderIds: number[] | null | undefined, sourceIds: string[] | null | undefined, countryCode: string | null | undefined, isInternal: boolean | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetPrintableOrderNoteInner?";
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(item => { url_ += "orderIds=" + encodeURIComponent("" + item) + "&"; });
        if (sourceIds !== undefined)
            sourceIds && sourceIds.forEach(item => { url_ += "sourceIds=" + encodeURIComponent("" + item) + "&"; });
        if (countryCode !== undefined)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&"; 
        if (isInternal === null)
            throw new Error("The parameter 'isInternal' cannot be null.");
        else if (isInternal !== undefined)
            url_ += "isInternal=" + encodeURIComponent("" + isInternal) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrintableOrderNoteInner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrintableOrderNoteInner(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetPrintableOrderNoteInner(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveGridConfig(body: GridConfigRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/SaveGridConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveGridConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveGridConfig(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSaveGridConfig(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param gridName (optional) 
     * @return Success
     */
    getGridConfig(gridName: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetGridConfig?";
        if (gridName !== undefined)
            url_ += "gridName=" + encodeURIComponent("" + gridName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGridConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGridConfig(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetGridConfig(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: OrderDto | undefined): Observable<OrderDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<OrderDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<OrderDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<OrderDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<OrderDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OrderDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDto>(<any>null);
    }
}

@Injectable()
export class OrderDetailServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getOrderDetail(orderId: number | undefined): Observable<OrderDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderDetail/GetOrderDetail?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDetail(<any>response_);
                } catch (e) {
                    return <Observable<OrderDetailDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderDetailDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrderDetail(response: HttpResponseBase): Observable<OrderDetailDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDetailDto>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getOrderDetailClaims(orderId: number | undefined): Observable<OrderDetailClaimDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrderDetail/GetOrderDetailClaims?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDetailClaims(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDetailClaims(<any>response_);
                } catch (e) {
                    return <Observable<OrderDetailClaimDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderDetailClaimDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrderDetailClaims(response: HttpResponseBase): Observable<OrderDetailClaimDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderDetailClaimDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDetailClaimDto[]>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getOrderDetailEventLog(orderId: number | undefined): Observable<OrderDetailEventLogDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrderDetail/GetOrderDetailEventLog?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDetailEventLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDetailEventLog(<any>response_);
                } catch (e) {
                    return <Observable<OrderDetailEventLogDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderDetailEventLogDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrderDetailEventLog(response: HttpResponseBase): Observable<OrderDetailEventLogDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderDetailEventLogDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDetailEventLogDto[]>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getOrderDetailHeader(orderId: number | undefined): Observable<OrderDetailHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderDetail/GetOrderDetailHeader?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDetailHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDetailHeader(<any>response_);
                } catch (e) {
                    return <Observable<OrderDetailHeaderDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderDetailHeaderDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrderDetailHeader(response: HttpResponseBase): Observable<OrderDetailHeaderDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDetailHeaderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDetailHeaderDto>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getOrderDetailInvoice(orderId: number | undefined): Observable<OrderDetailInvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderDetail/GetOrderDetailInvoice?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDetailInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDetailInvoice(<any>response_);
                } catch (e) {
                    return <Observable<OrderDetailInvoiceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderDetailInvoiceDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrderDetailInvoice(response: HttpResponseBase): Observable<OrderDetailInvoiceDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDetailInvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDetailInvoiceDto>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getOrderDetailBalance(orderId: number | undefined): Observable<OrderDetailOrderBalanceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrderDetail/GetOrderDetailBalance?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDetailBalance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDetailBalance(<any>response_);
                } catch (e) {
                    return <Observable<OrderDetailOrderBalanceDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderDetailOrderBalanceDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrderDetailBalance(response: HttpResponseBase): Observable<OrderDetailOrderBalanceDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderDetailOrderBalanceDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDetailOrderBalanceDto[]>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getOrderDetailDocuments(orderId: number | undefined): Observable<OrderDetailDocumentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrderDetail/GetOrderDetailDocuments?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDetailDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDetailDocuments(<any>response_);
                } catch (e) {
                    return <Observable<OrderDetailDocumentDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderDetailDocumentDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrderDetailDocuments(response: HttpResponseBase): Observable<OrderDetailDocumentDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderDetailDocumentDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDetailDocumentDto[]>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getOrderDetailItem(orderId: number | undefined): Observable<OrderDetailItemDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderDetail/GetOrderDetailItem?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDetailItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDetailItem(<any>response_);
                } catch (e) {
                    return <Observable<OrderDetailItemDetailDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderDetailItemDetailDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrderDetailItem(response: HttpResponseBase): Observable<OrderDetailItemDetailDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDetailItemDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDetailItemDetailDto>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getOrderDetailPickingGroups(orderId: number | undefined): Observable<OrderDetailPickingGroupDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrderDetail/GetOrderDetailPickingGroups?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDetailPickingGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDetailPickingGroups(<any>response_);
                } catch (e) {
                    return <Observable<OrderDetailPickingGroupDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderDetailPickingGroupDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrderDetailPickingGroups(response: HttpResponseBase): Observable<OrderDetailPickingGroupDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderDetailPickingGroupDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDetailPickingGroupDto[]>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getOrderDetailPreparations(orderId: number | undefined): Observable<OrderDetailPreparationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrderDetail/GetOrderDetailPreparations?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDetailPreparations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDetailPreparations(<any>response_);
                } catch (e) {
                    return <Observable<OrderDetailPreparationDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderDetailPreparationDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrderDetailPreparations(response: HttpResponseBase): Observable<OrderDetailPreparationDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderDetailPreparationDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDetailPreparationDto[]>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getOrderDetailReturnings(orderId: number | undefined): Observable<OrderDetailReturnDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrderDetail/GetOrderDetailReturnings?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDetailReturnings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDetailReturnings(<any>response_);
                } catch (e) {
                    return <Observable<OrderDetailReturnDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderDetailReturnDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrderDetailReturnings(response: HttpResponseBase): Observable<OrderDetailReturnDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderDetailReturnDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDetailReturnDto[]>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getOrderDetailShipments(orderId: number | undefined): Observable<OrderDetailShipmentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrderDetail/GetOrderDetailShipments?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDetailShipments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDetailShipments(<any>response_);
                } catch (e) {
                    return <Observable<OrderDetailShipmentDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderDetailShipmentDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrderDetailShipments(response: HttpResponseBase): Observable<OrderDetailShipmentDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderDetailShipmentDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDetailShipmentDto[]>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getOrderDetailQuadmindsOrderDto(orderId: number | undefined): Observable<OrderDetailQuadmindsDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderDetail/GetOrderDetailQuadmindsOrderDto?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDetailQuadmindsOrderDto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDetailQuadmindsOrderDto(<any>response_);
                } catch (e) {
                    return <Observable<OrderDetailQuadmindsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderDetailQuadmindsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrderDetailQuadmindsOrderDto(response: HttpResponseBase): Observable<OrderDetailQuadmindsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDetailQuadmindsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDetailQuadmindsDto>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getOrderDetailTransfers(orderId: number | undefined): Observable<OrderDetailTransferDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrderDetail/GetOrderDetailTransfers?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDetailTransfers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDetailTransfers(<any>response_);
                } catch (e) {
                    return <Observable<OrderDetailTransferDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderDetailTransferDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrderDetailTransfers(response: HttpResponseBase): Observable<OrderDetailTransferDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderDetailTransferDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDetailTransferDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePickupStore(body: UpdatePickupStoreRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderDetail/UpdatePickupStore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePickupStore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePickupStore(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePickupStore(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class OrderLogisticStatusServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param storeCode (optional) 
     * @param countryCode (optional) 
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(storeCode: string | null | undefined, countryCode: string | null | undefined, filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderLogisticAuditDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderLogisticStatus/GetAll?";
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&"; 
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&"; 
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<OrderLogisticAuditDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderLogisticAuditDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<OrderLogisticAuditDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderLogisticAuditDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderLogisticAuditDtoPagedResultDto>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    markAsCancelled(orderId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderLogisticStatus/MarkAsCancelled?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAsCancelled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsCancelled(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMarkAsCancelled(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    markAsReadyToHandle(orderId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderLogisticStatus/MarkAsReadyToHandle?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAsReadyToHandle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsReadyToHandle(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMarkAsReadyToHandle(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param storeCode (optional) 
     * @param countryCode (optional) 
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getCsv(storeCode: string | null | undefined, countryCode: string | null | undefined, filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/OrderLogisticStatus/GetCsv?";
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&"; 
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&"; 
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCsv(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetCsv(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<OrderLogisticAuditDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderLogisticStatus/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<OrderLogisticAuditDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderLogisticAuditDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OrderLogisticAuditDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderLogisticAuditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderLogisticAuditDto>(<any>null);
    }
}

@Injectable()
export class OrderNoteServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param orderId (optional) 
     * @param description (optional) 
     * @param notify (optional) 
     * @return Success
     */
    create(orderId: number | undefined, description: string | null | undefined, notify: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderNote/Create?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        if (description !== undefined)
            url_ += "description=" + encodeURIComponent("" + description) + "&"; 
        if (notify === null)
            throw new Error("The parameter 'notify' cannot be null.");
        else if (notify !== undefined)
            url_ += "notify=" + encodeURIComponent("" + notify) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param storeCode (optional) 
     * @return Success
     */
    getCount(storeCode: string | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/OrderNote/GetCount?";
        if (storeCode !== undefined)
            url_ += "storeCode=" + encodeURIComponent("" + storeCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCount(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    markAsReaded(body: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderNote/MarkAsReaded";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAsReaded(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsReaded(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMarkAsReaded(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<OrderNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderNote/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<OrderNoteDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderNoteDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OrderNoteDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderNoteDto>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @param storeCode (optional) 
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(orderId: number | null | undefined, storeCode: string | null | undefined, filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderNoteDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderNote/GetAll?";
        if (orderId !== undefined)
            url_ += "OrderId=" + encodeURIComponent("" + orderId) + "&"; 
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&"; 
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<OrderNoteDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderNoteDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<OrderNoteDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderNoteDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderNoteDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class OrderReadyToHandleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param selectedColumns (optional) 
     * @param storeCode (optional) 
     * @param countryCode (optional) 
     * @param orderIds (optional) 
     * @param filters (optional) 
     * @param search (optional) 
     * @param dateFrom (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(selectedColumns: string[] | null | undefined, storeCode: string | null | undefined, countryCode: string | null | undefined, orderIds: number[] | null | undefined, filters: string[] | null | undefined, search: string | null | undefined, dateFrom: moment.Moment | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderReadyToHandleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderReadyToHandle/GetAll?";
        if (selectedColumns !== undefined)
            selectedColumns && selectedColumns.forEach(item => { url_ += "SelectedColumns=" + encodeURIComponent("" + item) + "&"; });
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&"; 
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&"; 
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(item => { url_ += "OrderIds=" + encodeURIComponent("" + item) + "&"; });
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&"; 
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<OrderReadyToHandleDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderReadyToHandleDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<OrderReadyToHandleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderReadyToHandleDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderReadyToHandleDtoPagedResultDto>(<any>null);
    }

    /**
     * @param selectedColumns (optional) 
     * @param storeCode (optional) 
     * @param countryCode (optional) 
     * @param orderIds (optional) 
     * @param filters (optional) 
     * @param search (optional) 
     * @param dateFrom (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getCsvOL(selectedColumns: string[] | null | undefined, storeCode: string | null | undefined, countryCode: string | null | undefined, orderIds: number[] | null | undefined, filters: string[] | null | undefined, search: string | null | undefined, dateFrom: moment.Moment | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/OrderReadyToHandle/GetCsvOL?";
        if (selectedColumns !== undefined)
            selectedColumns && selectedColumns.forEach(item => { url_ += "SelectedColumns=" + encodeURIComponent("" + item) + "&"; });
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&"; 
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&"; 
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(item => { url_ += "OrderIds=" + encodeURIComponent("" + item) + "&"; });
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&"; 
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCsvOL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCsvOL(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetCsvOL(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param selectedColumns (optional) 
     * @param storeCode (optional) 
     * @param countryCode (optional) 
     * @param orderIds (optional) 
     * @param filters (optional) 
     * @param search (optional) 
     * @param dateFrom (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getCsvQuadmin(selectedColumns: string[] | null | undefined, storeCode: string | null | undefined, countryCode: string | null | undefined, orderIds: number[] | null | undefined, filters: string[] | null | undefined, search: string | null | undefined, dateFrom: moment.Moment | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/OrderReadyToHandle/GetCsvQuadmin?";
        if (selectedColumns !== undefined)
            selectedColumns && selectedColumns.forEach(item => { url_ += "SelectedColumns=" + encodeURIComponent("" + item) + "&"; });
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&"; 
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&"; 
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(item => { url_ += "OrderIds=" + encodeURIComponent("" + item) + "&"; });
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&"; 
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCsvQuadmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCsvQuadmin(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetCsvQuadmin(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param selectedColumns (optional) 
     * @param storeCode (optional) 
     * @param countryCode (optional) 
     * @param orderIds (optional) 
     * @param filters (optional) 
     * @param search (optional) 
     * @param dateFrom (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllOL(selectedColumns: string[] | null | undefined, storeCode: string | null | undefined, countryCode: string | null | undefined, orderIds: number[] | null | undefined, filters: string[] | null | undefined, search: string | null | undefined, dateFrom: moment.Moment | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderCsvOLDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrderReadyToHandle/GetAllOL?";
        if (selectedColumns !== undefined)
            selectedColumns && selectedColumns.forEach(item => { url_ += "SelectedColumns=" + encodeURIComponent("" + item) + "&"; });
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&"; 
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&"; 
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(item => { url_ += "OrderIds=" + encodeURIComponent("" + item) + "&"; });
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&"; 
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOL(<any>response_);
                } catch (e) {
                    return <Observable<OrderCsvOLDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderCsvOLDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllOL(response: HttpResponseBase): Observable<OrderCsvOLDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderCsvOLDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderCsvOLDto[]>(<any>null);
    }

    /**
     * @param selectedColumns (optional) 
     * @param storeCode (optional) 
     * @param countryCode (optional) 
     * @param orderIds (optional) 
     * @param filters (optional) 
     * @param search (optional) 
     * @param dateFrom (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllQuadmin(selectedColumns: string[] | null | undefined, storeCode: string | null | undefined, countryCode: string | null | undefined, orderIds: number[] | null | undefined, filters: string[] | null | undefined, search: string | null | undefined, dateFrom: moment.Moment | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderReadyToHandleCsvQuadminDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrderReadyToHandle/GetAllQuadmin?";
        if (selectedColumns !== undefined)
            selectedColumns && selectedColumns.forEach(item => { url_ += "SelectedColumns=" + encodeURIComponent("" + item) + "&"; });
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&"; 
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&"; 
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(item => { url_ += "OrderIds=" + encodeURIComponent("" + item) + "&"; });
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&"; 
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllQuadmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllQuadmin(<any>response_);
                } catch (e) {
                    return <Observable<OrderReadyToHandleCsvQuadminDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderReadyToHandleCsvQuadminDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllQuadmin(response: HttpResponseBase): Observable<OrderReadyToHandleCsvQuadminDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderReadyToHandleCsvQuadminDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderReadyToHandleCsvQuadminDto[]>(<any>null);
    }

    /**
     * @param pickingGroupId (optional) 
     * @param orderId (optional) 
     * @return Success
     */
    getOrdersToPrepare(pickingGroupId: number | null | undefined, orderId: number | null | undefined): Observable<OrderReadyToHandleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrderReadyToHandle/GetOrdersToPrepare?";
        if (pickingGroupId !== undefined)
            url_ += "PickingGroupId=" + encodeURIComponent("" + pickingGroupId) + "&"; 
        if (orderId !== undefined)
            url_ += "OrderId=" + encodeURIComponent("" + orderId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrdersToPrepare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrdersToPrepare(<any>response_);
                } catch (e) {
                    return <Observable<OrderReadyToHandleDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderReadyToHandleDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrdersToPrepare(response: HttpResponseBase): Observable<OrderReadyToHandleDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderReadyToHandleDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderReadyToHandleDto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<OrderReadyToHandleDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderReadyToHandle/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<OrderReadyToHandleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderReadyToHandleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OrderReadyToHandleDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderReadyToHandleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderReadyToHandleDto>(<any>null);
    }
}

@Injectable()
export class OrderReadyToShipServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param selectedColumns (optional) 
     * @param storeCode (optional) 
     * @param shippingTypeGroupId (optional) 
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(selectedColumns: string[] | null | undefined, storeCode: string | null | undefined, shippingTypeGroupId: number | null | undefined, filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderReadyToShipDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderReadyToShip/GetAll?";
        if (selectedColumns !== undefined)
            selectedColumns && selectedColumns.forEach(item => { url_ += "SelectedColumns=" + encodeURIComponent("" + item) + "&"; });
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&"; 
        if (shippingTypeGroupId !== undefined)
            url_ += "ShippingTypeGroupId=" + encodeURIComponent("" + shippingTypeGroupId) + "&"; 
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<OrderReadyToShipDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderReadyToShipDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<OrderReadyToShipDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderReadyToShipDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderReadyToShipDtoPagedResultDto>(<any>null);
    }

    /**
     * @param selectedColumns (optional) 
     * @param storeCode (optional) 
     * @param shippingTypeGroupId (optional) 
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getCountByShippingTypeGroup(selectedColumns: string[] | null | undefined, storeCode: string | null | undefined, shippingTypeGroupId: number | null | undefined, filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/OrderReadyToShip/GetCountByShippingTypeGroup?";
        if (selectedColumns !== undefined)
            selectedColumns && selectedColumns.forEach(item => { url_ += "SelectedColumns=" + encodeURIComponent("" + item) + "&"; });
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&"; 
        if (shippingTypeGroupId !== undefined)
            url_ += "ShippingTypeGroupId=" + encodeURIComponent("" + shippingTypeGroupId) + "&"; 
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountByShippingTypeGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountByShippingTypeGroup(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetCountByShippingTypeGroup(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadCsv(body: UploadRouteRequestDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/OrderReadyToShip/UploadCsv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadCsv(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUploadCsv(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: OrderReadyToShipDto | undefined): Observable<OrderReadyToShipDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderReadyToShip/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<OrderReadyToShipDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderReadyToShipDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<OrderReadyToShipDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderReadyToShipDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderReadyToShipDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: OrderReadyToShipDto | undefined): Observable<OrderReadyToShipDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderReadyToShip/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<OrderReadyToShipDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderReadyToShipDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<OrderReadyToShipDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderReadyToShipDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderReadyToShipDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderReadyToShip/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<OrderReadyToShipDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderReadyToShip/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<OrderReadyToShipDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderReadyToShipDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OrderReadyToShipDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderReadyToShipDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderReadyToShipDto>(<any>null);
    }
}

@Injectable()
export class OrderReturnedServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param carrierId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getCsv(carrierId: number | null | undefined, dateFrom: moment.Moment | null | undefined, dateTo: moment.Moment | null | undefined, filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/OrderReturned/GetCsv?";
        if (carrierId !== undefined)
            url_ += "CarrierId=" + encodeURIComponent("" + carrierId) + "&"; 
        if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&"; 
        if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&"; 
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCsv(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetCsv(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param carrierId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(carrierId: number | null | undefined, dateFrom: moment.Moment | null | undefined, dateTo: moment.Moment | null | undefined, filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderReturnedDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderReturned/GetAll?";
        if (carrierId !== undefined)
            url_ += "CarrierId=" + encodeURIComponent("" + carrierId) + "&"; 
        if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&"; 
        if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&"; 
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<OrderReturnedDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderReturnedDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<OrderReturnedDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderReturnedDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderReturnedDtoPagedResultDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<OrderReturnedDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderReturned/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<OrderReturnedDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderReturnedDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OrderReturnedDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderReturnedDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderReturnedDto>(<any>null);
    }
}

@Injectable()
export class OrderStatusServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param countryCode (optional) 
     * @param storeCode (optional) 
     * @return Success
     */
    getAll(countryCode: string | null | undefined, storeCode: string | null | undefined): Observable<OrderWorkflowDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderStatus/GetAll?";
        if (countryCode !== undefined)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&"; 
        if (storeCode !== undefined)
            url_ += "storeCode=" + encodeURIComponent("" + storeCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<OrderWorkflowDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderWorkflowDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<OrderWorkflowDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderWorkflowDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderWorkflowDto>(<any>null);
    }
}

@Injectable()
export class OrderStorePickupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param selectedColumns (optional) 
     * @param filters (optional) 
     * @param countryCode (optional) 
     * @param search (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(selectedColumns: string[] | null | undefined, filters: string[] | null | undefined, countryCode: string | null | undefined, search: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderStorePickupDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderStorePickup/GetAll?";
        if (selectedColumns !== undefined)
            selectedColumns && selectedColumns.forEach(item => { url_ += "SelectedColumns=" + encodeURIComponent("" + item) + "&"; });
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&"; 
        if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<OrderStorePickupDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderStorePickupDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<OrderStorePickupDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderStorePickupDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderStorePickupDtoPagedResultDto>(<any>null);
    }

    /**
     * @param storeCode (optional) 
     * @param key (optional) 
     * @param dateFrom (optional) 
     * @return Success
     */
    getTotals(storeCode: string | null | undefined, key: number | undefined, dateFrom: moment.Moment | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/OrderStorePickup/GetTotals?";
        if (storeCode !== undefined)
            url_ += "storeCode=" + encodeURIComponent("" + storeCode) + "&"; 
        if (key === null)
            throw new Error("The parameter 'key' cannot be null.");
        else if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&"; 
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotals(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetTotals(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param sourceCode (optional) 
     * @return Success
     */
    markAsReceivedBySourceCode(sourceCode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderStorePickup/MarkAsReceivedBySourceCode?";
        if (sourceCode !== undefined)
            url_ += "sourceCode=" + encodeURIComponent("" + sourceCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAsReceivedBySourceCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsReceivedBySourceCode(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMarkAsReceivedBySourceCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    markAsReceived(orderId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderStorePickup/MarkAsReceived?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAsReceived(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsReceived(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMarkAsReceived(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    markAsDelivered(orderId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderStorePickup/MarkAsDelivered?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAsDelivered(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsDelivered(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMarkAsDelivered(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @param note (optional) 
     * @return Success
     */
    markAsReceivedWithFailure(orderId: number | undefined, note: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderStorePickup/MarkAsReceivedWithFailure?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        if (note !== undefined)
            url_ += "note=" + encodeURIComponent("" + note) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAsReceivedWithFailure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsReceivedWithFailure(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMarkAsReceivedWithFailure(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @param note (optional) 
     * @return Success
     */
    markAsNotReceived(orderId: number | undefined, note: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderStorePickup/MarkAsNotReceived?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        if (note !== undefined)
            url_ += "note=" + encodeURIComponent("" + note) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAsNotReceived(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsNotReceived(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMarkAsNotReceived(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @param note (optional) 
     * @return Success
     */
    markAsNotDelivered(orderId: number | undefined, note: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderStorePickup/MarkAsNotDelivered?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        if (note !== undefined)
            url_ += "note=" + encodeURIComponent("" + note) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAsNotDelivered(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsNotDelivered(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMarkAsNotDelivered(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: OrderStorePickupDto | undefined): Observable<OrderStorePickupDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderStorePickup/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<OrderStorePickupDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderStorePickupDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<OrderStorePickupDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderStorePickupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderStorePickupDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: OrderStorePickupDto | undefined): Observable<OrderStorePickupDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderStorePickup/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<OrderStorePickupDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderStorePickupDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<OrderStorePickupDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderStorePickupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderStorePickupDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderStorePickup/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<OrderStorePickupDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderStorePickup/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<OrderStorePickupDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderStorePickupDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OrderStorePickupDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderStorePickupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderStorePickupDto>(<any>null);
    }
}

@Injectable()
export class OrderTrackingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param nro (optional) 
     * @return Success
     */
    get(nro: string | null | undefined): Observable<OrderTrackingDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderTracking/Get?";
        if (nro !== undefined)
            url_ += "nro=" + encodeURIComponent("" + nro) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<OrderTrackingDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderTrackingDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OrderTrackingDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderTrackingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderTrackingDto>(<any>null);
    }

    /**
     * @param secureid (optional) 
     * @return Success
     */
    validateOrderBySecureId(secureid: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderTracking/ValidateOrderBySecureId?";
        if (secureid !== undefined)
            url_ += "secureid=" + encodeURIComponent("" + secureid) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateOrderBySecureId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateOrderBySecureId(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processValidateOrderBySecureId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDeliveryData(body: UpdateDeliveryDataDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderTracking/UpdateDeliveryData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDeliveryData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDeliveryData(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateDeliveryData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class PendingManagementServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param orderId (optional) 
     * @param documentNumber (optional) 
     * @param amount (optional) 
     * @return Success
     */
    changeToCreditNoteIssue(orderId: number | undefined, documentNumber: string | null | undefined, amount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PendingManagement/ChangeToCreditNoteIssue?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        if (documentNumber !== undefined)
            url_ += "documentNumber=" + encodeURIComponent("" + documentNumber) + "&"; 
        if (amount === null)
            throw new Error("The parameter 'amount' cannot be null.");
        else if (amount !== undefined)
            url_ += "amount=" + encodeURIComponent("" + amount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeToCreditNoteIssue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeToCreditNoteIssue(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeToCreditNoteIssue(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @param body (optional) 
     * @return Success
     */
    changeToPaid(orderId: number | undefined, body: MovementType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PendingManagement/ChangeToPaid?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeToPaid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeToPaid(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeToPaid(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param countryCode (optional) 
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(countryCode: string | null | undefined, filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PendingManagement/GetAll?";
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&"; 
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<OrderDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<OrderDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDtoPagedResultDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<OrderDto> {
        let url_ = this.baseUrl + "/api/services/app/PendingManagement/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<OrderDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OrderDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDto>(<any>null);
    }
}

@Injectable()
export class PendingReturnServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PendingReturnDto> {
        let url_ = this.baseUrl + "/api/services/app/PendingReturn/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PendingReturnDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PendingReturnDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PendingReturnDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PendingReturnDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PendingReturnDto>(<any>null);
    }

    /**
     * @param pendingReturnId (optional) 
     * @param body (optional) 
     * @return Success
     */
    markAsReturned(pendingReturnId: number | undefined, body: PendingReturnItemDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PendingReturn/MarkAsReturned?";
        if (pendingReturnId === null)
            throw new Error("The parameter 'pendingReturnId' cannot be null.");
        else if (pendingReturnId !== undefined)
            url_ += "pendingReturnId=" + encodeURIComponent("" + pendingReturnId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAsReturned(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsReturned(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMarkAsReturned(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: PendingReturnDto | undefined): Observable<PendingReturnDto> {
        let url_ = this.baseUrl + "/api/services/app/PendingReturn/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<PendingReturnDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PendingReturnDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PendingReturnDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PendingReturnDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PendingReturnDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: PendingReturnDto | undefined): Observable<PendingReturnDto> {
        let url_ = this.baseUrl + "/api/services/app/PendingReturn/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PendingReturnDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PendingReturnDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PendingReturnDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PendingReturnDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PendingReturnDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PendingReturn/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PendingReturnDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PendingReturn/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PendingReturnDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PendingReturnDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PendingReturnDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PendingReturnDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PendingReturnDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class PicapServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    hookBooking(body: PicapBookingStatusDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Picap/HookBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHookBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHookBooking(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processHookBooking(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    hookPackage(body: PicapPackageStatusDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Picap/HookPackage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHookPackage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHookPackage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processHookPackage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class PickingGroupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param storeCode (optional) 
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(storeCode: string | null | undefined, filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PickingGroupDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PickingGroup/GetAll?";
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&"; 
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PickingGroupDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PickingGroupDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PickingGroupDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PickingGroupDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PickingGroupDtoPagedResultDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getWithOrders(input: number | undefined): Observable<PickingGroupDto> {
        let url_ = this.baseUrl + "/api/services/app/PickingGroup/GetWithOrders?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWithOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWithOrders(<any>response_);
                } catch (e) {
                    return <Observable<PickingGroupDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PickingGroupDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetWithOrders(response: HttpResponseBase): Observable<PickingGroupDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PickingGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PickingGroupDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addOrdersFromPickingGroup(body: UpdateOrdersFromPickingGroupRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PickingGroup/AddOrdersFromPickingGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrdersFromPickingGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrdersFromPickingGroup(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAddOrdersFromPickingGroup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param pickingGroupId (optional) 
     * @return Success
     */
    closePickingGroup(pickingGroupId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PickingGroup/ClosePickingGroup?";
        if (pickingGroupId === null)
            throw new Error("The parameter 'pickingGroupId' cannot be null.");
        else if (pickingGroupId !== undefined)
            url_ += "pickingGroupId=" + encodeURIComponent("" + pickingGroupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClosePickingGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClosePickingGroup(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processClosePickingGroup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPicking(body: PickingGroupCreateDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PickingGroup/CreatePicking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePicking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePicking(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreatePicking(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PickingGroup/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cancel(body: Int32EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PickingGroup/Cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCsv(id: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/PickingGroup/GetCsv?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCsv(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetCsv(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param orderIds (optional) 
     * @return Success
     */
    removeOrdersFromPickingGroup(pickingGroupId: number, orderIds: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PickingGroup/RemoveOrdersFromPickingGroup?";
        if (pickingGroupId === undefined || pickingGroupId === null)
            throw new Error("The parameter 'pickingGroupId' must be defined and cannot be null.");
        else
            url_ += "PickingGroupId=" + encodeURIComponent("" + pickingGroupId) + "&"; 
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(item => { url_ += "OrderIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveOrdersFromPickingGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveOrdersFromPickingGroup(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveOrdersFromPickingGroup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    solvePickingGroupConflicts(body: PickingGroupCreateWithConflictsRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PickingGroup/SolvePickingGroupConflicts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSolvePickingGroupConflicts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSolvePickingGroupConflicts(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSolvePickingGroupConflicts(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePickedQuantity(body: UpdatePickedQuantityRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PickingGroup/UpdatePickedQuantity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePickedQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePickedQuantity(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePickedQuantity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param pickingGroupId (optional) 
     * @return Success
     */
    getPrintablePickingNote(pickingGroupId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/PickingGroup/GetPrintablePickingNote?";
        if (pickingGroupId === null)
            throw new Error("The parameter 'pickingGroupId' cannot be null.");
        else if (pickingGroupId !== undefined)
            url_ += "pickingGroupId=" + encodeURIComponent("" + pickingGroupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrintablePickingNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrintablePickingNote(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetPrintablePickingNote(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: PickingGroupDto | undefined): Observable<PickingGroupDto> {
        let url_ = this.baseUrl + "/api/services/app/PickingGroup/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<PickingGroupDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PickingGroupDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PickingGroupDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PickingGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PickingGroupDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: PickingGroupDto | undefined): Observable<PickingGroupDto> {
        let url_ = this.baseUrl + "/api/services/app/PickingGroup/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PickingGroupDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PickingGroupDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PickingGroupDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PickingGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PickingGroupDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PickingGroupDto> {
        let url_ = this.baseUrl + "/api/services/app/PickingGroup/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PickingGroupDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PickingGroupDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PickingGroupDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PickingGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PickingGroupDto>(<any>null);
    }
}

@Injectable()
export class PickingGroupItemServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: PickingGroupItemDto | undefined): Observable<PickingGroupItemDto> {
        let url_ = this.baseUrl + "/api/services/app/PickingGroupItem/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PickingGroupItemDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PickingGroupItemDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PickingGroupItemDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PickingGroupItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PickingGroupItemDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: PickingGroupItemDto | undefined): Observable<PickingGroupItemDto> {
        let url_ = this.baseUrl + "/api/services/app/PickingGroupItem/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<PickingGroupItemDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PickingGroupItemDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PickingGroupItemDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PickingGroupItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PickingGroupItemDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PickingGroupItem/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PickingGroupItemDto> {
        let url_ = this.baseUrl + "/api/services/app/PickingGroupItem/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PickingGroupItemDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PickingGroupItemDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PickingGroupItemDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PickingGroupItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PickingGroupItemDto>(<any>null);
    }

    /**
     * @param storeCode (optional) 
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(storeCode: string | null | undefined, filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PickingGroupItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PickingGroupItem/GetAll?";
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&"; 
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PickingGroupItemDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PickingGroupItemDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PickingGroupItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PickingGroupItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PickingGroupItemDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class PickingGroupRuleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: PickingGroupRuleDto | undefined): Observable<PickingGroupRuleDto> {
        let url_ = this.baseUrl + "/api/services/app/PickingGroupRule/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<PickingGroupRuleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PickingGroupRuleDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PickingGroupRuleDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PickingGroupRuleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PickingGroupRuleDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: PickingGroupRuleDto | undefined): Observable<PickingGroupRuleDto> {
        let url_ = this.baseUrl + "/api/services/app/PickingGroupRule/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PickingGroupRuleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PickingGroupRuleDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PickingGroupRuleDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PickingGroupRuleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PickingGroupRuleDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PickingGroupRule/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PickingGroupRuleDto> {
        let url_ = this.baseUrl + "/api/services/app/PickingGroupRule/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PickingGroupRuleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PickingGroupRuleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PickingGroupRuleDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PickingGroupRuleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PickingGroupRuleDto>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PickingGroupRuleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PickingGroupRule/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PickingGroupRuleDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PickingGroupRuleDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PickingGroupRuleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PickingGroupRuleDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PickingGroupRuleDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class PreparationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: PreparationDto | undefined): Observable<PreparationDto> {
        let url_ = this.baseUrl + "/api/services/app/Preparation/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<PreparationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PreparationDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PreparationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreparationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PreparationDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getOrCreate(body: PreparationDto | undefined): Observable<PreparationDto> {
        let url_ = this.baseUrl + "/api/services/app/Preparation/GetOrCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrCreate(<any>response_);
                } catch (e) {
                    return <Observable<PreparationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PreparationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrCreate(response: HttpResponseBase): Observable<PreparationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreparationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PreparationDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: PreparationDto | undefined): Observable<PreparationDto> {
        let url_ = this.baseUrl + "/api/services/app/Preparation/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PreparationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PreparationDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PreparationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreparationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PreparationDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Preparation/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PreparationDto> {
        let url_ = this.baseUrl + "/api/services/app/Preparation/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PreparationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PreparationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PreparationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreparationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PreparationDto>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PreparationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Preparation/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PreparationDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PreparationDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PreparationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreparationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PreparationDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class ProcessServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ProcessDto> {
        let url_ = this.baseUrl + "/api/services/app/Process/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ProcessDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProcessDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProcessDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProcessDto>(<any>null);
    }
}

@Injectable()
export class PromotionMappingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PromotionMappingDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PromotionMapping/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PromotionMappingDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PromotionMappingDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PromotionMappingDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PromotionMappingDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PromotionMappingDtoPagedResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadPromotions(body: UploadPromotionDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PromotionMapping/UploadPromotions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadPromotions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadPromotions(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUploadPromotions(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @return Success
     */
    deleteAllPromotions(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PromotionMapping/DeleteAllPromotions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAllPromotions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAllPromotions(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteAllPromotions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: PromotionMappingDto | undefined): Observable<PromotionMappingDto> {
        let url_ = this.baseUrl + "/api/services/app/PromotionMapping/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<PromotionMappingDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PromotionMappingDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PromotionMappingDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PromotionMappingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PromotionMappingDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: PromotionMappingDto | undefined): Observable<PromotionMappingDto> {
        let url_ = this.baseUrl + "/api/services/app/PromotionMapping/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PromotionMappingDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PromotionMappingDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PromotionMappingDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PromotionMappingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PromotionMappingDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PromotionMapping/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PromotionMappingDto> {
        let url_ = this.baseUrl + "/api/services/app/PromotionMapping/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PromotionMappingDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PromotionMappingDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PromotionMappingDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PromotionMappingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PromotionMappingDto>(<any>null);
    }
}

@Injectable()
export class QuadmindsOrderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getTest(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/QuadmindsOrder/GetTest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTest(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processGetTest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveDataRequestDto(body: QuadmindsWebHookDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/QuadmindsOrder/SaveDataRequestDto";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveDataRequestDto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveDataRequestDto(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSaveDataRequestDto(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param responseData (optional) 
     * @return Success
     */
    saveDataRequestStr(responseData: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/QuadmindsOrder/SaveDataRequestStr?";
        if (responseData !== undefined)
            url_ += "responseData=" + encodeURIComponent("" + responseData) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveDataRequestStr(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveDataRequestStr(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSaveDataRequestStr(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ApiServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    quadMindsOrderGet(): Observable<void> {
        let url_ = this.baseUrl + "/api/QuadMindsOrder";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuadMindsOrderGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuadMindsOrderGet(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processQuadMindsOrderGet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    quadMindsOrderPost(): Observable<void> {
        let url_ = this.baseUrl + "/api/QuadMindsOrder";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuadMindsOrderPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuadMindsOrderPost(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processQuadMindsOrderPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    quadMindsOrderPut(body: QuadmindsWebHookDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/QuadMindsOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuadMindsOrderPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuadMindsOrderPut(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processQuadMindsOrderPut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class RapiboyWebhookServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    onChangeState(body: RapiboyRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RapiboyWebhook/OnChangeState";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnChangeState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnChangeState(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processOnChangeState(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class RappiServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: RappiItemDto | undefined): Observable<RappiItemDto> {
        let url_ = this.baseUrl + "/api/services/app/Rappi/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<RappiItemDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RappiItemDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RappiItemDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RappiItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RappiItemDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Rappi/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: RappiItemDto | undefined): Observable<RappiItemDto> {
        let url_ = this.baseUrl + "/api/services/app/Rappi/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<RappiItemDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RappiItemDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RappiItemDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RappiItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RappiItemDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCatalog(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Rappi/GetCatalog";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCatalog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCatalog(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetCatalog(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getCsv(filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Rappi/GetCsv?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCsv(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetCsv(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllDashboard(filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RappiItemCsvDashboardDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Rappi/GetAllDashboard?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDashboard(<any>response_);
                } catch (e) {
                    return <Observable<RappiItemCsvDashboardDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RappiItemCsvDashboardDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllDashboard(response: HttpResponseBase): Observable<RappiItemCsvDashboardDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RappiItemCsvDashboardDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RappiItemCsvDashboardDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    syncCatalog(body: SyncRappiCatalogDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Rappi/SyncCatalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncCatalog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncCatalog(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processSyncCatalog(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @return Success
     */
    syncFromComerssia(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Rappi/SyncFromComerssia";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncFromComerssia(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncFromComerssia(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSyncFromComerssia(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateConfig(body: RappiConfigDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Rappi/UpdateConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateConfig(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateConfig(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadCsv(body: UploadRappiDiscountsRequestDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Rappi/UploadCsv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadCsv(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUploadCsv(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadProductsCsv(body: UploadRappiProductsRequestDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Rappi/UploadProductsCsv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadProductsCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadProductsCsv(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUploadProductsCsv(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<RappiItemDto> {
        let url_ = this.baseUrl + "/api/services/app/Rappi/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<RappiItemDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RappiItemDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RappiItemDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RappiItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RappiItemDto>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RappiItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Rappi/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<RappiItemDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RappiItemDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RappiItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RappiItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RappiItemDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class RappiConfigServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: RappiStoreConfigDto | undefined): Observable<RappiStoreConfigDto> {
        let url_ = this.baseUrl + "/api/services/app/RappiConfig/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<RappiStoreConfigDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RappiStoreConfigDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RappiStoreConfigDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RappiStoreConfigDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RappiStoreConfigDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: RappiStoreConfigDto | undefined): Observable<RappiStoreConfigDto> {
        let url_ = this.baseUrl + "/api/services/app/RappiConfig/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<RappiStoreConfigDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RappiStoreConfigDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RappiStoreConfigDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RappiStoreConfigDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RappiStoreConfigDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RappiConfig/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<RappiStoreConfigDto> {
        let url_ = this.baseUrl + "/api/services/app/RappiConfig/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<RappiStoreConfigDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RappiStoreConfigDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RappiStoreConfigDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RappiStoreConfigDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RappiStoreConfigDto>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RappiStoreConfigDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/RappiConfig/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<RappiStoreConfigDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RappiStoreConfigDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RappiStoreConfigDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RappiStoreConfigDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RappiStoreConfigDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class ReturnServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param returningId (optional) 
     * @return Success
     */
    finalize(returningId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Return/Finalize?";
        if (returningId === null)
            throw new Error("The parameter 'returningId' cannot be null.");
        else if (returningId !== undefined)
            url_ += "returningId=" + encodeURIComponent("" + returningId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalize(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalize(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processFinalize(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param countryCode (optional) 
     * @param storeCode (optional) 
     * @param orderIds (optional) 
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(countryCode: string | null | undefined, storeCode: string | null | undefined, orderIds: number[] | null | undefined, filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ReturnDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Return/GetAll?";
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&"; 
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&"; 
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(item => { url_ += "OrderIds=" + encodeURIComponent("" + item) + "&"; });
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ReturnDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReturnDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ReturnDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReturnDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnDtoPagedResultDto>(<any>null);
    }

    /**
     * @param countryCode (optional) 
     * @param storeCode (optional) 
     * @param orderIds (optional) 
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getCsvQuadmin(countryCode: string | null | undefined, storeCode: string | null | undefined, orderIds: number[] | null | undefined, filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Return/GetCsvQuadmin?";
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&"; 
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&"; 
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(item => { url_ += "OrderIds=" + encodeURIComponent("" + item) + "&"; });
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCsvQuadmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCsvQuadmin(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetCsvQuadmin(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param countryCode (optional) 
     * @param storeCode (optional) 
     * @param orderIds (optional) 
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllQuadmin(countryCode: string | null | undefined, storeCode: string | null | undefined, orderIds: number[] | null | undefined, filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ReturnCsvQuadminDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Return/GetAllQuadmin?";
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&"; 
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&"; 
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(item => { url_ += "OrderIds=" + encodeURIComponent("" + item) + "&"; });
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllQuadmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllQuadmin(<any>response_);
                } catch (e) {
                    return <Observable<ReturnCsvQuadminDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReturnCsvQuadminDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllQuadmin(response: HttpResponseBase): Observable<ReturnCsvQuadminDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ReturnCsvQuadminDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnCsvQuadminDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ReturnDto | undefined): Observable<ReturnDto> {
        let url_ = this.baseUrl + "/api/services/app/Return/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<ReturnDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReturnDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ReturnDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReturnDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ReturnDto | undefined): Observable<ReturnDto> {
        let url_ = this.baseUrl + "/api/services/app/Return/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ReturnDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReturnDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ReturnDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReturnDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Return/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ReturnDto> {
        let url_ = this.baseUrl + "/api/services/app/Return/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ReturnDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReturnDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ReturnDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReturnDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnDto>(<any>null);
    }
}

@Injectable()
export class S3ServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param key (optional) 
     * @param bucket (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadFile(key: string | null | undefined, bucket: string | null | undefined, body: Blob | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/S3/UploadFile?";
        if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&"; 
        if (bucket !== undefined)
            url_ += "bucket=" + encodeURIComponent("" + bucket) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "multipart/form-data", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFile(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processUploadFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadImage(body: UploadImageInputDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/S3/UploadImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadImage(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processUploadImage(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class SalesOrderNotificationsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    notify(body: SalesOrderNotificationRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SalesOrderNotifications/Notify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotify(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotify(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processNotify(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    test(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SalesOrderNotifications/Test";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ShipmentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ShipmentCreateDto | undefined): Observable<ShipmentDto> {
        let url_ = this.baseUrl + "/api/services/app/Shipment/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<ShipmentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShipmentDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ShipmentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShipmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShipmentDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createShipmentProcess(body: ShipmentCreateDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Shipment/CreateShipmentProcess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateShipmentProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateShipmentProcess(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateShipmentProcess(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkOrdersAvailableToShip(body: number[] | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Shipment/CheckOrdersAvailableToShip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckOrdersAvailableToShip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckOrdersAvailableToShip(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCheckOrdersAvailableToShip(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    finalize(body: ShipmentRegisterRequest | undefined): Observable<ShipmentDto> {
        let url_ = this.baseUrl + "/api/services/app/Shipment/Finalize";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalize(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalize(<any>response_);
                } catch (e) {
                    return <Observable<ShipmentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShipmentDto>><any>_observableThrow(response_);
        }));
    }

    protected processFinalize(response: HttpResponseBase): Observable<ShipmentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShipmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShipmentDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    partialSave(body: ShipmentRegisterRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Shipment/PartialSave";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartialSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartialSave(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPartialSave(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ShipmentDto> {
        let url_ = this.baseUrl + "/api/services/app/Shipment/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ShipmentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShipmentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ShipmentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShipmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShipmentDto>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getCsv(filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Shipment/GetCsv?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCsv(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetCsv(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param carrierId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getCsvShipmentsCount(carrierId: number | null | undefined, dateFrom: moment.Moment | null | undefined, dateTo: moment.Moment | null | undefined, filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Shipment/GetCsvShipmentsCount?";
        if (carrierId !== undefined)
            url_ += "CarrierId=" + encodeURIComponent("" + carrierId) + "&"; 
        if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&"; 
        if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&"; 
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCsvShipmentsCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCsvShipmentsCount(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetCsvShipmentsCount(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getCsvCompleteShipmentOrderSku(filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Shipment/GetCsvCompleteShipmentOrderSku?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCsvCompleteShipmentOrderSku(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCsvCompleteShipmentOrderSku(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetCsvCompleteShipmentOrderSku(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param shipmentId (optional) 
     * @return Success
     */
    getShipmentResume(shipmentId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Shipment/GetShipmentResume?";
        if (shipmentId === null)
            throw new Error("The parameter 'shipmentId' cannot be null.");
        else if (shipmentId !== undefined)
            url_ += "shipmentId=" + encodeURIComponent("" + shipmentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShipmentResume(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShipmentResume(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetShipmentResume(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param shipmentId (optional) 
     * @param countryCode (optional) 
     * @return Success
     */
    getShipmentResumeInner(shipmentId: number | undefined, countryCode: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Shipment/GetShipmentResumeInner?";
        if (shipmentId === null)
            throw new Error("The parameter 'shipmentId' cannot be null.");
        else if (shipmentId !== undefined)
            url_ += "shipmentId=" + encodeURIComponent("" + shipmentId) + "&"; 
        if (countryCode !== undefined)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShipmentResumeInner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShipmentResumeInner(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetShipmentResumeInner(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ShipmentCreateDto | undefined): Observable<ShipmentDto> {
        let url_ = this.baseUrl + "/api/services/app/Shipment/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ShipmentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShipmentDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ShipmentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShipmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShipmentDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Shipment/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ShipmentDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Shipment/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ShipmentDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShipmentDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ShipmentDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShipmentDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShipmentDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class ShippingTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param shippingTypeId (optional) 
     * @param deliveryScheduleId (optional) 
     * @return Success
     */
    addDeliverySchedule(shippingTypeId: number | undefined, deliveryScheduleId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ShippingType/AddDeliverySchedule?";
        if (shippingTypeId === null)
            throw new Error("The parameter 'shippingTypeId' cannot be null.");
        else if (shippingTypeId !== undefined)
            url_ += "shippingTypeId=" + encodeURIComponent("" + shippingTypeId) + "&"; 
        if (deliveryScheduleId === null)
            throw new Error("The parameter 'deliveryScheduleId' cannot be null.");
        else if (deliveryScheduleId !== undefined)
            url_ += "deliveryScheduleId=" + encodeURIComponent("" + deliveryScheduleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDeliverySchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDeliverySchedule(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAddDeliverySchedule(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param shippingTypeId (optional) 
     * @return Success
     */
    getDeliverySchedules(shippingTypeId: number | undefined): Observable<DeliveryScheduleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ShippingType/GetDeliverySchedules?";
        if (shippingTypeId === null)
            throw new Error("The parameter 'shippingTypeId' cannot be null.");
        else if (shippingTypeId !== undefined)
            url_ += "shippingTypeId=" + encodeURIComponent("" + shippingTypeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliverySchedules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliverySchedules(<any>response_);
                } catch (e) {
                    return <Observable<DeliveryScheduleDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DeliveryScheduleDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDeliverySchedules(response: HttpResponseBase): Observable<DeliveryScheduleDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DeliveryScheduleDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryScheduleDto[]>(<any>null);
    }

    /**
     * @param shippingTypeId (optional) 
     * @param deliveryScheduleId (optional) 
     * @return Success
     */
    deleteDeliverySchedule(shippingTypeId: number | undefined, deliveryScheduleId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ShippingType/DeleteDeliverySchedule?";
        if (shippingTypeId === null)
            throw new Error("The parameter 'shippingTypeId' cannot be null.");
        else if (shippingTypeId !== undefined)
            url_ += "shippingTypeId=" + encodeURIComponent("" + shippingTypeId) + "&"; 
        if (deliveryScheduleId === null)
            throw new Error("The parameter 'deliveryScheduleId' cannot be null.");
        else if (deliveryScheduleId !== undefined)
            url_ += "deliveryScheduleId=" + encodeURIComponent("" + deliveryScheduleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDeliverySchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDeliverySchedule(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteDeliverySchedule(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param countryCode (optional) 
     * @return Success
     */
    getShippingTypeForCountry(countryCode: string | null | undefined): Observable<ShippingTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ShippingType/GetShippingTypeForCountry?";
        if (countryCode !== undefined)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShippingTypeForCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShippingTypeForCountry(<any>response_);
                } catch (e) {
                    return <Observable<ShippingTypeDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShippingTypeDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetShippingTypeForCountry(response: HttpResponseBase): Observable<ShippingTypeDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ShippingTypeDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShippingTypeDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ShippingTypeDto | undefined): Observable<ShippingTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/ShippingType/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<ShippingTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShippingTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ShippingTypeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShippingTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShippingTypeDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ShippingTypeDto | undefined): Observable<ShippingTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/ShippingType/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ShippingTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShippingTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ShippingTypeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShippingTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShippingTypeDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ShippingType/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ShippingTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/ShippingType/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ShippingTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShippingTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ShippingTypeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShippingTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShippingTypeDto>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ShippingTypeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ShippingType/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ShippingTypeDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShippingTypeDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ShippingTypeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShippingTypeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShippingTypeDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class ShippingTypeGroupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ShippingTypeGroupDto | undefined): Observable<ShippingTypeGroupDto> {
        let url_ = this.baseUrl + "/api/services/app/ShippingTypeGroup/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<ShippingTypeGroupDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShippingTypeGroupDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ShippingTypeGroupDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShippingTypeGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShippingTypeGroupDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ShippingTypeGroupDto | undefined): Observable<ShippingTypeGroupDto> {
        let url_ = this.baseUrl + "/api/services/app/ShippingTypeGroup/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ShippingTypeGroupDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShippingTypeGroupDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ShippingTypeGroupDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShippingTypeGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShippingTypeGroupDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ShippingTypeGroup/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ShippingTypeGroupDto> {
        let url_ = this.baseUrl + "/api/services/app/ShippingTypeGroup/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ShippingTypeGroupDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShippingTypeGroupDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ShippingTypeGroupDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShippingTypeGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShippingTypeGroupDto>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ShippingTypeGroupDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ShippingTypeGroup/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ShippingTypeGroupDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShippingTypeGroupDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ShippingTypeGroupDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShippingTypeGroupDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShippingTypeGroupDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class ShippingTypeMappingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ShippingTypeMappingDto | undefined): Observable<ShippingTypeMappingDto> {
        let url_ = this.baseUrl + "/api/services/app/ShippingTypeMapping/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<ShippingTypeMappingDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShippingTypeMappingDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ShippingTypeMappingDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShippingTypeMappingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShippingTypeMappingDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ShippingTypeMappingDto | undefined): Observable<ShippingTypeMappingDto> {
        let url_ = this.baseUrl + "/api/services/app/ShippingTypeMapping/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ShippingTypeMappingDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShippingTypeMappingDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ShippingTypeMappingDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShippingTypeMappingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShippingTypeMappingDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ShippingTypeMapping/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ShippingTypeMappingDto> {
        let url_ = this.baseUrl + "/api/services/app/ShippingTypeMapping/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ShippingTypeMappingDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShippingTypeMappingDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ShippingTypeMappingDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShippingTypeMappingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShippingTypeMappingDto>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ShippingTypeMappingDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ShippingTypeMapping/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ShippingTypeMappingDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShippingTypeMappingDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ShippingTypeMappingDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShippingTypeMappingDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShippingTypeMappingDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class SmartQuickServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createServicee(body: Order | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SmartQuick/CreateServicee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateServicee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateServicee(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateServicee(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createServicesFromShipment(body: ShipmentDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SmartQuick/CreateServicesFromShipment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateServicesFromShipment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateServicesFromShipment(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateServicesFromShipment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class StateServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<StateDto> {
        let url_ = this.baseUrl + "/api/services/app/State/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<StateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StateDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<StateDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StateDto>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StateDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/State/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<StateDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StateDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<StateDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StateDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StateDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class StoreAssignationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param orderId (optional) 
     * @param skus (optional) 
     * @param assignationDate (optional) 
     * @return Success
     */
    get(orderId: number | undefined, skus: string[] | null | undefined, assignationDate: string | null | undefined): Observable<StoreDistanceAndStockDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StoreAssignation/Get?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        if (skus !== undefined)
            skus && skus.forEach(item => { url_ += "skus=" + encodeURIComponent("" + item) + "&"; });
        if (assignationDate !== undefined)
            url_ += "assignationDate=" + encodeURIComponent("" + assignationDate) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<StoreDistanceAndStockDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<StoreDistanceAndStockDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<StoreDistanceAndStockDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StoreDistanceAndStockDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StoreDistanceAndStockDto[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    normalizarSku(input: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/StoreAssignation/NormalizarSku?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNormalizarSku(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNormalizarSku(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processNormalizarSku(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param destinationStoreCode (optional) 
     * @param skus (optional) 
     * @return Success
     */
    getByStore(destinationStoreCode: string | null | undefined, skus: string[] | null | undefined): Observable<StoreDistanceAndStockDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StoreAssignation/GetByStore?";
        if (destinationStoreCode !== undefined)
            url_ += "destinationStoreCode=" + encodeURIComponent("" + destinationStoreCode) + "&"; 
        if (skus !== undefined)
            skus && skus.forEach(item => { url_ += "skus=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByStore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByStore(<any>response_);
                } catch (e) {
                    return <Observable<StoreDistanceAndStockDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<StoreDistanceAndStockDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetByStore(response: HttpResponseBase): Observable<StoreDistanceAndStockDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StoreDistanceAndStockDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StoreDistanceAndStockDto[]>(<any>null);
    }
}

@Injectable()
export class StorePostalCodesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadCsv(body: UploadStorePostalCodesRequestDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/StorePostalCodes/UploadCsv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadCsv(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUploadCsv(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: StorePostalCodeDto | undefined): Observable<StorePostalCodeDto> {
        let url_ = this.baseUrl + "/api/services/app/StorePostalCodes/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<StorePostalCodeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StorePostalCodeDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<StorePostalCodeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StorePostalCodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StorePostalCodeDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: StorePostalCodeDto | undefined): Observable<StorePostalCodeDto> {
        let url_ = this.baseUrl + "/api/services/app/StorePostalCodes/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<StorePostalCodeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StorePostalCodeDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<StorePostalCodeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StorePostalCodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StorePostalCodeDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StorePostalCodes/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<StorePostalCodeDto> {
        let url_ = this.baseUrl + "/api/services/app/StorePostalCodes/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<StorePostalCodeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StorePostalCodeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<StorePostalCodeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StorePostalCodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StorePostalCodeDto>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StorePostalCodeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StorePostalCodes/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<StorePostalCodeDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StorePostalCodeDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<StorePostalCodeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StorePostalCodeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StorePostalCodeDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class TransferServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    acceptSapTransfers(body: SapTransfersDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Transfer/AcceptSapTransfers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptSapTransfers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptSapTransfers(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processAcceptSapTransfers(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @param trxSrcCode (optional) 
     * @return Success
     */
    createTransferRequest(orderId: number | undefined, trxSrcCode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transfer/CreateTransferRequest?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        if (trxSrcCode !== undefined)
            url_ += "trxSrcCode=" + encodeURIComponent("" + trxSrcCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTransferRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTransferRequest(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateTransferRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    completeTransferRequests(body: TransferRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transfer/CompleteTransferRequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteTransferRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteTransferRequests(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCompleteTransferRequests(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createSupplyingRequest(body: SupplyingOrderDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transfer/CreateSupplyingRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSupplyingRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSupplyingRequest(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateSupplyingRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTransfers(body: CreateTransfersDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Transfer/CreateTransfers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTransfers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTransfers(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateTransfers(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTransferOrderInfo(id: number | undefined): Observable<TransferOrderInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/Transfer/GetTransferOrderInfo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransferOrderInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransferOrderInfo(<any>response_);
                } catch (e) {
                    return <Observable<TransferOrderInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TransferOrderInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTransferOrderInfo(response: HttpResponseBase): Observable<TransferOrderInfoDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransferOrderInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransferOrderInfoDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: TransferRequestDto | undefined): Observable<TransferRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/Transfer/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<TransferRequestDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TransferRequestDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TransferRequestDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransferRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransferRequestDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TransferRequestDto | undefined): Observable<TransferRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/Transfer/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<TransferRequestDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TransferRequestDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TransferRequestDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransferRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransferRequestDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transfer/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TransferRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/Transfer/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<TransferRequestDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TransferRequestDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TransferRequestDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransferRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransferRequestDto>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TransferRequestDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Transfer/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<TransferRequestDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TransferRequestDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TransferRequestDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransferRequestDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransferRequestDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class VtexServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param vtexAccountId (optional) 
     * @return Success
     */
    disableListening(vtexAccountId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Vtex/DisableListening?";
        if (vtexAccountId === null)
            throw new Error("The parameter 'vtexAccountId' cannot be null.");
        else if (vtexAccountId !== undefined)
            url_ += "vtexAccountId=" + encodeURIComponent("" + vtexAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableListening(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableListening(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDisableListening(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param vtexAccountId (optional) 
     * @return Success
     */
    enableListening(vtexAccountId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Vtex/EnableListening?";
        if (vtexAccountId === null)
            throw new Error("The parameter 'vtexAccountId' cannot be null.");
        else if (vtexAccountId !== undefined)
            url_ += "vtexAccountId=" + encodeURIComponent("" + vtexAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnableListening(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnableListening(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processEnableListening(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getResourceAr(input: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Vtex/GetResourceAr?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetResourceAr(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResourceAr(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetResourceAr(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getResourceCo(input: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Vtex/GetResourceCo?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetResourceCo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResourceCo(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetResourceCo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: VtexAccountDto | undefined): Observable<VtexAccountDto> {
        let url_ = this.baseUrl + "/api/services/app/Vtex/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<VtexAccountDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VtexAccountDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<VtexAccountDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VtexAccountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VtexAccountDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: VtexAccountDto | undefined): Observable<VtexAccountDto> {
        let url_ = this.baseUrl + "/api/services/app/Vtex/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<VtexAccountDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VtexAccountDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<VtexAccountDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VtexAccountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VtexAccountDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Vtex/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<VtexAccountDto> {
        let url_ = this.baseUrl + "/api/services/app/Vtex/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<VtexAccountDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VtexAccountDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<VtexAccountDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VtexAccountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VtexAccountDto>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<VtexAccountDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Vtex/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<VtexAccountDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VtexAccountDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<VtexAccountDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VtexAccountDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VtexAccountDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class ZohoStadisticUrlServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ZohoStadisticUrlDto> {
        let url_ = this.baseUrl + "/api/services/app/ZohoStadisticUrl/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ZohoStadisticUrlDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ZohoStadisticUrlDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ZohoStadisticUrlDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZohoStadisticUrlDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ZohoStadisticUrlDto>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ZohoStadisticUrlDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ZohoStadisticUrl/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ZohoStadisticUrlDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ZohoStadisticUrlDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ZohoStadisticUrlDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZohoStadisticUrlDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ZohoStadisticUrlDtoPagedResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ZohoStadisticUrlDto | undefined): Observable<ZohoStadisticUrlDto> {
        let url_ = this.baseUrl + "/api/services/app/ZohoStadisticUrl/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<ZohoStadisticUrlDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ZohoStadisticUrlDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ZohoStadisticUrlDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZohoStadisticUrlDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ZohoStadisticUrlDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ZohoStadisticUrlDto | undefined): Observable<ZohoStadisticUrlDto> {
        let url_ = this.baseUrl + "/api/services/app/ZohoStadisticUrl/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ZohoStadisticUrlDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ZohoStadisticUrlDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ZohoStadisticUrlDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZohoStadisticUrlDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ZohoStadisticUrlDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ZohoStadisticUrl/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class WebhookServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    zubale(body: ZubaleNotificationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/webhook/Zubale";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processZubale(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processZubale(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processZubale(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ZubaleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDeliveryOrders(body: CreateDeliveryOrdersDto | undefined): Observable<CreateDeliveryOrderResponseModel[]> {
        let url_ = this.baseUrl + "/api/services/app/Zubale/CreateDeliveryOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDeliveryOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDeliveryOrders(<any>response_);
                } catch (e) {
                    return <Observable<CreateDeliveryOrderResponseModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateDeliveryOrderResponseModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processCreateDeliveryOrders(response: HttpResponseBase): Observable<CreateDeliveryOrderResponseModel[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CreateDeliveryOrderResponseModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateDeliveryOrderResponseModel[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    notification(body: ZubaleNotificationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Zubale/Notification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotification(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ZubaleNotificationDto | undefined): Observable<ZubaleNotificationDto> {
        let url_ = this.baseUrl + "/api/services/app/Zubale/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<ZubaleNotificationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ZubaleNotificationDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ZubaleNotificationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZubaleNotificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ZubaleNotificationDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ZubaleNotificationDto | undefined): Observable<ZubaleNotificationDto> {
        let url_ = this.baseUrl + "/api/services/app/Zubale/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ZubaleNotificationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ZubaleNotificationDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ZubaleNotificationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZubaleNotificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ZubaleNotificationDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Zubale/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ZubaleNotificationDto> {
        let url_ = this.baseUrl + "/api/services/app/Zubale/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ZubaleNotificationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ZubaleNotificationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ZubaleNotificationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZubaleNotificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ZubaleNotificationDto>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filters: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ZubaleNotificationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Zubale/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ZubaleNotificationDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ZubaleNotificationDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ZubaleNotificationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZubaleNotificationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ZubaleNotificationDtoPagedResultDto>(<any>null);
    }
}

export class UploadBinDto implements IUploadBinDto {
    url: string | undefined;
    countryCode: string | undefined;

    constructor(data?: IUploadBinDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.countryCode = _data["countryCode"];
        }
    }

    static fromJS(data: any): UploadBinDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadBinDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["countryCode"] = this.countryCode;
        return data; 
    }

    clone(): UploadBinDto {
        const json = this.toJSON();
        let result = new UploadBinDto();
        result.init(json);
        return result;
    }
}

export interface IUploadBinDto {
    url: string | undefined;
    countryCode: string | undefined;
}

export class BinDto implements IBinDto {
    binCode: string | undefined;
    creditCardCompany: string | undefined;
    bank: string | undefined;
    id: number;

    constructor(data?: IBinDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.binCode = _data["binCode"];
            this.creditCardCompany = _data["creditCardCompany"];
            this.bank = _data["bank"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BinDto {
        data = typeof data === 'object' ? data : {};
        let result = new BinDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["binCode"] = this.binCode;
        data["creditCardCompany"] = this.creditCardCompany;
        data["bank"] = this.bank;
        data["id"] = this.id;
        return data; 
    }

    clone(): BinDto {
        const json = this.toJSON();
        let result = new BinDto();
        result.init(json);
        return result;
    }
}

export interface IBinDto {
    binCode: string | undefined;
    creditCardCompany: string | undefined;
    bank: string | undefined;
    id: number;
}

export class BinDtoPagedResultDto implements IBinDtoPagedResultDto {
    totalCount: number;
    items: BinDto[] | undefined;

    constructor(data?: IBinDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(BinDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BinDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BinDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): BinDtoPagedResultDto {
        const json = this.toJSON();
        let result = new BinDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IBinDtoPagedResultDto {
    totalCount: number;
    items: BinDto[] | undefined;
}

export class CabifySendOrderRequest implements ICabifySendOrderRequest {
    orderIds: number[] | undefined;
    pickingGroupId: number | undefined;
    countryCode: string | undefined;

    constructor(data?: ICabifySendOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orderIds"])) {
                this.orderIds = [] as any;
                for (let item of _data["orderIds"])
                    this.orderIds.push(item);
            }
            this.pickingGroupId = _data["pickingGroupId"];
            this.countryCode = _data["countryCode"];
        }
    }

    static fromJS(data: any): CabifySendOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CabifySendOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderIds)) {
            data["orderIds"] = [];
            for (let item of this.orderIds)
                data["orderIds"].push(item);
        }
        data["pickingGroupId"] = this.pickingGroupId;
        data["countryCode"] = this.countryCode;
        return data; 
    }

    clone(): CabifySendOrderRequest {
        const json = this.toJSON();
        let result = new CabifySendOrderRequest();
        result.init(json);
        return result;
    }
}

export interface ICabifySendOrderRequest {
    orderIds: number[] | undefined;
    pickingGroupId: number | undefined;
    countryCode: string | undefined;
}

export class CabifyNotificationDto implements ICabifyNotificationDto {
    id: string;
    orderId: string | undefined;
    eventTime: moment.Moment;
    state: string | undefined;
    failureReason: string | undefined;

    constructor(data?: ICabifyNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.eventTime = _data["eventTime"] ? moment(_data["eventTime"].toString()) : <any>undefined;
            this.state = _data["state"];
            this.failureReason = _data["failureReason"];
        }
    }

    static fromJS(data: any): CabifyNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CabifyNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["eventTime"] = this.eventTime ? this.eventTime.toISOString() : <any>undefined;
        data["state"] = this.state;
        data["failureReason"] = this.failureReason;
        return data; 
    }

    clone(): CabifyNotificationDto {
        const json = this.toJSON();
        let result = new CabifyNotificationDto();
        result.init(json);
        return result;
    }
}

export interface ICabifyNotificationDto {
    id: string;
    orderId: string | undefined;
    eventTime: moment.Moment;
    state: string | undefined;
    failureReason: string | undefined;
}

export class CabifyOrderDto implements ICabifyOrderDto {
    parcelId: string | undefined;
    orderId: number;
    status: string | undefined;
    request: string | undefined;
    response: string | undefined;
    pickingGroupId: number | undefined;
    trackingUrl: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICabifyOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parcelId = _data["parcelId"];
            this.orderId = _data["orderId"];
            this.status = _data["status"];
            this.request = _data["request"];
            this.response = _data["response"];
            this.pickingGroupId = _data["pickingGroupId"];
            this.trackingUrl = _data["trackingUrl"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CabifyOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new CabifyOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parcelId"] = this.parcelId;
        data["orderId"] = this.orderId;
        data["status"] = this.status;
        data["request"] = this.request;
        data["response"] = this.response;
        data["pickingGroupId"] = this.pickingGroupId;
        data["trackingUrl"] = this.trackingUrl;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): CabifyOrderDto {
        const json = this.toJSON();
        let result = new CabifyOrderDto();
        result.init(json);
        return result;
    }
}

export interface ICabifyOrderDto {
    parcelId: string | undefined;
    orderId: number;
    status: string | undefined;
    request: string | undefined;
    response: string | undefined;
    pickingGroupId: number | undefined;
    trackingUrl: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CabifyOrderDtoPagedResultDto implements ICabifyOrderDtoPagedResultDto {
    totalCount: number;
    items: CabifyOrderDto[] | undefined;

    constructor(data?: ICabifyOrderDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CabifyOrderDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CabifyOrderDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CabifyOrderDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CabifyOrderDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CabifyOrderDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICabifyOrderDtoPagedResultDto {
    totalCount: number;
    items: CabifyOrderDto[] | undefined;
}

export class StoreCarrierDto implements IStoreCarrierDto {
    carrierId: number;
    storeCode: string | undefined;
    id: number;

    constructor(data?: IStoreCarrierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.carrierId = _data["carrierId"];
            this.storeCode = _data["storeCode"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StoreCarrierDto {
        data = typeof data === 'object' ? data : {};
        let result = new StoreCarrierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["carrierId"] = this.carrierId;
        data["storeCode"] = this.storeCode;
        data["id"] = this.id;
        return data; 
    }

    clone(): StoreCarrierDto {
        const json = this.toJSON();
        let result = new StoreCarrierDto();
        result.init(json);
        return result;
    }
}

export interface IStoreCarrierDto {
    carrierId: number;
    storeCode: string | undefined;
    id: number;
}

export class CarrierDto implements ICarrierDto {
    shippingTypeGroupId: number | undefined;
    shippingTypeGroupName: string | undefined;
    stores: StoreCarrierDto[] | undefined;
    apiToken: string | undefined;
    carrierGroup: string | undefined;
    name: string | undefined;
    description: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICarrierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shippingTypeGroupId = _data["shippingTypeGroupId"];
            this.shippingTypeGroupName = _data["shippingTypeGroupName"];
            if (Array.isArray(_data["stores"])) {
                this.stores = [] as any;
                for (let item of _data["stores"])
                    this.stores.push(StoreCarrierDto.fromJS(item));
            }
            this.apiToken = _data["apiToken"];
            this.carrierGroup = _data["carrierGroup"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CarrierDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shippingTypeGroupId"] = this.shippingTypeGroupId;
        data["shippingTypeGroupName"] = this.shippingTypeGroupName;
        if (Array.isArray(this.stores)) {
            data["stores"] = [];
            for (let item of this.stores)
                data["stores"].push(item.toJSON());
        }
        data["apiToken"] = this.apiToken;
        data["carrierGroup"] = this.carrierGroup;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): CarrierDto {
        const json = this.toJSON();
        let result = new CarrierDto();
        result.init(json);
        return result;
    }
}

export interface ICarrierDto {
    shippingTypeGroupId: number | undefined;
    shippingTypeGroupName: string | undefined;
    stores: StoreCarrierDto[] | undefined;
    apiToken: string | undefined;
    carrierGroup: string | undefined;
    name: string | undefined;
    description: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CarrierDtoPagedResultDto implements ICarrierDtoPagedResultDto {
    totalCount: number;
    items: CarrierDto[] | undefined;

    constructor(data?: ICarrierDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CarrierDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CarrierDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CarrierDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CarrierDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICarrierDtoPagedResultDto {
    totalCount: number;
    items: CarrierDto[] | undefined;
}

export class CarrierDriverDto implements ICarrierDriverDto {
    name: string | undefined;
    carrierId: number;
    carrier: CarrierDto;
    userId: number | undefined;
    isActive: boolean;
    id: number;

    constructor(data?: ICarrierDriverDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.carrierId = _data["carrierId"];
            this.carrier = _data["carrier"] ? CarrierDto.fromJS(_data["carrier"]) : <any>undefined;
            this.userId = _data["userId"];
            this.isActive = _data["isActive"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CarrierDriverDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierDriverDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["carrierId"] = this.carrierId;
        data["carrier"] = this.carrier ? this.carrier.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }

    clone(): CarrierDriverDto {
        const json = this.toJSON();
        let result = new CarrierDriverDto();
        result.init(json);
        return result;
    }
}

export interface ICarrierDriverDto {
    name: string | undefined;
    carrierId: number;
    carrier: CarrierDto;
    userId: number | undefined;
    isActive: boolean;
    id: number;
}

export class CarrierDriverDtoPagedResultDto implements ICarrierDriverDtoPagedResultDto {
    totalCount: number;
    items: CarrierDriverDto[] | undefined;

    constructor(data?: ICarrierDriverDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CarrierDriverDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CarrierDriverDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierDriverDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CarrierDriverDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CarrierDriverDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICarrierDriverDtoPagedResultDto {
    totalCount: number;
    items: CarrierDriverDto[] | undefined;
}

export class DistrictDto implements IDistrictDto {
    name: string | undefined;
    flashPostalCodes: string[] | undefined;
    cityId: number;
    countryCode: string | undefined;
    id: number;

    constructor(data?: IDistrictDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["flashPostalCodes"])) {
                this.flashPostalCodes = [] as any;
                for (let item of _data["flashPostalCodes"])
                    this.flashPostalCodes.push(item);
            }
            this.cityId = _data["cityId"];
            this.countryCode = _data["countryCode"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DistrictDto {
        data = typeof data === 'object' ? data : {};
        let result = new DistrictDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.flashPostalCodes)) {
            data["flashPostalCodes"] = [];
            for (let item of this.flashPostalCodes)
                data["flashPostalCodes"].push(item);
        }
        data["cityId"] = this.cityId;
        data["countryCode"] = this.countryCode;
        data["id"] = this.id;
        return data; 
    }

    clone(): DistrictDto {
        const json = this.toJSON();
        let result = new DistrictDto();
        result.init(json);
        return result;
    }
}

export interface IDistrictDto {
    name: string | undefined;
    flashPostalCodes: string[] | undefined;
    cityId: number;
    countryCode: string | undefined;
    id: number;
}

export class CityDto implements ICityDto {
    name: string | undefined;
    postalCode: string | undefined;
    stateId: number;
    districts: DistrictDto[] | undefined;
    acceptsFlashShipments: boolean;
    countryCode: string | undefined;
    id: number;

    constructor(data?: ICityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.postalCode = _data["postalCode"];
            this.stateId = _data["stateId"];
            if (Array.isArray(_data["districts"])) {
                this.districts = [] as any;
                for (let item of _data["districts"])
                    this.districts.push(DistrictDto.fromJS(item));
            }
            this.acceptsFlashShipments = _data["acceptsFlashShipments"];
            this.countryCode = _data["countryCode"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["postalCode"] = this.postalCode;
        data["stateId"] = this.stateId;
        if (Array.isArray(this.districts)) {
            data["districts"] = [];
            for (let item of this.districts)
                data["districts"].push(item.toJSON());
        }
        data["acceptsFlashShipments"] = this.acceptsFlashShipments;
        data["countryCode"] = this.countryCode;
        data["id"] = this.id;
        return data; 
    }

    clone(): CityDto {
        const json = this.toJSON();
        let result = new CityDto();
        result.init(json);
        return result;
    }
}

export interface ICityDto {
    name: string | undefined;
    postalCode: string | undefined;
    stateId: number;
    districts: DistrictDto[] | undefined;
    acceptsFlashShipments: boolean;
    countryCode: string | undefined;
    id: number;
}

export class CityDtoPagedResultDto implements ICityDtoPagedResultDto {
    totalCount: number;
    items: CityDto[] | undefined;

    constructor(data?: ICityDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CityDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CityDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CityDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CityDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICityDtoPagedResultDto {
    totalCount: number;
    items: CityDto[] | undefined;
}

export class ReturnOrderRequest implements IReturnOrderRequest {
    orderId: number;
    description: string | undefined;
    creationTime: moment.Moment | undefined;
    withdrawTime: moment.Moment | undefined;
    dispatchDate: moment.Moment | undefined;
    dispatchTag: string | undefined;

    constructor(data?: IReturnOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.description = _data["description"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : <any>undefined;
            this.dispatchDate = _data["dispatchDate"] ? moment(_data["dispatchDate"].toString()) : <any>undefined;
            this.dispatchTag = _data["dispatchTag"];
        }
    }

    static fromJS(data: any): ReturnOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReturnOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["description"] = this.description;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : <any>undefined;
        data["dispatchDate"] = this.dispatchDate ? this.dispatchDate.toISOString() : <any>undefined;
        data["dispatchTag"] = this.dispatchTag;
        return data; 
    }

    clone(): ReturnOrderRequest {
        const json = this.toJSON();
        let result = new ReturnOrderRequest();
        result.init(json);
        return result;
    }
}

export interface IReturnOrderRequest {
    orderId: number;
    description: string | undefined;
    creationTime: moment.Moment | undefined;
    withdrawTime: moment.Moment | undefined;
    dispatchDate: moment.Moment | undefined;
    dispatchTag: string | undefined;
}

export class PartialDeliveryFailOrderItem implements IPartialDeliveryFailOrderItem {
    id: number;
    sku: string | undefined;
    description: string | undefined;
    quantity: number;
    claimedQuantity: number;
    netAmount: number;
    deliveryIssue: string | undefined;
    observations: string | undefined;
    skuClaimAction: string | undefined;
    isPromotion: boolean;
    promotionId: number | undefined;

    constructor(data?: IPartialDeliveryFailOrderItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sku = _data["sku"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.claimedQuantity = _data["claimedQuantity"];
            this.netAmount = _data["netAmount"];
            this.deliveryIssue = _data["deliveryIssue"];
            this.observations = _data["observations"];
            this.skuClaimAction = _data["skuClaimAction"];
            this.isPromotion = _data["isPromotion"];
            this.promotionId = _data["promotionId"];
        }
    }

    static fromJS(data: any): PartialDeliveryFailOrderItem {
        data = typeof data === 'object' ? data : {};
        let result = new PartialDeliveryFailOrderItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sku"] = this.sku;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["claimedQuantity"] = this.claimedQuantity;
        data["netAmount"] = this.netAmount;
        data["deliveryIssue"] = this.deliveryIssue;
        data["observations"] = this.observations;
        data["skuClaimAction"] = this.skuClaimAction;
        data["isPromotion"] = this.isPromotion;
        data["promotionId"] = this.promotionId;
        return data; 
    }

    clone(): PartialDeliveryFailOrderItem {
        const json = this.toJSON();
        let result = new PartialDeliveryFailOrderItem();
        result.init(json);
        return result;
    }
}

export interface IPartialDeliveryFailOrderItem {
    id: number;
    sku: string | undefined;
    description: string | undefined;
    quantity: number;
    claimedQuantity: number;
    netAmount: number;
    deliveryIssue: string | undefined;
    observations: string | undefined;
    skuClaimAction: string | undefined;
    isPromotion: boolean;
    promotionId: number | undefined;
}

export class PartialReturnRequest implements IPartialReturnRequest {
    orderItems: PartialDeliveryFailOrderItem[] | undefined;
    orderId: number;
    description: string | undefined;
    creationTime: moment.Moment | undefined;
    withdrawTime: moment.Moment | undefined;
    dispatchDate: moment.Moment | undefined;
    dispatchTag: string | undefined;

    constructor(data?: IPartialReturnRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems.push(PartialDeliveryFailOrderItem.fromJS(item));
            }
            this.orderId = _data["orderId"];
            this.description = _data["description"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : <any>undefined;
            this.dispatchDate = _data["dispatchDate"] ? moment(_data["dispatchDate"].toString()) : <any>undefined;
            this.dispatchTag = _data["dispatchTag"];
        }
    }

    static fromJS(data: any): PartialReturnRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PartialReturnRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        data["orderId"] = this.orderId;
        data["description"] = this.description;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : <any>undefined;
        data["dispatchDate"] = this.dispatchDate ? this.dispatchDate.toISOString() : <any>undefined;
        data["dispatchTag"] = this.dispatchTag;
        return data; 
    }

    clone(): PartialReturnRequest {
        const json = this.toJSON();
        let result = new PartialReturnRequest();
        result.init(json);
        return result;
    }
}

export interface IPartialReturnRequest {
    orderItems: PartialDeliveryFailOrderItem[] | undefined;
    orderId: number;
    description: string | undefined;
    creationTime: moment.Moment | undefined;
    withdrawTime: moment.Moment | undefined;
    dispatchDate: moment.Moment | undefined;
    dispatchTag: string | undefined;
}

export class TotalDeliveryFailRequest implements ITotalDeliveryFailRequest {
    orderClaimAction: string;
    orderId: number;
    description: string | undefined;
    creationTime: moment.Moment | undefined;
    withdrawTime: moment.Moment | undefined;
    dispatchDate: moment.Moment | undefined;
    dispatchTag: string | undefined;

    constructor(data?: ITotalDeliveryFailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderClaimAction = _data["orderClaimAction"];
            this.orderId = _data["orderId"];
            this.description = _data["description"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : <any>undefined;
            this.dispatchDate = _data["dispatchDate"] ? moment(_data["dispatchDate"].toString()) : <any>undefined;
            this.dispatchTag = _data["dispatchTag"];
        }
    }

    static fromJS(data: any): TotalDeliveryFailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TotalDeliveryFailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderClaimAction"] = this.orderClaimAction;
        data["orderId"] = this.orderId;
        data["description"] = this.description;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : <any>undefined;
        data["dispatchDate"] = this.dispatchDate ? this.dispatchDate.toISOString() : <any>undefined;
        data["dispatchTag"] = this.dispatchTag;
        return data; 
    }

    clone(): TotalDeliveryFailRequest {
        const json = this.toJSON();
        let result = new TotalDeliveryFailRequest();
        result.init(json);
        return result;
    }
}

export interface ITotalDeliveryFailRequest {
    orderClaimAction: string;
    orderId: number;
    description: string | undefined;
    creationTime: moment.Moment | undefined;
    withdrawTime: moment.Moment | undefined;
    dispatchDate: moment.Moment | undefined;
    dispatchTag: string | undefined;
}

export class PartialDeliveryFailRequest implements IPartialDeliveryFailRequest {
    orderItems: PartialDeliveryFailOrderItem[] | undefined;
    orderId: number;
    description: string | undefined;
    creationTime: moment.Moment | undefined;
    withdrawTime: moment.Moment | undefined;
    dispatchDate: moment.Moment | undefined;
    dispatchTag: string | undefined;

    constructor(data?: IPartialDeliveryFailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems.push(PartialDeliveryFailOrderItem.fromJS(item));
            }
            this.orderId = _data["orderId"];
            this.description = _data["description"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : <any>undefined;
            this.dispatchDate = _data["dispatchDate"] ? moment(_data["dispatchDate"].toString()) : <any>undefined;
            this.dispatchTag = _data["dispatchTag"];
        }
    }

    static fromJS(data: any): PartialDeliveryFailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PartialDeliveryFailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        data["orderId"] = this.orderId;
        data["description"] = this.description;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : <any>undefined;
        data["dispatchDate"] = this.dispatchDate ? this.dispatchDate.toISOString() : <any>undefined;
        data["dispatchTag"] = this.dispatchTag;
        return data; 
    }

    clone(): PartialDeliveryFailRequest {
        const json = this.toJSON();
        let result = new PartialDeliveryFailRequest();
        result.init(json);
        return result;
    }
}

export interface IPartialDeliveryFailRequest {
    orderItems: PartialDeliveryFailOrderItem[] | undefined;
    orderId: number;
    description: string | undefined;
    creationTime: moment.Moment | undefined;
    withdrawTime: moment.Moment | undefined;
    dispatchDate: moment.Moment | undefined;
    dispatchTag: string | undefined;
}

export class OrderNotDeliveredRequest implements IOrderNotDeliveredRequest {
    orderClaimAction: string;
    orderId: number;
    description: string | undefined;
    creationTime: moment.Moment | undefined;
    withdrawTime: moment.Moment | undefined;
    dispatchDate: moment.Moment | undefined;
    dispatchTag: string | undefined;

    constructor(data?: IOrderNotDeliveredRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderClaimAction = _data["orderClaimAction"];
            this.orderId = _data["orderId"];
            this.description = _data["description"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : <any>undefined;
            this.dispatchDate = _data["dispatchDate"] ? moment(_data["dispatchDate"].toString()) : <any>undefined;
            this.dispatchTag = _data["dispatchTag"];
        }
    }

    static fromJS(data: any): OrderNotDeliveredRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderNotDeliveredRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderClaimAction"] = this.orderClaimAction;
        data["orderId"] = this.orderId;
        data["description"] = this.description;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : <any>undefined;
        data["dispatchDate"] = this.dispatchDate ? this.dispatchDate.toISOString() : <any>undefined;
        data["dispatchTag"] = this.dispatchTag;
        return data; 
    }

    clone(): OrderNotDeliveredRequest {
        const json = this.toJSON();
        let result = new OrderNotDeliveredRequest();
        result.init(json);
        return result;
    }
}

export interface IOrderNotDeliveredRequest {
    orderClaimAction: string;
    orderId: number;
    description: string | undefined;
    creationTime: moment.Moment | undefined;
    withdrawTime: moment.Moment | undefined;
    dispatchDate: moment.Moment | undefined;
    dispatchTag: string | undefined;
}

export class ItemReplacementRequest implements IItemReplacementRequest {
    orderItems: PartialDeliveryFailOrderItem[] | undefined;
    orderId: number;
    description: string | undefined;
    creationTime: moment.Moment | undefined;
    withdrawTime: moment.Moment | undefined;
    dispatchDate: moment.Moment | undefined;
    dispatchTag: string | undefined;

    constructor(data?: IItemReplacementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems.push(PartialDeliveryFailOrderItem.fromJS(item));
            }
            this.orderId = _data["orderId"];
            this.description = _data["description"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : <any>undefined;
            this.dispatchDate = _data["dispatchDate"] ? moment(_data["dispatchDate"].toString()) : <any>undefined;
            this.dispatchTag = _data["dispatchTag"];
        }
    }

    static fromJS(data: any): ItemReplacementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ItemReplacementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        data["orderId"] = this.orderId;
        data["description"] = this.description;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : <any>undefined;
        data["dispatchDate"] = this.dispatchDate ? this.dispatchDate.toISOString() : <any>undefined;
        data["dispatchTag"] = this.dispatchTag;
        return data; 
    }

    clone(): ItemReplacementRequest {
        const json = this.toJSON();
        let result = new ItemReplacementRequest();
        result.init(json);
        return result;
    }
}

export interface IItemReplacementRequest {
    orderItems: PartialDeliveryFailOrderItem[] | undefined;
    orderId: number;
    description: string | undefined;
    creationTime: moment.Moment | undefined;
    withdrawTime: moment.Moment | undefined;
    dispatchDate: moment.Moment | undefined;
    dispatchTag: string | undefined;
}

export class ClaimTypeDto implements IClaimTypeDto {
    id: number;
    name: string | undefined;

    constructor(data?: IClaimTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ClaimTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): ClaimTypeDto {
        const json = this.toJSON();
        let result = new ClaimTypeDto();
        result.init(json);
        return result;
    }
}

export interface IClaimTypeDto {
    id: number;
    name: string | undefined;
}

export class SourceValueDto implements ISourceValueDto {
    id: number;
    name: string | undefined;

    constructor(data?: ISourceValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SourceValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new SourceValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): SourceValueDto {
        const json = this.toJSON();
        let result = new SourceValueDto();
        result.init(json);
        return result;
    }
}

export interface ISourceValueDto {
    id: number;
    name: string | undefined;
}

export class CustomerDto implements ICustomerDto {
    code: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    documentType: string | undefined;
    documentNumber: string | undefined;
    phoneNumber: string | undefined;
    phoneNumberAlternative: string | undefined;
    email: string | undefined;
    id: number;

    constructor(data?: ICustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.documentType = _data["documentType"];
            this.documentNumber = _data["documentNumber"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberAlternative = _data["phoneNumberAlternative"];
            this.email = _data["email"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["documentType"] = this.documentType;
        data["documentNumber"] = this.documentNumber;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberAlternative"] = this.phoneNumberAlternative;
        data["email"] = this.email;
        data["id"] = this.id;
        return data; 
    }

    clone(): CustomerDto {
        const json = this.toJSON();
        let result = new CustomerDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerDto {
    code: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    documentType: string | undefined;
    documentNumber: string | undefined;
    phoneNumber: string | undefined;
    phoneNumberAlternative: string | undefined;
    email: string | undefined;
    id: number;
}

export class MovementTypeDto implements IMovementTypeDto {
    id: number;
    name: string | undefined;

    constructor(data?: IMovementTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MovementTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new MovementTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): MovementTypeDto {
        const json = this.toJSON();
        let result = new MovementTypeDto();
        result.init(json);
        return result;
    }
}

export interface IMovementTypeDto {
    id: number;
    name: string | undefined;
}

export class OrderBalanceDto implements IOrderBalanceDto {
    creationTime: moment.Moment;
    description: string | undefined;
    amount: number;
    sku: string | undefined;
    quantity: number;
    movementType: MovementTypeDto;

    constructor(data?: IOrderBalanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.amount = _data["amount"];
            this.sku = _data["sku"];
            this.quantity = _data["quantity"];
            this.movementType = _data["movementType"] ? MovementTypeDto.fromJS(_data["movementType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderBalanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderBalanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["amount"] = this.amount;
        data["sku"] = this.sku;
        data["quantity"] = this.quantity;
        data["movementType"] = this.movementType ? this.movementType.toJSON() : <any>undefined;
        return data; 
    }

    clone(): OrderBalanceDto {
        const json = this.toJSON();
        let result = new OrderBalanceDto();
        result.init(json);
        return result;
    }
}

export interface IOrderBalanceDto {
    creationTime: moment.Moment;
    description: string | undefined;
    amount: number;
    sku: string | undefined;
    quantity: number;
    movementType: MovementTypeDto;
}

export class OrderNoteDto implements IOrderNoteDto {
    readed: boolean;
    notify: boolean;
    description: string | undefined;
    orderId: number;
    creatorName: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.readed = _data["readed"];
            this.notify = _data["notify"];
            this.description = _data["description"];
            this.orderId = _data["orderId"];
            this.creatorName = _data["creatorName"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["readed"] = this.readed;
        data["notify"] = this.notify;
        data["description"] = this.description;
        data["orderId"] = this.orderId;
        data["creatorName"] = this.creatorName;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderNoteDto {
        const json = this.toJSON();
        let result = new OrderNoteDto();
        result.init(json);
        return result;
    }
}

export interface IOrderNoteDto {
    readed: boolean;
    notify: boolean;
    description: string | undefined;
    orderId: number;
    creatorName: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class EventLogDto implements IEventLogDto {
    creatorUserId: number | undefined;
    creationTime: moment.Moment;
    description: string | undefined;
    orderId: number | undefined;
    id: number;

    constructor(data?: IEventLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.orderId = _data["orderId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EventLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["orderId"] = this.orderId;
        data["id"] = this.id;
        return data; 
    }

    clone(): EventLogDto {
        const json = this.toJSON();
        let result = new EventLogDto();
        result.init(json);
        return result;
    }
}

export interface IEventLogDto {
    creatorUserId: number | undefined;
    creationTime: moment.Moment;
    description: string | undefined;
    orderId: number | undefined;
    id: number;
}

export enum SourceValue {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
    _13 = 13,
    _14 = 14,
    _15 = 15,
}

export class SourceOrderItemDto implements ISourceOrderItemDto {
    sourceName: SourceValue;
    sourceCode: string | undefined;
    sku: string | undefined;
    description: string | undefined;
    imageUrl: string | undefined;
    quantity: number;
    grossAmount: number;
    netAmount: number;
    discount: number;
    taxes: number;
    selfPurchaseFrequency: number;
    isExclusiveOnline: boolean;
    barCode: string | undefined;
    id: number;

    constructor(data?: ISourceOrderItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceName = _data["sourceName"];
            this.sourceCode = _data["sourceCode"];
            this.sku = _data["sku"];
            this.description = _data["description"];
            this.imageUrl = _data["imageUrl"];
            this.quantity = _data["quantity"];
            this.grossAmount = _data["grossAmount"];
            this.netAmount = _data["netAmount"];
            this.discount = _data["discount"];
            this.taxes = _data["taxes"];
            this.selfPurchaseFrequency = _data["selfPurchaseFrequency"];
            this.isExclusiveOnline = _data["isExclusiveOnline"];
            this.barCode = _data["barCode"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SourceOrderItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SourceOrderItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceName"] = this.sourceName;
        data["sourceCode"] = this.sourceCode;
        data["sku"] = this.sku;
        data["description"] = this.description;
        data["imageUrl"] = this.imageUrl;
        data["quantity"] = this.quantity;
        data["grossAmount"] = this.grossAmount;
        data["netAmount"] = this.netAmount;
        data["discount"] = this.discount;
        data["taxes"] = this.taxes;
        data["selfPurchaseFrequency"] = this.selfPurchaseFrequency;
        data["isExclusiveOnline"] = this.isExclusiveOnline;
        data["barCode"] = this.barCode;
        data["id"] = this.id;
        return data; 
    }

    clone(): SourceOrderItemDto {
        const json = this.toJSON();
        let result = new SourceOrderItemDto();
        result.init(json);
        return result;
    }
}

export interface ISourceOrderItemDto {
    sourceName: SourceValue;
    sourceCode: string | undefined;
    sku: string | undefined;
    description: string | undefined;
    imageUrl: string | undefined;
    quantity: number;
    grossAmount: number;
    netAmount: number;
    discount: number;
    taxes: number;
    selfPurchaseFrequency: number;
    isExclusiveOnline: boolean;
    barCode: string | undefined;
    id: number;
}

export class OrderItemDto implements IOrderItemDto {
    sourceCode: string | undefined;
    sku: string | undefined;
    description: string | undefined;
    imageUrl: string | undefined;
    quantity: number;
    quantityDelivered: number;
    quantityInConflict: number;
    grossAmount: number;
    netAmount: number;
    cancelled: boolean;
    isDeleted: boolean;
    discount: number;
    taxes: number;
    sourceOrderItemId: number | undefined;
    selfPurchaseFrequency: number;
    isExclusiveOnline: boolean;
    isPromotion: boolean;
    promotionId: number | undefined;
    promotion: OrderItemDto;
    barCode: string | undefined;
    supplierCatalogNumber: string | undefined;
    stock: number;
    notInventory: boolean;
    id: number;

    constructor(data?: IOrderItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceCode = _data["sourceCode"];
            this.sku = _data["sku"];
            this.description = _data["description"];
            this.imageUrl = _data["imageUrl"];
            this.quantity = _data["quantity"];
            this.quantityDelivered = _data["quantityDelivered"];
            this.quantityInConflict = _data["quantityInConflict"];
            this.grossAmount = _data["grossAmount"];
            this.netAmount = _data["netAmount"];
            this.cancelled = _data["cancelled"];
            this.isDeleted = _data["isDeleted"];
            this.discount = _data["discount"];
            this.taxes = _data["taxes"];
            this.sourceOrderItemId = _data["sourceOrderItemId"];
            this.selfPurchaseFrequency = _data["selfPurchaseFrequency"];
            this.isExclusiveOnline = _data["isExclusiveOnline"];
            this.isPromotion = _data["isPromotion"];
            this.promotionId = _data["promotionId"];
            this.promotion = _data["promotion"] ? OrderItemDto.fromJS(_data["promotion"]) : <any>undefined;
            this.barCode = _data["barCode"];
            this.supplierCatalogNumber = _data["supplierCatalogNumber"];
            this.stock = _data["stock"];
            this.notInventory = _data["notInventory"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceCode"] = this.sourceCode;
        data["sku"] = this.sku;
        data["description"] = this.description;
        data["imageUrl"] = this.imageUrl;
        data["quantity"] = this.quantity;
        data["quantityDelivered"] = this.quantityDelivered;
        data["quantityInConflict"] = this.quantityInConflict;
        data["grossAmount"] = this.grossAmount;
        data["netAmount"] = this.netAmount;
        data["cancelled"] = this.cancelled;
        data["isDeleted"] = this.isDeleted;
        data["discount"] = this.discount;
        data["taxes"] = this.taxes;
        data["sourceOrderItemId"] = this.sourceOrderItemId;
        data["selfPurchaseFrequency"] = this.selfPurchaseFrequency;
        data["isExclusiveOnline"] = this.isExclusiveOnline;
        data["isPromotion"] = this.isPromotion;
        data["promotionId"] = this.promotionId;
        data["promotion"] = this.promotion ? this.promotion.toJSON() : <any>undefined;
        data["barCode"] = this.barCode;
        data["supplierCatalogNumber"] = this.supplierCatalogNumber;
        data["stock"] = this.stock;
        data["notInventory"] = this.notInventory;
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderItemDto {
        const json = this.toJSON();
        let result = new OrderItemDto();
        result.init(json);
        return result;
    }
}

export interface IOrderItemDto {
    sourceCode: string | undefined;
    sku: string | undefined;
    description: string | undefined;
    imageUrl: string | undefined;
    quantity: number;
    quantityDelivered: number;
    quantityInConflict: number;
    grossAmount: number;
    netAmount: number;
    cancelled: boolean;
    isDeleted: boolean;
    discount: number;
    taxes: number;
    sourceOrderItemId: number | undefined;
    selfPurchaseFrequency: number;
    isExclusiveOnline: boolean;
    isPromotion: boolean;
    promotionId: number | undefined;
    promotion: OrderItemDto;
    barCode: string | undefined;
    supplierCatalogNumber: string | undefined;
    stock: number;
    notInventory: boolean;
    id: number;
}

export class DocumentTypeDto implements IDocumentTypeDto {
    id: number;
    name: string | undefined;

    constructor(data?: IDocumentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): DocumentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): DocumentTypeDto {
        const json = this.toJSON();
        let result = new DocumentTypeDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentTypeDto {
    id: number;
    name: string | undefined;
}

export class OrderDocumentDto implements IOrderDocumentDto {
    number: string | undefined;
    documentCreationTime: moment.Moment | undefined;
    type: DocumentTypeDto;
    id: number;

    constructor(data?: IOrderDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.documentCreationTime = _data["documentCreationTime"] ? moment(_data["documentCreationTime"].toString()) : <any>undefined;
            this.type = _data["type"] ? DocumentTypeDto.fromJS(_data["type"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["documentCreationTime"] = this.documentCreationTime ? this.documentCreationTime.toISOString() : <any>undefined;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderDocumentDto {
        const json = this.toJSON();
        let result = new OrderDocumentDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDocumentDto {
    number: string | undefined;
    documentCreationTime: moment.Moment | undefined;
    type: DocumentTypeDto;
    id: number;
}

export class DocumentDto implements IDocumentDto {
    orderId: number;
    sourceCode: string | undefined;
    sourceName: string | undefined;
    type: string | undefined;
    sourceCreationTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    documentUrl: string | undefined;
    customerFirstName: string | undefined;
    customerLastName: string | undefined;
    customerDocumentNumber: string | undefined;
    customerPhoneNumber: string | undefined;
    status: string | undefined;
    draftNumber: string | undefined;
    number: string | undefined;
    folioNumber: string | undefined;
    amount: number;
    additionalInfo: string | undefined;
    documentNotificationId: number | undefined;
    storeCode: string | undefined;
    id: number;

    constructor(data?: IDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.sourceCode = _data["sourceCode"];
            this.sourceName = _data["sourceName"];
            this.type = _data["type"];
            this.sourceCreationTime = _data["sourceCreationTime"] ? moment(_data["sourceCreationTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.documentUrl = _data["documentUrl"];
            this.customerFirstName = _data["customerFirstName"];
            this.customerLastName = _data["customerLastName"];
            this.customerDocumentNumber = _data["customerDocumentNumber"];
            this.customerPhoneNumber = _data["customerPhoneNumber"];
            this.status = _data["status"];
            this.draftNumber = _data["draftNumber"];
            this.number = _data["number"];
            this.folioNumber = _data["folioNumber"];
            this.amount = _data["amount"];
            this.additionalInfo = _data["additionalInfo"];
            this.documentNotificationId = _data["documentNotificationId"];
            this.storeCode = _data["storeCode"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["sourceCode"] = this.sourceCode;
        data["sourceName"] = this.sourceName;
        data["type"] = this.type;
        data["sourceCreationTime"] = this.sourceCreationTime ? this.sourceCreationTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["documentUrl"] = this.documentUrl;
        data["customerFirstName"] = this.customerFirstName;
        data["customerLastName"] = this.customerLastName;
        data["customerDocumentNumber"] = this.customerDocumentNumber;
        data["customerPhoneNumber"] = this.customerPhoneNumber;
        data["status"] = this.status;
        data["draftNumber"] = this.draftNumber;
        data["number"] = this.number;
        data["folioNumber"] = this.folioNumber;
        data["amount"] = this.amount;
        data["additionalInfo"] = this.additionalInfo;
        data["documentNotificationId"] = this.documentNotificationId;
        data["storeCode"] = this.storeCode;
        data["id"] = this.id;
        return data; 
    }

    clone(): DocumentDto {
        const json = this.toJSON();
        let result = new DocumentDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentDto {
    orderId: number;
    sourceCode: string | undefined;
    sourceName: string | undefined;
    type: string | undefined;
    sourceCreationTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    documentUrl: string | undefined;
    customerFirstName: string | undefined;
    customerLastName: string | undefined;
    customerDocumentNumber: string | undefined;
    customerPhoneNumber: string | undefined;
    status: string | undefined;
    draftNumber: string | undefined;
    number: string | undefined;
    folioNumber: string | undefined;
    amount: number;
    additionalInfo: string | undefined;
    documentNotificationId: number | undefined;
    storeCode: string | undefined;
    id: number;
}

export class PaymentDto implements IPaymentDto {
    sourceCode: string | undefined;
    paymentSystemName: string | undefined;
    installments: number;
    value: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceCode = _data["sourceCode"];
            this.paymentSystemName = _data["paymentSystemName"];
            this.installments = _data["installments"];
            this.value = _data["value"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceCode"] = this.sourceCode;
        data["paymentSystemName"] = this.paymentSystemName;
        data["installments"] = this.installments;
        data["value"] = this.value;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): PaymentDto {
        const json = this.toJSON();
        let result = new PaymentDto();
        result.init(json);
        return result;
    }
}

export interface IPaymentDto {
    sourceCode: string | undefined;
    paymentSystemName: string | undefined;
    installments: number;
    value: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class DeliveryTypeDto implements IDeliveryTypeDto {
    id: number;
    name: string | undefined;

    constructor(data?: IDeliveryTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): DeliveryTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): DeliveryTypeDto {
        const json = this.toJSON();
        let result = new DeliveryTypeDto();
        result.init(json);
        return result;
    }
}

export interface IDeliveryTypeDto {
    id: number;
    name: string | undefined;
}

export class ShippingTypeDto implements IShippingTypeDto {
    code: string | undefined;
    name: string | undefined;
    shippingTypeGroupId: number | undefined;
    shippingTypeGroupName: string | undefined;
    id: number;

    constructor(data?: IShippingTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.shippingTypeGroupId = _data["shippingTypeGroupId"];
            this.shippingTypeGroupName = _data["shippingTypeGroupName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ShippingTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["shippingTypeGroupId"] = this.shippingTypeGroupId;
        data["shippingTypeGroupName"] = this.shippingTypeGroupName;
        data["id"] = this.id;
        return data; 
    }

    clone(): ShippingTypeDto {
        const json = this.toJSON();
        let result = new ShippingTypeDto();
        result.init(json);
        return result;
    }
}

export interface IShippingTypeDto {
    code: string | undefined;
    name: string | undefined;
    shippingTypeGroupId: number | undefined;
    shippingTypeGroupName: string | undefined;
    id: number;
}

export class DeliveryDataDto implements IDeliveryDataDto {
    sourceName: SourceValueDto;
    sourceCode: string | undefined;
    sourceStatus: string | undefined;
    estimatedDeliveryDateFrom: moment.Moment | undefined;
    estimatedDeliveryDateTo: moment.Moment | undefined;
    deliveryType: DeliveryTypeDto;
    pointOfDelivery: string | undefined;
    addressTypeCode: string | undefined;
    street: string | undefined;
    number: string | undefined;
    complement: string | undefined;
    postalCode: string | undefined;
    neighborhood: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    geoLat: number | undefined;
    geoLong: number | undefined;
    readonly completeAddress: string | undefined;
    trackingMethod: string | undefined;
    trackingNumber: string | undefined;
    shippingCost: number;
    deliveryCompany: string | undefined;
    shippingTypeId: number | undefined;
    shippingType: ShippingTypeDto;
    shippingTypeSourceCode: string | undefined;
    receiverName: string | undefined;
    carrierEsimatedDeliveryDate: moment.Moment | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IDeliveryDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceName = _data["sourceName"] ? SourceValueDto.fromJS(_data["sourceName"]) : <any>undefined;
            this.sourceCode = _data["sourceCode"];
            this.sourceStatus = _data["sourceStatus"];
            this.estimatedDeliveryDateFrom = _data["estimatedDeliveryDateFrom"] ? moment(_data["estimatedDeliveryDateFrom"].toString()) : <any>undefined;
            this.estimatedDeliveryDateTo = _data["estimatedDeliveryDateTo"] ? moment(_data["estimatedDeliveryDateTo"].toString()) : <any>undefined;
            this.deliveryType = _data["deliveryType"] ? DeliveryTypeDto.fromJS(_data["deliveryType"]) : <any>undefined;
            this.pointOfDelivery = _data["pointOfDelivery"];
            this.addressTypeCode = _data["addressTypeCode"];
            this.street = _data["street"];
            this.number = _data["number"];
            this.complement = _data["complement"];
            this.postalCode = _data["postalCode"];
            this.neighborhood = _data["neighborhood"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.geoLat = _data["geoLat"];
            this.geoLong = _data["geoLong"];
            (<any>this).completeAddress = _data["completeAddress"];
            this.trackingMethod = _data["trackingMethod"];
            this.trackingNumber = _data["trackingNumber"];
            this.shippingCost = _data["shippingCost"];
            this.deliveryCompany = _data["deliveryCompany"];
            this.shippingTypeId = _data["shippingTypeId"];
            this.shippingType = _data["shippingType"] ? ShippingTypeDto.fromJS(_data["shippingType"]) : <any>undefined;
            this.shippingTypeSourceCode = _data["shippingTypeSourceCode"];
            this.receiverName = _data["receiverName"];
            this.carrierEsimatedDeliveryDate = _data["carrierEsimatedDeliveryDate"] ? moment(_data["carrierEsimatedDeliveryDate"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeliveryDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceName"] = this.sourceName ? this.sourceName.toJSON() : <any>undefined;
        data["sourceCode"] = this.sourceCode;
        data["sourceStatus"] = this.sourceStatus;
        data["estimatedDeliveryDateFrom"] = this.estimatedDeliveryDateFrom ? this.estimatedDeliveryDateFrom.toISOString() : <any>undefined;
        data["estimatedDeliveryDateTo"] = this.estimatedDeliveryDateTo ? this.estimatedDeliveryDateTo.toISOString() : <any>undefined;
        data["deliveryType"] = this.deliveryType ? this.deliveryType.toJSON() : <any>undefined;
        data["pointOfDelivery"] = this.pointOfDelivery;
        data["addressTypeCode"] = this.addressTypeCode;
        data["street"] = this.street;
        data["number"] = this.number;
        data["complement"] = this.complement;
        data["postalCode"] = this.postalCode;
        data["neighborhood"] = this.neighborhood;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["geoLat"] = this.geoLat;
        data["geoLong"] = this.geoLong;
        data["completeAddress"] = this.completeAddress;
        data["trackingMethod"] = this.trackingMethod;
        data["trackingNumber"] = this.trackingNumber;
        data["shippingCost"] = this.shippingCost;
        data["deliveryCompany"] = this.deliveryCompany;
        data["shippingTypeId"] = this.shippingTypeId;
        data["shippingType"] = this.shippingType ? this.shippingType.toJSON() : <any>undefined;
        data["shippingTypeSourceCode"] = this.shippingTypeSourceCode;
        data["receiverName"] = this.receiverName;
        data["carrierEsimatedDeliveryDate"] = this.carrierEsimatedDeliveryDate ? this.carrierEsimatedDeliveryDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): DeliveryDataDto {
        const json = this.toJSON();
        let result = new DeliveryDataDto();
        result.init(json);
        return result;
    }
}

export interface IDeliveryDataDto {
    sourceName: SourceValueDto;
    sourceCode: string | undefined;
    sourceStatus: string | undefined;
    estimatedDeliveryDateFrom: moment.Moment | undefined;
    estimatedDeliveryDateTo: moment.Moment | undefined;
    deliveryType: DeliveryTypeDto;
    pointOfDelivery: string | undefined;
    addressTypeCode: string | undefined;
    street: string | undefined;
    number: string | undefined;
    complement: string | undefined;
    postalCode: string | undefined;
    neighborhood: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    geoLat: number | undefined;
    geoLong: number | undefined;
    completeAddress: string | undefined;
    trackingMethod: string | undefined;
    trackingNumber: string | undefined;
    shippingCost: number;
    deliveryCompany: string | undefined;
    shippingTypeId: number | undefined;
    shippingType: ShippingTypeDto;
    shippingTypeSourceCode: string | undefined;
    receiverName: string | undefined;
    carrierEsimatedDeliveryDate: moment.Moment | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class AssignedToStoreDto implements IAssignedToStoreDto {
    storeCode: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IAssignedToStoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeCode = _data["storeCode"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AssignedToStoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignedToStoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeCode"] = this.storeCode;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): AssignedToStoreDto {
        const json = this.toJSON();
        let result = new AssignedToStoreDto();
        result.init(json);
        return result;
    }
}

export interface IAssignedToStoreDto {
    storeCode: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class OverallStatusValueDto implements IOverallStatusValueDto {
    id: number;
    name: string | undefined;

    constructor(data?: IOverallStatusValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): OverallStatusValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new OverallStatusValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): OverallStatusValueDto {
        const json = this.toJSON();
        let result = new OverallStatusValueDto();
        result.init(json);
        return result;
    }
}

export interface IOverallStatusValueDto {
    id: number;
    name: string | undefined;
}

export class OverallStatusDto implements IOverallStatusDto {
    value: OverallStatusValueDto;

    constructor(data?: IOverallStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? OverallStatusValueDto.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OverallStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new OverallStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data; 
    }

    clone(): OverallStatusDto {
        const json = this.toJSON();
        let result = new OverallStatusDto();
        result.init(json);
        return result;
    }
}

export interface IOverallStatusDto {
    value: OverallStatusValueDto;
}

export class CommercialStatusValueDto implements ICommercialStatusValueDto {
    id: number;
    name: string | undefined;

    constructor(data?: ICommercialStatusValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CommercialStatusValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommercialStatusValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): CommercialStatusValueDto {
        const json = this.toJSON();
        let result = new CommercialStatusValueDto();
        result.init(json);
        return result;
    }
}

export interface ICommercialStatusValueDto {
    id: number;
    name: string | undefined;
}

export class CommercialStatusDto implements ICommercialStatusDto {
    value: CommercialStatusValueDto;

    constructor(data?: ICommercialStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? CommercialStatusValueDto.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CommercialStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommercialStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data; 
    }

    clone(): CommercialStatusDto {
        const json = this.toJSON();
        let result = new CommercialStatusDto();
        result.init(json);
        return result;
    }
}

export interface ICommercialStatusDto {
    value: CommercialStatusValueDto;
}

export class FinancialStatusValueDto implements IFinancialStatusValueDto {
    id: number;
    name: string | undefined;

    constructor(data?: IFinancialStatusValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FinancialStatusValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialStatusValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): FinancialStatusValueDto {
        const json = this.toJSON();
        let result = new FinancialStatusValueDto();
        result.init(json);
        return result;
    }
}

export interface IFinancialStatusValueDto {
    id: number;
    name: string | undefined;
}

export class FinancialStatusDto implements IFinancialStatusDto {
    value: FinancialStatusValueDto;

    constructor(data?: IFinancialStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? FinancialStatusValueDto.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FinancialStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data; 
    }

    clone(): FinancialStatusDto {
        const json = this.toJSON();
        let result = new FinancialStatusDto();
        result.init(json);
        return result;
    }
}

export interface IFinancialStatusDto {
    value: FinancialStatusValueDto;
}

export class LogisticStatusValueDto implements ILogisticStatusValueDto {
    id: number;
    name: string | undefined;

    constructor(data?: ILogisticStatusValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): LogisticStatusValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new LogisticStatusValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): LogisticStatusValueDto {
        const json = this.toJSON();
        let result = new LogisticStatusValueDto();
        result.init(json);
        return result;
    }
}

export interface ILogisticStatusValueDto {
    id: number;
    name: string | undefined;
}

export class LogisticStatusDto implements ILogisticStatusDto {
    value: LogisticStatusValueDto;

    constructor(data?: ILogisticStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? LogisticStatusValueDto.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LogisticStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new LogisticStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data; 
    }

    clone(): LogisticStatusDto {
        const json = this.toJSON();
        let result = new LogisticStatusDto();
        result.init(json);
        return result;
    }
}

export interface ILogisticStatusDto {
    value: LogisticStatusValueDto;
}

export class PreparedItemDto implements IPreparedItemDto {
    orderId: number;
    orderItemId: number;
    orderItemDescription: string | undefined;
    discount: number;
    grossAmount: number;
    imageUrl: string | undefined;
    netAmount: number;
    orderQuantity: number;
    quantity: number;
    sku: string | undefined;
    taxes: number;
    totalAmount: number;
    calculatedAmount: number;
    barCode: string | undefined;
    supplierCatalogNumber: string | undefined;
    stock: number;
    id: number;

    constructor(data?: IPreparedItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.orderItemId = _data["orderItemId"];
            this.orderItemDescription = _data["orderItemDescription"];
            this.discount = _data["discount"];
            this.grossAmount = _data["grossAmount"];
            this.imageUrl = _data["imageUrl"];
            this.netAmount = _data["netAmount"];
            this.orderQuantity = _data["orderQuantity"];
            this.quantity = _data["quantity"];
            this.sku = _data["sku"];
            this.taxes = _data["taxes"];
            this.totalAmount = _data["totalAmount"];
            this.calculatedAmount = _data["calculatedAmount"];
            this.barCode = _data["barCode"];
            this.supplierCatalogNumber = _data["supplierCatalogNumber"];
            this.stock = _data["stock"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PreparedItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PreparedItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["orderItemId"] = this.orderItemId;
        data["orderItemDescription"] = this.orderItemDescription;
        data["discount"] = this.discount;
        data["grossAmount"] = this.grossAmount;
        data["imageUrl"] = this.imageUrl;
        data["netAmount"] = this.netAmount;
        data["orderQuantity"] = this.orderQuantity;
        data["quantity"] = this.quantity;
        data["sku"] = this.sku;
        data["taxes"] = this.taxes;
        data["totalAmount"] = this.totalAmount;
        data["calculatedAmount"] = this.calculatedAmount;
        data["barCode"] = this.barCode;
        data["supplierCatalogNumber"] = this.supplierCatalogNumber;
        data["stock"] = this.stock;
        data["id"] = this.id;
        return data; 
    }

    clone(): PreparedItemDto {
        const json = this.toJSON();
        let result = new PreparedItemDto();
        result.init(json);
        return result;
    }
}

export interface IPreparedItemDto {
    orderId: number;
    orderItemId: number;
    orderItemDescription: string | undefined;
    discount: number;
    grossAmount: number;
    imageUrl: string | undefined;
    netAmount: number;
    orderQuantity: number;
    quantity: number;
    sku: string | undefined;
    taxes: number;
    totalAmount: number;
    calculatedAmount: number;
    barCode: string | undefined;
    supplierCatalogNumber: string | undefined;
    stock: number;
    id: number;
}

export class PackageDto implements IPackageDto {
    code: string | undefined;
    id: number;

    constructor(data?: IPackageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PackageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        return data; 
    }

    clone(): PackageDto {
        const json = this.toJSON();
        let result = new PackageDto();
        result.init(json);
        return result;
    }
}

export interface IPackageDto {
    code: string | undefined;
    id: number;
}

export class PreparationDto implements IPreparationDto {
    storeCode: string | undefined;
    responsible: string | undefined;
    status: string | undefined;
    orderId: number;
    preparedItems: PreparedItemDto[] | undefined;
    packages: PackageDto[] | undefined;
    id: number;

    constructor(data?: IPreparationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeCode = _data["storeCode"];
            this.responsible = _data["responsible"];
            this.status = _data["status"];
            this.orderId = _data["orderId"];
            if (Array.isArray(_data["preparedItems"])) {
                this.preparedItems = [] as any;
                for (let item of _data["preparedItems"])
                    this.preparedItems.push(PreparedItemDto.fromJS(item));
            }
            if (Array.isArray(_data["packages"])) {
                this.packages = [] as any;
                for (let item of _data["packages"])
                    this.packages.push(PackageDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PreparationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PreparationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeCode"] = this.storeCode;
        data["responsible"] = this.responsible;
        data["status"] = this.status;
        data["orderId"] = this.orderId;
        if (Array.isArray(this.preparedItems)) {
            data["preparedItems"] = [];
            for (let item of this.preparedItems)
                data["preparedItems"].push(item.toJSON());
        }
        if (Array.isArray(this.packages)) {
            data["packages"] = [];
            for (let item of this.packages)
                data["packages"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): PreparationDto {
        const json = this.toJSON();
        let result = new PreparationDto();
        result.init(json);
        return result;
    }
}

export interface IPreparationDto {
    storeCode: string | undefined;
    responsible: string | undefined;
    status: string | undefined;
    orderId: number;
    preparedItems: PreparedItemDto[] | undefined;
    packages: PackageDto[] | undefined;
    id: number;
}

export class ShipmentOrderDto implements IShipmentOrderDto {
    shipmentId: number;
    orderId: number;
    sourceCode: string | undefined;
    sourceName: string | undefined;
    customer: string | undefined;
    address: string | undefined;
    addressComplement: string | undefined;
    phoneNumber: string | undefined;
    shippingStatus: string | undefined;
    shipmentIssue: string | undefined;
    deliveryType: string | undefined;
    pickupStoreCode: string | undefined;
    deliveredOn: moment.Moment | undefined;
    notDeliveredOn: moment.Moment | undefined;
    proofFiles: string[] | undefined;
    proofNote: string | undefined;

    constructor(data?: IShipmentOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shipmentId = _data["shipmentId"];
            this.orderId = _data["orderId"];
            this.sourceCode = _data["sourceCode"];
            this.sourceName = _data["sourceName"];
            this.customer = _data["customer"];
            this.address = _data["address"];
            this.addressComplement = _data["addressComplement"];
            this.phoneNumber = _data["phoneNumber"];
            this.shippingStatus = _data["shippingStatus"];
            this.shipmentIssue = _data["shipmentIssue"];
            this.deliveryType = _data["deliveryType"];
            this.pickupStoreCode = _data["pickupStoreCode"];
            this.deliveredOn = _data["deliveredOn"] ? moment(_data["deliveredOn"].toString()) : <any>undefined;
            this.notDeliveredOn = _data["notDeliveredOn"] ? moment(_data["notDeliveredOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["proofFiles"])) {
                this.proofFiles = [] as any;
                for (let item of _data["proofFiles"])
                    this.proofFiles.push(item);
            }
            this.proofNote = _data["proofNote"];
        }
    }

    static fromJS(data: any): ShipmentOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShipmentOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shipmentId"] = this.shipmentId;
        data["orderId"] = this.orderId;
        data["sourceCode"] = this.sourceCode;
        data["sourceName"] = this.sourceName;
        data["customer"] = this.customer;
        data["address"] = this.address;
        data["addressComplement"] = this.addressComplement;
        data["phoneNumber"] = this.phoneNumber;
        data["shippingStatus"] = this.shippingStatus;
        data["shipmentIssue"] = this.shipmentIssue;
        data["deliveryType"] = this.deliveryType;
        data["pickupStoreCode"] = this.pickupStoreCode;
        data["deliveredOn"] = this.deliveredOn ? this.deliveredOn.toISOString() : <any>undefined;
        data["notDeliveredOn"] = this.notDeliveredOn ? this.notDeliveredOn.toISOString() : <any>undefined;
        if (Array.isArray(this.proofFiles)) {
            data["proofFiles"] = [];
            for (let item of this.proofFiles)
                data["proofFiles"].push(item);
        }
        data["proofNote"] = this.proofNote;
        return data; 
    }

    clone(): ShipmentOrderDto {
        const json = this.toJSON();
        let result = new ShipmentOrderDto();
        result.init(json);
        return result;
    }
}

export interface IShipmentOrderDto {
    shipmentId: number;
    orderId: number;
    sourceCode: string | undefined;
    sourceName: string | undefined;
    customer: string | undefined;
    address: string | undefined;
    addressComplement: string | undefined;
    phoneNumber: string | undefined;
    shippingStatus: string | undefined;
    shipmentIssue: string | undefined;
    deliveryType: string | undefined;
    pickupStoreCode: string | undefined;
    deliveredOn: moment.Moment | undefined;
    notDeliveredOn: moment.Moment | undefined;
    proofFiles: string[] | undefined;
    proofNote: string | undefined;
}

export class StockStatusDto implements IStockStatusDto {
    id: number;
    name: string | undefined;

    constructor(data?: IStockStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): StockStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): StockStatusDto {
        const json = this.toJSON();
        let result = new StockStatusDto();
        result.init(json);
        return result;
    }
}

export interface IStockStatusDto {
    id: number;
    name: string | undefined;
}

export class ReplacementCriteriaDto implements IReplacementCriteriaDto {
    id: number;
    name: string | undefined;

    constructor(data?: IReplacementCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ReplacementCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReplacementCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): ReplacementCriteriaDto {
        const json = this.toJSON();
        let result = new ReplacementCriteriaDto();
        result.init(json);
        return result;
    }
}

export interface IReplacementCriteriaDto {
    id: number;
    name: string | undefined;
}

export class IncludedGiftCardDto implements IIncludedGiftCardDto {
    id: number;
    name: string | undefined;

    constructor(data?: IIncludedGiftCardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): IncludedGiftCardDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncludedGiftCardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): IncludedGiftCardDto {
        const json = this.toJSON();
        let result = new IncludedGiftCardDto();
        result.init(json);
        return result;
    }
}

export interface IIncludedGiftCardDto {
    id: number;
    name: string | undefined;
}

export class OrderDto implements IOrderDto {
    sourceName: SourceValueDto;
    sourceCode: string | undefined;
    grossAmount: number;
    netAmount: number;
    discount: number;
    taxes: number;
    invoiceNumber: string | undefined;
    routeOrder: number | undefined;
    invoiceCreationTime: moment.Moment | undefined;
    invoiceType: string | undefined;
    highlighted: boolean;
    customer: CustomerDto;
    carrierId: number | undefined;
    carrier: CarrierDto;
    sourceCreationTime: moment.Moment | undefined;
    dispatchDate: moment.Moment | undefined;
    isPackOrder: boolean;
    isPackItemOrder: boolean;
    packOrderId: number | undefined;
    balance: number;
    orderBalances: OrderBalanceDto[] | undefined;
    notes: OrderNoteDto[] | undefined;
    eventLogs: EventLogDto[] | undefined;
    sourceOrderItems: SourceOrderItemDto[] | undefined;
    orderItems: OrderItemDto[] | undefined;
    relatedDocuments: OrderDocumentDto[] | undefined;
    documents: DocumentDto[] | undefined;
    payments: PaymentDto[] | undefined;
    deliveryData: DeliveryDataDto;
    currentAssignedToStore: AssignedToStoreDto;
    currentOverallStatus: OverallStatusDto;
    currentCommercialStatus: CommercialStatusDto;
    currentFinancialStatus: FinancialStatusDto;
    currentLogisticStatus: LogisticStatusDto;
    preparations: PreparationDto[] | undefined;
    shipmentOrder: ShipmentOrderDto;
    withdrawTime: moment.Moment | undefined;
    dispatchTag: string | undefined;
    pickupStoreCode: string | undefined;
    stockStatus: StockStatusDto;
    carrierDriverId: number | undefined;
    carrierDriver: CarrierDriverDto;
    openTextField: string | undefined;
    replacementCriteria: ReplacementCriteriaDto;
    carrierInfo: string | undefined;
    giftCard: string | undefined;
    includedGiftCard: IncludedGiftCardDto;
    createFromOrderStorePickup: boolean;
    invoiceStoreCode: string | undefined;
    shipmentQuantity: number;
    interest: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceName = _data["sourceName"] ? SourceValueDto.fromJS(_data["sourceName"]) : <any>undefined;
            this.sourceCode = _data["sourceCode"];
            this.grossAmount = _data["grossAmount"];
            this.netAmount = _data["netAmount"];
            this.discount = _data["discount"];
            this.taxes = _data["taxes"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.routeOrder = _data["routeOrder"];
            this.invoiceCreationTime = _data["invoiceCreationTime"] ? moment(_data["invoiceCreationTime"].toString()) : <any>undefined;
            this.invoiceType = _data["invoiceType"];
            this.highlighted = _data["highlighted"];
            this.customer = _data["customer"] ? CustomerDto.fromJS(_data["customer"]) : <any>undefined;
            this.carrierId = _data["carrierId"];
            this.carrier = _data["carrier"] ? CarrierDto.fromJS(_data["carrier"]) : <any>undefined;
            this.sourceCreationTime = _data["sourceCreationTime"] ? moment(_data["sourceCreationTime"].toString()) : <any>undefined;
            this.dispatchDate = _data["dispatchDate"] ? moment(_data["dispatchDate"].toString()) : <any>undefined;
            this.isPackOrder = _data["isPackOrder"];
            this.isPackItemOrder = _data["isPackItemOrder"];
            this.packOrderId = _data["packOrderId"];
            this.balance = _data["balance"];
            if (Array.isArray(_data["orderBalances"])) {
                this.orderBalances = [] as any;
                for (let item of _data["orderBalances"])
                    this.orderBalances.push(OrderBalanceDto.fromJS(item));
            }
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes.push(OrderNoteDto.fromJS(item));
            }
            if (Array.isArray(_data["eventLogs"])) {
                this.eventLogs = [] as any;
                for (let item of _data["eventLogs"])
                    this.eventLogs.push(EventLogDto.fromJS(item));
            }
            if (Array.isArray(_data["sourceOrderItems"])) {
                this.sourceOrderItems = [] as any;
                for (let item of _data["sourceOrderItems"])
                    this.sourceOrderItems.push(SourceOrderItemDto.fromJS(item));
            }
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems.push(OrderItemDto.fromJS(item));
            }
            if (Array.isArray(_data["relatedDocuments"])) {
                this.relatedDocuments = [] as any;
                for (let item of _data["relatedDocuments"])
                    this.relatedDocuments.push(OrderDocumentDto.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents.push(DocumentDto.fromJS(item));
            }
            if (Array.isArray(_data["payments"])) {
                this.payments = [] as any;
                for (let item of _data["payments"])
                    this.payments.push(PaymentDto.fromJS(item));
            }
            this.deliveryData = _data["deliveryData"] ? DeliveryDataDto.fromJS(_data["deliveryData"]) : <any>undefined;
            this.currentAssignedToStore = _data["currentAssignedToStore"] ? AssignedToStoreDto.fromJS(_data["currentAssignedToStore"]) : <any>undefined;
            this.currentOverallStatus = _data["currentOverallStatus"] ? OverallStatusDto.fromJS(_data["currentOverallStatus"]) : <any>undefined;
            this.currentCommercialStatus = _data["currentCommercialStatus"] ? CommercialStatusDto.fromJS(_data["currentCommercialStatus"]) : <any>undefined;
            this.currentFinancialStatus = _data["currentFinancialStatus"] ? FinancialStatusDto.fromJS(_data["currentFinancialStatus"]) : <any>undefined;
            this.currentLogisticStatus = _data["currentLogisticStatus"] ? LogisticStatusDto.fromJS(_data["currentLogisticStatus"]) : <any>undefined;
            if (Array.isArray(_data["preparations"])) {
                this.preparations = [] as any;
                for (let item of _data["preparations"])
                    this.preparations.push(PreparationDto.fromJS(item));
            }
            this.shipmentOrder = _data["shipmentOrder"] ? ShipmentOrderDto.fromJS(_data["shipmentOrder"]) : <any>undefined;
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : <any>undefined;
            this.dispatchTag = _data["dispatchTag"];
            this.pickupStoreCode = _data["pickupStoreCode"];
            this.stockStatus = _data["stockStatus"] ? StockStatusDto.fromJS(_data["stockStatus"]) : <any>undefined;
            this.carrierDriverId = _data["carrierDriverId"];
            this.carrierDriver = _data["carrierDriver"] ? CarrierDriverDto.fromJS(_data["carrierDriver"]) : <any>undefined;
            this.openTextField = _data["openTextField"];
            this.replacementCriteria = _data["replacementCriteria"] ? ReplacementCriteriaDto.fromJS(_data["replacementCriteria"]) : <any>undefined;
            this.carrierInfo = _data["carrierInfo"];
            this.giftCard = _data["giftCard"];
            this.includedGiftCard = _data["includedGiftCard"] ? IncludedGiftCardDto.fromJS(_data["includedGiftCard"]) : <any>undefined;
            this.createFromOrderStorePickup = _data["createFromOrderStorePickup"];
            this.invoiceStoreCode = _data["invoiceStoreCode"];
            this.shipmentQuantity = _data["shipmentQuantity"];
            this.interest = _data["interest"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceName"] = this.sourceName ? this.sourceName.toJSON() : <any>undefined;
        data["sourceCode"] = this.sourceCode;
        data["grossAmount"] = this.grossAmount;
        data["netAmount"] = this.netAmount;
        data["discount"] = this.discount;
        data["taxes"] = this.taxes;
        data["invoiceNumber"] = this.invoiceNumber;
        data["routeOrder"] = this.routeOrder;
        data["invoiceCreationTime"] = this.invoiceCreationTime ? this.invoiceCreationTime.toISOString() : <any>undefined;
        data["invoiceType"] = this.invoiceType;
        data["highlighted"] = this.highlighted;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["carrierId"] = this.carrierId;
        data["carrier"] = this.carrier ? this.carrier.toJSON() : <any>undefined;
        data["sourceCreationTime"] = this.sourceCreationTime ? this.sourceCreationTime.toISOString() : <any>undefined;
        data["dispatchDate"] = this.dispatchDate ? this.dispatchDate.toISOString() : <any>undefined;
        data["isPackOrder"] = this.isPackOrder;
        data["isPackItemOrder"] = this.isPackItemOrder;
        data["packOrderId"] = this.packOrderId;
        data["balance"] = this.balance;
        if (Array.isArray(this.orderBalances)) {
            data["orderBalances"] = [];
            for (let item of this.orderBalances)
                data["orderBalances"].push(item.toJSON());
        }
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        if (Array.isArray(this.eventLogs)) {
            data["eventLogs"] = [];
            for (let item of this.eventLogs)
                data["eventLogs"].push(item.toJSON());
        }
        if (Array.isArray(this.sourceOrderItems)) {
            data["sourceOrderItems"] = [];
            for (let item of this.sourceOrderItems)
                data["sourceOrderItems"].push(item.toJSON());
        }
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        if (Array.isArray(this.relatedDocuments)) {
            data["relatedDocuments"] = [];
            for (let item of this.relatedDocuments)
                data["relatedDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        data["deliveryData"] = this.deliveryData ? this.deliveryData.toJSON() : <any>undefined;
        data["currentAssignedToStore"] = this.currentAssignedToStore ? this.currentAssignedToStore.toJSON() : <any>undefined;
        data["currentOverallStatus"] = this.currentOverallStatus ? this.currentOverallStatus.toJSON() : <any>undefined;
        data["currentCommercialStatus"] = this.currentCommercialStatus ? this.currentCommercialStatus.toJSON() : <any>undefined;
        data["currentFinancialStatus"] = this.currentFinancialStatus ? this.currentFinancialStatus.toJSON() : <any>undefined;
        data["currentLogisticStatus"] = this.currentLogisticStatus ? this.currentLogisticStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.preparations)) {
            data["preparations"] = [];
            for (let item of this.preparations)
                data["preparations"].push(item.toJSON());
        }
        data["shipmentOrder"] = this.shipmentOrder ? this.shipmentOrder.toJSON() : <any>undefined;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : <any>undefined;
        data["dispatchTag"] = this.dispatchTag;
        data["pickupStoreCode"] = this.pickupStoreCode;
        data["stockStatus"] = this.stockStatus ? this.stockStatus.toJSON() : <any>undefined;
        data["carrierDriverId"] = this.carrierDriverId;
        data["carrierDriver"] = this.carrierDriver ? this.carrierDriver.toJSON() : <any>undefined;
        data["openTextField"] = this.openTextField;
        data["replacementCriteria"] = this.replacementCriteria ? this.replacementCriteria.toJSON() : <any>undefined;
        data["carrierInfo"] = this.carrierInfo;
        data["giftCard"] = this.giftCard;
        data["includedGiftCard"] = this.includedGiftCard ? this.includedGiftCard.toJSON() : <any>undefined;
        data["createFromOrderStorePickup"] = this.createFromOrderStorePickup;
        data["invoiceStoreCode"] = this.invoiceStoreCode;
        data["shipmentQuantity"] = this.shipmentQuantity;
        data["interest"] = this.interest;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderDto {
        const json = this.toJSON();
        let result = new OrderDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDto {
    sourceName: SourceValueDto;
    sourceCode: string | undefined;
    grossAmount: number;
    netAmount: number;
    discount: number;
    taxes: number;
    invoiceNumber: string | undefined;
    routeOrder: number | undefined;
    invoiceCreationTime: moment.Moment | undefined;
    invoiceType: string | undefined;
    highlighted: boolean;
    customer: CustomerDto;
    carrierId: number | undefined;
    carrier: CarrierDto;
    sourceCreationTime: moment.Moment | undefined;
    dispatchDate: moment.Moment | undefined;
    isPackOrder: boolean;
    isPackItemOrder: boolean;
    packOrderId: number | undefined;
    balance: number;
    orderBalances: OrderBalanceDto[] | undefined;
    notes: OrderNoteDto[] | undefined;
    eventLogs: EventLogDto[] | undefined;
    sourceOrderItems: SourceOrderItemDto[] | undefined;
    orderItems: OrderItemDto[] | undefined;
    relatedDocuments: OrderDocumentDto[] | undefined;
    documents: DocumentDto[] | undefined;
    payments: PaymentDto[] | undefined;
    deliveryData: DeliveryDataDto;
    currentAssignedToStore: AssignedToStoreDto;
    currentOverallStatus: OverallStatusDto;
    currentCommercialStatus: CommercialStatusDto;
    currentFinancialStatus: FinancialStatusDto;
    currentLogisticStatus: LogisticStatusDto;
    preparations: PreparationDto[] | undefined;
    shipmentOrder: ShipmentOrderDto;
    withdrawTime: moment.Moment | undefined;
    dispatchTag: string | undefined;
    pickupStoreCode: string | undefined;
    stockStatus: StockStatusDto;
    carrierDriverId: number | undefined;
    carrierDriver: CarrierDriverDto;
    openTextField: string | undefined;
    replacementCriteria: ReplacementCriteriaDto;
    carrierInfo: string | undefined;
    giftCard: string | undefined;
    includedGiftCard: IncludedGiftCardDto;
    createFromOrderStorePickup: boolean;
    invoiceStoreCode: string | undefined;
    shipmentQuantity: number;
    interest: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ClaimItemDto implements IClaimItemDto {
    sku: string | undefined;
    description: string | undefined;
    quantity: number;
    netAmount: number;
    claimedQuantity: number;
    deliveryIssue: string | undefined;
    observation: string | undefined;
    action: string | undefined;
    id: number;

    constructor(data?: IClaimItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sku = _data["sku"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.netAmount = _data["netAmount"];
            this.claimedQuantity = _data["claimedQuantity"];
            this.deliveryIssue = _data["deliveryIssue"];
            this.observation = _data["observation"];
            this.action = _data["action"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ClaimItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["netAmount"] = this.netAmount;
        data["claimedQuantity"] = this.claimedQuantity;
        data["deliveryIssue"] = this.deliveryIssue;
        data["observation"] = this.observation;
        data["action"] = this.action;
        data["id"] = this.id;
        return data; 
    }

    clone(): ClaimItemDto {
        const json = this.toJSON();
        let result = new ClaimItemDto();
        result.init(json);
        return result;
    }
}

export interface IClaimItemDto {
    sku: string | undefined;
    description: string | undefined;
    quantity: number;
    netAmount: number;
    claimedQuantity: number;
    deliveryIssue: string | undefined;
    observation: string | undefined;
    action: string | undefined;
    id: number;
}

export class ClaimDto implements IClaimDto {
    description: string | undefined;
    type: ClaimTypeDto;
    orderId: number;
    order: OrderDto;
    creationTime: moment.Moment;
    withdrawTime: moment.Moment | undefined;
    claimItems: ClaimItemDto[] | undefined;
    id: number;

    constructor(data?: IClaimDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.type = _data["type"] ? ClaimTypeDto.fromJS(_data["type"]) : <any>undefined;
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? OrderDto.fromJS(_data["order"]) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["claimItems"])) {
                this.claimItems = [] as any;
                for (let item of _data["claimItems"])
                    this.claimItems.push(ClaimItemDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ClaimDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : <any>undefined;
        if (Array.isArray(this.claimItems)) {
            data["claimItems"] = [];
            for (let item of this.claimItems)
                data["claimItems"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): ClaimDto {
        const json = this.toJSON();
        let result = new ClaimDto();
        result.init(json);
        return result;
    }
}

export interface IClaimDto {
    description: string | undefined;
    type: ClaimTypeDto;
    orderId: number;
    order: OrderDto;
    creationTime: moment.Moment;
    withdrawTime: moment.Moment | undefined;
    claimItems: ClaimItemDto[] | undefined;
    id: number;
}

export class ClaimDtoPagedResultDto implements IClaimDtoPagedResultDto {
    totalCount: number;
    items: ClaimDto[] | undefined;

    constructor(data?: IClaimDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ClaimDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClaimDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ClaimDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ClaimDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IClaimDtoPagedResultDto {
    totalCount: number;
    items: ClaimDto[] | undefined;
}

export class ComerssiaOrderStatus implements IComerssiaOrderStatus {
    sourceCode: string | undefined;
    statusCode: string | undefined;
    statusDescription: string | undefined;
    storeCode: string | undefined;
    invoiceNumber: string | undefined;

    constructor(data?: IComerssiaOrderStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceCode = _data["sourceCode"];
            this.statusCode = _data["statusCode"];
            this.statusDescription = _data["statusDescription"];
            this.storeCode = _data["storeCode"];
            this.invoiceNumber = _data["invoiceNumber"];
        }
    }

    static fromJS(data: any): ComerssiaOrderStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ComerssiaOrderStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceCode"] = this.sourceCode;
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["storeCode"] = this.storeCode;
        data["invoiceNumber"] = this.invoiceNumber;
        return data; 
    }

    clone(): ComerssiaOrderStatus {
        const json = this.toJSON();
        let result = new ComerssiaOrderStatus();
        result.init(json);
        return result;
    }
}

export interface IComerssiaOrderStatus {
    sourceCode: string | undefined;
    statusCode: string | undefined;
    statusDescription: string | undefined;
    storeCode: string | undefined;
    invoiceNumber: string | undefined;
}

export class CapturaDto implements ICapturaDto {
    presentacion: string | undefined;
    descripcion: string | undefined;
    cadena: number;
    letra: string | undefined;
    valorNumerico: number;

    constructor(data?: ICapturaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.presentacion = _data["presentacion"];
            this.descripcion = _data["descripcion"];
            this.cadena = _data["cadena"];
            this.letra = _data["letra"];
            this.valorNumerico = _data["valorNumerico"];
        }
    }

    static fromJS(data: any): CapturaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CapturaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["presentacion"] = this.presentacion;
        data["descripcion"] = this.descripcion;
        data["cadena"] = this.cadena;
        data["letra"] = this.letra;
        data["valorNumerico"] = this.valorNumerico;
        return data; 
    }

    clone(): CapturaDto {
        const json = this.toJSON();
        let result = new CapturaDto();
        result.init(json);
        return result;
    }
}

export interface ICapturaDto {
    presentacion: string | undefined;
    descripcion: string | undefined;
    cadena: number;
    letra: string | undefined;
    valorNumerico: number;
}

export class InvoiceItemDto implements IInvoiceItemDto {
    nItem: number;
    tipo: string | undefined;
    visible: boolean;
    imprime: boolean;
    presentacion: string | undefined;
    descripcion: string | undefined;
    cadena: string | undefined;
    letra: string | undefined;
    codigo: number | undefined;
    tfcCodigo: number | undefined;
    tipoRef: string | undefined;
    refCodigo1: string | undefined;
    carCodigo1: string | undefined;
    refPrecioLista: number | undefined;
    irfBruto: number | undefined;
    irfDescuento: number | undefined;
    irfPago: number | undefined;
    irfCantidad: number | undefined;
    irfValorImpuesto: number | undefined;
    irfImpuesto: number | undefined;
    refEsCombo: number | undefined;
    irfVenta: number | undefined;
    irfNeto: number | undefined;
    irfValorImpuestoNeto: number | undefined;
    captura: CapturaDto;
    irfBase: number | undefined;

    constructor(data?: IInvoiceItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nItem = _data["nItem"];
            this.tipo = _data["tipo"];
            this.visible = _data["visible"];
            this.imprime = _data["imprime"];
            this.presentacion = _data["presentacion"];
            this.descripcion = _data["descripcion"];
            this.cadena = _data["cadena"];
            this.letra = _data["letra"];
            this.codigo = _data["codigo"];
            this.tfcCodigo = _data["tfcCodigo"];
            this.tipoRef = _data["tipoRef"];
            this.refCodigo1 = _data["refCodigo1"];
            this.carCodigo1 = _data["carCodigo1"];
            this.refPrecioLista = _data["refPrecioLista"];
            this.irfBruto = _data["irfBruto"];
            this.irfDescuento = _data["irfDescuento"];
            this.irfPago = _data["irfPago"];
            this.irfCantidad = _data["irfCantidad"];
            this.irfValorImpuesto = _data["irfValorImpuesto"];
            this.irfImpuesto = _data["irfImpuesto"];
            this.refEsCombo = _data["refEsCombo"];
            this.irfVenta = _data["irfVenta"];
            this.irfNeto = _data["irfNeto"];
            this.irfValorImpuestoNeto = _data["irfValorImpuestoNeto"];
            this.captura = _data["captura"] ? CapturaDto.fromJS(_data["captura"]) : <any>undefined;
            this.irfBase = _data["irfBase"];
        }
    }

    static fromJS(data: any): InvoiceItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nItem"] = this.nItem;
        data["tipo"] = this.tipo;
        data["visible"] = this.visible;
        data["imprime"] = this.imprime;
        data["presentacion"] = this.presentacion;
        data["descripcion"] = this.descripcion;
        data["cadena"] = this.cadena;
        data["letra"] = this.letra;
        data["codigo"] = this.codigo;
        data["tfcCodigo"] = this.tfcCodigo;
        data["tipoRef"] = this.tipoRef;
        data["refCodigo1"] = this.refCodigo1;
        data["carCodigo1"] = this.carCodigo1;
        data["refPrecioLista"] = this.refPrecioLista;
        data["irfBruto"] = this.irfBruto;
        data["irfDescuento"] = this.irfDescuento;
        data["irfPago"] = this.irfPago;
        data["irfCantidad"] = this.irfCantidad;
        data["irfValorImpuesto"] = this.irfValorImpuesto;
        data["irfImpuesto"] = this.irfImpuesto;
        data["refEsCombo"] = this.refEsCombo;
        data["irfVenta"] = this.irfVenta;
        data["irfNeto"] = this.irfNeto;
        data["irfValorImpuestoNeto"] = this.irfValorImpuestoNeto;
        data["captura"] = this.captura ? this.captura.toJSON() : <any>undefined;
        data["irfBase"] = this.irfBase;
        return data; 
    }

    clone(): InvoiceItemDto {
        const json = this.toJSON();
        let result = new InvoiceItemDto();
        result.init(json);
        return result;
    }
}

export interface IInvoiceItemDto {
    nItem: number;
    tipo: string | undefined;
    visible: boolean;
    imprime: boolean;
    presentacion: string | undefined;
    descripcion: string | undefined;
    cadena: string | undefined;
    letra: string | undefined;
    codigo: number | undefined;
    tfcCodigo: number | undefined;
    tipoRef: string | undefined;
    refCodigo1: string | undefined;
    carCodigo1: string | undefined;
    refPrecioLista: number | undefined;
    irfBruto: number | undefined;
    irfDescuento: number | undefined;
    irfPago: number | undefined;
    irfCantidad: number | undefined;
    irfValorImpuesto: number | undefined;
    irfImpuesto: number | undefined;
    refEsCombo: number | undefined;
    irfVenta: number | undefined;
    irfNeto: number | undefined;
    irfValorImpuestoNeto: number | undefined;
    captura: CapturaDto;
    irfBase: number | undefined;
}

export class InvoiceDto implements IInvoiceDto {
    usuCodigo: string | undefined;
    cajCodigo: string | undefined;
    almCodigo: string | undefined;
    almNombre: string | undefined;
    fecha: string | undefined;
    hora: string | undefined;
    prcCodigo: string | undefined;
    encConsTrx: number | undefined;
    totalReferencias: number;
    data: InvoiceItemDto[] | undefined;

    constructor(data?: IInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.usuCodigo = _data["usuCodigo"];
            this.cajCodigo = _data["cajCodigo"];
            this.almCodigo = _data["almCodigo"];
            this.almNombre = _data["almNombre"];
            this.fecha = _data["fecha"];
            this.hora = _data["hora"];
            this.prcCodigo = _data["prcCodigo"];
            this.encConsTrx = _data["encConsTrx"];
            this.totalReferencias = _data["totalReferencias"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data.push(InvoiceItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["usuCodigo"] = this.usuCodigo;
        data["cajCodigo"] = this.cajCodigo;
        data["almCodigo"] = this.almCodigo;
        data["almNombre"] = this.almNombre;
        data["fecha"] = this.fecha;
        data["hora"] = this.hora;
        data["prcCodigo"] = this.prcCodigo;
        data["encConsTrx"] = this.encConsTrx;
        data["totalReferencias"] = this.totalReferencias;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }

    clone(): InvoiceDto {
        const json = this.toJSON();
        let result = new InvoiceDto();
        result.init(json);
        return result;
    }
}

export interface IInvoiceDto {
    usuCodigo: string | undefined;
    cajCodigo: string | undefined;
    almCodigo: string | undefined;
    almNombre: string | undefined;
    fecha: string | undefined;
    hora: string | undefined;
    prcCodigo: string | undefined;
    encConsTrx: number | undefined;
    totalReferencias: number;
    data: InvoiceItemDto[] | undefined;
}

export class InvoiceResponse implements IInvoiceResponse {
    codigo: string | undefined;
    descripcion: string | undefined;
    xmlUrl: string | undefined;
    prcCodigo: string | undefined;

    constructor(data?: IInvoiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codigo = _data["codigo"];
            this.descripcion = _data["descripcion"];
            this.xmlUrl = _data["xmlUrl"];
            this.prcCodigo = _data["prcCodigo"];
        }
    }

    static fromJS(data: any): InvoiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codigo"] = this.codigo;
        data["descripcion"] = this.descripcion;
        data["xmlUrl"] = this.xmlUrl;
        data["prcCodigo"] = this.prcCodigo;
        return data; 
    }

    clone(): InvoiceResponse {
        const json = this.toJSON();
        let result = new InvoiceResponse();
        result.init(json);
        return result;
    }
}

export interface IInvoiceResponse {
    codigo: string | undefined;
    descripcion: string | undefined;
    xmlUrl: string | undefined;
    prcCodigo: string | undefined;
}

export class CustomValueDto implements ICustomValueDto {
    reference: string | undefined;
    value: string | undefined;
    countryCode: string | undefined;
    id: number;

    constructor(data?: ICustomValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reference = _data["reference"];
            this.value = _data["value"];
            this.countryCode = _data["countryCode"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CustomValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reference"] = this.reference;
        data["value"] = this.value;
        data["countryCode"] = this.countryCode;
        data["id"] = this.id;
        return data; 
    }

    clone(): CustomValueDto {
        const json = this.toJSON();
        let result = new CustomValueDto();
        result.init(json);
        return result;
    }
}

export interface ICustomValueDto {
    reference: string | undefined;
    value: string | undefined;
    countryCode: string | undefined;
    id: number;
}

export class CustomValueDtoPagedResultDto implements ICustomValueDtoPagedResultDto {
    totalCount: number;
    items: CustomValueDto[] | undefined;

    constructor(data?: ICustomValueDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CustomValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomValueDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomValueDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CustomValueDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CustomValueDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICustomValueDtoPagedResultDto {
    totalCount: number;
    items: CustomValueDto[] | undefined;
}

export class DeliveryScheduleDto implements IDeliveryScheduleDto {
    label: string | undefined;
    hourFrom: string | undefined;
    offset: string | undefined;
    customValueId: number;
    countryCode: string | undefined;
    customValue: CustomValueDto;
    id: number;

    constructor(data?: IDeliveryScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.hourFrom = _data["hourFrom"];
            this.offset = _data["offset"];
            this.customValueId = _data["customValueId"];
            this.countryCode = _data["countryCode"];
            this.customValue = _data["customValue"] ? CustomValueDto.fromJS(_data["customValue"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeliveryScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["hourFrom"] = this.hourFrom;
        data["offset"] = this.offset;
        data["customValueId"] = this.customValueId;
        data["countryCode"] = this.countryCode;
        data["customValue"] = this.customValue ? this.customValue.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): DeliveryScheduleDto {
        const json = this.toJSON();
        let result = new DeliveryScheduleDto();
        result.init(json);
        return result;
    }
}

export interface IDeliveryScheduleDto {
    label: string | undefined;
    hourFrom: string | undefined;
    offset: string | undefined;
    customValueId: number;
    countryCode: string | undefined;
    customValue: CustomValueDto;
    id: number;
}

export class DeliveryScheduleDtoPagedResultDto implements IDeliveryScheduleDtoPagedResultDto {
    totalCount: number;
    items: DeliveryScheduleDto[] | undefined;

    constructor(data?: IDeliveryScheduleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DeliveryScheduleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeliveryScheduleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryScheduleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): DeliveryScheduleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DeliveryScheduleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDeliveryScheduleDtoPagedResultDto {
    totalCount: number;
    items: DeliveryScheduleDto[] | undefined;
}

export class OrderDtoPagedResultDto implements IOrderDtoPagedResultDto {
    totalCount: number;
    items: OrderDto[] | undefined;

    constructor(data?: IOrderDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): OrderDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OrderDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDtoPagedResultDto {
    totalCount: number;
    items: OrderDto[] | undefined;
}

export class DistrictDtoPagedResultDto implements IDistrictDtoPagedResultDto {
    totalCount: number;
    items: DistrictDto[] | undefined;

    constructor(data?: IDistrictDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DistrictDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DistrictDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DistrictDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): DistrictDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DistrictDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDistrictDtoPagedResultDto {
    totalCount: number;
    items: DistrictDto[] | undefined;
}

export class SendDraftRequest implements ISendDraftRequest {
    orderId: number;
    documentType: string | undefined;
    documentId: number | undefined;
    documentNotificationId: number | undefined;

    constructor(data?: ISendDraftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.documentType = _data["documentType"];
            this.documentId = _data["documentId"];
            this.documentNotificationId = _data["documentNotificationId"];
        }
    }

    static fromJS(data: any): SendDraftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendDraftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["documentType"] = this.documentType;
        data["documentId"] = this.documentId;
        data["documentNotificationId"] = this.documentNotificationId;
        return data; 
    }

    clone(): SendDraftRequest {
        const json = this.toJSON();
        let result = new SendDraftRequest();
        result.init(json);
        return result;
    }
}

export interface ISendDraftRequest {
    orderId: number;
    documentType: string | undefined;
    documentId: number | undefined;
    documentNotificationId: number | undefined;
}

export class SendDraftRequestList implements ISendDraftRequestList {
    drafts: SendDraftRequest[] | undefined;

    constructor(data?: ISendDraftRequestList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["drafts"])) {
                this.drafts = [] as any;
                for (let item of _data["drafts"])
                    this.drafts.push(SendDraftRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SendDraftRequestList {
        data = typeof data === 'object' ? data : {};
        let result = new SendDraftRequestList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.drafts)) {
            data["drafts"] = [];
            for (let item of this.drafts)
                data["drafts"].push(item.toJSON());
        }
        return data; 
    }

    clone(): SendDraftRequestList {
        const json = this.toJSON();
        let result = new SendDraftRequestList();
        result.init(json);
        return result;
    }
}

export interface ISendDraftRequestList {
    drafts: SendDraftRequest[] | undefined;
}

export class DocumentDtoPagedResultDto implements IDocumentDtoPagedResultDto {
    totalCount: number;
    items: DocumentDto[] | undefined;

    constructor(data?: IDocumentDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DocumentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): DocumentDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DocumentDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentDtoPagedResultDto {
    totalCount: number;
    items: DocumentDto[] | undefined;
}

export class FailedDeliveryItemDto implements IFailedDeliveryItemDto {
    sku: string | undefined;
    description: string | undefined;
    quantity: number;
    quantityFailed: number;
    comments: string | undefined;
    id: number;

    constructor(data?: IFailedDeliveryItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sku = _data["sku"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.quantityFailed = _data["quantityFailed"];
            this.comments = _data["comments"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FailedDeliveryItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new FailedDeliveryItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["quantityFailed"] = this.quantityFailed;
        data["comments"] = this.comments;
        data["id"] = this.id;
        return data; 
    }

    clone(): FailedDeliveryItemDto {
        const json = this.toJSON();
        let result = new FailedDeliveryItemDto();
        result.init(json);
        return result;
    }
}

export interface IFailedDeliveryItemDto {
    sku: string | undefined;
    description: string | undefined;
    quantity: number;
    quantityFailed: number;
    comments: string | undefined;
    id: number;
}

export class FailedDeliveryDto implements IFailedDeliveryDto {
    orderId: number;
    comments: string | undefined;
    failedItems: FailedDeliveryItemDto[] | undefined;
    id: number;

    constructor(data?: IFailedDeliveryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.comments = _data["comments"];
            if (Array.isArray(_data["failedItems"])) {
                this.failedItems = [] as any;
                for (let item of _data["failedItems"])
                    this.failedItems.push(FailedDeliveryItemDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FailedDeliveryDto {
        data = typeof data === 'object' ? data : {};
        let result = new FailedDeliveryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["comments"] = this.comments;
        if (Array.isArray(this.failedItems)) {
            data["failedItems"] = [];
            for (let item of this.failedItems)
                data["failedItems"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): FailedDeliveryDto {
        const json = this.toJSON();
        let result = new FailedDeliveryDto();
        result.init(json);
        return result;
    }
}

export interface IFailedDeliveryDto {
    orderId: number;
    comments: string | undefined;
    failedItems: FailedDeliveryItemDto[] | undefined;
    id: number;
}

export class FailedDeliveryDtoPagedResultDto implements IFailedDeliveryDtoPagedResultDto {
    totalCount: number;
    items: FailedDeliveryDto[] | undefined;

    constructor(data?: IFailedDeliveryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(FailedDeliveryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FailedDeliveryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FailedDeliveryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): FailedDeliveryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new FailedDeliveryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IFailedDeliveryDtoPagedResultDto {
    totalCount: number;
    items: FailedDeliveryDto[] | undefined;
}

export class FlyerDto implements IFlyerDto {
    code: string | undefined;
    color: string | undefined;
    isDefault: boolean;
    id: number;

    constructor(data?: IFlyerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.color = _data["color"];
            this.isDefault = _data["isDefault"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FlyerDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlyerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["color"] = this.color;
        data["isDefault"] = this.isDefault;
        data["id"] = this.id;
        return data; 
    }

    clone(): FlyerDto {
        const json = this.toJSON();
        let result = new FlyerDto();
        result.init(json);
        return result;
    }
}

export interface IFlyerDto {
    code: string | undefined;
    color: string | undefined;
    isDefault: boolean;
    id: number;
}

export class FlyerDtoPagedResultDto implements IFlyerDtoPagedResultDto {
    totalCount: number;
    items: FlyerDto[] | undefined;

    constructor(data?: IFlyerDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(FlyerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FlyerDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlyerDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): FlyerDtoPagedResultDto {
        const json = this.toJSON();
        let result = new FlyerDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IFlyerDtoPagedResultDto {
    totalCount: number;
    items: FlyerDto[] | undefined;
}

export class FlyerDistributionDto implements IFlyerDistributionDto {
    flyerId: number;
    flyer: FlyerDto;
    sourceName: SourceValueDto;
    city: string | undefined;
    postalCodeFrom: number;
    postalCodeTo: number;
    dateFrom: moment.Moment;
    dateTo: moment.Moment;
    name: string | undefined;
    id: number;

    constructor(data?: IFlyerDistributionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flyerId = _data["flyerId"];
            this.flyer = _data["flyer"] ? FlyerDto.fromJS(_data["flyer"]) : <any>undefined;
            this.sourceName = _data["sourceName"] ? SourceValueDto.fromJS(_data["sourceName"]) : <any>undefined;
            this.city = _data["city"];
            this.postalCodeFrom = _data["postalCodeFrom"];
            this.postalCodeTo = _data["postalCodeTo"];
            this.dateFrom = _data["dateFrom"] ? moment(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? moment(_data["dateTo"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FlyerDistributionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlyerDistributionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flyerId"] = this.flyerId;
        data["flyer"] = this.flyer ? this.flyer.toJSON() : <any>undefined;
        data["sourceName"] = this.sourceName ? this.sourceName.toJSON() : <any>undefined;
        data["city"] = this.city;
        data["postalCodeFrom"] = this.postalCodeFrom;
        data["postalCodeTo"] = this.postalCodeTo;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }

    clone(): FlyerDistributionDto {
        const json = this.toJSON();
        let result = new FlyerDistributionDto();
        result.init(json);
        return result;
    }
}

export interface IFlyerDistributionDto {
    flyerId: number;
    flyer: FlyerDto;
    sourceName: SourceValueDto;
    city: string | undefined;
    postalCodeFrom: number;
    postalCodeTo: number;
    dateFrom: moment.Moment;
    dateTo: moment.Moment;
    name: string | undefined;
    id: number;
}

export class FlyerUploadDto implements IFlyerUploadDto {
    url: string | undefined;
    countryCode: string | undefined;

    constructor(data?: IFlyerUploadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.countryCode = _data["countryCode"];
        }
    }

    static fromJS(data: any): FlyerUploadDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlyerUploadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["countryCode"] = this.countryCode;
        return data; 
    }

    clone(): FlyerUploadDto {
        const json = this.toJSON();
        let result = new FlyerUploadDto();
        result.init(json);
        return result;
    }
}

export interface IFlyerUploadDto {
    url: string | undefined;
    countryCode: string | undefined;
}

export class FlyerDistributionDtoPagedResultDto implements IFlyerDistributionDtoPagedResultDto {
    totalCount: number;
    items: FlyerDistributionDto[] | undefined;

    constructor(data?: IFlyerDistributionDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(FlyerDistributionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FlyerDistributionDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlyerDistributionDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): FlyerDistributionDtoPagedResultDto {
        const json = this.toJSON();
        let result = new FlyerDistributionDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IFlyerDistributionDtoPagedResultDto {
    totalCount: number;
    items: FlyerDistributionDto[] | undefined;
}

export class GeneralAuditOrderDetail implements IGeneralAuditOrderDetail {
    shipmentId: number;
    shipmentIssue: string | undefined;
    shipmentDate: moment.Moment;
    carrierName: string | undefined;

    constructor(data?: IGeneralAuditOrderDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shipmentId = _data["shipmentId"];
            this.shipmentIssue = _data["shipmentIssue"];
            this.shipmentDate = _data["shipmentDate"] ? moment(_data["shipmentDate"].toString()) : <any>undefined;
            this.carrierName = _data["carrierName"];
        }
    }

    static fromJS(data: any): GeneralAuditOrderDetail {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralAuditOrderDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shipmentId"] = this.shipmentId;
        data["shipmentIssue"] = this.shipmentIssue;
        data["shipmentDate"] = this.shipmentDate ? this.shipmentDate.toISOString() : <any>undefined;
        data["carrierName"] = this.carrierName;
        return data; 
    }

    clone(): GeneralAuditOrderDetail {
        const json = this.toJSON();
        let result = new GeneralAuditOrderDetail();
        result.init(json);
        return result;
    }
}

export interface IGeneralAuditOrderDetail {
    shipmentId: number;
    shipmentIssue: string | undefined;
    shipmentDate: moment.Moment;
    carrierName: string | undefined;
}

export class GeneralAuditDto implements IGeneralAuditDto {
    shipmentsCount: number;
    orderNumber: string | undefined;
    channel: string | undefined;
    reviewDate: moment.Moment;
    shippingType: string | undefined;
    logisticStatus: LogisticStatusValueDto;
    countryCode: string | undefined;
    quantityInClonflict: number;
    id: number;

    constructor(data?: IGeneralAuditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shipmentsCount = _data["shipmentsCount"];
            this.orderNumber = _data["orderNumber"];
            this.channel = _data["channel"];
            this.reviewDate = _data["reviewDate"] ? moment(_data["reviewDate"].toString()) : <any>undefined;
            this.shippingType = _data["shippingType"];
            this.logisticStatus = _data["logisticStatus"] ? LogisticStatusValueDto.fromJS(_data["logisticStatus"]) : <any>undefined;
            this.countryCode = _data["countryCode"];
            this.quantityInClonflict = _data["quantityInClonflict"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GeneralAuditDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralAuditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shipmentsCount"] = this.shipmentsCount;
        data["orderNumber"] = this.orderNumber;
        data["channel"] = this.channel;
        data["reviewDate"] = this.reviewDate ? this.reviewDate.toISOString() : <any>undefined;
        data["shippingType"] = this.shippingType;
        data["logisticStatus"] = this.logisticStatus ? this.logisticStatus.toJSON() : <any>undefined;
        data["countryCode"] = this.countryCode;
        data["quantityInClonflict"] = this.quantityInClonflict;
        data["id"] = this.id;
        return data; 
    }

    clone(): GeneralAuditDto {
        const json = this.toJSON();
        let result = new GeneralAuditDto();
        result.init(json);
        return result;
    }
}

export interface IGeneralAuditDto {
    shipmentsCount: number;
    orderNumber: string | undefined;
    channel: string | undefined;
    reviewDate: moment.Moment;
    shippingType: string | undefined;
    logisticStatus: LogisticStatusValueDto;
    countryCode: string | undefined;
    quantityInClonflict: number;
    id: number;
}

export class GeneralAuditDtoPagedResultDto implements IGeneralAuditDtoPagedResultDto {
    totalCount: number;
    items: GeneralAuditDto[] | undefined;

    constructor(data?: IGeneralAuditDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(GeneralAuditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GeneralAuditDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralAuditDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GeneralAuditDtoPagedResultDto {
        const json = this.toJSON();
        let result = new GeneralAuditDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IGeneralAuditDtoPagedResultDto {
    totalCount: number;
    items: GeneralAuditDto[] | undefined;
}

export class UploadHubDeliveryMappingDto implements IUploadHubDeliveryMappingDto {
    url: string | undefined;
    countryCode: string | undefined;

    constructor(data?: IUploadHubDeliveryMappingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.countryCode = _data["countryCode"];
        }
    }

    static fromJS(data: any): UploadHubDeliveryMappingDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadHubDeliveryMappingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["countryCode"] = this.countryCode;
        return data; 
    }

    clone(): UploadHubDeliveryMappingDto {
        const json = this.toJSON();
        let result = new UploadHubDeliveryMappingDto();
        result.init(json);
        return result;
    }
}

export interface IUploadHubDeliveryMappingDto {
    url: string | undefined;
    countryCode: string | undefined;
}

export class HubDeliveryMappingDto implements IHubDeliveryMappingDto {
    storeCode: string | undefined;
    sourceName: string | undefined;
    postalCode: string | undefined;
    countryCode: string | undefined;
    orderCreationWindow: string | undefined;
    isSunday: boolean;
    id: number;

    constructor(data?: IHubDeliveryMappingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeCode = _data["storeCode"];
            this.sourceName = _data["sourceName"];
            this.postalCode = _data["postalCode"];
            this.countryCode = _data["countryCode"];
            this.orderCreationWindow = _data["orderCreationWindow"];
            this.isSunday = _data["isSunday"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HubDeliveryMappingDto {
        data = typeof data === 'object' ? data : {};
        let result = new HubDeliveryMappingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeCode"] = this.storeCode;
        data["sourceName"] = this.sourceName;
        data["postalCode"] = this.postalCode;
        data["countryCode"] = this.countryCode;
        data["orderCreationWindow"] = this.orderCreationWindow;
        data["isSunday"] = this.isSunday;
        data["id"] = this.id;
        return data; 
    }

    clone(): HubDeliveryMappingDto {
        const json = this.toJSON();
        let result = new HubDeliveryMappingDto();
        result.init(json);
        return result;
    }
}

export interface IHubDeliveryMappingDto {
    storeCode: string | undefined;
    sourceName: string | undefined;
    postalCode: string | undefined;
    countryCode: string | undefined;
    orderCreationWindow: string | undefined;
    isSunday: boolean;
    id: number;
}

export class HubDeliveryMappingDtoPagedResultDto implements IHubDeliveryMappingDtoPagedResultDto {
    totalCount: number;
    items: HubDeliveryMappingDto[] | undefined;

    constructor(data?: IHubDeliveryMappingDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(HubDeliveryMappingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HubDeliveryMappingDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new HubDeliveryMappingDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): HubDeliveryMappingDtoPagedResultDto {
        const json = this.toJSON();
        let result = new HubDeliveryMappingDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IHubDeliveryMappingDtoPagedResultDto {
    totalCount: number;
    items: HubDeliveryMappingDto[] | undefined;
}

export class LandingInfoDto implements ILandingInfoDto {
    group: string | undefined;
    value: string | undefined;
    extraInfo: string | undefined;
    category: string | undefined;
    countryCode: string | undefined;
    id: number;

    constructor(data?: ILandingInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.group = _data["group"];
            this.value = _data["value"];
            this.extraInfo = _data["extraInfo"];
            this.category = _data["category"];
            this.countryCode = _data["countryCode"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LandingInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new LandingInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["group"] = this.group;
        data["value"] = this.value;
        data["extraInfo"] = this.extraInfo;
        data["category"] = this.category;
        data["countryCode"] = this.countryCode;
        data["id"] = this.id;
        return data; 
    }

    clone(): LandingInfoDto {
        const json = this.toJSON();
        let result = new LandingInfoDto();
        result.init(json);
        return result;
    }
}

export interface ILandingInfoDto {
    group: string | undefined;
    value: string | undefined;
    extraInfo: string | undefined;
    category: string | undefined;
    countryCode: string | undefined;
    id: number;
}

export class AddMeliNotification implements IAddMeliNotification {
    sourceCode: string | undefined;

    constructor(data?: IAddMeliNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceCode = _data["sourceCode"];
        }
    }

    static fromJS(data: any): AddMeliNotification {
        data = typeof data === 'object' ? data : {};
        let result = new AddMeliNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceCode"] = this.sourceCode;
        return data; 
    }

    clone(): AddMeliNotification {
        const json = this.toJSON();
        let result = new AddMeliNotification();
        result.init(json);
        return result;
    }
}

export interface IAddMeliNotification {
    sourceCode: string | undefined;
}

export class AddMeliNotificationResponse implements IAddMeliNotificationResponse {
    addOk: boolean;
    validationMsj: string | undefined;

    constructor(data?: IAddMeliNotificationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addOk = _data["addOk"];
            this.validationMsj = _data["validationMsj"];
        }
    }

    static fromJS(data: any): AddMeliNotificationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddMeliNotificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addOk"] = this.addOk;
        data["validationMsj"] = this.validationMsj;
        return data; 
    }

    clone(): AddMeliNotificationResponse {
        const json = this.toJSON();
        let result = new AddMeliNotificationResponse();
        result.init(json);
        return result;
    }
}

export interface IAddMeliNotificationResponse {
    addOk: boolean;
    validationMsj: string | undefined;
}

export class OrderDtoListResultDto implements IOrderDtoListResultDto {
    items: OrderDto[] | undefined;

    constructor(data?: IOrderDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): OrderDtoListResultDto {
        const json = this.toJSON();
        let result = new OrderDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDtoListResultDto {
    items: OrderDto[] | undefined;
}

export class DispatchOrderRequest implements IDispatchOrderRequest {
    orderId: number;
    relatedDocuments: OrderDocumentDto[] | undefined;

    constructor(data?: IDispatchOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            if (Array.isArray(_data["relatedDocuments"])) {
                this.relatedDocuments = [] as any;
                for (let item of _data["relatedDocuments"])
                    this.relatedDocuments.push(OrderDocumentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DispatchOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DispatchOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        if (Array.isArray(this.relatedDocuments)) {
            data["relatedDocuments"] = [];
            for (let item of this.relatedDocuments)
                data["relatedDocuments"].push(item.toJSON());
        }
        return data; 
    }

    clone(): DispatchOrderRequest {
        const json = this.toJSON();
        let result = new DispatchOrderRequest();
        result.init(json);
        return result;
    }
}

export interface IDispatchOrderRequest {
    orderId: number;
    relatedDocuments: OrderDocumentDto[] | undefined;
}

export class OrderCsvDashboardDto implements IOrderCsvDashboardDto {
    id: number;
    sourceOrderCode: string | undefined;
    salesChannel: string | undefined;
    sourceCreationTime: string | undefined;
    estimatedDeliveryDate: string | undefined;
    timeZone: string | undefined;
    shippingType: string | undefined;
    currentOverallStatus: string | undefined;
    currentLogisticStatus: string | undefined;
    customerDocument: string | undefined;
    customer: string | undefined;
    deliveryAddress: string | undefined;
    customerPhone: string | undefined;
    invoiceNumber: string | undefined;
    netValue: number;
    totalValue: number;
    carrier: string | undefined;
    currentAssignedToStore: string | undefined;
    distanceTraveled: string | undefined;
    orderNotes: string | undefined;
    geoLat: string | undefined;
    geoLong: string | undefined;
    shipmentDeliveredOn: string | undefined;

    constructor(data?: IOrderCsvDashboardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceOrderCode = _data["sourceOrderCode"];
            this.salesChannel = _data["salesChannel"];
            this.sourceCreationTime = _data["sourceCreationTime"];
            this.estimatedDeliveryDate = _data["estimatedDeliveryDate"];
            this.timeZone = _data["timeZone"];
            this.shippingType = _data["shippingType"];
            this.currentOverallStatus = _data["currentOverallStatus"];
            this.currentLogisticStatus = _data["currentLogisticStatus"];
            this.customerDocument = _data["customerDocument"];
            this.customer = _data["customer"];
            this.deliveryAddress = _data["deliveryAddress"];
            this.customerPhone = _data["customerPhone"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.netValue = _data["netValue"];
            this.totalValue = _data["totalValue"];
            this.carrier = _data["carrier"];
            this.currentAssignedToStore = _data["currentAssignedToStore"];
            this.distanceTraveled = _data["distanceTraveled"];
            this.orderNotes = _data["orderNotes"];
            this.geoLat = _data["geoLat"];
            this.geoLong = _data["geoLong"];
            this.shipmentDeliveredOn = _data["shipmentDeliveredOn"];
        }
    }

    static fromJS(data: any): OrderCsvDashboardDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCsvDashboardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceOrderCode"] = this.sourceOrderCode;
        data["salesChannel"] = this.salesChannel;
        data["sourceCreationTime"] = this.sourceCreationTime;
        data["estimatedDeliveryDate"] = this.estimatedDeliveryDate;
        data["timeZone"] = this.timeZone;
        data["shippingType"] = this.shippingType;
        data["currentOverallStatus"] = this.currentOverallStatus;
        data["currentLogisticStatus"] = this.currentLogisticStatus;
        data["customerDocument"] = this.customerDocument;
        data["customer"] = this.customer;
        data["deliveryAddress"] = this.deliveryAddress;
        data["customerPhone"] = this.customerPhone;
        data["invoiceNumber"] = this.invoiceNumber;
        data["netValue"] = this.netValue;
        data["totalValue"] = this.totalValue;
        data["carrier"] = this.carrier;
        data["currentAssignedToStore"] = this.currentAssignedToStore;
        data["distanceTraveled"] = this.distanceTraveled;
        data["orderNotes"] = this.orderNotes;
        data["geoLat"] = this.geoLat;
        data["geoLong"] = this.geoLong;
        data["shipmentDeliveredOn"] = this.shipmentDeliveredOn;
        return data; 
    }

    clone(): OrderCsvDashboardDto {
        const json = this.toJSON();
        let result = new OrderCsvDashboardDto();
        result.init(json);
        return result;
    }
}

export interface IOrderCsvDashboardDto {
    id: number;
    sourceOrderCode: string | undefined;
    salesChannel: string | undefined;
    sourceCreationTime: string | undefined;
    estimatedDeliveryDate: string | undefined;
    timeZone: string | undefined;
    shippingType: string | undefined;
    currentOverallStatus: string | undefined;
    currentLogisticStatus: string | undefined;
    customerDocument: string | undefined;
    customer: string | undefined;
    deliveryAddress: string | undefined;
    customerPhone: string | undefined;
    invoiceNumber: string | undefined;
    netValue: number;
    totalValue: number;
    carrier: string | undefined;
    currentAssignedToStore: string | undefined;
    distanceTraveled: string | undefined;
    orderNotes: string | undefined;
    geoLat: string | undefined;
    geoLong: string | undefined;
    shipmentDeliveredOn: string | undefined;
}

export class OrderCsvOLDto implements IOrderCsvOLDto {
    orderId: number;
    dispatchDate: string | undefined;
    dispatchTime: string | undefined;
    estimatedDeliveryDateFrom: string | undefined;
    estimatedDeliveryDateFromTime: string | undefined;
    city: string | undefined;
    state: string | undefined;
    customerCode: string | undefined;
    customer: string | undefined;
    documentNumber: string | undefined;
    email: string | undefined;
    shippingType: string | undefined;
    address: string | undefined;
    postalCode: string | undefined;
    complement: string | undefined;
    franjaHoraria: string | undefined;
    canalDeEntrega: string | undefined;
    estadoGeneral: string | undefined;
    tiendaAsignada: string | undefined;

    constructor(data?: IOrderCsvOLDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.dispatchDate = _data["dispatchDate"];
            this.dispatchTime = _data["dispatchTime"];
            this.estimatedDeliveryDateFrom = _data["estimatedDeliveryDateFrom"];
            this.estimatedDeliveryDateFromTime = _data["estimatedDeliveryDateFromTime"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.customerCode = _data["customerCode"];
            this.customer = _data["customer"];
            this.documentNumber = _data["documentNumber"];
            this.email = _data["email"];
            this.shippingType = _data["shippingType"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
            this.complement = _data["complement"];
            this.franjaHoraria = _data["franjaHoraria"];
            this.canalDeEntrega = _data["canalDeEntrega"];
            this.estadoGeneral = _data["estadoGeneral"];
            this.tiendaAsignada = _data["tiendaAsignada"];
        }
    }

    static fromJS(data: any): OrderCsvOLDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCsvOLDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["dispatchDate"] = this.dispatchDate;
        data["dispatchTime"] = this.dispatchTime;
        data["estimatedDeliveryDateFrom"] = this.estimatedDeliveryDateFrom;
        data["estimatedDeliveryDateFromTime"] = this.estimatedDeliveryDateFromTime;
        data["city"] = this.city;
        data["state"] = this.state;
        data["customerCode"] = this.customerCode;
        data["customer"] = this.customer;
        data["documentNumber"] = this.documentNumber;
        data["email"] = this.email;
        data["shippingType"] = this.shippingType;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["complement"] = this.complement;
        data["franjaHoraria"] = this.franjaHoraria;
        data["canalDeEntrega"] = this.canalDeEntrega;
        data["estadoGeneral"] = this.estadoGeneral;
        data["tiendaAsignada"] = this.tiendaAsignada;
        return data; 
    }

    clone(): OrderCsvOLDto {
        const json = this.toJSON();
        let result = new OrderCsvOLDto();
        result.init(json);
        return result;
    }
}

export interface IOrderCsvOLDto {
    orderId: number;
    dispatchDate: string | undefined;
    dispatchTime: string | undefined;
    estimatedDeliveryDateFrom: string | undefined;
    estimatedDeliveryDateFromTime: string | undefined;
    city: string | undefined;
    state: string | undefined;
    customerCode: string | undefined;
    customer: string | undefined;
    documentNumber: string | undefined;
    email: string | undefined;
    shippingType: string | undefined;
    address: string | undefined;
    postalCode: string | undefined;
    complement: string | undefined;
    franjaHoraria: string | undefined;
    canalDeEntrega: string | undefined;
    estadoGeneral: string | undefined;
    tiendaAsignada: string | undefined;
}

export class OrderCsvQuadminDto implements IOrderCsvQuadminDto {
    customerCode: string | undefined;
    customer: string | undefined;
    address: string | undefined;
    city: string | undefined;
    state: string | undefined;
    geoLat: number | undefined;
    geoLong: number | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    orderId: number;
    dispatchTime: string | undefined;
    operation: string | undefined;
    sku: string | undefined;
    productDescription: string | undefined;
    quantity: number | undefined;
    weight: number;
    volume: number | undefined;
    money: string | undefined;
    clientDelay: string | undefined;
    deliveryWindow1: string | undefined;
    deliveryWindow2: string | undefined;
    deliveryCommentaries: string | undefined;
    group: string | undefined;
    withdrawTime: moment.Moment | undefined;

    constructor(data?: IOrderCsvQuadminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerCode = _data["customerCode"];
            this.customer = _data["customer"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.geoLat = _data["geoLat"];
            this.geoLong = _data["geoLong"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.orderId = _data["orderId"];
            this.dispatchTime = _data["dispatchTime"];
            this.operation = _data["operation"];
            this.sku = _data["sku"];
            this.productDescription = _data["productDescription"];
            this.quantity = _data["quantity"];
            this.weight = _data["weight"];
            this.volume = _data["volume"];
            this.money = _data["money"];
            this.clientDelay = _data["clientDelay"];
            this.deliveryWindow1 = _data["deliveryWindow1"];
            this.deliveryWindow2 = _data["deliveryWindow2"];
            this.deliveryCommentaries = _data["deliveryCommentaries"];
            this.group = _data["group"];
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderCsvQuadminDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCsvQuadminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerCode"] = this.customerCode;
        data["customer"] = this.customer;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["geoLat"] = this.geoLat;
        data["geoLong"] = this.geoLong;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["orderId"] = this.orderId;
        data["dispatchTime"] = this.dispatchTime;
        data["operation"] = this.operation;
        data["sku"] = this.sku;
        data["productDescription"] = this.productDescription;
        data["quantity"] = this.quantity;
        data["weight"] = this.weight;
        data["volume"] = this.volume;
        data["money"] = this.money;
        data["clientDelay"] = this.clientDelay;
        data["deliveryWindow1"] = this.deliveryWindow1;
        data["deliveryWindow2"] = this.deliveryWindow2;
        data["deliveryCommentaries"] = this.deliveryCommentaries;
        data["group"] = this.group;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : <any>undefined;
        return data; 
    }

    clone(): OrderCsvQuadminDto {
        const json = this.toJSON();
        let result = new OrderCsvQuadminDto();
        result.init(json);
        return result;
    }
}

export interface IOrderCsvQuadminDto {
    customerCode: string | undefined;
    customer: string | undefined;
    address: string | undefined;
    city: string | undefined;
    state: string | undefined;
    geoLat: number | undefined;
    geoLong: number | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    orderId: number;
    dispatchTime: string | undefined;
    operation: string | undefined;
    sku: string | undefined;
    productDescription: string | undefined;
    quantity: number | undefined;
    weight: number;
    volume: number | undefined;
    money: string | undefined;
    clientDelay: string | undefined;
    deliveryWindow1: string | undefined;
    deliveryWindow2: string | undefined;
    deliveryCommentaries: string | undefined;
    group: string | undefined;
    withdrawTime: moment.Moment | undefined;
}

export class SendToQuadmindsDto implements ISendToQuadmindsDto {
    orders: number[] | undefined;
    countryCode: string | undefined;
    type: string | undefined;

    constructor(data?: ISendToQuadmindsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders.push(item);
            }
            this.countryCode = _data["countryCode"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): SendToQuadmindsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendToQuadmindsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item);
        }
        data["countryCode"] = this.countryCode;
        data["type"] = this.type;
        return data; 
    }

    clone(): SendToQuadmindsDto {
        const json = this.toJSON();
        let result = new SendToQuadmindsDto();
        result.init(json);
        return result;
    }
}

export interface ISendToQuadmindsDto {
    orders: number[] | undefined;
    countryCode: string | undefined;
    type: string | undefined;
}

export class OrderUpdateReturnAssignedRequest implements IOrderUpdateReturnAssignedRequest {
    orderIds: number[];
    reason: string | undefined;

    constructor(data?: IOrderUpdateReturnAssignedRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.orderIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orderIds"])) {
                this.orderIds = [] as any;
                for (let item of _data["orderIds"])
                    this.orderIds.push(item);
            }
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): OrderUpdateReturnAssignedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderUpdateReturnAssignedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderIds)) {
            data["orderIds"] = [];
            for (let item of this.orderIds)
                data["orderIds"].push(item);
        }
        data["reason"] = this.reason;
        return data; 
    }

    clone(): OrderUpdateReturnAssignedRequest {
        const json = this.toJSON();
        let result = new OrderUpdateReturnAssignedRequest();
        result.init(json);
        return result;
    }
}

export interface IOrderUpdateReturnAssignedRequest {
    orderIds: number[];
    reason: string | undefined;
}

export class OrderUpdateAssignedStoreRequest implements IOrderUpdateAssignedStoreRequest {
    orderIds: number[];
    storeCode: string;

    constructor(data?: IOrderUpdateAssignedStoreRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.orderIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orderIds"])) {
                this.orderIds = [] as any;
                for (let item of _data["orderIds"])
                    this.orderIds.push(item);
            }
            this.storeCode = _data["storeCode"];
        }
    }

    static fromJS(data: any): OrderUpdateAssignedStoreRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderUpdateAssignedStoreRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderIds)) {
            data["orderIds"] = [];
            for (let item of this.orderIds)
                data["orderIds"].push(item);
        }
        data["storeCode"] = this.storeCode;
        return data; 
    }

    clone(): OrderUpdateAssignedStoreRequest {
        const json = this.toJSON();
        let result = new OrderUpdateAssignedStoreRequest();
        result.init(json);
        return result;
    }
}

export interface IOrderUpdateAssignedStoreRequest {
    orderIds: number[];
    storeCode: string;
}

export class OrderUpdateCarrierRequest implements IOrderUpdateCarrierRequest {
    orderIds: number[];
    carrierId: number;
    carrierDriverId: number;

    constructor(data?: IOrderUpdateCarrierRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.orderIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orderIds"])) {
                this.orderIds = [] as any;
                for (let item of _data["orderIds"])
                    this.orderIds.push(item);
            }
            this.carrierId = _data["carrierId"];
            this.carrierDriverId = _data["carrierDriverId"];
        }
    }

    static fromJS(data: any): OrderUpdateCarrierRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderUpdateCarrierRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderIds)) {
            data["orderIds"] = [];
            for (let item of this.orderIds)
                data["orderIds"].push(item);
        }
        data["carrierId"] = this.carrierId;
        data["carrierDriverId"] = this.carrierDriverId;
        return data; 
    }

    clone(): OrderUpdateCarrierRequest {
        const json = this.toJSON();
        let result = new OrderUpdateCarrierRequest();
        result.init(json);
        return result;
    }
}

export interface IOrderUpdateCarrierRequest {
    orderIds: number[];
    carrierId: number;
    carrierDriverId: number;
}

export class OrderUpdateStatusRequest implements IOrderUpdateStatusRequest {
    orderIds: number[];
    commercialStatusId: number | undefined;
    financialStatusId: number | undefined;
    logisticStatusId: number | undefined;
    overallStatusId: number | undefined;
    logisticAuditStatusId: number | undefined;

    constructor(data?: IOrderUpdateStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.orderIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orderIds"])) {
                this.orderIds = [] as any;
                for (let item of _data["orderIds"])
                    this.orderIds.push(item);
            }
            this.commercialStatusId = _data["commercialStatusId"];
            this.financialStatusId = _data["financialStatusId"];
            this.logisticStatusId = _data["logisticStatusId"];
            this.overallStatusId = _data["overallStatusId"];
            this.logisticAuditStatusId = _data["logisticAuditStatusId"];
        }
    }

    static fromJS(data: any): OrderUpdateStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderUpdateStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderIds)) {
            data["orderIds"] = [];
            for (let item of this.orderIds)
                data["orderIds"].push(item);
        }
        data["commercialStatusId"] = this.commercialStatusId;
        data["financialStatusId"] = this.financialStatusId;
        data["logisticStatusId"] = this.logisticStatusId;
        data["overallStatusId"] = this.overallStatusId;
        data["logisticAuditStatusId"] = this.logisticAuditStatusId;
        return data; 
    }

    clone(): OrderUpdateStatusRequest {
        const json = this.toJSON();
        let result = new OrderUpdateStatusRequest();
        result.init(json);
        return result;
    }
}

export interface IOrderUpdateStatusRequest {
    orderIds: number[];
    commercialStatusId: number | undefined;
    financialStatusId: number | undefined;
    logisticStatusId: number | undefined;
    overallStatusId: number | undefined;
    logisticAuditStatusId: number | undefined;
}

export class OrderReturnedStatusRequest implements IOrderReturnedStatusRequest {
    orderId: number;
    logisticStatus: number;
    reason: string | undefined;
    shipmentId: number;
    failedDelivery: FailedDeliveryDto;

    constructor(data?: IOrderReturnedStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.logisticStatus = _data["logisticStatus"];
            this.reason = _data["reason"];
            this.shipmentId = _data["shipmentId"];
            this.failedDelivery = _data["failedDelivery"] ? FailedDeliveryDto.fromJS(_data["failedDelivery"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderReturnedStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderReturnedStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["logisticStatus"] = this.logisticStatus;
        data["reason"] = this.reason;
        data["shipmentId"] = this.shipmentId;
        data["failedDelivery"] = this.failedDelivery ? this.failedDelivery.toJSON() : <any>undefined;
        return data; 
    }

    clone(): OrderReturnedStatusRequest {
        const json = this.toJSON();
        let result = new OrderReturnedStatusRequest();
        result.init(json);
        return result;
    }
}

export interface IOrderReturnedStatusRequest {
    orderId: number;
    logisticStatus: number;
    reason: string | undefined;
    shipmentId: number;
    failedDelivery: FailedDeliveryDto;
}

export class OrderUpdateHeaderRequest implements IOrderUpdateHeaderRequest {
    orderId: number;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    documentNumber: string;
    street: string;
    number: string;
    city: string;
    state: string;
    postalCode: string;
    dispatchTag: string | undefined;
    dispatchDate: moment.Moment | undefined;
    estimatedDeliveryDateFrom: moment.Moment | undefined;
    withdrawTime: moment.Moment | undefined;
    shippingTypeId: number;
    receiverName: string | undefined;
    pickupStoreCode: string | undefined;

    constructor(data?: IOrderUpdateHeaderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.documentNumber = _data["documentNumber"];
            this.street = _data["street"];
            this.number = _data["number"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
            this.dispatchTag = _data["dispatchTag"];
            this.dispatchDate = _data["dispatchDate"] ? moment(_data["dispatchDate"].toString()) : <any>undefined;
            this.estimatedDeliveryDateFrom = _data["estimatedDeliveryDateFrom"] ? moment(_data["estimatedDeliveryDateFrom"].toString()) : <any>undefined;
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : <any>undefined;
            this.shippingTypeId = _data["shippingTypeId"];
            this.receiverName = _data["receiverName"];
            this.pickupStoreCode = _data["pickupStoreCode"];
        }
    }

    static fromJS(data: any): OrderUpdateHeaderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderUpdateHeaderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["documentNumber"] = this.documentNumber;
        data["street"] = this.street;
        data["number"] = this.number;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["dispatchTag"] = this.dispatchTag;
        data["dispatchDate"] = this.dispatchDate ? this.dispatchDate.toISOString() : <any>undefined;
        data["estimatedDeliveryDateFrom"] = this.estimatedDeliveryDateFrom ? this.estimatedDeliveryDateFrom.toISOString() : <any>undefined;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : <any>undefined;
        data["shippingTypeId"] = this.shippingTypeId;
        data["receiverName"] = this.receiverName;
        data["pickupStoreCode"] = this.pickupStoreCode;
        return data; 
    }

    clone(): OrderUpdateHeaderRequest {
        const json = this.toJSON();
        let result = new OrderUpdateHeaderRequest();
        result.init(json);
        return result;
    }
}

export interface IOrderUpdateHeaderRequest {
    orderId: number;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    documentNumber: string;
    street: string;
    number: string;
    city: string;
    state: string;
    postalCode: string;
    dispatchTag: string | undefined;
    dispatchDate: moment.Moment | undefined;
    estimatedDeliveryDateFrom: moment.Moment | undefined;
    withdrawTime: moment.Moment | undefined;
    shippingTypeId: number;
    receiverName: string | undefined;
    pickupStoreCode: string | undefined;
}

export class OrderItemUpdateDto implements IOrderItemUpdateDto {
    sourceCode: string | undefined;
    sku: string | undefined;
    description: string | undefined;
    imageUrl: string | undefined;
    price: number;
    quantity: number;
    id: number;

    constructor(data?: IOrderItemUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceCode = _data["sourceCode"];
            this.sku = _data["sku"];
            this.description = _data["description"];
            this.imageUrl = _data["imageUrl"];
            this.price = _data["price"];
            this.quantity = _data["quantity"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderItemUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceCode"] = this.sourceCode;
        data["sku"] = this.sku;
        data["description"] = this.description;
        data["imageUrl"] = this.imageUrl;
        data["price"] = this.price;
        data["quantity"] = this.quantity;
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderItemUpdateDto {
        const json = this.toJSON();
        let result = new OrderItemUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IOrderItemUpdateDto {
    sourceCode: string | undefined;
    sku: string | undefined;
    description: string | undefined;
    imageUrl: string | undefined;
    price: number;
    quantity: number;
    id: number;
}

export class OrderUpdateItemsRequest implements IOrderUpdateItemsRequest {
    orderId: number;
    orderItems: OrderItemUpdateDto[] | undefined;
    addedOrderItems: OrderItemUpdateDto[] | undefined;
    removedOrderItems: OrderItemUpdateDto[] | undefined;
    updatedOrderItems: OrderItemUpdateDto[] | undefined;
    updatePromoItemsPrice: boolean;

    constructor(data?: IOrderUpdateItemsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems.push(OrderItemUpdateDto.fromJS(item));
            }
            if (Array.isArray(_data["addedOrderItems"])) {
                this.addedOrderItems = [] as any;
                for (let item of _data["addedOrderItems"])
                    this.addedOrderItems.push(OrderItemUpdateDto.fromJS(item));
            }
            if (Array.isArray(_data["removedOrderItems"])) {
                this.removedOrderItems = [] as any;
                for (let item of _data["removedOrderItems"])
                    this.removedOrderItems.push(OrderItemUpdateDto.fromJS(item));
            }
            if (Array.isArray(_data["updatedOrderItems"])) {
                this.updatedOrderItems = [] as any;
                for (let item of _data["updatedOrderItems"])
                    this.updatedOrderItems.push(OrderItemUpdateDto.fromJS(item));
            }
            this.updatePromoItemsPrice = _data["updatePromoItemsPrice"];
        }
    }

    static fromJS(data: any): OrderUpdateItemsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderUpdateItemsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        if (Array.isArray(this.addedOrderItems)) {
            data["addedOrderItems"] = [];
            for (let item of this.addedOrderItems)
                data["addedOrderItems"].push(item.toJSON());
        }
        if (Array.isArray(this.removedOrderItems)) {
            data["removedOrderItems"] = [];
            for (let item of this.removedOrderItems)
                data["removedOrderItems"].push(item.toJSON());
        }
        if (Array.isArray(this.updatedOrderItems)) {
            data["updatedOrderItems"] = [];
            for (let item of this.updatedOrderItems)
                data["updatedOrderItems"].push(item.toJSON());
        }
        data["updatePromoItemsPrice"] = this.updatePromoItemsPrice;
        return data; 
    }

    clone(): OrderUpdateItemsRequest {
        const json = this.toJSON();
        let result = new OrderUpdateItemsRequest();
        result.init(json);
        return result;
    }
}

export interface IOrderUpdateItemsRequest {
    orderId: number;
    orderItems: OrderItemUpdateDto[] | undefined;
    addedOrderItems: OrderItemUpdateDto[] | undefined;
    removedOrderItems: OrderItemUpdateDto[] | undefined;
    updatedOrderItems: OrderItemUpdateDto[] | undefined;
    updatePromoItemsPrice: boolean;
}

export class GridConfigRequest implements IGridConfigRequest {
    gridName: string | undefined;
    excludedColumns: string | undefined;

    constructor(data?: IGridConfigRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gridName = _data["gridName"];
            this.excludedColumns = _data["excludedColumns"];
        }
    }

    static fromJS(data: any): GridConfigRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GridConfigRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gridName"] = this.gridName;
        data["excludedColumns"] = this.excludedColumns;
        return data; 
    }

    clone(): GridConfigRequest {
        const json = this.toJSON();
        let result = new GridConfigRequest();
        result.init(json);
        return result;
    }
}

export interface IGridConfigRequest {
    gridName: string | undefined;
    excludedColumns: string | undefined;
}

export class OrderDetailDto implements IOrderDetailDto {
    sourceCreationTime: moment.Moment | undefined;
    currentAssignedToStore: string | undefined;
    currentLogisticStatus: string | undefined;
    currentOverallStatus: string | undefined;
    currentCommercialStatus: string | undefined;
    currentFinancialStatus: string | undefined;
    currentLogisticStatusId: number;
    currentOverallStatusId: number;
    currentCommercialStatusId: number;
    currentFinancialStatusId: number;
    sourceCode: string | undefined;
    deliverySourceCode: string | undefined;
    sourceName: string | undefined;
    readonly highlighted: boolean;
    carrierId: number | undefined;
    pickupStoreCode: string | undefined;
    replacementCriteria: string | undefined;
    id: number;

    constructor(data?: IOrderDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceCreationTime = _data["sourceCreationTime"] ? moment(_data["sourceCreationTime"].toString()) : <any>undefined;
            this.currentAssignedToStore = _data["currentAssignedToStore"];
            this.currentLogisticStatus = _data["currentLogisticStatus"];
            this.currentOverallStatus = _data["currentOverallStatus"];
            this.currentCommercialStatus = _data["currentCommercialStatus"];
            this.currentFinancialStatus = _data["currentFinancialStatus"];
            this.currentLogisticStatusId = _data["currentLogisticStatusId"];
            this.currentOverallStatusId = _data["currentOverallStatusId"];
            this.currentCommercialStatusId = _data["currentCommercialStatusId"];
            this.currentFinancialStatusId = _data["currentFinancialStatusId"];
            this.sourceCode = _data["sourceCode"];
            this.deliverySourceCode = _data["deliverySourceCode"];
            this.sourceName = _data["sourceName"];
            (<any>this).highlighted = _data["highlighted"];
            this.carrierId = _data["carrierId"];
            this.pickupStoreCode = _data["pickupStoreCode"];
            this.replacementCriteria = _data["replacementCriteria"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceCreationTime"] = this.sourceCreationTime ? this.sourceCreationTime.toISOString() : <any>undefined;
        data["currentAssignedToStore"] = this.currentAssignedToStore;
        data["currentLogisticStatus"] = this.currentLogisticStatus;
        data["currentOverallStatus"] = this.currentOverallStatus;
        data["currentCommercialStatus"] = this.currentCommercialStatus;
        data["currentFinancialStatus"] = this.currentFinancialStatus;
        data["currentLogisticStatusId"] = this.currentLogisticStatusId;
        data["currentOverallStatusId"] = this.currentOverallStatusId;
        data["currentCommercialStatusId"] = this.currentCommercialStatusId;
        data["currentFinancialStatusId"] = this.currentFinancialStatusId;
        data["sourceCode"] = this.sourceCode;
        data["deliverySourceCode"] = this.deliverySourceCode;
        data["sourceName"] = this.sourceName;
        data["highlighted"] = this.highlighted;
        data["carrierId"] = this.carrierId;
        data["pickupStoreCode"] = this.pickupStoreCode;
        data["replacementCriteria"] = this.replacementCriteria;
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderDetailDto {
        const json = this.toJSON();
        let result = new OrderDetailDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDetailDto {
    sourceCreationTime: moment.Moment | undefined;
    currentAssignedToStore: string | undefined;
    currentLogisticStatus: string | undefined;
    currentOverallStatus: string | undefined;
    currentCommercialStatus: string | undefined;
    currentFinancialStatus: string | undefined;
    currentLogisticStatusId: number;
    currentOverallStatusId: number;
    currentCommercialStatusId: number;
    currentFinancialStatusId: number;
    sourceCode: string | undefined;
    deliverySourceCode: string | undefined;
    sourceName: string | undefined;
    highlighted: boolean;
    carrierId: number | undefined;
    pickupStoreCode: string | undefined;
    replacementCriteria: string | undefined;
    id: number;
}

export class OrderDetailClaimDto implements IOrderDetailClaimDto {
    creationTime: moment.Moment;
    description: string | undefined;
    type: string | undefined;
    withdrawTime: moment.Moment | undefined;
    id: number;

    constructor(data?: IOrderDetailClaimDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.type = _data["type"];
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderDetailClaimDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailClaimDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["type"] = this.type;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderDetailClaimDto {
        const json = this.toJSON();
        let result = new OrderDetailClaimDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDetailClaimDto {
    creationTime: moment.Moment;
    description: string | undefined;
    type: string | undefined;
    withdrawTime: moment.Moment | undefined;
    id: number;
}

export class OrderDetailEventLogDto implements IOrderDetailEventLogDto {
    creatorUserId: number | undefined;
    creatorName: string | undefined;
    creationTime: moment.Moment;
    description: string | undefined;
    id: number;

    constructor(data?: IOrderDetailEventLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creatorUserId = _data["creatorUserId"];
            this.creatorName = _data["creatorName"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderDetailEventLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailEventLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creatorUserId"] = this.creatorUserId;
        data["creatorName"] = this.creatorName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderDetailEventLogDto {
        const json = this.toJSON();
        let result = new OrderDetailEventLogDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDetailEventLogDto {
    creatorUserId: number | undefined;
    creatorName: string | undefined;
    creationTime: moment.Moment;
    description: string | undefined;
    id: number;
}

export class OrderHeaderCustomerDto implements IOrderHeaderCustomerDto {
    code: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    documentNumber: string | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;

    constructor(data?: IOrderHeaderCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.documentNumber = _data["documentNumber"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): OrderHeaderCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderHeaderCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["documentNumber"] = this.documentNumber;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        return data; 
    }

    clone(): OrderHeaderCustomerDto {
        const json = this.toJSON();
        let result = new OrderHeaderCustomerDto();
        result.init(json);
        return result;
    }
}

export interface IOrderHeaderCustomerDto {
    code: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    documentNumber: string | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
}

export class OrderHeaderDeliveryDataDto implements IOrderHeaderDeliveryDataDto {
    estimatedDeliveryDateFrom: moment.Moment | undefined;
    estimatedDeliveryDateTo: moment.Moment | undefined;
    deliveryType: string | undefined;
    shippingType: string | undefined;
    street: string | undefined;
    number: string | undefined;
    city: string | undefined;
    geoLat: number | undefined;
    geoLong: number | undefined;
    trackingNumber: string | undefined;
    readonly completeAddress: string | undefined;
    receiverName: string | undefined;
    complement: string | undefined;
    neighborhood: string | undefined;

    constructor(data?: IOrderHeaderDeliveryDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.estimatedDeliveryDateFrom = _data["estimatedDeliveryDateFrom"] ? moment(_data["estimatedDeliveryDateFrom"].toString()) : <any>undefined;
            this.estimatedDeliveryDateTo = _data["estimatedDeliveryDateTo"] ? moment(_data["estimatedDeliveryDateTo"].toString()) : <any>undefined;
            this.deliveryType = _data["deliveryType"];
            this.shippingType = _data["shippingType"];
            this.street = _data["street"];
            this.number = _data["number"];
            this.city = _data["city"];
            this.geoLat = _data["geoLat"];
            this.geoLong = _data["geoLong"];
            this.trackingNumber = _data["trackingNumber"];
            (<any>this).completeAddress = _data["completeAddress"];
            this.receiverName = _data["receiverName"];
            this.complement = _data["complement"];
            this.neighborhood = _data["neighborhood"];
        }
    }

    static fromJS(data: any): OrderHeaderDeliveryDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderHeaderDeliveryDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estimatedDeliveryDateFrom"] = this.estimatedDeliveryDateFrom ? this.estimatedDeliveryDateFrom.toISOString() : <any>undefined;
        data["estimatedDeliveryDateTo"] = this.estimatedDeliveryDateTo ? this.estimatedDeliveryDateTo.toISOString() : <any>undefined;
        data["deliveryType"] = this.deliveryType;
        data["shippingType"] = this.shippingType;
        data["street"] = this.street;
        data["number"] = this.number;
        data["city"] = this.city;
        data["geoLat"] = this.geoLat;
        data["geoLong"] = this.geoLong;
        data["trackingNumber"] = this.trackingNumber;
        data["completeAddress"] = this.completeAddress;
        data["receiverName"] = this.receiverName;
        data["complement"] = this.complement;
        data["neighborhood"] = this.neighborhood;
        return data; 
    }

    clone(): OrderHeaderDeliveryDataDto {
        const json = this.toJSON();
        let result = new OrderHeaderDeliveryDataDto();
        result.init(json);
        return result;
    }
}

export interface IOrderHeaderDeliveryDataDto {
    estimatedDeliveryDateFrom: moment.Moment | undefined;
    estimatedDeliveryDateTo: moment.Moment | undefined;
    deliveryType: string | undefined;
    shippingType: string | undefined;
    street: string | undefined;
    number: string | undefined;
    city: string | undefined;
    geoLat: number | undefined;
    geoLong: number | undefined;
    trackingNumber: string | undefined;
    completeAddress: string | undefined;
    receiverName: string | undefined;
    complement: string | undefined;
    neighborhood: string | undefined;
}

export class OrderDetailHeaderDto implements IOrderDetailHeaderDto {
    dispatchDate: moment.Moment | undefined;
    withdrawTime: moment.Moment | undefined;
    dispatchTag: string | undefined;
    carrierName: string | undefined;
    pickupStoreCode: string | undefined;
    customer: OrderHeaderCustomerDto;
    deliveryData: OrderHeaderDeliveryDataDto;
    stockStatus: string | undefined;
    currentFinancialStatus: string | undefined;
    currentFinancialStatusId: number;
    id: number;

    constructor(data?: IOrderDetailHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dispatchDate = _data["dispatchDate"] ? moment(_data["dispatchDate"].toString()) : <any>undefined;
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : <any>undefined;
            this.dispatchTag = _data["dispatchTag"];
            this.carrierName = _data["carrierName"];
            this.pickupStoreCode = _data["pickupStoreCode"];
            this.customer = _data["customer"] ? OrderHeaderCustomerDto.fromJS(_data["customer"]) : <any>undefined;
            this.deliveryData = _data["deliveryData"] ? OrderHeaderDeliveryDataDto.fromJS(_data["deliveryData"]) : <any>undefined;
            this.stockStatus = _data["stockStatus"];
            this.currentFinancialStatus = _data["currentFinancialStatus"];
            this.currentFinancialStatusId = _data["currentFinancialStatusId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderDetailHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dispatchDate"] = this.dispatchDate ? this.dispatchDate.toISOString() : <any>undefined;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : <any>undefined;
        data["dispatchTag"] = this.dispatchTag;
        data["carrierName"] = this.carrierName;
        data["pickupStoreCode"] = this.pickupStoreCode;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["deliveryData"] = this.deliveryData ? this.deliveryData.toJSON() : <any>undefined;
        data["stockStatus"] = this.stockStatus;
        data["currentFinancialStatus"] = this.currentFinancialStatus;
        data["currentFinancialStatusId"] = this.currentFinancialStatusId;
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderDetailHeaderDto {
        const json = this.toJSON();
        let result = new OrderDetailHeaderDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDetailHeaderDto {
    dispatchDate: moment.Moment | undefined;
    withdrawTime: moment.Moment | undefined;
    dispatchTag: string | undefined;
    carrierName: string | undefined;
    pickupStoreCode: string | undefined;
    customer: OrderHeaderCustomerDto;
    deliveryData: OrderHeaderDeliveryDataDto;
    stockStatus: string | undefined;
    currentFinancialStatus: string | undefined;
    currentFinancialStatusId: number;
    id: number;
}

export class OrderDetailInvoiceDto implements IOrderDetailInvoiceDto {
    balance: number;
    totalAmount: number;
    currentCommercialStatus: string | undefined;
    currentFinancialStatus: string | undefined;
    paymentSystemName: string | undefined;
    id: number;

    constructor(data?: IOrderDetailInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.balance = _data["balance"];
            this.totalAmount = _data["totalAmount"];
            this.currentCommercialStatus = _data["currentCommercialStatus"];
            this.currentFinancialStatus = _data["currentFinancialStatus"];
            this.paymentSystemName = _data["paymentSystemName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderDetailInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["balance"] = this.balance;
        data["totalAmount"] = this.totalAmount;
        data["currentCommercialStatus"] = this.currentCommercialStatus;
        data["currentFinancialStatus"] = this.currentFinancialStatus;
        data["paymentSystemName"] = this.paymentSystemName;
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderDetailInvoiceDto {
        const json = this.toJSON();
        let result = new OrderDetailInvoiceDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDetailInvoiceDto {
    balance: number;
    totalAmount: number;
    currentCommercialStatus: string | undefined;
    currentFinancialStatus: string | undefined;
    paymentSystemName: string | undefined;
    id: number;
}

export class OrderDetailOrderBalanceDto implements IOrderDetailOrderBalanceDto {
    creationTime: moment.Moment;
    amount: number;
    sku: string | undefined;
    description: string | undefined;
    quantity: number;
    movementType: string | undefined;

    constructor(data?: IOrderDetailOrderBalanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.sku = _data["sku"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.movementType = _data["movementType"];
        }
    }

    static fromJS(data: any): OrderDetailOrderBalanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailOrderBalanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["sku"] = this.sku;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["movementType"] = this.movementType;
        return data; 
    }

    clone(): OrderDetailOrderBalanceDto {
        const json = this.toJSON();
        let result = new OrderDetailOrderBalanceDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDetailOrderBalanceDto {
    creationTime: moment.Moment;
    amount: number;
    sku: string | undefined;
    description: string | undefined;
    quantity: number;
    movementType: string | undefined;
}

export class OrderDetailDocumentDto implements IOrderDetailDocumentDto {
    draftNumber: string | undefined;
    number: string | undefined;
    amount: number;
    type: string | undefined;
    additionalInfo: string | undefined;
    documentUrl: string | undefined;
    status: string | undefined;

    constructor(data?: IOrderDetailDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.draftNumber = _data["draftNumber"];
            this.number = _data["number"];
            this.amount = _data["amount"];
            this.type = _data["type"];
            this.additionalInfo = _data["additionalInfo"];
            this.documentUrl = _data["documentUrl"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): OrderDetailDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["draftNumber"] = this.draftNumber;
        data["number"] = this.number;
        data["amount"] = this.amount;
        data["type"] = this.type;
        data["additionalInfo"] = this.additionalInfo;
        data["documentUrl"] = this.documentUrl;
        data["status"] = this.status;
        return data; 
    }

    clone(): OrderDetailDocumentDto {
        const json = this.toJSON();
        let result = new OrderDetailDocumentDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDetailDocumentDto {
    draftNumber: string | undefined;
    number: string | undefined;
    amount: number;
    type: string | undefined;
    additionalInfo: string | undefined;
    documentUrl: string | undefined;
    status: string | undefined;
}

export class OrderDetailOrderItemDto implements IOrderDetailOrderItemDto {
    sku: string | undefined;
    description: string | undefined;
    imageUrl: string | undefined;
    quantity: number;
    grossAmount: number;
    netAmount: number;
    discount: number;
    taxes: number;
    sourceOrderItemId: number | undefined;
    selfPurchaseFrequency: number;
    isExclusiveOnline: boolean;
    quantityInConflict: number | undefined;
    barCode: string | undefined;
    promotedItems: OrderDetailOrderItemDto[] | undefined;
    id: number;

    constructor(data?: IOrderDetailOrderItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sku = _data["sku"];
            this.description = _data["description"];
            this.imageUrl = _data["imageUrl"];
            this.quantity = _data["quantity"];
            this.grossAmount = _data["grossAmount"];
            this.netAmount = _data["netAmount"];
            this.discount = _data["discount"];
            this.taxes = _data["taxes"];
            this.sourceOrderItemId = _data["sourceOrderItemId"];
            this.selfPurchaseFrequency = _data["selfPurchaseFrequency"];
            this.isExclusiveOnline = _data["isExclusiveOnline"];
            this.quantityInConflict = _data["quantityInConflict"];
            this.barCode = _data["barCode"];
            if (Array.isArray(_data["promotedItems"])) {
                this.promotedItems = [] as any;
                for (let item of _data["promotedItems"])
                    this.promotedItems.push(OrderDetailOrderItemDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderDetailOrderItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailOrderItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["description"] = this.description;
        data["imageUrl"] = this.imageUrl;
        data["quantity"] = this.quantity;
        data["grossAmount"] = this.grossAmount;
        data["netAmount"] = this.netAmount;
        data["discount"] = this.discount;
        data["taxes"] = this.taxes;
        data["sourceOrderItemId"] = this.sourceOrderItemId;
        data["selfPurchaseFrequency"] = this.selfPurchaseFrequency;
        data["isExclusiveOnline"] = this.isExclusiveOnline;
        data["quantityInConflict"] = this.quantityInConflict;
        data["barCode"] = this.barCode;
        if (Array.isArray(this.promotedItems)) {
            data["promotedItems"] = [];
            for (let item of this.promotedItems)
                data["promotedItems"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderDetailOrderItemDto {
        const json = this.toJSON();
        let result = new OrderDetailOrderItemDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDetailOrderItemDto {
    sku: string | undefined;
    description: string | undefined;
    imageUrl: string | undefined;
    quantity: number;
    grossAmount: number;
    netAmount: number;
    discount: number;
    taxes: number;
    sourceOrderItemId: number | undefined;
    selfPurchaseFrequency: number;
    isExclusiveOnline: boolean;
    quantityInConflict: number | undefined;
    barCode: string | undefined;
    promotedItems: OrderDetailOrderItemDto[] | undefined;
    id: number;
}

export class OrderDetailItemDetailDto implements IOrderDetailItemDetailDto {
    totalAmount: number;
    sourceTotalAmount: number;
    sourceGrossAmount: number;
    sourceNetAmount: number;
    grossAmount: number;
    netAmount: number;
    discount: number;
    shippingCost: number;
    interest: number;
    orderItems: OrderDetailOrderItemDto[] | undefined;
    sourceOrderItems: OrderDetailOrderItemDto[] | undefined;
    id: number;

    constructor(data?: IOrderDetailItemDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalAmount = _data["totalAmount"];
            this.sourceTotalAmount = _data["sourceTotalAmount"];
            this.sourceGrossAmount = _data["sourceGrossAmount"];
            this.sourceNetAmount = _data["sourceNetAmount"];
            this.grossAmount = _data["grossAmount"];
            this.netAmount = _data["netAmount"];
            this.discount = _data["discount"];
            this.shippingCost = _data["shippingCost"];
            this.interest = _data["interest"];
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems.push(OrderDetailOrderItemDto.fromJS(item));
            }
            if (Array.isArray(_data["sourceOrderItems"])) {
                this.sourceOrderItems = [] as any;
                for (let item of _data["sourceOrderItems"])
                    this.sourceOrderItems.push(OrderDetailOrderItemDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderDetailItemDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailItemDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalAmount"] = this.totalAmount;
        data["sourceTotalAmount"] = this.sourceTotalAmount;
        data["sourceGrossAmount"] = this.sourceGrossAmount;
        data["sourceNetAmount"] = this.sourceNetAmount;
        data["grossAmount"] = this.grossAmount;
        data["netAmount"] = this.netAmount;
        data["discount"] = this.discount;
        data["shippingCost"] = this.shippingCost;
        data["interest"] = this.interest;
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        if (Array.isArray(this.sourceOrderItems)) {
            data["sourceOrderItems"] = [];
            for (let item of this.sourceOrderItems)
                data["sourceOrderItems"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderDetailItemDetailDto {
        const json = this.toJSON();
        let result = new OrderDetailItemDetailDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDetailItemDetailDto {
    totalAmount: number;
    sourceTotalAmount: number;
    sourceGrossAmount: number;
    sourceNetAmount: number;
    grossAmount: number;
    netAmount: number;
    discount: number;
    shippingCost: number;
    interest: number;
    orderItems: OrderDetailOrderItemDto[] | undefined;
    sourceOrderItems: OrderDetailOrderItemDto[] | undefined;
    id: number;
}

export class OrderDetailPickingGroupDto implements IOrderDetailPickingGroupDto {
    alias: string | undefined;
    creationTime: moment.Moment;
    responsible: string | undefined;
    status: string | undefined;
    id: number;

    constructor(data?: IOrderDetailPickingGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alias = _data["alias"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.responsible = _data["responsible"];
            this.status = _data["status"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderDetailPickingGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailPickingGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alias"] = this.alias;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["responsible"] = this.responsible;
        data["status"] = this.status;
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderDetailPickingGroupDto {
        const json = this.toJSON();
        let result = new OrderDetailPickingGroupDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDetailPickingGroupDto {
    alias: string | undefined;
    creationTime: moment.Moment;
    responsible: string | undefined;
    status: string | undefined;
    id: number;
}

export class OrderDetailPreparationDto implements IOrderDetailPreparationDto {
    creationTime: moment.Moment;
    status: string | undefined;
    storeCode: string | undefined;
    id: number;

    constructor(data?: IOrderDetailPreparationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.storeCode = _data["storeCode"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderDetailPreparationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailPreparationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["storeCode"] = this.storeCode;
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderDetailPreparationDto {
        const json = this.toJSON();
        let result = new OrderDetailPreparationDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDetailPreparationDto {
    creationTime: moment.Moment;
    status: string | undefined;
    storeCode: string | undefined;
    id: number;
}

export class OrderDetailReturnDto implements IOrderDetailReturnDto {
    withdrawTime: moment.Moment;
    status: string | undefined;
    returnedItemsQuantity: number;
    completeAddress: string | undefined;
    id: number;

    constructor(data?: IOrderDetailReturnDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.returnedItemsQuantity = _data["returnedItemsQuantity"];
            this.completeAddress = _data["completeAddress"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderDetailReturnDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailReturnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["returnedItemsQuantity"] = this.returnedItemsQuantity;
        data["completeAddress"] = this.completeAddress;
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderDetailReturnDto {
        const json = this.toJSON();
        let result = new OrderDetailReturnDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDetailReturnDto {
    withdrawTime: moment.Moment;
    status: string | undefined;
    returnedItemsQuantity: number;
    completeAddress: string | undefined;
    id: number;
}

export class OrderDetailShipmentDto implements IOrderDetailShipmentDto {
    creationTime: moment.Moment;
    carrierDriver: string | undefined;
    carrier: string | undefined;
    shippingTypeGroup: string | undefined;
    deliveryDate: moment.Moment | undefined;
    shipmentStatus: string | undefined;
    shipmentOrderStatus: string | undefined;
    proofNote: string | undefined;
    proofFiles: string[] | undefined;
    id: number;

    constructor(data?: IOrderDetailShipmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.carrierDriver = _data["carrierDriver"];
            this.carrier = _data["carrier"];
            this.shippingTypeGroup = _data["shippingTypeGroup"];
            this.deliveryDate = _data["deliveryDate"] ? moment(_data["deliveryDate"].toString()) : <any>undefined;
            this.shipmentStatus = _data["shipmentStatus"];
            this.shipmentOrderStatus = _data["shipmentOrderStatus"];
            this.proofNote = _data["proofNote"];
            if (Array.isArray(_data["proofFiles"])) {
                this.proofFiles = [] as any;
                for (let item of _data["proofFiles"])
                    this.proofFiles.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderDetailShipmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailShipmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["carrierDriver"] = this.carrierDriver;
        data["carrier"] = this.carrier;
        data["shippingTypeGroup"] = this.shippingTypeGroup;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["shipmentStatus"] = this.shipmentStatus;
        data["shipmentOrderStatus"] = this.shipmentOrderStatus;
        data["proofNote"] = this.proofNote;
        if (Array.isArray(this.proofFiles)) {
            data["proofFiles"] = [];
            for (let item of this.proofFiles)
                data["proofFiles"].push(item);
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderDetailShipmentDto {
        const json = this.toJSON();
        let result = new OrderDetailShipmentDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDetailShipmentDto {
    creationTime: moment.Moment;
    carrierDriver: string | undefined;
    carrier: string | undefined;
    shippingTypeGroup: string | undefined;
    deliveryDate: moment.Moment | undefined;
    shipmentStatus: string | undefined;
    shipmentOrderStatus: string | undefined;
    proofNote: string | undefined;
    proofFiles: string[] | undefined;
    id: number;
}

export class OrderDetailQuadmindsDto implements IOrderDetailQuadmindsDto {
    orderId: number;
    sourceId: number;
    status: string | undefined;
    statusRoute: string | undefined;
    visitedStart: moment.Moment | undefined;
    visitedEnd: moment.Moment | undefined;
    visitedDuration: number | undefined;
    warehouseDepartureDate: moment.Moment | undefined;
    id: number;

    constructor(data?: IOrderDetailQuadmindsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.sourceId = _data["sourceId"];
            this.status = _data["status"];
            this.statusRoute = _data["statusRoute"];
            this.visitedStart = _data["visitedStart"] ? moment(_data["visitedStart"].toString()) : <any>undefined;
            this.visitedEnd = _data["visitedEnd"] ? moment(_data["visitedEnd"].toString()) : <any>undefined;
            this.visitedDuration = _data["visitedDuration"];
            this.warehouseDepartureDate = _data["warehouseDepartureDate"] ? moment(_data["warehouseDepartureDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderDetailQuadmindsDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailQuadmindsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["sourceId"] = this.sourceId;
        data["status"] = this.status;
        data["statusRoute"] = this.statusRoute;
        data["visitedStart"] = this.visitedStart ? this.visitedStart.toISOString() : <any>undefined;
        data["visitedEnd"] = this.visitedEnd ? this.visitedEnd.toISOString() : <any>undefined;
        data["visitedDuration"] = this.visitedDuration;
        data["warehouseDepartureDate"] = this.warehouseDepartureDate ? this.warehouseDepartureDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderDetailQuadmindsDto {
        const json = this.toJSON();
        let result = new OrderDetailQuadmindsDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDetailQuadmindsDto {
    orderId: number;
    sourceId: number;
    status: string | undefined;
    statusRoute: string | undefined;
    visitedStart: moment.Moment | undefined;
    visitedEnd: moment.Moment | undefined;
    visitedDuration: number | undefined;
    warehouseDepartureDate: moment.Moment | undefined;
    id: number;
}

export class OrderDetailTransferItemDto implements IOrderDetailTransferItemDto {
    sku: string | undefined;
    name: string | undefined;
    unitPrice: number;
    quantity: number;
    id: number;

    constructor(data?: IOrderDetailTransferItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sku = _data["sku"];
            this.name = _data["name"];
            this.unitPrice = _data["unitPrice"];
            this.quantity = _data["quantity"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderDetailTransferItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailTransferItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["name"] = this.name;
        data["unitPrice"] = this.unitPrice;
        data["quantity"] = this.quantity;
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderDetailTransferItemDto {
        const json = this.toJSON();
        let result = new OrderDetailTransferItemDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDetailTransferItemDto {
    sku: string | undefined;
    name: string | undefined;
    unitPrice: number;
    quantity: number;
    id: number;
}

export class OrderDetailTransferDto implements IOrderDetailTransferDto {
    creationTime: moment.Moment;
    trxSrcCode: string | undefined;
    sourceStoreCode: string | undefined;
    destinationStoreCode: string | undefined;
    status: string | undefined;
    type: string | undefined;
    shipmentId: number | undefined;
    transferId: number | undefined;
    sapCode: string | undefined;
    transferItems: OrderDetailTransferItemDto[] | undefined;
    id: number;

    constructor(data?: IOrderDetailTransferDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.trxSrcCode = _data["trxSrcCode"];
            this.sourceStoreCode = _data["sourceStoreCode"];
            this.destinationStoreCode = _data["destinationStoreCode"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.shipmentId = _data["shipmentId"];
            this.transferId = _data["transferId"];
            this.sapCode = _data["sapCode"];
            if (Array.isArray(_data["transferItems"])) {
                this.transferItems = [] as any;
                for (let item of _data["transferItems"])
                    this.transferItems.push(OrderDetailTransferItemDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderDetailTransferDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailTransferDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["trxSrcCode"] = this.trxSrcCode;
        data["sourceStoreCode"] = this.sourceStoreCode;
        data["destinationStoreCode"] = this.destinationStoreCode;
        data["status"] = this.status;
        data["type"] = this.type;
        data["shipmentId"] = this.shipmentId;
        data["transferId"] = this.transferId;
        data["sapCode"] = this.sapCode;
        if (Array.isArray(this.transferItems)) {
            data["transferItems"] = [];
            for (let item of this.transferItems)
                data["transferItems"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderDetailTransferDto {
        const json = this.toJSON();
        let result = new OrderDetailTransferDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDetailTransferDto {
    creationTime: moment.Moment;
    trxSrcCode: string | undefined;
    sourceStoreCode: string | undefined;
    destinationStoreCode: string | undefined;
    status: string | undefined;
    type: string | undefined;
    shipmentId: number | undefined;
    transferId: number | undefined;
    sapCode: string | undefined;
    transferItems: OrderDetailTransferItemDto[] | undefined;
    id: number;
}

export class UpdatePickupStoreRequest implements IUpdatePickupStoreRequest {
    orderId: number;
    pickupStoreCode: string | undefined;

    constructor(data?: IUpdatePickupStoreRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.pickupStoreCode = _data["pickupStoreCode"];
        }
    }

    static fromJS(data: any): UpdatePickupStoreRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePickupStoreRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["pickupStoreCode"] = this.pickupStoreCode;
        return data; 
    }

    clone(): UpdatePickupStoreRequest {
        const json = this.toJSON();
        let result = new UpdatePickupStoreRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdatePickupStoreRequest {
    orderId: number;
    pickupStoreCode: string | undefined;
}

export class LogisticAuditStatusValueDto implements ILogisticAuditStatusValueDto {
    id: number;
    name: string | undefined;

    constructor(data?: ILogisticAuditStatusValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): LogisticAuditStatusValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new LogisticAuditStatusValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): LogisticAuditStatusValueDto {
        const json = this.toJSON();
        let result = new LogisticAuditStatusValueDto();
        result.init(json);
        return result;
    }
}

export interface ILogisticAuditStatusValueDto {
    id: number;
    name: string | undefined;
}

export class LogisticAuditStatusDto implements ILogisticAuditStatusDto {
    value: LogisticAuditStatusValueDto;

    constructor(data?: ILogisticAuditStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? LogisticAuditStatusValueDto.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LogisticAuditStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new LogisticAuditStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data; 
    }

    clone(): LogisticAuditStatusDto {
        const json = this.toJSON();
        let result = new LogisticAuditStatusDto();
        result.init(json);
        return result;
    }
}

export interface ILogisticAuditStatusDto {
    value: LogisticAuditStatusValueDto;
}

export class OrderLogisticAuditDto implements IOrderLogisticAuditDto {
    currentLogisticAuditStatus: LogisticAuditStatusDto;
    itemsInConflict: number;
    lastNote: string | undefined;
    sourceName: SourceValueDto;
    sourceCode: string | undefined;
    grossAmount: number;
    netAmount: number;
    discount: number;
    taxes: number;
    invoiceNumber: string | undefined;
    routeOrder: number | undefined;
    invoiceCreationTime: moment.Moment | undefined;
    invoiceType: string | undefined;
    highlighted: boolean;
    customer: CustomerDto;
    carrierId: number | undefined;
    carrier: CarrierDto;
    sourceCreationTime: moment.Moment | undefined;
    dispatchDate: moment.Moment | undefined;
    isPackOrder: boolean;
    isPackItemOrder: boolean;
    packOrderId: number | undefined;
    balance: number;
    orderBalances: OrderBalanceDto[] | undefined;
    notes: OrderNoteDto[] | undefined;
    eventLogs: EventLogDto[] | undefined;
    sourceOrderItems: SourceOrderItemDto[] | undefined;
    orderItems: OrderItemDto[] | undefined;
    relatedDocuments: OrderDocumentDto[] | undefined;
    documents: DocumentDto[] | undefined;
    payments: PaymentDto[] | undefined;
    deliveryData: DeliveryDataDto;
    currentAssignedToStore: AssignedToStoreDto;
    currentOverallStatus: OverallStatusDto;
    currentCommercialStatus: CommercialStatusDto;
    currentFinancialStatus: FinancialStatusDto;
    currentLogisticStatus: LogisticStatusDto;
    preparations: PreparationDto[] | undefined;
    shipmentOrder: ShipmentOrderDto;
    withdrawTime: moment.Moment | undefined;
    dispatchTag: string | undefined;
    pickupStoreCode: string | undefined;
    stockStatus: StockStatusDto;
    carrierDriverId: number | undefined;
    carrierDriver: CarrierDriverDto;
    openTextField: string | undefined;
    replacementCriteria: ReplacementCriteriaDto;
    carrierInfo: string | undefined;
    giftCard: string | undefined;
    includedGiftCard: IncludedGiftCardDto;
    createFromOrderStorePickup: boolean;
    invoiceStoreCode: string | undefined;
    shipmentQuantity: number;
    interest: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderLogisticAuditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentLogisticAuditStatus = _data["currentLogisticAuditStatus"] ? LogisticAuditStatusDto.fromJS(_data["currentLogisticAuditStatus"]) : <any>undefined;
            this.itemsInConflict = _data["itemsInConflict"];
            this.lastNote = _data["lastNote"];
            this.sourceName = _data["sourceName"] ? SourceValueDto.fromJS(_data["sourceName"]) : <any>undefined;
            this.sourceCode = _data["sourceCode"];
            this.grossAmount = _data["grossAmount"];
            this.netAmount = _data["netAmount"];
            this.discount = _data["discount"];
            this.taxes = _data["taxes"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.routeOrder = _data["routeOrder"];
            this.invoiceCreationTime = _data["invoiceCreationTime"] ? moment(_data["invoiceCreationTime"].toString()) : <any>undefined;
            this.invoiceType = _data["invoiceType"];
            this.highlighted = _data["highlighted"];
            this.customer = _data["customer"] ? CustomerDto.fromJS(_data["customer"]) : <any>undefined;
            this.carrierId = _data["carrierId"];
            this.carrier = _data["carrier"] ? CarrierDto.fromJS(_data["carrier"]) : <any>undefined;
            this.sourceCreationTime = _data["sourceCreationTime"] ? moment(_data["sourceCreationTime"].toString()) : <any>undefined;
            this.dispatchDate = _data["dispatchDate"] ? moment(_data["dispatchDate"].toString()) : <any>undefined;
            this.isPackOrder = _data["isPackOrder"];
            this.isPackItemOrder = _data["isPackItemOrder"];
            this.packOrderId = _data["packOrderId"];
            this.balance = _data["balance"];
            if (Array.isArray(_data["orderBalances"])) {
                this.orderBalances = [] as any;
                for (let item of _data["orderBalances"])
                    this.orderBalances.push(OrderBalanceDto.fromJS(item));
            }
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes.push(OrderNoteDto.fromJS(item));
            }
            if (Array.isArray(_data["eventLogs"])) {
                this.eventLogs = [] as any;
                for (let item of _data["eventLogs"])
                    this.eventLogs.push(EventLogDto.fromJS(item));
            }
            if (Array.isArray(_data["sourceOrderItems"])) {
                this.sourceOrderItems = [] as any;
                for (let item of _data["sourceOrderItems"])
                    this.sourceOrderItems.push(SourceOrderItemDto.fromJS(item));
            }
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems.push(OrderItemDto.fromJS(item));
            }
            if (Array.isArray(_data["relatedDocuments"])) {
                this.relatedDocuments = [] as any;
                for (let item of _data["relatedDocuments"])
                    this.relatedDocuments.push(OrderDocumentDto.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents.push(DocumentDto.fromJS(item));
            }
            if (Array.isArray(_data["payments"])) {
                this.payments = [] as any;
                for (let item of _data["payments"])
                    this.payments.push(PaymentDto.fromJS(item));
            }
            this.deliveryData = _data["deliveryData"] ? DeliveryDataDto.fromJS(_data["deliveryData"]) : <any>undefined;
            this.currentAssignedToStore = _data["currentAssignedToStore"] ? AssignedToStoreDto.fromJS(_data["currentAssignedToStore"]) : <any>undefined;
            this.currentOverallStatus = _data["currentOverallStatus"] ? OverallStatusDto.fromJS(_data["currentOverallStatus"]) : <any>undefined;
            this.currentCommercialStatus = _data["currentCommercialStatus"] ? CommercialStatusDto.fromJS(_data["currentCommercialStatus"]) : <any>undefined;
            this.currentFinancialStatus = _data["currentFinancialStatus"] ? FinancialStatusDto.fromJS(_data["currentFinancialStatus"]) : <any>undefined;
            this.currentLogisticStatus = _data["currentLogisticStatus"] ? LogisticStatusDto.fromJS(_data["currentLogisticStatus"]) : <any>undefined;
            if (Array.isArray(_data["preparations"])) {
                this.preparations = [] as any;
                for (let item of _data["preparations"])
                    this.preparations.push(PreparationDto.fromJS(item));
            }
            this.shipmentOrder = _data["shipmentOrder"] ? ShipmentOrderDto.fromJS(_data["shipmentOrder"]) : <any>undefined;
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : <any>undefined;
            this.dispatchTag = _data["dispatchTag"];
            this.pickupStoreCode = _data["pickupStoreCode"];
            this.stockStatus = _data["stockStatus"] ? StockStatusDto.fromJS(_data["stockStatus"]) : <any>undefined;
            this.carrierDriverId = _data["carrierDriverId"];
            this.carrierDriver = _data["carrierDriver"] ? CarrierDriverDto.fromJS(_data["carrierDriver"]) : <any>undefined;
            this.openTextField = _data["openTextField"];
            this.replacementCriteria = _data["replacementCriteria"] ? ReplacementCriteriaDto.fromJS(_data["replacementCriteria"]) : <any>undefined;
            this.carrierInfo = _data["carrierInfo"];
            this.giftCard = _data["giftCard"];
            this.includedGiftCard = _data["includedGiftCard"] ? IncludedGiftCardDto.fromJS(_data["includedGiftCard"]) : <any>undefined;
            this.createFromOrderStorePickup = _data["createFromOrderStorePickup"];
            this.invoiceStoreCode = _data["invoiceStoreCode"];
            this.shipmentQuantity = _data["shipmentQuantity"];
            this.interest = _data["interest"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderLogisticAuditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLogisticAuditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentLogisticAuditStatus"] = this.currentLogisticAuditStatus ? this.currentLogisticAuditStatus.toJSON() : <any>undefined;
        data["itemsInConflict"] = this.itemsInConflict;
        data["lastNote"] = this.lastNote;
        data["sourceName"] = this.sourceName ? this.sourceName.toJSON() : <any>undefined;
        data["sourceCode"] = this.sourceCode;
        data["grossAmount"] = this.grossAmount;
        data["netAmount"] = this.netAmount;
        data["discount"] = this.discount;
        data["taxes"] = this.taxes;
        data["invoiceNumber"] = this.invoiceNumber;
        data["routeOrder"] = this.routeOrder;
        data["invoiceCreationTime"] = this.invoiceCreationTime ? this.invoiceCreationTime.toISOString() : <any>undefined;
        data["invoiceType"] = this.invoiceType;
        data["highlighted"] = this.highlighted;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["carrierId"] = this.carrierId;
        data["carrier"] = this.carrier ? this.carrier.toJSON() : <any>undefined;
        data["sourceCreationTime"] = this.sourceCreationTime ? this.sourceCreationTime.toISOString() : <any>undefined;
        data["dispatchDate"] = this.dispatchDate ? this.dispatchDate.toISOString() : <any>undefined;
        data["isPackOrder"] = this.isPackOrder;
        data["isPackItemOrder"] = this.isPackItemOrder;
        data["packOrderId"] = this.packOrderId;
        data["balance"] = this.balance;
        if (Array.isArray(this.orderBalances)) {
            data["orderBalances"] = [];
            for (let item of this.orderBalances)
                data["orderBalances"].push(item.toJSON());
        }
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        if (Array.isArray(this.eventLogs)) {
            data["eventLogs"] = [];
            for (let item of this.eventLogs)
                data["eventLogs"].push(item.toJSON());
        }
        if (Array.isArray(this.sourceOrderItems)) {
            data["sourceOrderItems"] = [];
            for (let item of this.sourceOrderItems)
                data["sourceOrderItems"].push(item.toJSON());
        }
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        if (Array.isArray(this.relatedDocuments)) {
            data["relatedDocuments"] = [];
            for (let item of this.relatedDocuments)
                data["relatedDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        data["deliveryData"] = this.deliveryData ? this.deliveryData.toJSON() : <any>undefined;
        data["currentAssignedToStore"] = this.currentAssignedToStore ? this.currentAssignedToStore.toJSON() : <any>undefined;
        data["currentOverallStatus"] = this.currentOverallStatus ? this.currentOverallStatus.toJSON() : <any>undefined;
        data["currentCommercialStatus"] = this.currentCommercialStatus ? this.currentCommercialStatus.toJSON() : <any>undefined;
        data["currentFinancialStatus"] = this.currentFinancialStatus ? this.currentFinancialStatus.toJSON() : <any>undefined;
        data["currentLogisticStatus"] = this.currentLogisticStatus ? this.currentLogisticStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.preparations)) {
            data["preparations"] = [];
            for (let item of this.preparations)
                data["preparations"].push(item.toJSON());
        }
        data["shipmentOrder"] = this.shipmentOrder ? this.shipmentOrder.toJSON() : <any>undefined;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : <any>undefined;
        data["dispatchTag"] = this.dispatchTag;
        data["pickupStoreCode"] = this.pickupStoreCode;
        data["stockStatus"] = this.stockStatus ? this.stockStatus.toJSON() : <any>undefined;
        data["carrierDriverId"] = this.carrierDriverId;
        data["carrierDriver"] = this.carrierDriver ? this.carrierDriver.toJSON() : <any>undefined;
        data["openTextField"] = this.openTextField;
        data["replacementCriteria"] = this.replacementCriteria ? this.replacementCriteria.toJSON() : <any>undefined;
        data["carrierInfo"] = this.carrierInfo;
        data["giftCard"] = this.giftCard;
        data["includedGiftCard"] = this.includedGiftCard ? this.includedGiftCard.toJSON() : <any>undefined;
        data["createFromOrderStorePickup"] = this.createFromOrderStorePickup;
        data["invoiceStoreCode"] = this.invoiceStoreCode;
        data["shipmentQuantity"] = this.shipmentQuantity;
        data["interest"] = this.interest;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderLogisticAuditDto {
        const json = this.toJSON();
        let result = new OrderLogisticAuditDto();
        result.init(json);
        return result;
    }
}

export interface IOrderLogisticAuditDto {
    currentLogisticAuditStatus: LogisticAuditStatusDto;
    itemsInConflict: number;
    lastNote: string | undefined;
    sourceName: SourceValueDto;
    sourceCode: string | undefined;
    grossAmount: number;
    netAmount: number;
    discount: number;
    taxes: number;
    invoiceNumber: string | undefined;
    routeOrder: number | undefined;
    invoiceCreationTime: moment.Moment | undefined;
    invoiceType: string | undefined;
    highlighted: boolean;
    customer: CustomerDto;
    carrierId: number | undefined;
    carrier: CarrierDto;
    sourceCreationTime: moment.Moment | undefined;
    dispatchDate: moment.Moment | undefined;
    isPackOrder: boolean;
    isPackItemOrder: boolean;
    packOrderId: number | undefined;
    balance: number;
    orderBalances: OrderBalanceDto[] | undefined;
    notes: OrderNoteDto[] | undefined;
    eventLogs: EventLogDto[] | undefined;
    sourceOrderItems: SourceOrderItemDto[] | undefined;
    orderItems: OrderItemDto[] | undefined;
    relatedDocuments: OrderDocumentDto[] | undefined;
    documents: DocumentDto[] | undefined;
    payments: PaymentDto[] | undefined;
    deliveryData: DeliveryDataDto;
    currentAssignedToStore: AssignedToStoreDto;
    currentOverallStatus: OverallStatusDto;
    currentCommercialStatus: CommercialStatusDto;
    currentFinancialStatus: FinancialStatusDto;
    currentLogisticStatus: LogisticStatusDto;
    preparations: PreparationDto[] | undefined;
    shipmentOrder: ShipmentOrderDto;
    withdrawTime: moment.Moment | undefined;
    dispatchTag: string | undefined;
    pickupStoreCode: string | undefined;
    stockStatus: StockStatusDto;
    carrierDriverId: number | undefined;
    carrierDriver: CarrierDriverDto;
    openTextField: string | undefined;
    replacementCriteria: ReplacementCriteriaDto;
    carrierInfo: string | undefined;
    giftCard: string | undefined;
    includedGiftCard: IncludedGiftCardDto;
    createFromOrderStorePickup: boolean;
    invoiceStoreCode: string | undefined;
    shipmentQuantity: number;
    interest: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class OrderLogisticAuditDtoPagedResultDto implements IOrderLogisticAuditDtoPagedResultDto {
    totalCount: number;
    items: OrderLogisticAuditDto[] | undefined;

    constructor(data?: IOrderLogisticAuditDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderLogisticAuditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderLogisticAuditDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLogisticAuditDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): OrderLogisticAuditDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OrderLogisticAuditDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrderLogisticAuditDtoPagedResultDto {
    totalCount: number;
    items: OrderLogisticAuditDto[] | undefined;
}

export class OrderNoteDtoPagedResultDto implements IOrderNoteDtoPagedResultDto {
    totalCount: number;
    items: OrderNoteDto[] | undefined;

    constructor(data?: IOrderNoteDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderNoteDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderNoteDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderNoteDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): OrderNoteDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OrderNoteDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrderNoteDtoPagedResultDto {
    totalCount: number;
    items: OrderNoteDto[] | undefined;
}

export class OrderReadyToHandleDto implements IOrderReadyToHandleDto {
    currentPreparationId: number | undefined;
    currentPickingGroupId: number | undefined;
    currentPickingGroupActive: boolean;
    currentPreparationActive: boolean;
    storeCode: string | undefined;
    responsible: string | undefined;
    cabifyParcelId: string | undefined;
    flyers: FlyerDistributionDto[] | undefined;
    sourceName: SourceValueDto;
    sourceCode: string | undefined;
    grossAmount: number;
    netAmount: number;
    discount: number;
    taxes: number;
    invoiceNumber: string | undefined;
    routeOrder: number | undefined;
    invoiceCreationTime: moment.Moment | undefined;
    invoiceType: string | undefined;
    highlighted: boolean;
    customer: CustomerDto;
    carrierId: number | undefined;
    carrier: CarrierDto;
    sourceCreationTime: moment.Moment | undefined;
    dispatchDate: moment.Moment | undefined;
    isPackOrder: boolean;
    isPackItemOrder: boolean;
    packOrderId: number | undefined;
    balance: number;
    orderBalances: OrderBalanceDto[] | undefined;
    notes: OrderNoteDto[] | undefined;
    eventLogs: EventLogDto[] | undefined;
    sourceOrderItems: SourceOrderItemDto[] | undefined;
    orderItems: OrderItemDto[] | undefined;
    relatedDocuments: OrderDocumentDto[] | undefined;
    documents: DocumentDto[] | undefined;
    payments: PaymentDto[] | undefined;
    deliveryData: DeliveryDataDto;
    currentAssignedToStore: AssignedToStoreDto;
    currentOverallStatus: OverallStatusDto;
    currentCommercialStatus: CommercialStatusDto;
    currentFinancialStatus: FinancialStatusDto;
    currentLogisticStatus: LogisticStatusDto;
    preparations: PreparationDto[] | undefined;
    shipmentOrder: ShipmentOrderDto;
    withdrawTime: moment.Moment | undefined;
    dispatchTag: string | undefined;
    pickupStoreCode: string | undefined;
    stockStatus: StockStatusDto;
    carrierDriverId: number | undefined;
    carrierDriver: CarrierDriverDto;
    openTextField: string | undefined;
    replacementCriteria: ReplacementCriteriaDto;
    carrierInfo: string | undefined;
    giftCard: string | undefined;
    includedGiftCard: IncludedGiftCardDto;
    createFromOrderStorePickup: boolean;
    invoiceStoreCode: string | undefined;
    shipmentQuantity: number;
    interest: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderReadyToHandleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPreparationId = _data["currentPreparationId"];
            this.currentPickingGroupId = _data["currentPickingGroupId"];
            this.currentPickingGroupActive = _data["currentPickingGroupActive"];
            this.currentPreparationActive = _data["currentPreparationActive"];
            this.storeCode = _data["storeCode"];
            this.responsible = _data["responsible"];
            this.cabifyParcelId = _data["cabifyParcelId"];
            if (Array.isArray(_data["flyers"])) {
                this.flyers = [] as any;
                for (let item of _data["flyers"])
                    this.flyers.push(FlyerDistributionDto.fromJS(item));
            }
            this.sourceName = _data["sourceName"] ? SourceValueDto.fromJS(_data["sourceName"]) : <any>undefined;
            this.sourceCode = _data["sourceCode"];
            this.grossAmount = _data["grossAmount"];
            this.netAmount = _data["netAmount"];
            this.discount = _data["discount"];
            this.taxes = _data["taxes"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.routeOrder = _data["routeOrder"];
            this.invoiceCreationTime = _data["invoiceCreationTime"] ? moment(_data["invoiceCreationTime"].toString()) : <any>undefined;
            this.invoiceType = _data["invoiceType"];
            this.highlighted = _data["highlighted"];
            this.customer = _data["customer"] ? CustomerDto.fromJS(_data["customer"]) : <any>undefined;
            this.carrierId = _data["carrierId"];
            this.carrier = _data["carrier"] ? CarrierDto.fromJS(_data["carrier"]) : <any>undefined;
            this.sourceCreationTime = _data["sourceCreationTime"] ? moment(_data["sourceCreationTime"].toString()) : <any>undefined;
            this.dispatchDate = _data["dispatchDate"] ? moment(_data["dispatchDate"].toString()) : <any>undefined;
            this.isPackOrder = _data["isPackOrder"];
            this.isPackItemOrder = _data["isPackItemOrder"];
            this.packOrderId = _data["packOrderId"];
            this.balance = _data["balance"];
            if (Array.isArray(_data["orderBalances"])) {
                this.orderBalances = [] as any;
                for (let item of _data["orderBalances"])
                    this.orderBalances.push(OrderBalanceDto.fromJS(item));
            }
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes.push(OrderNoteDto.fromJS(item));
            }
            if (Array.isArray(_data["eventLogs"])) {
                this.eventLogs = [] as any;
                for (let item of _data["eventLogs"])
                    this.eventLogs.push(EventLogDto.fromJS(item));
            }
            if (Array.isArray(_data["sourceOrderItems"])) {
                this.sourceOrderItems = [] as any;
                for (let item of _data["sourceOrderItems"])
                    this.sourceOrderItems.push(SourceOrderItemDto.fromJS(item));
            }
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems.push(OrderItemDto.fromJS(item));
            }
            if (Array.isArray(_data["relatedDocuments"])) {
                this.relatedDocuments = [] as any;
                for (let item of _data["relatedDocuments"])
                    this.relatedDocuments.push(OrderDocumentDto.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents.push(DocumentDto.fromJS(item));
            }
            if (Array.isArray(_data["payments"])) {
                this.payments = [] as any;
                for (let item of _data["payments"])
                    this.payments.push(PaymentDto.fromJS(item));
            }
            this.deliveryData = _data["deliveryData"] ? DeliveryDataDto.fromJS(_data["deliveryData"]) : <any>undefined;
            this.currentAssignedToStore = _data["currentAssignedToStore"] ? AssignedToStoreDto.fromJS(_data["currentAssignedToStore"]) : <any>undefined;
            this.currentOverallStatus = _data["currentOverallStatus"] ? OverallStatusDto.fromJS(_data["currentOverallStatus"]) : <any>undefined;
            this.currentCommercialStatus = _data["currentCommercialStatus"] ? CommercialStatusDto.fromJS(_data["currentCommercialStatus"]) : <any>undefined;
            this.currentFinancialStatus = _data["currentFinancialStatus"] ? FinancialStatusDto.fromJS(_data["currentFinancialStatus"]) : <any>undefined;
            this.currentLogisticStatus = _data["currentLogisticStatus"] ? LogisticStatusDto.fromJS(_data["currentLogisticStatus"]) : <any>undefined;
            if (Array.isArray(_data["preparations"])) {
                this.preparations = [] as any;
                for (let item of _data["preparations"])
                    this.preparations.push(PreparationDto.fromJS(item));
            }
            this.shipmentOrder = _data["shipmentOrder"] ? ShipmentOrderDto.fromJS(_data["shipmentOrder"]) : <any>undefined;
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : <any>undefined;
            this.dispatchTag = _data["dispatchTag"];
            this.pickupStoreCode = _data["pickupStoreCode"];
            this.stockStatus = _data["stockStatus"] ? StockStatusDto.fromJS(_data["stockStatus"]) : <any>undefined;
            this.carrierDriverId = _data["carrierDriverId"];
            this.carrierDriver = _data["carrierDriver"] ? CarrierDriverDto.fromJS(_data["carrierDriver"]) : <any>undefined;
            this.openTextField = _data["openTextField"];
            this.replacementCriteria = _data["replacementCriteria"] ? ReplacementCriteriaDto.fromJS(_data["replacementCriteria"]) : <any>undefined;
            this.carrierInfo = _data["carrierInfo"];
            this.giftCard = _data["giftCard"];
            this.includedGiftCard = _data["includedGiftCard"] ? IncludedGiftCardDto.fromJS(_data["includedGiftCard"]) : <any>undefined;
            this.createFromOrderStorePickup = _data["createFromOrderStorePickup"];
            this.invoiceStoreCode = _data["invoiceStoreCode"];
            this.shipmentQuantity = _data["shipmentQuantity"];
            this.interest = _data["interest"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderReadyToHandleDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderReadyToHandleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPreparationId"] = this.currentPreparationId;
        data["currentPickingGroupId"] = this.currentPickingGroupId;
        data["currentPickingGroupActive"] = this.currentPickingGroupActive;
        data["currentPreparationActive"] = this.currentPreparationActive;
        data["storeCode"] = this.storeCode;
        data["responsible"] = this.responsible;
        data["cabifyParcelId"] = this.cabifyParcelId;
        if (Array.isArray(this.flyers)) {
            data["flyers"] = [];
            for (let item of this.flyers)
                data["flyers"].push(item.toJSON());
        }
        data["sourceName"] = this.sourceName ? this.sourceName.toJSON() : <any>undefined;
        data["sourceCode"] = this.sourceCode;
        data["grossAmount"] = this.grossAmount;
        data["netAmount"] = this.netAmount;
        data["discount"] = this.discount;
        data["taxes"] = this.taxes;
        data["invoiceNumber"] = this.invoiceNumber;
        data["routeOrder"] = this.routeOrder;
        data["invoiceCreationTime"] = this.invoiceCreationTime ? this.invoiceCreationTime.toISOString() : <any>undefined;
        data["invoiceType"] = this.invoiceType;
        data["highlighted"] = this.highlighted;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["carrierId"] = this.carrierId;
        data["carrier"] = this.carrier ? this.carrier.toJSON() : <any>undefined;
        data["sourceCreationTime"] = this.sourceCreationTime ? this.sourceCreationTime.toISOString() : <any>undefined;
        data["dispatchDate"] = this.dispatchDate ? this.dispatchDate.toISOString() : <any>undefined;
        data["isPackOrder"] = this.isPackOrder;
        data["isPackItemOrder"] = this.isPackItemOrder;
        data["packOrderId"] = this.packOrderId;
        data["balance"] = this.balance;
        if (Array.isArray(this.orderBalances)) {
            data["orderBalances"] = [];
            for (let item of this.orderBalances)
                data["orderBalances"].push(item.toJSON());
        }
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        if (Array.isArray(this.eventLogs)) {
            data["eventLogs"] = [];
            for (let item of this.eventLogs)
                data["eventLogs"].push(item.toJSON());
        }
        if (Array.isArray(this.sourceOrderItems)) {
            data["sourceOrderItems"] = [];
            for (let item of this.sourceOrderItems)
                data["sourceOrderItems"].push(item.toJSON());
        }
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        if (Array.isArray(this.relatedDocuments)) {
            data["relatedDocuments"] = [];
            for (let item of this.relatedDocuments)
                data["relatedDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        data["deliveryData"] = this.deliveryData ? this.deliveryData.toJSON() : <any>undefined;
        data["currentAssignedToStore"] = this.currentAssignedToStore ? this.currentAssignedToStore.toJSON() : <any>undefined;
        data["currentOverallStatus"] = this.currentOverallStatus ? this.currentOverallStatus.toJSON() : <any>undefined;
        data["currentCommercialStatus"] = this.currentCommercialStatus ? this.currentCommercialStatus.toJSON() : <any>undefined;
        data["currentFinancialStatus"] = this.currentFinancialStatus ? this.currentFinancialStatus.toJSON() : <any>undefined;
        data["currentLogisticStatus"] = this.currentLogisticStatus ? this.currentLogisticStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.preparations)) {
            data["preparations"] = [];
            for (let item of this.preparations)
                data["preparations"].push(item.toJSON());
        }
        data["shipmentOrder"] = this.shipmentOrder ? this.shipmentOrder.toJSON() : <any>undefined;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : <any>undefined;
        data["dispatchTag"] = this.dispatchTag;
        data["pickupStoreCode"] = this.pickupStoreCode;
        data["stockStatus"] = this.stockStatus ? this.stockStatus.toJSON() : <any>undefined;
        data["carrierDriverId"] = this.carrierDriverId;
        data["carrierDriver"] = this.carrierDriver ? this.carrierDriver.toJSON() : <any>undefined;
        data["openTextField"] = this.openTextField;
        data["replacementCriteria"] = this.replacementCriteria ? this.replacementCriteria.toJSON() : <any>undefined;
        data["carrierInfo"] = this.carrierInfo;
        data["giftCard"] = this.giftCard;
        data["includedGiftCard"] = this.includedGiftCard ? this.includedGiftCard.toJSON() : <any>undefined;
        data["createFromOrderStorePickup"] = this.createFromOrderStorePickup;
        data["invoiceStoreCode"] = this.invoiceStoreCode;
        data["shipmentQuantity"] = this.shipmentQuantity;
        data["interest"] = this.interest;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderReadyToHandleDto {
        const json = this.toJSON();
        let result = new OrderReadyToHandleDto();
        result.init(json);
        return result;
    }
}

export interface IOrderReadyToHandleDto {
    currentPreparationId: number | undefined;
    currentPickingGroupId: number | undefined;
    currentPickingGroupActive: boolean;
    currentPreparationActive: boolean;
    storeCode: string | undefined;
    responsible: string | undefined;
    cabifyParcelId: string | undefined;
    flyers: FlyerDistributionDto[] | undefined;
    sourceName: SourceValueDto;
    sourceCode: string | undefined;
    grossAmount: number;
    netAmount: number;
    discount: number;
    taxes: number;
    invoiceNumber: string | undefined;
    routeOrder: number | undefined;
    invoiceCreationTime: moment.Moment | undefined;
    invoiceType: string | undefined;
    highlighted: boolean;
    customer: CustomerDto;
    carrierId: number | undefined;
    carrier: CarrierDto;
    sourceCreationTime: moment.Moment | undefined;
    dispatchDate: moment.Moment | undefined;
    isPackOrder: boolean;
    isPackItemOrder: boolean;
    packOrderId: number | undefined;
    balance: number;
    orderBalances: OrderBalanceDto[] | undefined;
    notes: OrderNoteDto[] | undefined;
    eventLogs: EventLogDto[] | undefined;
    sourceOrderItems: SourceOrderItemDto[] | undefined;
    orderItems: OrderItemDto[] | undefined;
    relatedDocuments: OrderDocumentDto[] | undefined;
    documents: DocumentDto[] | undefined;
    payments: PaymentDto[] | undefined;
    deliveryData: DeliveryDataDto;
    currentAssignedToStore: AssignedToStoreDto;
    currentOverallStatus: OverallStatusDto;
    currentCommercialStatus: CommercialStatusDto;
    currentFinancialStatus: FinancialStatusDto;
    currentLogisticStatus: LogisticStatusDto;
    preparations: PreparationDto[] | undefined;
    shipmentOrder: ShipmentOrderDto;
    withdrawTime: moment.Moment | undefined;
    dispatchTag: string | undefined;
    pickupStoreCode: string | undefined;
    stockStatus: StockStatusDto;
    carrierDriverId: number | undefined;
    carrierDriver: CarrierDriverDto;
    openTextField: string | undefined;
    replacementCriteria: ReplacementCriteriaDto;
    carrierInfo: string | undefined;
    giftCard: string | undefined;
    includedGiftCard: IncludedGiftCardDto;
    createFromOrderStorePickup: boolean;
    invoiceStoreCode: string | undefined;
    shipmentQuantity: number;
    interest: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class OrderReadyToHandleDtoPagedResultDto implements IOrderReadyToHandleDtoPagedResultDto {
    totalCount: number;
    items: OrderReadyToHandleDto[] | undefined;

    constructor(data?: IOrderReadyToHandleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderReadyToHandleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderReadyToHandleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderReadyToHandleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): OrderReadyToHandleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OrderReadyToHandleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrderReadyToHandleDtoPagedResultDto {
    totalCount: number;
    items: OrderReadyToHandleDto[] | undefined;
}

export class OrderReadyToHandleCsvQuadminDto implements IOrderReadyToHandleCsvQuadminDto {
    customerCode: string | undefined;
    customer: string | undefined;
    address: string | undefined;
    city: string | undefined;
    state: string | undefined;
    geoLat: number | undefined;
    geoLong: number | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    orderId: number;
    dispatchTime: string | undefined;
    operation: string | undefined;
    sku: string | undefined;
    productDescription: string | undefined;
    quantity: number | undefined;
    weight: number;
    volume: number | undefined;
    money: string | undefined;
    clientDelay: string | undefined;
    deliveryWindow1: string | undefined;
    deliveryWindow2: string | undefined;
    deliveryCommentaries: string | undefined;
    group: string | undefined;
    withdrawTime: moment.Moment | undefined;

    constructor(data?: IOrderReadyToHandleCsvQuadminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerCode = _data["customerCode"];
            this.customer = _data["customer"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.geoLat = _data["geoLat"];
            this.geoLong = _data["geoLong"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.orderId = _data["orderId"];
            this.dispatchTime = _data["dispatchTime"];
            this.operation = _data["operation"];
            this.sku = _data["sku"];
            this.productDescription = _data["productDescription"];
            this.quantity = _data["quantity"];
            this.weight = _data["weight"];
            this.volume = _data["volume"];
            this.money = _data["money"];
            this.clientDelay = _data["clientDelay"];
            this.deliveryWindow1 = _data["deliveryWindow1"];
            this.deliveryWindow2 = _data["deliveryWindow2"];
            this.deliveryCommentaries = _data["deliveryCommentaries"];
            this.group = _data["group"];
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderReadyToHandleCsvQuadminDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderReadyToHandleCsvQuadminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerCode"] = this.customerCode;
        data["customer"] = this.customer;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["geoLat"] = this.geoLat;
        data["geoLong"] = this.geoLong;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["orderId"] = this.orderId;
        data["dispatchTime"] = this.dispatchTime;
        data["operation"] = this.operation;
        data["sku"] = this.sku;
        data["productDescription"] = this.productDescription;
        data["quantity"] = this.quantity;
        data["weight"] = this.weight;
        data["volume"] = this.volume;
        data["money"] = this.money;
        data["clientDelay"] = this.clientDelay;
        data["deliveryWindow1"] = this.deliveryWindow1;
        data["deliveryWindow2"] = this.deliveryWindow2;
        data["deliveryCommentaries"] = this.deliveryCommentaries;
        data["group"] = this.group;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : <any>undefined;
        return data; 
    }

    clone(): OrderReadyToHandleCsvQuadminDto {
        const json = this.toJSON();
        let result = new OrderReadyToHandleCsvQuadminDto();
        result.init(json);
        return result;
    }
}

export interface IOrderReadyToHandleCsvQuadminDto {
    customerCode: string | undefined;
    customer: string | undefined;
    address: string | undefined;
    city: string | undefined;
    state: string | undefined;
    geoLat: number | undefined;
    geoLong: number | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    orderId: number;
    dispatchTime: string | undefined;
    operation: string | undefined;
    sku: string | undefined;
    productDescription: string | undefined;
    quantity: number | undefined;
    weight: number;
    volume: number | undefined;
    money: string | undefined;
    clientDelay: string | undefined;
    deliveryWindow1: string | undefined;
    deliveryWindow2: string | undefined;
    deliveryCommentaries: string | undefined;
    group: string | undefined;
    withdrawTime: moment.Moment | undefined;
}

export class OrderReadyToShipDto implements IOrderReadyToShipDto {
    currentPreparationId: number | undefined;
    currentPickingGroupId: number | undefined;
    storeCode: string | undefined;
    returnedDate: moment.Moment | undefined;
    readonly pendingReturning: boolean;
    lastPendingReturnId: number | undefined;
    responsible: string | undefined;
    sourceName: SourceValueDto;
    sourceCode: string | undefined;
    grossAmount: number;
    netAmount: number;
    discount: number;
    taxes: number;
    invoiceNumber: string | undefined;
    routeOrder: number | undefined;
    invoiceCreationTime: moment.Moment | undefined;
    invoiceType: string | undefined;
    highlighted: boolean;
    customer: CustomerDto;
    carrierId: number | undefined;
    carrier: CarrierDto;
    sourceCreationTime: moment.Moment | undefined;
    dispatchDate: moment.Moment | undefined;
    isPackOrder: boolean;
    isPackItemOrder: boolean;
    packOrderId: number | undefined;
    balance: number;
    orderBalances: OrderBalanceDto[] | undefined;
    notes: OrderNoteDto[] | undefined;
    eventLogs: EventLogDto[] | undefined;
    sourceOrderItems: SourceOrderItemDto[] | undefined;
    orderItems: OrderItemDto[] | undefined;
    relatedDocuments: OrderDocumentDto[] | undefined;
    documents: DocumentDto[] | undefined;
    payments: PaymentDto[] | undefined;
    deliveryData: DeliveryDataDto;
    currentAssignedToStore: AssignedToStoreDto;
    currentOverallStatus: OverallStatusDto;
    currentCommercialStatus: CommercialStatusDto;
    currentFinancialStatus: FinancialStatusDto;
    currentLogisticStatus: LogisticStatusDto;
    preparations: PreparationDto[] | undefined;
    shipmentOrder: ShipmentOrderDto;
    withdrawTime: moment.Moment | undefined;
    dispatchTag: string | undefined;
    pickupStoreCode: string | undefined;
    stockStatus: StockStatusDto;
    carrierDriverId: number | undefined;
    carrierDriver: CarrierDriverDto;
    openTextField: string | undefined;
    replacementCriteria: ReplacementCriteriaDto;
    carrierInfo: string | undefined;
    giftCard: string | undefined;
    includedGiftCard: IncludedGiftCardDto;
    createFromOrderStorePickup: boolean;
    invoiceStoreCode: string | undefined;
    shipmentQuantity: number;
    interest: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderReadyToShipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPreparationId = _data["currentPreparationId"];
            this.currentPickingGroupId = _data["currentPickingGroupId"];
            this.storeCode = _data["storeCode"];
            this.returnedDate = _data["returnedDate"] ? moment(_data["returnedDate"].toString()) : <any>undefined;
            (<any>this).pendingReturning = _data["pendingReturning"];
            this.lastPendingReturnId = _data["lastPendingReturnId"];
            this.responsible = _data["responsible"];
            this.sourceName = _data["sourceName"] ? SourceValueDto.fromJS(_data["sourceName"]) : <any>undefined;
            this.sourceCode = _data["sourceCode"];
            this.grossAmount = _data["grossAmount"];
            this.netAmount = _data["netAmount"];
            this.discount = _data["discount"];
            this.taxes = _data["taxes"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.routeOrder = _data["routeOrder"];
            this.invoiceCreationTime = _data["invoiceCreationTime"] ? moment(_data["invoiceCreationTime"].toString()) : <any>undefined;
            this.invoiceType = _data["invoiceType"];
            this.highlighted = _data["highlighted"];
            this.customer = _data["customer"] ? CustomerDto.fromJS(_data["customer"]) : <any>undefined;
            this.carrierId = _data["carrierId"];
            this.carrier = _data["carrier"] ? CarrierDto.fromJS(_data["carrier"]) : <any>undefined;
            this.sourceCreationTime = _data["sourceCreationTime"] ? moment(_data["sourceCreationTime"].toString()) : <any>undefined;
            this.dispatchDate = _data["dispatchDate"] ? moment(_data["dispatchDate"].toString()) : <any>undefined;
            this.isPackOrder = _data["isPackOrder"];
            this.isPackItemOrder = _data["isPackItemOrder"];
            this.packOrderId = _data["packOrderId"];
            this.balance = _data["balance"];
            if (Array.isArray(_data["orderBalances"])) {
                this.orderBalances = [] as any;
                for (let item of _data["orderBalances"])
                    this.orderBalances.push(OrderBalanceDto.fromJS(item));
            }
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes.push(OrderNoteDto.fromJS(item));
            }
            if (Array.isArray(_data["eventLogs"])) {
                this.eventLogs = [] as any;
                for (let item of _data["eventLogs"])
                    this.eventLogs.push(EventLogDto.fromJS(item));
            }
            if (Array.isArray(_data["sourceOrderItems"])) {
                this.sourceOrderItems = [] as any;
                for (let item of _data["sourceOrderItems"])
                    this.sourceOrderItems.push(SourceOrderItemDto.fromJS(item));
            }
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems.push(OrderItemDto.fromJS(item));
            }
            if (Array.isArray(_data["relatedDocuments"])) {
                this.relatedDocuments = [] as any;
                for (let item of _data["relatedDocuments"])
                    this.relatedDocuments.push(OrderDocumentDto.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents.push(DocumentDto.fromJS(item));
            }
            if (Array.isArray(_data["payments"])) {
                this.payments = [] as any;
                for (let item of _data["payments"])
                    this.payments.push(PaymentDto.fromJS(item));
            }
            this.deliveryData = _data["deliveryData"] ? DeliveryDataDto.fromJS(_data["deliveryData"]) : <any>undefined;
            this.currentAssignedToStore = _data["currentAssignedToStore"] ? AssignedToStoreDto.fromJS(_data["currentAssignedToStore"]) : <any>undefined;
            this.currentOverallStatus = _data["currentOverallStatus"] ? OverallStatusDto.fromJS(_data["currentOverallStatus"]) : <any>undefined;
            this.currentCommercialStatus = _data["currentCommercialStatus"] ? CommercialStatusDto.fromJS(_data["currentCommercialStatus"]) : <any>undefined;
            this.currentFinancialStatus = _data["currentFinancialStatus"] ? FinancialStatusDto.fromJS(_data["currentFinancialStatus"]) : <any>undefined;
            this.currentLogisticStatus = _data["currentLogisticStatus"] ? LogisticStatusDto.fromJS(_data["currentLogisticStatus"]) : <any>undefined;
            if (Array.isArray(_data["preparations"])) {
                this.preparations = [] as any;
                for (let item of _data["preparations"])
                    this.preparations.push(PreparationDto.fromJS(item));
            }
            this.shipmentOrder = _data["shipmentOrder"] ? ShipmentOrderDto.fromJS(_data["shipmentOrder"]) : <any>undefined;
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : <any>undefined;
            this.dispatchTag = _data["dispatchTag"];
            this.pickupStoreCode = _data["pickupStoreCode"];
            this.stockStatus = _data["stockStatus"] ? StockStatusDto.fromJS(_data["stockStatus"]) : <any>undefined;
            this.carrierDriverId = _data["carrierDriverId"];
            this.carrierDriver = _data["carrierDriver"] ? CarrierDriverDto.fromJS(_data["carrierDriver"]) : <any>undefined;
            this.openTextField = _data["openTextField"];
            this.replacementCriteria = _data["replacementCriteria"] ? ReplacementCriteriaDto.fromJS(_data["replacementCriteria"]) : <any>undefined;
            this.carrierInfo = _data["carrierInfo"];
            this.giftCard = _data["giftCard"];
            this.includedGiftCard = _data["includedGiftCard"] ? IncludedGiftCardDto.fromJS(_data["includedGiftCard"]) : <any>undefined;
            this.createFromOrderStorePickup = _data["createFromOrderStorePickup"];
            this.invoiceStoreCode = _data["invoiceStoreCode"];
            this.shipmentQuantity = _data["shipmentQuantity"];
            this.interest = _data["interest"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderReadyToShipDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderReadyToShipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPreparationId"] = this.currentPreparationId;
        data["currentPickingGroupId"] = this.currentPickingGroupId;
        data["storeCode"] = this.storeCode;
        data["returnedDate"] = this.returnedDate ? this.returnedDate.toISOString() : <any>undefined;
        data["pendingReturning"] = this.pendingReturning;
        data["lastPendingReturnId"] = this.lastPendingReturnId;
        data["responsible"] = this.responsible;
        data["sourceName"] = this.sourceName ? this.sourceName.toJSON() : <any>undefined;
        data["sourceCode"] = this.sourceCode;
        data["grossAmount"] = this.grossAmount;
        data["netAmount"] = this.netAmount;
        data["discount"] = this.discount;
        data["taxes"] = this.taxes;
        data["invoiceNumber"] = this.invoiceNumber;
        data["routeOrder"] = this.routeOrder;
        data["invoiceCreationTime"] = this.invoiceCreationTime ? this.invoiceCreationTime.toISOString() : <any>undefined;
        data["invoiceType"] = this.invoiceType;
        data["highlighted"] = this.highlighted;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["carrierId"] = this.carrierId;
        data["carrier"] = this.carrier ? this.carrier.toJSON() : <any>undefined;
        data["sourceCreationTime"] = this.sourceCreationTime ? this.sourceCreationTime.toISOString() : <any>undefined;
        data["dispatchDate"] = this.dispatchDate ? this.dispatchDate.toISOString() : <any>undefined;
        data["isPackOrder"] = this.isPackOrder;
        data["isPackItemOrder"] = this.isPackItemOrder;
        data["packOrderId"] = this.packOrderId;
        data["balance"] = this.balance;
        if (Array.isArray(this.orderBalances)) {
            data["orderBalances"] = [];
            for (let item of this.orderBalances)
                data["orderBalances"].push(item.toJSON());
        }
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        if (Array.isArray(this.eventLogs)) {
            data["eventLogs"] = [];
            for (let item of this.eventLogs)
                data["eventLogs"].push(item.toJSON());
        }
        if (Array.isArray(this.sourceOrderItems)) {
            data["sourceOrderItems"] = [];
            for (let item of this.sourceOrderItems)
                data["sourceOrderItems"].push(item.toJSON());
        }
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        if (Array.isArray(this.relatedDocuments)) {
            data["relatedDocuments"] = [];
            for (let item of this.relatedDocuments)
                data["relatedDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        data["deliveryData"] = this.deliveryData ? this.deliveryData.toJSON() : <any>undefined;
        data["currentAssignedToStore"] = this.currentAssignedToStore ? this.currentAssignedToStore.toJSON() : <any>undefined;
        data["currentOverallStatus"] = this.currentOverallStatus ? this.currentOverallStatus.toJSON() : <any>undefined;
        data["currentCommercialStatus"] = this.currentCommercialStatus ? this.currentCommercialStatus.toJSON() : <any>undefined;
        data["currentFinancialStatus"] = this.currentFinancialStatus ? this.currentFinancialStatus.toJSON() : <any>undefined;
        data["currentLogisticStatus"] = this.currentLogisticStatus ? this.currentLogisticStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.preparations)) {
            data["preparations"] = [];
            for (let item of this.preparations)
                data["preparations"].push(item.toJSON());
        }
        data["shipmentOrder"] = this.shipmentOrder ? this.shipmentOrder.toJSON() : <any>undefined;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : <any>undefined;
        data["dispatchTag"] = this.dispatchTag;
        data["pickupStoreCode"] = this.pickupStoreCode;
        data["stockStatus"] = this.stockStatus ? this.stockStatus.toJSON() : <any>undefined;
        data["carrierDriverId"] = this.carrierDriverId;
        data["carrierDriver"] = this.carrierDriver ? this.carrierDriver.toJSON() : <any>undefined;
        data["openTextField"] = this.openTextField;
        data["replacementCriteria"] = this.replacementCriteria ? this.replacementCriteria.toJSON() : <any>undefined;
        data["carrierInfo"] = this.carrierInfo;
        data["giftCard"] = this.giftCard;
        data["includedGiftCard"] = this.includedGiftCard ? this.includedGiftCard.toJSON() : <any>undefined;
        data["createFromOrderStorePickup"] = this.createFromOrderStorePickup;
        data["invoiceStoreCode"] = this.invoiceStoreCode;
        data["shipmentQuantity"] = this.shipmentQuantity;
        data["interest"] = this.interest;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderReadyToShipDto {
        const json = this.toJSON();
        let result = new OrderReadyToShipDto();
        result.init(json);
        return result;
    }
}

export interface IOrderReadyToShipDto {
    currentPreparationId: number | undefined;
    currentPickingGroupId: number | undefined;
    storeCode: string | undefined;
    returnedDate: moment.Moment | undefined;
    pendingReturning: boolean;
    lastPendingReturnId: number | undefined;
    responsible: string | undefined;
    sourceName: SourceValueDto;
    sourceCode: string | undefined;
    grossAmount: number;
    netAmount: number;
    discount: number;
    taxes: number;
    invoiceNumber: string | undefined;
    routeOrder: number | undefined;
    invoiceCreationTime: moment.Moment | undefined;
    invoiceType: string | undefined;
    highlighted: boolean;
    customer: CustomerDto;
    carrierId: number | undefined;
    carrier: CarrierDto;
    sourceCreationTime: moment.Moment | undefined;
    dispatchDate: moment.Moment | undefined;
    isPackOrder: boolean;
    isPackItemOrder: boolean;
    packOrderId: number | undefined;
    balance: number;
    orderBalances: OrderBalanceDto[] | undefined;
    notes: OrderNoteDto[] | undefined;
    eventLogs: EventLogDto[] | undefined;
    sourceOrderItems: SourceOrderItemDto[] | undefined;
    orderItems: OrderItemDto[] | undefined;
    relatedDocuments: OrderDocumentDto[] | undefined;
    documents: DocumentDto[] | undefined;
    payments: PaymentDto[] | undefined;
    deliveryData: DeliveryDataDto;
    currentAssignedToStore: AssignedToStoreDto;
    currentOverallStatus: OverallStatusDto;
    currentCommercialStatus: CommercialStatusDto;
    currentFinancialStatus: FinancialStatusDto;
    currentLogisticStatus: LogisticStatusDto;
    preparations: PreparationDto[] | undefined;
    shipmentOrder: ShipmentOrderDto;
    withdrawTime: moment.Moment | undefined;
    dispatchTag: string | undefined;
    pickupStoreCode: string | undefined;
    stockStatus: StockStatusDto;
    carrierDriverId: number | undefined;
    carrierDriver: CarrierDriverDto;
    openTextField: string | undefined;
    replacementCriteria: ReplacementCriteriaDto;
    carrierInfo: string | undefined;
    giftCard: string | undefined;
    includedGiftCard: IncludedGiftCardDto;
    createFromOrderStorePickup: boolean;
    invoiceStoreCode: string | undefined;
    shipmentQuantity: number;
    interest: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class OrderReadyToShipDtoPagedResultDto implements IOrderReadyToShipDtoPagedResultDto {
    totalCount: number;
    items: OrderReadyToShipDto[] | undefined;

    constructor(data?: IOrderReadyToShipDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderReadyToShipDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderReadyToShipDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderReadyToShipDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): OrderReadyToShipDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OrderReadyToShipDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrderReadyToShipDtoPagedResultDto {
    totalCount: number;
    items: OrderReadyToShipDto[] | undefined;
}

export class UploadRouteRequestDto implements IUploadRouteRequestDto {
    url: string | undefined;
    countryCode: string | undefined;

    constructor(data?: IUploadRouteRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.countryCode = _data["countryCode"];
        }
    }

    static fromJS(data: any): UploadRouteRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadRouteRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["countryCode"] = this.countryCode;
        return data; 
    }

    clone(): UploadRouteRequestDto {
        const json = this.toJSON();
        let result = new UploadRouteRequestDto();
        result.init(json);
        return result;
    }
}

export interface IUploadRouteRequestDto {
    url: string | undefined;
    countryCode: string | undefined;
}

export class OrderReturnedDto implements IOrderReturnedDto {
    sourceCode: string | undefined;
    customerName: string | undefined;
    customerAdress: string | undefined;
    shipmentId: string | undefined;
    shipmentQuantity: number;
    carrierName: string | undefined;
    orderAction: string | undefined;
    observation: string | undefined;
    sku: string | undefined;
    name: string | undefined;
    quantity: number | undefined;
    quantityReturned: number | undefined;
    comentary: string | undefined;
    id: number;

    constructor(data?: IOrderReturnedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceCode = _data["sourceCode"];
            this.customerName = _data["customerName"];
            this.customerAdress = _data["customerAdress"];
            this.shipmentId = _data["shipmentId"];
            this.shipmentQuantity = _data["shipmentQuantity"];
            this.carrierName = _data["carrierName"];
            this.orderAction = _data["orderAction"];
            this.observation = _data["observation"];
            this.sku = _data["sku"];
            this.name = _data["name"];
            this.quantity = _data["quantity"];
            this.quantityReturned = _data["quantityReturned"];
            this.comentary = _data["comentary"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderReturnedDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderReturnedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceCode"] = this.sourceCode;
        data["customerName"] = this.customerName;
        data["customerAdress"] = this.customerAdress;
        data["shipmentId"] = this.shipmentId;
        data["shipmentQuantity"] = this.shipmentQuantity;
        data["carrierName"] = this.carrierName;
        data["orderAction"] = this.orderAction;
        data["observation"] = this.observation;
        data["sku"] = this.sku;
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["quantityReturned"] = this.quantityReturned;
        data["comentary"] = this.comentary;
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderReturnedDto {
        const json = this.toJSON();
        let result = new OrderReturnedDto();
        result.init(json);
        return result;
    }
}

export interface IOrderReturnedDto {
    sourceCode: string | undefined;
    customerName: string | undefined;
    customerAdress: string | undefined;
    shipmentId: string | undefined;
    shipmentQuantity: number;
    carrierName: string | undefined;
    orderAction: string | undefined;
    observation: string | undefined;
    sku: string | undefined;
    name: string | undefined;
    quantity: number | undefined;
    quantityReturned: number | undefined;
    comentary: string | undefined;
    id: number;
}

export class OrderReturnedDtoPagedResultDto implements IOrderReturnedDtoPagedResultDto {
    totalCount: number;
    items: OrderReturnedDto[] | undefined;

    constructor(data?: IOrderReturnedDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderReturnedDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderReturnedDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderReturnedDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): OrderReturnedDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OrderReturnedDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrderReturnedDtoPagedResultDto {
    totalCount: number;
    items: OrderReturnedDto[] | undefined;
}

export class OverallFlowStatusDto implements IOverallFlowStatusDto {
    from: OverallStatusValueDto;
    to: OverallStatusValueDto[] | undefined;

    constructor(data?: IOverallFlowStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? OverallStatusValueDto.fromJS(_data["from"]) : <any>undefined;
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to.push(OverallStatusValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OverallFlowStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new OverallFlowStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toJSON() : <any>undefined;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item.toJSON());
        }
        return data; 
    }

    clone(): OverallFlowStatusDto {
        const json = this.toJSON();
        let result = new OverallFlowStatusDto();
        result.init(json);
        return result;
    }
}

export interface IOverallFlowStatusDto {
    from: OverallStatusValueDto;
    to: OverallStatusValueDto[] | undefined;
}

export class LogisticFlowStatusDto implements ILogisticFlowStatusDto {
    from: LogisticStatusValueDto;
    to: LogisticStatusValueDto[] | undefined;

    constructor(data?: ILogisticFlowStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? LogisticStatusValueDto.fromJS(_data["from"]) : <any>undefined;
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to.push(LogisticStatusValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LogisticFlowStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new LogisticFlowStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toJSON() : <any>undefined;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item.toJSON());
        }
        return data; 
    }

    clone(): LogisticFlowStatusDto {
        const json = this.toJSON();
        let result = new LogisticFlowStatusDto();
        result.init(json);
        return result;
    }
}

export interface ILogisticFlowStatusDto {
    from: LogisticStatusValueDto;
    to: LogisticStatusValueDto[] | undefined;
}

export class LogisticAuditFlowStatusDto implements ILogisticAuditFlowStatusDto {
    from: LogisticAuditStatusValueDto;
    to: LogisticAuditStatusValueDto[] | undefined;

    constructor(data?: ILogisticAuditFlowStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? LogisticAuditStatusValueDto.fromJS(_data["from"]) : <any>undefined;
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to.push(LogisticAuditStatusValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LogisticAuditFlowStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new LogisticAuditFlowStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toJSON() : <any>undefined;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item.toJSON());
        }
        return data; 
    }

    clone(): LogisticAuditFlowStatusDto {
        const json = this.toJSON();
        let result = new LogisticAuditFlowStatusDto();
        result.init(json);
        return result;
    }
}

export interface ILogisticAuditFlowStatusDto {
    from: LogisticAuditStatusValueDto;
    to: LogisticAuditStatusValueDto[] | undefined;
}

export class CommercialFlowStatusDto implements ICommercialFlowStatusDto {
    from: CommercialStatusValueDto;
    to: CommercialStatusValueDto[] | undefined;

    constructor(data?: ICommercialFlowStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? CommercialStatusValueDto.fromJS(_data["from"]) : <any>undefined;
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to.push(CommercialStatusValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CommercialFlowStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommercialFlowStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toJSON() : <any>undefined;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CommercialFlowStatusDto {
        const json = this.toJSON();
        let result = new CommercialFlowStatusDto();
        result.init(json);
        return result;
    }
}

export interface ICommercialFlowStatusDto {
    from: CommercialStatusValueDto;
    to: CommercialStatusValueDto[] | undefined;
}

export class FinancialFlowStatusDto implements IFinancialFlowStatusDto {
    from: FinancialStatusValueDto;
    to: FinancialStatusValueDto[] | undefined;

    constructor(data?: IFinancialFlowStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? FinancialStatusValueDto.fromJS(_data["from"]) : <any>undefined;
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to.push(FinancialStatusValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FinancialFlowStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialFlowStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toJSON() : <any>undefined;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item.toJSON());
        }
        return data; 
    }

    clone(): FinancialFlowStatusDto {
        const json = this.toJSON();
        let result = new FinancialFlowStatusDto();
        result.init(json);
        return result;
    }
}

export interface IFinancialFlowStatusDto {
    from: FinancialStatusValueDto;
    to: FinancialStatusValueDto[] | undefined;
}

export class OrderWorkflowDto implements IOrderWorkflowDto {
    overallStatus: OverallFlowStatusDto[] | undefined;
    logisticStatus: LogisticFlowStatusDto[] | undefined;
    logisticAuditStatus: LogisticAuditFlowStatusDto[] | undefined;
    comerciallStatus: CommercialFlowStatusDto[] | undefined;
    financialStatus: FinancialFlowStatusDto[] | undefined;

    constructor(data?: IOrderWorkflowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["overallStatus"])) {
                this.overallStatus = [] as any;
                for (let item of _data["overallStatus"])
                    this.overallStatus.push(OverallFlowStatusDto.fromJS(item));
            }
            if (Array.isArray(_data["logisticStatus"])) {
                this.logisticStatus = [] as any;
                for (let item of _data["logisticStatus"])
                    this.logisticStatus.push(LogisticFlowStatusDto.fromJS(item));
            }
            if (Array.isArray(_data["logisticAuditStatus"])) {
                this.logisticAuditStatus = [] as any;
                for (let item of _data["logisticAuditStatus"])
                    this.logisticAuditStatus.push(LogisticAuditFlowStatusDto.fromJS(item));
            }
            if (Array.isArray(_data["comerciallStatus"])) {
                this.comerciallStatus = [] as any;
                for (let item of _data["comerciallStatus"])
                    this.comerciallStatus.push(CommercialFlowStatusDto.fromJS(item));
            }
            if (Array.isArray(_data["financialStatus"])) {
                this.financialStatus = [] as any;
                for (let item of _data["financialStatus"])
                    this.financialStatus.push(FinancialFlowStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderWorkflowDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderWorkflowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.overallStatus)) {
            data["overallStatus"] = [];
            for (let item of this.overallStatus)
                data["overallStatus"].push(item.toJSON());
        }
        if (Array.isArray(this.logisticStatus)) {
            data["logisticStatus"] = [];
            for (let item of this.logisticStatus)
                data["logisticStatus"].push(item.toJSON());
        }
        if (Array.isArray(this.logisticAuditStatus)) {
            data["logisticAuditStatus"] = [];
            for (let item of this.logisticAuditStatus)
                data["logisticAuditStatus"].push(item.toJSON());
        }
        if (Array.isArray(this.comerciallStatus)) {
            data["comerciallStatus"] = [];
            for (let item of this.comerciallStatus)
                data["comerciallStatus"].push(item.toJSON());
        }
        if (Array.isArray(this.financialStatus)) {
            data["financialStatus"] = [];
            for (let item of this.financialStatus)
                data["financialStatus"].push(item.toJSON());
        }
        return data; 
    }

    clone(): OrderWorkflowDto {
        const json = this.toJSON();
        let result = new OrderWorkflowDto();
        result.init(json);
        return result;
    }
}

export interface IOrderWorkflowDto {
    overallStatus: OverallFlowStatusDto[] | undefined;
    logisticStatus: LogisticFlowStatusDto[] | undefined;
    logisticAuditStatus: LogisticAuditFlowStatusDto[] | undefined;
    comerciallStatus: CommercialFlowStatusDto[] | undefined;
    financialStatus: FinancialFlowStatusDto[] | undefined;
}

export class FlashStatusIndicatorDto implements IFlashStatusIndicatorDto {
    icon: string | undefined;
    severity: number;

    constructor(data?: IFlashStatusIndicatorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.icon = _data["icon"];
            this.severity = _data["severity"];
        }
    }

    static fromJS(data: any): FlashStatusIndicatorDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlashStatusIndicatorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["icon"] = this.icon;
        data["severity"] = this.severity;
        return data; 
    }

    clone(): FlashStatusIndicatorDto {
        const json = this.toJSON();
        let result = new FlashStatusIndicatorDto();
        result.init(json);
        return result;
    }
}

export interface IFlashStatusIndicatorDto {
    icon: string | undefined;
    severity: number;
}

export class OrderStorePickupDto implements IOrderStorePickupDto {
    sourceName: SourceValueDto;
    sourceCode: string | undefined;
    customer: CustomerDto;
    sourceCreationTime: moment.Moment | undefined;
    dispatchDate: moment.Moment | undefined;
    pickupStoreCode: string | undefined;
    deliveryData: DeliveryDataDto;
    currentAssignedToStore: AssignedToStoreDto;
    currentOverallStatus: OverallStatusDto;
    currentLogisticStatus: LogisticStatusDto;
    currentFinancialStatus: FinancialStatusDto;
    modified: boolean;
    flashStatusIndicators: FlashStatusIndicatorDto[] | undefined;
    carrierId: number | undefined;
    invoiceNumber: string | undefined;
    netAmount: number;
    notes: OrderNoteDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderStorePickupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceName = _data["sourceName"] ? SourceValueDto.fromJS(_data["sourceName"]) : <any>undefined;
            this.sourceCode = _data["sourceCode"];
            this.customer = _data["customer"] ? CustomerDto.fromJS(_data["customer"]) : <any>undefined;
            this.sourceCreationTime = _data["sourceCreationTime"] ? moment(_data["sourceCreationTime"].toString()) : <any>undefined;
            this.dispatchDate = _data["dispatchDate"] ? moment(_data["dispatchDate"].toString()) : <any>undefined;
            this.pickupStoreCode = _data["pickupStoreCode"];
            this.deliveryData = _data["deliveryData"] ? DeliveryDataDto.fromJS(_data["deliveryData"]) : <any>undefined;
            this.currentAssignedToStore = _data["currentAssignedToStore"] ? AssignedToStoreDto.fromJS(_data["currentAssignedToStore"]) : <any>undefined;
            this.currentOverallStatus = _data["currentOverallStatus"] ? OverallStatusDto.fromJS(_data["currentOverallStatus"]) : <any>undefined;
            this.currentLogisticStatus = _data["currentLogisticStatus"] ? LogisticStatusDto.fromJS(_data["currentLogisticStatus"]) : <any>undefined;
            this.currentFinancialStatus = _data["currentFinancialStatus"] ? FinancialStatusDto.fromJS(_data["currentFinancialStatus"]) : <any>undefined;
            this.modified = _data["modified"];
            if (Array.isArray(_data["flashStatusIndicators"])) {
                this.flashStatusIndicators = [] as any;
                for (let item of _data["flashStatusIndicators"])
                    this.flashStatusIndicators.push(FlashStatusIndicatorDto.fromJS(item));
            }
            this.carrierId = _data["carrierId"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.netAmount = _data["netAmount"];
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes.push(OrderNoteDto.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderStorePickupDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStorePickupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceName"] = this.sourceName ? this.sourceName.toJSON() : <any>undefined;
        data["sourceCode"] = this.sourceCode;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["sourceCreationTime"] = this.sourceCreationTime ? this.sourceCreationTime.toISOString() : <any>undefined;
        data["dispatchDate"] = this.dispatchDate ? this.dispatchDate.toISOString() : <any>undefined;
        data["pickupStoreCode"] = this.pickupStoreCode;
        data["deliveryData"] = this.deliveryData ? this.deliveryData.toJSON() : <any>undefined;
        data["currentAssignedToStore"] = this.currentAssignedToStore ? this.currentAssignedToStore.toJSON() : <any>undefined;
        data["currentOverallStatus"] = this.currentOverallStatus ? this.currentOverallStatus.toJSON() : <any>undefined;
        data["currentLogisticStatus"] = this.currentLogisticStatus ? this.currentLogisticStatus.toJSON() : <any>undefined;
        data["currentFinancialStatus"] = this.currentFinancialStatus ? this.currentFinancialStatus.toJSON() : <any>undefined;
        data["modified"] = this.modified;
        if (Array.isArray(this.flashStatusIndicators)) {
            data["flashStatusIndicators"] = [];
            for (let item of this.flashStatusIndicators)
                data["flashStatusIndicators"].push(item.toJSON());
        }
        data["carrierId"] = this.carrierId;
        data["invoiceNumber"] = this.invoiceNumber;
        data["netAmount"] = this.netAmount;
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderStorePickupDto {
        const json = this.toJSON();
        let result = new OrderStorePickupDto();
        result.init(json);
        return result;
    }
}

export interface IOrderStorePickupDto {
    sourceName: SourceValueDto;
    sourceCode: string | undefined;
    customer: CustomerDto;
    sourceCreationTime: moment.Moment | undefined;
    dispatchDate: moment.Moment | undefined;
    pickupStoreCode: string | undefined;
    deliveryData: DeliveryDataDto;
    currentAssignedToStore: AssignedToStoreDto;
    currentOverallStatus: OverallStatusDto;
    currentLogisticStatus: LogisticStatusDto;
    currentFinancialStatus: FinancialStatusDto;
    modified: boolean;
    flashStatusIndicators: FlashStatusIndicatorDto[] | undefined;
    carrierId: number | undefined;
    invoiceNumber: string | undefined;
    netAmount: number;
    notes: OrderNoteDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class OrderStorePickupDtoPagedResultDto implements IOrderStorePickupDtoPagedResultDto {
    totalCount: number;
    items: OrderStorePickupDto[] | undefined;

    constructor(data?: IOrderStorePickupDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderStorePickupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderStorePickupDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStorePickupDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): OrderStorePickupDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OrderStorePickupDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrderStorePickupDtoPagedResultDto {
    totalCount: number;
    items: OrderStorePickupDto[] | undefined;
}

export class OrderTrackingStepDto implements IOrderTrackingStepDto {
    date: moment.Moment;
    dateDesc: string | undefined;
    stepDesc: string | undefined;
    stepDescSub: string | undefined;
    isChecked: boolean;

    constructor(data?: IOrderTrackingStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.dateDesc = _data["dateDesc"];
            this.stepDesc = _data["stepDesc"];
            this.stepDescSub = _data["stepDescSub"];
            this.isChecked = _data["isChecked"];
        }
    }

    static fromJS(data: any): OrderTrackingStepDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderTrackingStepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["dateDesc"] = this.dateDesc;
        data["stepDesc"] = this.stepDesc;
        data["stepDescSub"] = this.stepDescSub;
        data["isChecked"] = this.isChecked;
        return data; 
    }

    clone(): OrderTrackingStepDto {
        const json = this.toJSON();
        let result = new OrderTrackingStepDto();
        result.init(json);
        return result;
    }
}

export interface IOrderTrackingStepDto {
    date: moment.Moment;
    dateDesc: string | undefined;
    stepDesc: string | undefined;
    stepDescSub: string | undefined;
    isChecked: boolean;
}

export class OrderTrackingDto implements IOrderTrackingDto {
    countryCode: string | undefined;
    isShipping: boolean;
    nombre: string | undefined;
    estimatedDate: string | undefined;
    estimatedTime: string | undefined;
    estimatedTimeEnd: string | undefined;
    storeName: string | undefined;
    storeAdress: string | undefined;
    storeTelefono: string | undefined;
    storeMail: string | undefined;
    adress: string | undefined;
    calle: string | undefined;
    numero: string | undefined;
    pisoDepto: string | undefined;
    barrioCiudad: string | undefined;
    codigoPostal: string | undefined;
    provincia: string | undefined;
    telefono: string | undefined;
    adressLat: number;
    adressLng: number;
    steps: OrderTrackingStepDto[] | undefined;
    lastStepDesc: string | undefined;
    lastStepDetail: string | undefined;
    lastStepDescSub: string | undefined;
    lastStepIsDelivered: boolean;
    orderItems: OrderItemDto[] | undefined;
    editable: boolean;
    dispatchTag: string | undefined;
    id: number;

    constructor(data?: IOrderTrackingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryCode = _data["countryCode"];
            this.isShipping = _data["isShipping"];
            this.nombre = _data["nombre"];
            this.estimatedDate = _data["estimatedDate"];
            this.estimatedTime = _data["estimatedTime"];
            this.estimatedTimeEnd = _data["estimatedTimeEnd"];
            this.storeName = _data["storeName"];
            this.storeAdress = _data["storeAdress"];
            this.storeTelefono = _data["storeTelefono"];
            this.storeMail = _data["storeMail"];
            this.adress = _data["adress"];
            this.calle = _data["calle"];
            this.numero = _data["numero"];
            this.pisoDepto = _data["pisoDepto"];
            this.barrioCiudad = _data["barrioCiudad"];
            this.codigoPostal = _data["codigoPostal"];
            this.provincia = _data["provincia"];
            this.telefono = _data["telefono"];
            this.adressLat = _data["adressLat"];
            this.adressLng = _data["adressLng"];
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps.push(OrderTrackingStepDto.fromJS(item));
            }
            this.lastStepDesc = _data["lastStepDesc"];
            this.lastStepDetail = _data["lastStepDetail"];
            this.lastStepDescSub = _data["lastStepDescSub"];
            this.lastStepIsDelivered = _data["lastStepIsDelivered"];
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems.push(OrderItemDto.fromJS(item));
            }
            this.editable = _data["editable"];
            this.dispatchTag = _data["dispatchTag"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderTrackingDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderTrackingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryCode"] = this.countryCode;
        data["isShipping"] = this.isShipping;
        data["nombre"] = this.nombre;
        data["estimatedDate"] = this.estimatedDate;
        data["estimatedTime"] = this.estimatedTime;
        data["estimatedTimeEnd"] = this.estimatedTimeEnd;
        data["storeName"] = this.storeName;
        data["storeAdress"] = this.storeAdress;
        data["storeTelefono"] = this.storeTelefono;
        data["storeMail"] = this.storeMail;
        data["adress"] = this.adress;
        data["calle"] = this.calle;
        data["numero"] = this.numero;
        data["pisoDepto"] = this.pisoDepto;
        data["barrioCiudad"] = this.barrioCiudad;
        data["codigoPostal"] = this.codigoPostal;
        data["provincia"] = this.provincia;
        data["telefono"] = this.telefono;
        data["adressLat"] = this.adressLat;
        data["adressLng"] = this.adressLng;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item.toJSON());
        }
        data["lastStepDesc"] = this.lastStepDesc;
        data["lastStepDetail"] = this.lastStepDetail;
        data["lastStepDescSub"] = this.lastStepDescSub;
        data["lastStepIsDelivered"] = this.lastStepIsDelivered;
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        data["editable"] = this.editable;
        data["dispatchTag"] = this.dispatchTag;
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderTrackingDto {
        const json = this.toJSON();
        let result = new OrderTrackingDto();
        result.init(json);
        return result;
    }
}

export interface IOrderTrackingDto {
    countryCode: string | undefined;
    isShipping: boolean;
    nombre: string | undefined;
    estimatedDate: string | undefined;
    estimatedTime: string | undefined;
    estimatedTimeEnd: string | undefined;
    storeName: string | undefined;
    storeAdress: string | undefined;
    storeTelefono: string | undefined;
    storeMail: string | undefined;
    adress: string | undefined;
    calle: string | undefined;
    numero: string | undefined;
    pisoDepto: string | undefined;
    barrioCiudad: string | undefined;
    codigoPostal: string | undefined;
    provincia: string | undefined;
    telefono: string | undefined;
    adressLat: number;
    adressLng: number;
    steps: OrderTrackingStepDto[] | undefined;
    lastStepDesc: string | undefined;
    lastStepDetail: string | undefined;
    lastStepDescSub: string | undefined;
    lastStepIsDelivered: boolean;
    orderItems: OrderItemDto[] | undefined;
    editable: boolean;
    dispatchTag: string | undefined;
    id: number;
}

export class UpdateDeliveryDataDto implements IUpdateDeliveryDataDto {
    secureId: string | undefined;
    country: string | undefined;
    state: string | undefined;
    city: string | undefined;
    street: string | undefined;
    number: string | undefined;
    postalCode: string | undefined;
    geoLat: number;
    geoLong: number;
    depto: string | undefined;
    phoneNumber: string | undefined;

    constructor(data?: IUpdateDeliveryDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secureId = _data["secureId"];
            this.country = _data["country"];
            this.state = _data["state"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.number = _data["number"];
            this.postalCode = _data["postalCode"];
            this.geoLat = _data["geoLat"];
            this.geoLong = _data["geoLong"];
            this.depto = _data["depto"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): UpdateDeliveryDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDeliveryDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secureId"] = this.secureId;
        data["country"] = this.country;
        data["state"] = this.state;
        data["city"] = this.city;
        data["street"] = this.street;
        data["number"] = this.number;
        data["postalCode"] = this.postalCode;
        data["geoLat"] = this.geoLat;
        data["geoLong"] = this.geoLong;
        data["depto"] = this.depto;
        data["phoneNumber"] = this.phoneNumber;
        return data; 
    }

    clone(): UpdateDeliveryDataDto {
        const json = this.toJSON();
        let result = new UpdateDeliveryDataDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateDeliveryDataDto {
    secureId: string | undefined;
    country: string | undefined;
    state: string | undefined;
    city: string | undefined;
    street: string | undefined;
    number: string | undefined;
    postalCode: string | undefined;
    geoLat: number;
    geoLong: number;
    depto: string | undefined;
    phoneNumber: string | undefined;
}

export enum MovementType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export class PendingReturnStatusDto implements IPendingReturnStatusDto {
    id: number;
    name: string | undefined;

    constructor(data?: IPendingReturnStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PendingReturnStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new PendingReturnStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): PendingReturnStatusDto {
        const json = this.toJSON();
        let result = new PendingReturnStatusDto();
        result.init(json);
        return result;
    }
}

export interface IPendingReturnStatusDto {
    id: number;
    name: string | undefined;
}

export class PendingReturnItemDto implements IPendingReturnItemDto {
    sku: string | undefined;
    description: string | undefined;
    quantity: number;
    quantityReturned: number;
    comments: string | undefined;
    id: number;

    constructor(data?: IPendingReturnItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sku = _data["sku"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.quantityReturned = _data["quantityReturned"];
            this.comments = _data["comments"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PendingReturnItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PendingReturnItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["quantityReturned"] = this.quantityReturned;
        data["comments"] = this.comments;
        data["id"] = this.id;
        return data; 
    }

    clone(): PendingReturnItemDto {
        const json = this.toJSON();
        let result = new PendingReturnItemDto();
        result.init(json);
        return result;
    }
}

export interface IPendingReturnItemDto {
    sku: string | undefined;
    description: string | undefined;
    quantity: number;
    quantityReturned: number;
    comments: string | undefined;
    id: number;
}

export class PendingReturnDto implements IPendingReturnDto {
    creationTime: moment.Moment;
    returnDate: moment.Moment | undefined;
    order: OrderDto;
    claim: ClaimDto;
    status: PendingReturnStatusDto;
    pendingReturnsItems: PendingReturnItemDto[] | undefined;
    id: number;

    constructor(data?: IPendingReturnDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.returnDate = _data["returnDate"] ? moment(_data["returnDate"].toString()) : <any>undefined;
            this.order = _data["order"] ? OrderDto.fromJS(_data["order"]) : <any>undefined;
            this.claim = _data["claim"] ? ClaimDto.fromJS(_data["claim"]) : <any>undefined;
            this.status = _data["status"] ? PendingReturnStatusDto.fromJS(_data["status"]) : <any>undefined;
            if (Array.isArray(_data["pendingReturnsItems"])) {
                this.pendingReturnsItems = [] as any;
                for (let item of _data["pendingReturnsItems"])
                    this.pendingReturnsItems.push(PendingReturnItemDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PendingReturnDto {
        data = typeof data === 'object' ? data : {};
        let result = new PendingReturnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["returnDate"] = this.returnDate ? this.returnDate.toISOString() : <any>undefined;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["claim"] = this.claim ? this.claim.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        if (Array.isArray(this.pendingReturnsItems)) {
            data["pendingReturnsItems"] = [];
            for (let item of this.pendingReturnsItems)
                data["pendingReturnsItems"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): PendingReturnDto {
        const json = this.toJSON();
        let result = new PendingReturnDto();
        result.init(json);
        return result;
    }
}

export interface IPendingReturnDto {
    creationTime: moment.Moment;
    returnDate: moment.Moment | undefined;
    order: OrderDto;
    claim: ClaimDto;
    status: PendingReturnStatusDto;
    pendingReturnsItems: PendingReturnItemDto[] | undefined;
    id: number;
}

export class PendingReturnDtoPagedResultDto implements IPendingReturnDtoPagedResultDto {
    totalCount: number;
    items: PendingReturnDto[] | undefined;

    constructor(data?: IPendingReturnDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PendingReturnDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PendingReturnDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PendingReturnDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PendingReturnDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PendingReturnDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPendingReturnDtoPagedResultDto {
    totalCount: number;
    items: PendingReturnDto[] | undefined;
}

export class PicapBookingStatusDto implements IPicapBookingStatusDto {
    bookingId: string | undefined;
    statusCd: number;
    eventCd: number;
    createdAt: moment.Moment;
    relaunchedToId: string | undefined;
    driver: { [key: string]: any; } | undefined;
    vehicle: { [key: string]: any; } | undefined;

    constructor(data?: IPicapBookingStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingId = _data["bookingId"];
            this.statusCd = _data["statusCd"];
            this.eventCd = _data["eventCd"];
            this.createdAt = _data["createdAt"] ? moment(_data["createdAt"].toString()) : <any>undefined;
            this.relaunchedToId = _data["relaunchedToId"];
            if (_data["driver"]) {
                this.driver = {} as any;
                for (let key in _data["driver"]) {
                    if (_data["driver"].hasOwnProperty(key))
                        this.driver[key] = _data["driver"][key];
                }
            }
            if (_data["vehicle"]) {
                this.vehicle = {} as any;
                for (let key in _data["vehicle"]) {
                    if (_data["vehicle"].hasOwnProperty(key))
                        this.vehicle[key] = _data["vehicle"][key];
                }
            }
        }
    }

    static fromJS(data: any): PicapBookingStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new PicapBookingStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingId"] = this.bookingId;
        data["statusCd"] = this.statusCd;
        data["eventCd"] = this.eventCd;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["relaunchedToId"] = this.relaunchedToId;
        if (this.driver) {
            data["driver"] = {};
            for (let key in this.driver) {
                if (this.driver.hasOwnProperty(key))
                    data["driver"][key] = this.driver[key];
            }
        }
        if (this.vehicle) {
            data["vehicle"] = {};
            for (let key in this.vehicle) {
                if (this.vehicle.hasOwnProperty(key))
                    data["vehicle"][key] = this.vehicle[key];
            }
        }
        return data; 
    }

    clone(): PicapBookingStatusDto {
        const json = this.toJSON();
        let result = new PicapBookingStatusDto();
        result.init(json);
        return result;
    }
}

export interface IPicapBookingStatusDto {
    bookingId: string | undefined;
    statusCd: number;
    eventCd: number;
    createdAt: moment.Moment;
    relaunchedToId: string | undefined;
    driver: { [key: string]: any; } | undefined;
    vehicle: { [key: string]: any; } | undefined;
}

export class PicapPackageStatusDto implements IPicapPackageStatusDto {
    packageId: string | undefined;
    statusCd: number;
    eventCd: number;
    createdAt: moment.Moment;

    constructor(data?: IPicapPackageStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.packageId = _data["packageId"];
            this.statusCd = _data["statusCd"];
            this.eventCd = _data["eventCd"];
            this.createdAt = _data["createdAt"] ? moment(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PicapPackageStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new PicapPackageStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["packageId"] = this.packageId;
        data["statusCd"] = this.statusCd;
        data["eventCd"] = this.eventCd;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data; 
    }

    clone(): PicapPackageStatusDto {
        const json = this.toJSON();
        let result = new PicapPackageStatusDto();
        result.init(json);
        return result;
    }
}

export interface IPicapPackageStatusDto {
    packageId: string | undefined;
    statusCd: number;
    eventCd: number;
    createdAt: moment.Moment;
}

export class PickingGroupStatusValueDto implements IPickingGroupStatusValueDto {
    id: number;
    name: string | undefined;

    constructor(data?: IPickingGroupStatusValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PickingGroupStatusValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new PickingGroupStatusValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): PickingGroupStatusValueDto {
        const json = this.toJSON();
        let result = new PickingGroupStatusValueDto();
        result.init(json);
        return result;
    }
}

export interface IPickingGroupStatusValueDto {
    id: number;
    name: string | undefined;
}

export class OrderPickingGroupDto implements IOrderPickingGroupDto {
    order: OrderDto;
    orderId: number;
    pickingGroupId: number;
    id: number;

    constructor(data?: IOrderPickingGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"] ? OrderDto.fromJS(_data["order"]) : <any>undefined;
            this.orderId = _data["orderId"];
            this.pickingGroupId = _data["pickingGroupId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderPickingGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderPickingGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["orderId"] = this.orderId;
        data["pickingGroupId"] = this.pickingGroupId;
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderPickingGroupDto {
        const json = this.toJSON();
        let result = new OrderPickingGroupDto();
        result.init(json);
        return result;
    }
}

export interface IOrderPickingGroupDto {
    order: OrderDto;
    orderId: number;
    pickingGroupId: number;
    id: number;
}

export class PickingGroupItemDto implements IPickingGroupItemDto {
    sku: string | undefined;
    description: string | undefined;
    imageUrl: string | undefined;
    quantity: number;
    quantityPicked: number;
    barCode: string | undefined;
    orderNumber: number;
    aisle: string | undefined;
    location: string | undefined;
    locationId: number | undefined;
    weight: number | undefined;
    id: number;

    constructor(data?: IPickingGroupItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sku = _data["sku"];
            this.description = _data["description"];
            this.imageUrl = _data["imageUrl"];
            this.quantity = _data["quantity"];
            this.quantityPicked = _data["quantityPicked"];
            this.barCode = _data["barCode"];
            this.orderNumber = _data["orderNumber"];
            this.aisle = _data["aisle"];
            this.location = _data["location"];
            this.locationId = _data["locationId"];
            this.weight = _data["weight"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PickingGroupItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PickingGroupItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["description"] = this.description;
        data["imageUrl"] = this.imageUrl;
        data["quantity"] = this.quantity;
        data["quantityPicked"] = this.quantityPicked;
        data["barCode"] = this.barCode;
        data["orderNumber"] = this.orderNumber;
        data["aisle"] = this.aisle;
        data["location"] = this.location;
        data["locationId"] = this.locationId;
        data["weight"] = this.weight;
        data["id"] = this.id;
        return data; 
    }

    clone(): PickingGroupItemDto {
        const json = this.toJSON();
        let result = new PickingGroupItemDto();
        result.init(json);
        return result;
    }
}

export interface IPickingGroupItemDto {
    sku: string | undefined;
    description: string | undefined;
    imageUrl: string | undefined;
    quantity: number;
    quantityPicked: number;
    barCode: string | undefined;
    orderNumber: number;
    aisle: string | undefined;
    location: string | undefined;
    locationId: number | undefined;
    weight: number | undefined;
    id: number;
}

export class PickingGroupDto implements IPickingGroupDto {
    storeCode: string | undefined;
    responsible: string | undefined;
    pickingGroupStatus: PickingGroupStatusValueDto;
    quantityToPick: number;
    quantityPicked: number;
    lines: number;
    orderQuantity: number;
    alias: string | undefined;
    dispatchDate: moment.Moment | undefined;
    dispatchTag: string | undefined;
    weight: number | undefined;
    shippingTypes: ShippingTypeDto[] | undefined;
    ordersToPick: OrderPickingGroupDto[] | undefined;
    pickingGroupItems: PickingGroupItemDto[] | undefined;
    name: string | undefined;
    description: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IPickingGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeCode = _data["storeCode"];
            this.responsible = _data["responsible"];
            this.pickingGroupStatus = _data["pickingGroupStatus"] ? PickingGroupStatusValueDto.fromJS(_data["pickingGroupStatus"]) : <any>undefined;
            this.quantityToPick = _data["quantityToPick"];
            this.quantityPicked = _data["quantityPicked"];
            this.lines = _data["lines"];
            this.orderQuantity = _data["orderQuantity"];
            this.alias = _data["alias"];
            this.dispatchDate = _data["dispatchDate"] ? moment(_data["dispatchDate"].toString()) : <any>undefined;
            this.dispatchTag = _data["dispatchTag"];
            this.weight = _data["weight"];
            if (Array.isArray(_data["shippingTypes"])) {
                this.shippingTypes = [] as any;
                for (let item of _data["shippingTypes"])
                    this.shippingTypes.push(ShippingTypeDto.fromJS(item));
            }
            if (Array.isArray(_data["ordersToPick"])) {
                this.ordersToPick = [] as any;
                for (let item of _data["ordersToPick"])
                    this.ordersToPick.push(OrderPickingGroupDto.fromJS(item));
            }
            if (Array.isArray(_data["pickingGroupItems"])) {
                this.pickingGroupItems = [] as any;
                for (let item of _data["pickingGroupItems"])
                    this.pickingGroupItems.push(PickingGroupItemDto.fromJS(item));
            }
            this.name = _data["name"];
            this.description = _data["description"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PickingGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new PickingGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeCode"] = this.storeCode;
        data["responsible"] = this.responsible;
        data["pickingGroupStatus"] = this.pickingGroupStatus ? this.pickingGroupStatus.toJSON() : <any>undefined;
        data["quantityToPick"] = this.quantityToPick;
        data["quantityPicked"] = this.quantityPicked;
        data["lines"] = this.lines;
        data["orderQuantity"] = this.orderQuantity;
        data["alias"] = this.alias;
        data["dispatchDate"] = this.dispatchDate ? this.dispatchDate.toISOString() : <any>undefined;
        data["dispatchTag"] = this.dispatchTag;
        data["weight"] = this.weight;
        if (Array.isArray(this.shippingTypes)) {
            data["shippingTypes"] = [];
            for (let item of this.shippingTypes)
                data["shippingTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.ordersToPick)) {
            data["ordersToPick"] = [];
            for (let item of this.ordersToPick)
                data["ordersToPick"].push(item.toJSON());
        }
        if (Array.isArray(this.pickingGroupItems)) {
            data["pickingGroupItems"] = [];
            for (let item of this.pickingGroupItems)
                data["pickingGroupItems"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["description"] = this.description;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): PickingGroupDto {
        const json = this.toJSON();
        let result = new PickingGroupDto();
        result.init(json);
        return result;
    }
}

export interface IPickingGroupDto {
    storeCode: string | undefined;
    responsible: string | undefined;
    pickingGroupStatus: PickingGroupStatusValueDto;
    quantityToPick: number;
    quantityPicked: number;
    lines: number;
    orderQuantity: number;
    alias: string | undefined;
    dispatchDate: moment.Moment | undefined;
    dispatchTag: string | undefined;
    weight: number | undefined;
    shippingTypes: ShippingTypeDto[] | undefined;
    ordersToPick: OrderPickingGroupDto[] | undefined;
    pickingGroupItems: PickingGroupItemDto[] | undefined;
    name: string | undefined;
    description: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class PickingGroupDtoPagedResultDto implements IPickingGroupDtoPagedResultDto {
    totalCount: number;
    items: PickingGroupDto[] | undefined;

    constructor(data?: IPickingGroupDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PickingGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PickingGroupDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PickingGroupDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PickingGroupDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PickingGroupDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPickingGroupDtoPagedResultDto {
    totalCount: number;
    items: PickingGroupDto[] | undefined;
}

export class UpdateOrdersFromPickingGroupRequest implements IUpdateOrdersFromPickingGroupRequest {
    pickingGroupId: number;
    orderIds: number[] | undefined;

    constructor(data?: IUpdateOrdersFromPickingGroupRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pickingGroupId = _data["pickingGroupId"];
            if (Array.isArray(_data["orderIds"])) {
                this.orderIds = [] as any;
                for (let item of _data["orderIds"])
                    this.orderIds.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateOrdersFromPickingGroupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrdersFromPickingGroupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pickingGroupId"] = this.pickingGroupId;
        if (Array.isArray(this.orderIds)) {
            data["orderIds"] = [];
            for (let item of this.orderIds)
                data["orderIds"].push(item);
        }
        return data; 
    }

    clone(): UpdateOrdersFromPickingGroupRequest {
        const json = this.toJSON();
        let result = new UpdateOrdersFromPickingGroupRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateOrdersFromPickingGroupRequest {
    pickingGroupId: number;
    orderIds: number[] | undefined;
}

export class PickingGroupCreateDto implements IPickingGroupCreateDto {
    orderIds: number[] | undefined;
    assignedTo: string | undefined;
    storeCode: string;
    alias: string | undefined;

    constructor(data?: IPickingGroupCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orderIds"])) {
                this.orderIds = [] as any;
                for (let item of _data["orderIds"])
                    this.orderIds.push(item);
            }
            this.assignedTo = _data["assignedTo"];
            this.storeCode = _data["storeCode"];
            this.alias = _data["alias"];
        }
    }

    static fromJS(data: any): PickingGroupCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PickingGroupCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderIds)) {
            data["orderIds"] = [];
            for (let item of this.orderIds)
                data["orderIds"].push(item);
        }
        data["assignedTo"] = this.assignedTo;
        data["storeCode"] = this.storeCode;
        data["alias"] = this.alias;
        return data; 
    }

    clone(): PickingGroupCreateDto {
        const json = this.toJSON();
        let result = new PickingGroupCreateDto();
        result.init(json);
        return result;
    }
}

export interface IPickingGroupCreateDto {
    orderIds: number[] | undefined;
    assignedTo: string | undefined;
    storeCode: string;
    alias: string | undefined;
}

export class Int32EntityDto implements IInt32EntityDto {
    id: number;

    constructor(data?: IInt32EntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Int32EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int32EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): Int32EntityDto {
        const json = this.toJSON();
        let result = new Int32EntityDto();
        result.init(json);
        return result;
    }
}

export interface IInt32EntityDto {
    id: number;
}

export class PickingGroupCreateWithConflictsRequest implements IPickingGroupCreateWithConflictsRequest {
    pickingGroupId: number;
    isRequestToStore: boolean;
    ordersToRemoveFromPickingGroup: number[] | undefined;

    constructor(data?: IPickingGroupCreateWithConflictsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pickingGroupId = _data["pickingGroupId"];
            this.isRequestToStore = _data["isRequestToStore"];
            if (Array.isArray(_data["ordersToRemoveFromPickingGroup"])) {
                this.ordersToRemoveFromPickingGroup = [] as any;
                for (let item of _data["ordersToRemoveFromPickingGroup"])
                    this.ordersToRemoveFromPickingGroup.push(item);
            }
        }
    }

    static fromJS(data: any): PickingGroupCreateWithConflictsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PickingGroupCreateWithConflictsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pickingGroupId"] = this.pickingGroupId;
        data["isRequestToStore"] = this.isRequestToStore;
        if (Array.isArray(this.ordersToRemoveFromPickingGroup)) {
            data["ordersToRemoveFromPickingGroup"] = [];
            for (let item of this.ordersToRemoveFromPickingGroup)
                data["ordersToRemoveFromPickingGroup"].push(item);
        }
        return data; 
    }

    clone(): PickingGroupCreateWithConflictsRequest {
        const json = this.toJSON();
        let result = new PickingGroupCreateWithConflictsRequest();
        result.init(json);
        return result;
    }
}

export interface IPickingGroupCreateWithConflictsRequest {
    pickingGroupId: number;
    isRequestToStore: boolean;
    ordersToRemoveFromPickingGroup: number[] | undefined;
}

export class UpdatePickedQuantityRequest implements IUpdatePickedQuantityRequest {
    pickingGroupId: number;
    pickingGroupItems: PickingGroupItemDto[] | undefined;

    constructor(data?: IUpdatePickedQuantityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pickingGroupId = _data["pickingGroupId"];
            if (Array.isArray(_data["pickingGroupItems"])) {
                this.pickingGroupItems = [] as any;
                for (let item of _data["pickingGroupItems"])
                    this.pickingGroupItems.push(PickingGroupItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdatePickedQuantityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePickedQuantityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pickingGroupId"] = this.pickingGroupId;
        if (Array.isArray(this.pickingGroupItems)) {
            data["pickingGroupItems"] = [];
            for (let item of this.pickingGroupItems)
                data["pickingGroupItems"].push(item.toJSON());
        }
        return data; 
    }

    clone(): UpdatePickedQuantityRequest {
        const json = this.toJSON();
        let result = new UpdatePickedQuantityRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdatePickedQuantityRequest {
    pickingGroupId: number;
    pickingGroupItems: PickingGroupItemDto[] | undefined;
}

export class PickingGroupItemDtoPagedResultDto implements IPickingGroupItemDtoPagedResultDto {
    totalCount: number;
    items: PickingGroupItemDto[] | undefined;

    constructor(data?: IPickingGroupItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PickingGroupItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PickingGroupItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PickingGroupItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PickingGroupItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PickingGroupItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPickingGroupItemDtoPagedResultDto {
    totalCount: number;
    items: PickingGroupItemDto[] | undefined;
}

export class PickingGroupRuleDto implements IPickingGroupRuleDto {
    alias: string | undefined;
    ordersLimit: number;
    fields: string[] | undefined;
    dispatchTags: string[] | undefined;
    withPostalCode: boolean;
    postalCode: string[] | undefined;
    shippingTypeIds: number[] | undefined;
    postalCodesFile: string | undefined;
    enabled: boolean;
    id: number;

    constructor(data?: IPickingGroupRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alias = _data["alias"];
            this.ordersLimit = _data["ordersLimit"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields.push(item);
            }
            if (Array.isArray(_data["dispatchTags"])) {
                this.dispatchTags = [] as any;
                for (let item of _data["dispatchTags"])
                    this.dispatchTags.push(item);
            }
            this.withPostalCode = _data["withPostalCode"];
            if (Array.isArray(_data["postalCode"])) {
                this.postalCode = [] as any;
                for (let item of _data["postalCode"])
                    this.postalCode.push(item);
            }
            if (Array.isArray(_data["shippingTypeIds"])) {
                this.shippingTypeIds = [] as any;
                for (let item of _data["shippingTypeIds"])
                    this.shippingTypeIds.push(item);
            }
            this.postalCodesFile = _data["postalCodesFile"];
            this.enabled = _data["enabled"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PickingGroupRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PickingGroupRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alias"] = this.alias;
        data["ordersLimit"] = this.ordersLimit;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item);
        }
        if (Array.isArray(this.dispatchTags)) {
            data["dispatchTags"] = [];
            for (let item of this.dispatchTags)
                data["dispatchTags"].push(item);
        }
        data["withPostalCode"] = this.withPostalCode;
        if (Array.isArray(this.postalCode)) {
            data["postalCode"] = [];
            for (let item of this.postalCode)
                data["postalCode"].push(item);
        }
        if (Array.isArray(this.shippingTypeIds)) {
            data["shippingTypeIds"] = [];
            for (let item of this.shippingTypeIds)
                data["shippingTypeIds"].push(item);
        }
        data["postalCodesFile"] = this.postalCodesFile;
        data["enabled"] = this.enabled;
        data["id"] = this.id;
        return data; 
    }

    clone(): PickingGroupRuleDto {
        const json = this.toJSON();
        let result = new PickingGroupRuleDto();
        result.init(json);
        return result;
    }
}

export interface IPickingGroupRuleDto {
    alias: string | undefined;
    ordersLimit: number;
    fields: string[] | undefined;
    dispatchTags: string[] | undefined;
    withPostalCode: boolean;
    postalCode: string[] | undefined;
    shippingTypeIds: number[] | undefined;
    postalCodesFile: string | undefined;
    enabled: boolean;
    id: number;
}

export class PickingGroupRuleDtoPagedResultDto implements IPickingGroupRuleDtoPagedResultDto {
    totalCount: number;
    items: PickingGroupRuleDto[] | undefined;

    constructor(data?: IPickingGroupRuleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PickingGroupRuleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PickingGroupRuleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PickingGroupRuleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PickingGroupRuleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PickingGroupRuleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPickingGroupRuleDtoPagedResultDto {
    totalCount: number;
    items: PickingGroupRuleDto[] | undefined;
}

export class PreparationDtoPagedResultDto implements IPreparationDtoPagedResultDto {
    totalCount: number;
    items: PreparationDto[] | undefined;

    constructor(data?: IPreparationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PreparationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PreparationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PreparationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PreparationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PreparationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPreparationDtoPagedResultDto {
    totalCount: number;
    items: PreparationDto[] | undefined;
}

export class CurrentStatusDto implements ICurrentStatusDto {
    processId: number;
    status: string | undefined;
    currentStep: string[] | undefined;

    constructor(data?: ICurrentStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processId = _data["processId"];
            this.status = _data["status"];
            if (Array.isArray(_data["currentStep"])) {
                this.currentStep = [] as any;
                for (let item of _data["currentStep"])
                    this.currentStep.push(item);
            }
        }
    }

    static fromJS(data: any): CurrentStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processId"] = this.processId;
        data["status"] = this.status;
        if (Array.isArray(this.currentStep)) {
            data["currentStep"] = [];
            for (let item of this.currentStep)
                data["currentStep"].push(item);
        }
        return data; 
    }

    clone(): CurrentStatusDto {
        const json = this.toJSON();
        let result = new CurrentStatusDto();
        result.init(json);
        return result;
    }
}

export interface ICurrentStatusDto {
    processId: number;
    status: string | undefined;
    currentStep: string[] | undefined;
}

export class ProcessDto implements IProcessDto {
    name: string | undefined;
    status: string | undefined;
    creationTime: moment.Moment;
    currentStatus: CurrentStatusDto;
    output: string | undefined;
    readonly action: string | undefined;
    parameters: string | undefined;

    constructor(data?: IProcessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.status = _data["status"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.currentStatus = _data["currentStatus"] ? CurrentStatusDto.fromJS(_data["currentStatus"]) : <any>undefined;
            this.output = _data["output"];
            (<any>this).action = _data["action"];
            this.parameters = _data["parameters"];
        }
    }

    static fromJS(data: any): ProcessDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["status"] = this.status;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["currentStatus"] = this.currentStatus ? this.currentStatus.toJSON() : <any>undefined;
        data["output"] = this.output;
        data["action"] = this.action;
        data["parameters"] = this.parameters;
        return data; 
    }

    clone(): ProcessDto {
        const json = this.toJSON();
        let result = new ProcessDto();
        result.init(json);
        return result;
    }
}

export interface IProcessDto {
    name: string | undefined;
    status: string | undefined;
    creationTime: moment.Moment;
    currentStatus: CurrentStatusDto;
    output: string | undefined;
    action: string | undefined;
    parameters: string | undefined;
}

export class PromotionMappingDto implements IPromotionMappingDto {
    promotionCode: string | undefined;
    description: string | undefined;
    isSkuPromotion: boolean;
    sku: string | undefined;
    productDescription: string | undefined;
    quantity: number;
    id: number;

    constructor(data?: IPromotionMappingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.promotionCode = _data["promotionCode"];
            this.description = _data["description"];
            this.isSkuPromotion = _data["isSkuPromotion"];
            this.sku = _data["sku"];
            this.productDescription = _data["productDescription"];
            this.quantity = _data["quantity"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PromotionMappingDto {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionMappingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promotionCode"] = this.promotionCode;
        data["description"] = this.description;
        data["isSkuPromotion"] = this.isSkuPromotion;
        data["sku"] = this.sku;
        data["productDescription"] = this.productDescription;
        data["quantity"] = this.quantity;
        data["id"] = this.id;
        return data; 
    }

    clone(): PromotionMappingDto {
        const json = this.toJSON();
        let result = new PromotionMappingDto();
        result.init(json);
        return result;
    }
}

export interface IPromotionMappingDto {
    promotionCode: string | undefined;
    description: string | undefined;
    isSkuPromotion: boolean;
    sku: string | undefined;
    productDescription: string | undefined;
    quantity: number;
    id: number;
}

export class PromotionMappingDtoPagedResultDto implements IPromotionMappingDtoPagedResultDto {
    totalCount: number;
    items: PromotionMappingDto[] | undefined;

    constructor(data?: IPromotionMappingDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PromotionMappingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PromotionMappingDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionMappingDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PromotionMappingDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PromotionMappingDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPromotionMappingDtoPagedResultDto {
    totalCount: number;
    items: PromotionMappingDto[] | undefined;
}

export class UploadPromotionDto implements IUploadPromotionDto {
    url: string | undefined;
    countryCode: string | undefined;

    constructor(data?: IUploadPromotionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.countryCode = _data["countryCode"];
        }
    }

    static fromJS(data: any): UploadPromotionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadPromotionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["countryCode"] = this.countryCode;
        return data; 
    }

    clone(): UploadPromotionDto {
        const json = this.toJSON();
        let result = new UploadPromotionDto();
        result.init(json);
        return result;
    }
}

export interface IUploadPromotionDto {
    url: string | undefined;
    countryCode: string | undefined;
}

export class DeliveryState implements IDeliveryState {
    description: string | undefined;
    reason: string | undefined;

    constructor(data?: IDeliveryState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): DeliveryState {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["reason"] = this.reason;
        return data; 
    }

    clone(): DeliveryState {
        const json = this.toJSON();
        let result = new DeliveryState();
        result.init(json);
        return result;
    }
}

export interface IDeliveryState {
    description: string | undefined;
    reason: string | undefined;
}

export class Poi implements IPoi {
    id: string | undefined;
    name: string | undefined;
    address: string | undefined;
    lat: number;
    lng: number;
    email: string | undefined;
    phone: string | undefined;

    constructor(data?: IPoi) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.lat = _data["lat"];
            this.lng = _data["lng"];
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): Poi {
        data = typeof data === 'object' ? data : {};
        let result = new Poi();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address"] = this.address;
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data; 
    }

    clone(): Poi {
        const json = this.toJSON();
        let result = new Poi();
        result.init(json);
        return result;
    }
}

export interface IPoi {
    id: string | undefined;
    name: string | undefined;
    address: string | undefined;
    lat: number;
    lng: number;
    email: string | undefined;
    phone: string | undefined;
}

export class OrderW implements IOrderW {
    id: string | undefined;
    code: string | undefined;
    qtn: string | undefined;

    constructor(data?: IOrderW) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.qtn = _data["qtn"];
        }
    }

    static fromJS(data: any): OrderW {
        data = typeof data === 'object' ? data : {};
        let result = new OrderW();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["qtn"] = this.qtn;
        return data; 
    }

    clone(): OrderW {
        const json = this.toJSON();
        let result = new OrderW();
        result.init(json);
        return result;
    }
}

export interface IOrderW {
    id: string | undefined;
    code: string | undefined;
    qtn: string | undefined;
}

export class Route implements IRoute {
    id: string | undefined;
    code: string | undefined;

    constructor(data?: IRoute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): Route {
        data = typeof data === 'object' ? data : {};
        let result = new Route();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        return data; 
    }

    clone(): Route {
        const json = this.toJSON();
        let result = new Route();
        result.init(json);
        return result;
    }
}

export interface IRoute {
    id: string | undefined;
    code: string | undefined;
}

export class QuadmindsWebHookDto implements IQuadmindsWebHookDto {
    event: string | undefined;
    deliveryDate: string | undefined;
    deliveryDateUTC: string | undefined;
    code: string | undefined;
    qtn: string | undefined;
    eta: string | undefined;
    etaUTC: string | undefined;
    deliveryState: DeliveryState;
    poi: Poi;
    order: OrderW;
    route: Route;

    constructor(data?: IQuadmindsWebHookDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.event = _data["event"];
            this.deliveryDate = _data["deliveryDate"];
            this.deliveryDateUTC = _data["deliveryDateUTC"];
            this.code = _data["code"];
            this.qtn = _data["qtn"];
            this.eta = _data["eta"];
            this.etaUTC = _data["etaUTC"];
            this.deliveryState = _data["deliveryState"] ? DeliveryState.fromJS(_data["deliveryState"]) : <any>undefined;
            this.poi = _data["poi"] ? Poi.fromJS(_data["poi"]) : <any>undefined;
            this.order = _data["order"] ? OrderW.fromJS(_data["order"]) : <any>undefined;
            this.route = _data["route"] ? Route.fromJS(_data["route"]) : <any>undefined;
        }
    }

    static fromJS(data: any): QuadmindsWebHookDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuadmindsWebHookDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["event"] = this.event;
        data["deliveryDate"] = this.deliveryDate;
        data["deliveryDateUTC"] = this.deliveryDateUTC;
        data["code"] = this.code;
        data["qtn"] = this.qtn;
        data["eta"] = this.eta;
        data["etaUTC"] = this.etaUTC;
        data["deliveryState"] = this.deliveryState ? this.deliveryState.toJSON() : <any>undefined;
        data["poi"] = this.poi ? this.poi.toJSON() : <any>undefined;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["route"] = this.route ? this.route.toJSON() : <any>undefined;
        return data; 
    }

    clone(): QuadmindsWebHookDto {
        const json = this.toJSON();
        let result = new QuadmindsWebHookDto();
        result.init(json);
        return result;
    }
}

export interface IQuadmindsWebHookDto {
    event: string | undefined;
    deliveryDate: string | undefined;
    deliveryDateUTC: string | undefined;
    code: string | undefined;
    qtn: string | undefined;
    eta: string | undefined;
    etaUTC: string | undefined;
    deliveryState: DeliveryState;
    poi: Poi;
    order: OrderW;
    route: Route;
}

export class RapiboyRequest implements IRapiboyRequest {
    idPedido: number;
    trackingId: string | undefined;
    referenciaExterna: string | undefined;
    estado: number;
    nombre: string | undefined;
    telefono: string | undefined;
    idMotivoCancelacion: number | undefined;
    motivoCancelacion: string | undefined;
    idMotivoNoEntregado: number | undefined;
    motivoNoEntregado: string | undefined;
    fecha: string | undefined;

    constructor(data?: IRapiboyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idPedido = _data["idPedido"];
            this.trackingId = _data["trackingId"];
            this.referenciaExterna = _data["referenciaExterna"];
            this.estado = _data["estado"];
            this.nombre = _data["nombre"];
            this.telefono = _data["telefono"];
            this.idMotivoCancelacion = _data["idMotivoCancelacion"];
            this.motivoCancelacion = _data["motivoCancelacion"];
            this.idMotivoNoEntregado = _data["idMotivoNoEntregado"];
            this.motivoNoEntregado = _data["motivoNoEntregado"];
            this.fecha = _data["fecha"];
        }
    }

    static fromJS(data: any): RapiboyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RapiboyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idPedido"] = this.idPedido;
        data["trackingId"] = this.trackingId;
        data["referenciaExterna"] = this.referenciaExterna;
        data["estado"] = this.estado;
        data["nombre"] = this.nombre;
        data["telefono"] = this.telefono;
        data["idMotivoCancelacion"] = this.idMotivoCancelacion;
        data["motivoCancelacion"] = this.motivoCancelacion;
        data["idMotivoNoEntregado"] = this.idMotivoNoEntregado;
        data["motivoNoEntregado"] = this.motivoNoEntregado;
        data["fecha"] = this.fecha;
        return data; 
    }

    clone(): RapiboyRequest {
        const json = this.toJSON();
        let result = new RapiboyRequest();
        result.init(json);
        return result;
    }
}

export interface IRapiboyRequest {
    idPedido: number;
    trackingId: string | undefined;
    referenciaExterna: string | undefined;
    estado: number;
    nombre: string | undefined;
    telefono: string | undefined;
    idMotivoCancelacion: number | undefined;
    motivoCancelacion: string | undefined;
    idMotivoNoEntregado: number | undefined;
    motivoNoEntregado: string | undefined;
    fecha: string | undefined;
}

export class RappiItemDto implements IRappiItemDto {
    storeCode: string | undefined;
    codComerssia: string | undefined;
    referenciaAliado: string | undefined;
    sku: string | undefined;
    nombre: string | undefined;
    descripcion: string | undefined;
    marca: string | undefined;
    stock: number;
    tienda: string | undefined;
    precioPorTienda: number | undefined;
    precioConDescuento: number | undefined;
    descuento: number | undefined;
    fechaInicioDescuento: moment.Moment | undefined;
    fechaFinDescuento: moment.Moment | undefined;
    categoriaProducto1: string | undefined;
    categoriaProducto2: string | undefined;
    categoriaProducto3: string | undefined;
    imagenDeProducto: string | undefined;
    categoriaCombinacion: string | undefined;
    nombreCombinacion: string | undefined;
    disponible: boolean;
    name: string | undefined;
    description: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IRappiItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeCode = _data["storeCode"];
            this.codComerssia = _data["codComerssia"];
            this.referenciaAliado = _data["referenciaAliado"];
            this.sku = _data["sku"];
            this.nombre = _data["nombre"];
            this.descripcion = _data["descripcion"];
            this.marca = _data["marca"];
            this.stock = _data["stock"];
            this.tienda = _data["tienda"];
            this.precioPorTienda = _data["precioPorTienda"];
            this.precioConDescuento = _data["precioConDescuento"];
            this.descuento = _data["descuento"];
            this.fechaInicioDescuento = _data["fechaInicioDescuento"] ? moment(_data["fechaInicioDescuento"].toString()) : <any>undefined;
            this.fechaFinDescuento = _data["fechaFinDescuento"] ? moment(_data["fechaFinDescuento"].toString()) : <any>undefined;
            this.categoriaProducto1 = _data["categoriaProducto1"];
            this.categoriaProducto2 = _data["categoriaProducto2"];
            this.categoriaProducto3 = _data["categoriaProducto3"];
            this.imagenDeProducto = _data["imagenDeProducto"];
            this.categoriaCombinacion = _data["categoriaCombinacion"];
            this.nombreCombinacion = _data["nombreCombinacion"];
            this.disponible = _data["disponible"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RappiItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new RappiItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeCode"] = this.storeCode;
        data["codComerssia"] = this.codComerssia;
        data["referenciaAliado"] = this.referenciaAliado;
        data["sku"] = this.sku;
        data["nombre"] = this.nombre;
        data["descripcion"] = this.descripcion;
        data["marca"] = this.marca;
        data["stock"] = this.stock;
        data["tienda"] = this.tienda;
        data["precioPorTienda"] = this.precioPorTienda;
        data["precioConDescuento"] = this.precioConDescuento;
        data["descuento"] = this.descuento;
        data["fechaInicioDescuento"] = this.fechaInicioDescuento ? this.fechaInicioDescuento.toISOString() : <any>undefined;
        data["fechaFinDescuento"] = this.fechaFinDescuento ? this.fechaFinDescuento.toISOString() : <any>undefined;
        data["categoriaProducto1"] = this.categoriaProducto1;
        data["categoriaProducto2"] = this.categoriaProducto2;
        data["categoriaProducto3"] = this.categoriaProducto3;
        data["imagenDeProducto"] = this.imagenDeProducto;
        data["categoriaCombinacion"] = this.categoriaCombinacion;
        data["nombreCombinacion"] = this.nombreCombinacion;
        data["disponible"] = this.disponible;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): RappiItemDto {
        const json = this.toJSON();
        let result = new RappiItemDto();
        result.init(json);
        return result;
    }
}

export interface IRappiItemDto {
    storeCode: string | undefined;
    codComerssia: string | undefined;
    referenciaAliado: string | undefined;
    sku: string | undefined;
    nombre: string | undefined;
    descripcion: string | undefined;
    marca: string | undefined;
    stock: number;
    tienda: string | undefined;
    precioPorTienda: number | undefined;
    precioConDescuento: number | undefined;
    descuento: number | undefined;
    fechaInicioDescuento: moment.Moment | undefined;
    fechaFinDescuento: moment.Moment | undefined;
    categoriaProducto1: string | undefined;
    categoriaProducto2: string | undefined;
    categoriaProducto3: string | undefined;
    imagenDeProducto: string | undefined;
    categoriaCombinacion: string | undefined;
    nombreCombinacion: string | undefined;
    disponible: boolean;
    name: string | undefined;
    description: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class RappiItemCsvDashboardDto implements IRappiItemCsvDashboardDto {
    storeCode: string | undefined;
    codComerssia: string | undefined;
    referenciaAliado: string | undefined;
    sku: string | undefined;
    nombre: string | undefined;
    descripcion: string | undefined;
    marca: string | undefined;
    stock: number;
    tienda: string | undefined;
    precioPorTienda: number | undefined;
    precioConDescuento: number | undefined;
    descuento: number | undefined;
    fechaInicioDescuento: moment.Moment | undefined;
    fechaFinDescuento: moment.Moment | undefined;
    categoriaProducto1: string | undefined;
    categoriaProducto2: string | undefined;
    categoriaProducto3: string | undefined;
    imagenDeProducto: string | undefined;
    categoriaCombinacion: string | undefined;
    nombreCombinacion: string | undefined;
    disponible: boolean;

    constructor(data?: IRappiItemCsvDashboardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeCode = _data["storeCode"];
            this.codComerssia = _data["codComerssia"];
            this.referenciaAliado = _data["referenciaAliado"];
            this.sku = _data["sku"];
            this.nombre = _data["nombre"];
            this.descripcion = _data["descripcion"];
            this.marca = _data["marca"];
            this.stock = _data["stock"];
            this.tienda = _data["tienda"];
            this.precioPorTienda = _data["precioPorTienda"];
            this.precioConDescuento = _data["precioConDescuento"];
            this.descuento = _data["descuento"];
            this.fechaInicioDescuento = _data["fechaInicioDescuento"] ? moment(_data["fechaInicioDescuento"].toString()) : <any>undefined;
            this.fechaFinDescuento = _data["fechaFinDescuento"] ? moment(_data["fechaFinDescuento"].toString()) : <any>undefined;
            this.categoriaProducto1 = _data["categoriaProducto1"];
            this.categoriaProducto2 = _data["categoriaProducto2"];
            this.categoriaProducto3 = _data["categoriaProducto3"];
            this.imagenDeProducto = _data["imagenDeProducto"];
            this.categoriaCombinacion = _data["categoriaCombinacion"];
            this.nombreCombinacion = _data["nombreCombinacion"];
            this.disponible = _data["disponible"];
        }
    }

    static fromJS(data: any): RappiItemCsvDashboardDto {
        data = typeof data === 'object' ? data : {};
        let result = new RappiItemCsvDashboardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeCode"] = this.storeCode;
        data["codComerssia"] = this.codComerssia;
        data["referenciaAliado"] = this.referenciaAliado;
        data["sku"] = this.sku;
        data["nombre"] = this.nombre;
        data["descripcion"] = this.descripcion;
        data["marca"] = this.marca;
        data["stock"] = this.stock;
        data["tienda"] = this.tienda;
        data["precioPorTienda"] = this.precioPorTienda;
        data["precioConDescuento"] = this.precioConDescuento;
        data["descuento"] = this.descuento;
        data["fechaInicioDescuento"] = this.fechaInicioDescuento ? this.fechaInicioDescuento.toISOString() : <any>undefined;
        data["fechaFinDescuento"] = this.fechaFinDescuento ? this.fechaFinDescuento.toISOString() : <any>undefined;
        data["categoriaProducto1"] = this.categoriaProducto1;
        data["categoriaProducto2"] = this.categoriaProducto2;
        data["categoriaProducto3"] = this.categoriaProducto3;
        data["imagenDeProducto"] = this.imagenDeProducto;
        data["categoriaCombinacion"] = this.categoriaCombinacion;
        data["nombreCombinacion"] = this.nombreCombinacion;
        data["disponible"] = this.disponible;
        return data; 
    }

    clone(): RappiItemCsvDashboardDto {
        const json = this.toJSON();
        let result = new RappiItemCsvDashboardDto();
        result.init(json);
        return result;
    }
}

export interface IRappiItemCsvDashboardDto {
    storeCode: string | undefined;
    codComerssia: string | undefined;
    referenciaAliado: string | undefined;
    sku: string | undefined;
    nombre: string | undefined;
    descripcion: string | undefined;
    marca: string | undefined;
    stock: number;
    tienda: string | undefined;
    precioPorTienda: number | undefined;
    precioConDescuento: number | undefined;
    descuento: number | undefined;
    fechaInicioDescuento: moment.Moment | undefined;
    fechaFinDescuento: moment.Moment | undefined;
    categoriaProducto1: string | undefined;
    categoriaProducto2: string | undefined;
    categoriaProducto3: string | undefined;
    imagenDeProducto: string | undefined;
    categoriaCombinacion: string | undefined;
    nombreCombinacion: string | undefined;
    disponible: boolean;
}

export class SyncRappiCatalogDto implements ISyncRappiCatalogDto {
    countryCode: string | undefined;
    type: string | undefined;
    stores: string[] | undefined;

    constructor(data?: ISyncRappiCatalogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryCode = _data["countryCode"];
            this.type = _data["type"];
            if (Array.isArray(_data["stores"])) {
                this.stores = [] as any;
                for (let item of _data["stores"])
                    this.stores.push(item);
            }
        }
    }

    static fromJS(data: any): SyncRappiCatalogDto {
        data = typeof data === 'object' ? data : {};
        let result = new SyncRappiCatalogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryCode"] = this.countryCode;
        data["type"] = this.type;
        if (Array.isArray(this.stores)) {
            data["stores"] = [];
            for (let item of this.stores)
                data["stores"].push(item);
        }
        return data; 
    }

    clone(): SyncRappiCatalogDto {
        const json = this.toJSON();
        let result = new SyncRappiCatalogDto();
        result.init(json);
        return result;
    }
}

export interface ISyncRappiCatalogDto {
    countryCode: string | undefined;
    type: string | undefined;
    stores: string[] | undefined;
}

export class StoreConfig implements IStoreConfig {
    storeId: number;
    percentage: number;
    amount: number;

    constructor(data?: IStoreConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeId = _data["storeId"];
            this.percentage = _data["percentage"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): StoreConfig {
        data = typeof data === 'object' ? data : {};
        let result = new StoreConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["percentage"] = this.percentage;
        data["amount"] = this.amount;
        return data; 
    }

    clone(): StoreConfig {
        const json = this.toJSON();
        let result = new StoreConfig();
        result.init(json);
        return result;
    }
}

export interface IStoreConfig {
    storeId: number;
    percentage: number;
    amount: number;
}

export class RappiConfigDto implements IRappiConfigDto {
    storeConfigs: StoreConfig[] | undefined;

    constructor(data?: IRappiConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["storeConfigs"])) {
                this.storeConfigs = [] as any;
                for (let item of _data["storeConfigs"])
                    this.storeConfigs.push(StoreConfig.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RappiConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new RappiConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.storeConfigs)) {
            data["storeConfigs"] = [];
            for (let item of this.storeConfigs)
                data["storeConfigs"].push(item.toJSON());
        }
        return data; 
    }

    clone(): RappiConfigDto {
        const json = this.toJSON();
        let result = new RappiConfigDto();
        result.init(json);
        return result;
    }
}

export interface IRappiConfigDto {
    storeConfigs: StoreConfig[] | undefined;
}

export class UploadRappiDiscountsRequestDto implements IUploadRappiDiscountsRequestDto {
    countryCode: string | undefined;
    url: string | undefined;
    stores: string[] | undefined;

    constructor(data?: IUploadRappiDiscountsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryCode = _data["countryCode"];
            this.url = _data["url"];
            if (Array.isArray(_data["stores"])) {
                this.stores = [] as any;
                for (let item of _data["stores"])
                    this.stores.push(item);
            }
        }
    }

    static fromJS(data: any): UploadRappiDiscountsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadRappiDiscountsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryCode"] = this.countryCode;
        data["url"] = this.url;
        if (Array.isArray(this.stores)) {
            data["stores"] = [];
            for (let item of this.stores)
                data["stores"].push(item);
        }
        return data; 
    }

    clone(): UploadRappiDiscountsRequestDto {
        const json = this.toJSON();
        let result = new UploadRappiDiscountsRequestDto();
        result.init(json);
        return result;
    }
}

export interface IUploadRappiDiscountsRequestDto {
    countryCode: string | undefined;
    url: string | undefined;
    stores: string[] | undefined;
}

export class UploadRappiProductsRequestDto implements IUploadRappiProductsRequestDto {
    countryCode: string | undefined;
    url: string | undefined;

    constructor(data?: IUploadRappiProductsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryCode = _data["countryCode"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): UploadRappiProductsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadRappiProductsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryCode"] = this.countryCode;
        data["url"] = this.url;
        return data; 
    }

    clone(): UploadRappiProductsRequestDto {
        const json = this.toJSON();
        let result = new UploadRappiProductsRequestDto();
        result.init(json);
        return result;
    }
}

export interface IUploadRappiProductsRequestDto {
    countryCode: string | undefined;
    url: string | undefined;
}

export class RappiItemDtoPagedResultDto implements IRappiItemDtoPagedResultDto {
    totalCount: number;
    items: RappiItemDto[] | undefined;

    constructor(data?: IRappiItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RappiItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RappiItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RappiItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): RappiItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RappiItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRappiItemDtoPagedResultDto {
    totalCount: number;
    items: RappiItemDto[] | undefined;
}

export class RappiStoreConfigDto implements IRappiStoreConfigDto {
    rappiStoreId: number;
    safetyStockPercentage: number;
    safetyStockAmount: number;
    name: string | undefined;
    description: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IRappiStoreConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rappiStoreId = _data["rappiStoreId"];
            this.safetyStockPercentage = _data["safetyStockPercentage"];
            this.safetyStockAmount = _data["safetyStockAmount"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RappiStoreConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new RappiStoreConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rappiStoreId"] = this.rappiStoreId;
        data["safetyStockPercentage"] = this.safetyStockPercentage;
        data["safetyStockAmount"] = this.safetyStockAmount;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): RappiStoreConfigDto {
        const json = this.toJSON();
        let result = new RappiStoreConfigDto();
        result.init(json);
        return result;
    }
}

export interface IRappiStoreConfigDto {
    rappiStoreId: number;
    safetyStockPercentage: number;
    safetyStockAmount: number;
    name: string | undefined;
    description: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class RappiStoreConfigDtoPagedResultDto implements IRappiStoreConfigDtoPagedResultDto {
    totalCount: number;
    items: RappiStoreConfigDto[] | undefined;

    constructor(data?: IRappiStoreConfigDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RappiStoreConfigDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RappiStoreConfigDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RappiStoreConfigDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): RappiStoreConfigDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RappiStoreConfigDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRappiStoreConfigDtoPagedResultDto {
    totalCount: number;
    items: RappiStoreConfigDto[] | undefined;
}

export class ReturnStatusDto implements IReturnStatusDto {
    id: number;
    name: string | undefined;

    constructor(data?: IReturnStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ReturnStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReturnStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): ReturnStatusDto {
        const json = this.toJSON();
        let result = new ReturnStatusDto();
        result.init(json);
        return result;
    }
}

export interface IReturnStatusDto {
    id: number;
    name: string | undefined;
}

export class ReturnItemDto implements IReturnItemDto {
    sku: string | undefined;
    quantity: number;
    description: string | undefined;
    imageUrl: string | undefined;
    id: number;

    constructor(data?: IReturnItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sku = _data["sku"];
            this.quantity = _data["quantity"];
            this.description = _data["description"];
            this.imageUrl = _data["imageUrl"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ReturnItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReturnItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["quantity"] = this.quantity;
        data["description"] = this.description;
        data["imageUrl"] = this.imageUrl;
        data["id"] = this.id;
        return data; 
    }

    clone(): ReturnItemDto {
        const json = this.toJSON();
        let result = new ReturnItemDto();
        result.init(json);
        return result;
    }
}

export interface IReturnItemDto {
    sku: string | undefined;
    quantity: number;
    description: string | undefined;
    imageUrl: string | undefined;
    id: number;
}

export class ReturnDto implements IReturnDto {
    withdrawTime: moment.Moment;
    deliveryData: DeliveryDataDto;
    status: ReturnStatusDto;
    claim: ClaimDto;
    readonly itemQuantity: number;
    returnItems: ReturnItemDto[] | undefined;
    id: number;

    constructor(data?: IReturnDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : <any>undefined;
            this.deliveryData = _data["deliveryData"] ? DeliveryDataDto.fromJS(_data["deliveryData"]) : <any>undefined;
            this.status = _data["status"] ? ReturnStatusDto.fromJS(_data["status"]) : <any>undefined;
            this.claim = _data["claim"] ? ClaimDto.fromJS(_data["claim"]) : <any>undefined;
            (<any>this).itemQuantity = _data["itemQuantity"];
            if (Array.isArray(_data["returnItems"])) {
                this.returnItems = [] as any;
                for (let item of _data["returnItems"])
                    this.returnItems.push(ReturnItemDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ReturnDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReturnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : <any>undefined;
        data["deliveryData"] = this.deliveryData ? this.deliveryData.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["claim"] = this.claim ? this.claim.toJSON() : <any>undefined;
        data["itemQuantity"] = this.itemQuantity;
        if (Array.isArray(this.returnItems)) {
            data["returnItems"] = [];
            for (let item of this.returnItems)
                data["returnItems"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): ReturnDto {
        const json = this.toJSON();
        let result = new ReturnDto();
        result.init(json);
        return result;
    }
}

export interface IReturnDto {
    withdrawTime: moment.Moment;
    deliveryData: DeliveryDataDto;
    status: ReturnStatusDto;
    claim: ClaimDto;
    itemQuantity: number;
    returnItems: ReturnItemDto[] | undefined;
    id: number;
}

export class ReturnDtoPagedResultDto implements IReturnDtoPagedResultDto {
    totalCount: number;
    items: ReturnDto[] | undefined;

    constructor(data?: IReturnDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ReturnDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReturnDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReturnDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ReturnDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ReturnDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IReturnDtoPagedResultDto {
    totalCount: number;
    items: ReturnDto[] | undefined;
}

export class ReturnCsvQuadminDto implements IReturnCsvQuadminDto {
    customerCode: string | undefined;
    customer: string | undefined;
    address: string | undefined;
    city: string | undefined;
    state: string | undefined;
    geoLat: number | undefined;
    geoLong: number | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    orderId: number;
    withdrawTime: moment.Moment | undefined;
    operation: string | undefined;
    sku: string | undefined;
    productDescription: string | undefined;
    quantity: number | undefined;
    weight: number;
    volume: number | undefined;
    money: string | undefined;
    clientDelay: string | undefined;
    deliveryWindow1: string | undefined;
    deliveryWindow2: string | undefined;
    deliveryCommentaries: string | undefined;
    group: string | undefined;

    constructor(data?: IReturnCsvQuadminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerCode = _data["customerCode"];
            this.customer = _data["customer"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.geoLat = _data["geoLat"];
            this.geoLong = _data["geoLong"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.orderId = _data["orderId"];
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : <any>undefined;
            this.operation = _data["operation"];
            this.sku = _data["sku"];
            this.productDescription = _data["productDescription"];
            this.quantity = _data["quantity"];
            this.weight = _data["weight"];
            this.volume = _data["volume"];
            this.money = _data["money"];
            this.clientDelay = _data["clientDelay"];
            this.deliveryWindow1 = _data["deliveryWindow1"];
            this.deliveryWindow2 = _data["deliveryWindow2"];
            this.deliveryCommentaries = _data["deliveryCommentaries"];
            this.group = _data["group"];
        }
    }

    static fromJS(data: any): ReturnCsvQuadminDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReturnCsvQuadminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerCode"] = this.customerCode;
        data["customer"] = this.customer;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["geoLat"] = this.geoLat;
        data["geoLong"] = this.geoLong;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["orderId"] = this.orderId;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : <any>undefined;
        data["operation"] = this.operation;
        data["sku"] = this.sku;
        data["productDescription"] = this.productDescription;
        data["quantity"] = this.quantity;
        data["weight"] = this.weight;
        data["volume"] = this.volume;
        data["money"] = this.money;
        data["clientDelay"] = this.clientDelay;
        data["deliveryWindow1"] = this.deliveryWindow1;
        data["deliveryWindow2"] = this.deliveryWindow2;
        data["deliveryCommentaries"] = this.deliveryCommentaries;
        data["group"] = this.group;
        return data; 
    }

    clone(): ReturnCsvQuadminDto {
        const json = this.toJSON();
        let result = new ReturnCsvQuadminDto();
        result.init(json);
        return result;
    }
}

export interface IReturnCsvQuadminDto {
    customerCode: string | undefined;
    customer: string | undefined;
    address: string | undefined;
    city: string | undefined;
    state: string | undefined;
    geoLat: number | undefined;
    geoLong: number | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    orderId: number;
    withdrawTime: moment.Moment | undefined;
    operation: string | undefined;
    sku: string | undefined;
    productDescription: string | undefined;
    quantity: number | undefined;
    weight: number;
    volume: number | undefined;
    money: string | undefined;
    clientDelay: string | undefined;
    deliveryWindow1: string | undefined;
    deliveryWindow2: string | undefined;
    deliveryCommentaries: string | undefined;
    group: string | undefined;
}

export class UploadImageInputDto implements IUploadImageInputDto {
    imageBase64: string | undefined;
    fileName: string | undefined;
    fileContentType: string | undefined;
    bucket: string | undefined;

    constructor(data?: IUploadImageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageBase64 = _data["imageBase64"];
            this.fileName = _data["fileName"];
            this.fileContentType = _data["fileContentType"];
            this.bucket = _data["bucket"];
        }
    }

    static fromJS(data: any): UploadImageInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadImageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageBase64"] = this.imageBase64;
        data["fileName"] = this.fileName;
        data["fileContentType"] = this.fileContentType;
        data["bucket"] = this.bucket;
        return data; 
    }

    clone(): UploadImageInputDto {
        const json = this.toJSON();
        let result = new UploadImageInputDto();
        result.init(json);
        return result;
    }
}

export interface IUploadImageInputDto {
    imageBase64: string | undefined;
    fileName: string | undefined;
    fileContentType: string | undefined;
    bucket: string | undefined;
}

export class SalesOrderNotificationRequest implements ISalesOrderNotificationRequest {
    salesOrderId: number;

    constructor(data?: ISalesOrderNotificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salesOrderId = _data["salesOrderId"];
        }
    }

    static fromJS(data: any): SalesOrderNotificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOrderNotificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesOrderId"] = this.salesOrderId;
        return data; 
    }

    clone(): SalesOrderNotificationRequest {
        const json = this.toJSON();
        let result = new SalesOrderNotificationRequest();
        result.init(json);
        return result;
    }
}

export interface ISalesOrderNotificationRequest {
    salesOrderId: number;
}

export class ShipmentCreateDto implements IShipmentCreateDto {
    orderIds: number[] | undefined;
    carrierId: number;
    carrierDriverId: number;
    storeCode: string;
    countryCode: string | undefined;
    deliveryType: string | undefined;
    id: number;

    constructor(data?: IShipmentCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orderIds"])) {
                this.orderIds = [] as any;
                for (let item of _data["orderIds"])
                    this.orderIds.push(item);
            }
            this.carrierId = _data["carrierId"];
            this.carrierDriverId = _data["carrierDriverId"];
            this.storeCode = _data["storeCode"];
            this.countryCode = _data["countryCode"];
            this.deliveryType = _data["deliveryType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ShipmentCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShipmentCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderIds)) {
            data["orderIds"] = [];
            for (let item of this.orderIds)
                data["orderIds"].push(item);
        }
        data["carrierId"] = this.carrierId;
        data["carrierDriverId"] = this.carrierDriverId;
        data["storeCode"] = this.storeCode;
        data["countryCode"] = this.countryCode;
        data["deliveryType"] = this.deliveryType;
        data["id"] = this.id;
        return data; 
    }

    clone(): ShipmentCreateDto {
        const json = this.toJSON();
        let result = new ShipmentCreateDto();
        result.init(json);
        return result;
    }
}

export interface IShipmentCreateDto {
    orderIds: number[] | undefined;
    carrierId: number;
    carrierDriverId: number;
    storeCode: string;
    countryCode: string | undefined;
    deliveryType: string | undefined;
    id: number;
}

export class OrderDelivered implements IOrderDelivered {
    orderId: number;
    proofFiles: string[] | undefined;
    proofNote: string | undefined;

    constructor(data?: IOrderDelivered) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            if (Array.isArray(_data["proofFiles"])) {
                this.proofFiles = [] as any;
                for (let item of _data["proofFiles"])
                    this.proofFiles.push(item);
            }
            this.proofNote = _data["proofNote"];
        }
    }

    static fromJS(data: any): OrderDelivered {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDelivered();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        if (Array.isArray(this.proofFiles)) {
            data["proofFiles"] = [];
            for (let item of this.proofFiles)
                data["proofFiles"].push(item);
        }
        data["proofNote"] = this.proofNote;
        return data; 
    }

    clone(): OrderDelivered {
        const json = this.toJSON();
        let result = new OrderDelivered();
        result.init(json);
        return result;
    }
}

export interface IOrderDelivered {
    orderId: number;
    proofFiles: string[] | undefined;
    proofNote: string | undefined;
}

export class OrderNotDelivered implements IOrderNotDelivered {
    orderId: number;
    proofFiles: string[] | undefined;
    proofNote: string | undefined;
    shipmentIssue: string | undefined;

    constructor(data?: IOrderNotDelivered) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            if (Array.isArray(_data["proofFiles"])) {
                this.proofFiles = [] as any;
                for (let item of _data["proofFiles"])
                    this.proofFiles.push(item);
            }
            this.proofNote = _data["proofNote"];
            this.shipmentIssue = _data["shipmentIssue"];
        }
    }

    static fromJS(data: any): OrderNotDelivered {
        data = typeof data === 'object' ? data : {};
        let result = new OrderNotDelivered();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        if (Array.isArray(this.proofFiles)) {
            data["proofFiles"] = [];
            for (let item of this.proofFiles)
                data["proofFiles"].push(item);
        }
        data["proofNote"] = this.proofNote;
        data["shipmentIssue"] = this.shipmentIssue;
        return data; 
    }

    clone(): OrderNotDelivered {
        const json = this.toJSON();
        let result = new OrderNotDelivered();
        result.init(json);
        return result;
    }
}

export interface IOrderNotDelivered {
    orderId: number;
    proofFiles: string[] | undefined;
    proofNote: string | undefined;
    shipmentIssue: string | undefined;
}

export class ShipmentRegisterRequest implements IShipmentRegisterRequest {
    shipmentId: number;
    orderDelivered: OrderDelivered[] | undefined;
    ordersNotDelivered: OrderNotDelivered[] | undefined;

    constructor(data?: IShipmentRegisterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shipmentId = _data["shipmentId"];
            if (Array.isArray(_data["orderDelivered"])) {
                this.orderDelivered = [] as any;
                for (let item of _data["orderDelivered"])
                    this.orderDelivered.push(OrderDelivered.fromJS(item));
            }
            if (Array.isArray(_data["ordersNotDelivered"])) {
                this.ordersNotDelivered = [] as any;
                for (let item of _data["ordersNotDelivered"])
                    this.ordersNotDelivered.push(OrderNotDelivered.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShipmentRegisterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ShipmentRegisterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shipmentId"] = this.shipmentId;
        if (Array.isArray(this.orderDelivered)) {
            data["orderDelivered"] = [];
            for (let item of this.orderDelivered)
                data["orderDelivered"].push(item.toJSON());
        }
        if (Array.isArray(this.ordersNotDelivered)) {
            data["ordersNotDelivered"] = [];
            for (let item of this.ordersNotDelivered)
                data["ordersNotDelivered"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ShipmentRegisterRequest {
        const json = this.toJSON();
        let result = new ShipmentRegisterRequest();
        result.init(json);
        return result;
    }
}

export interface IShipmentRegisterRequest {
    shipmentId: number;
    orderDelivered: OrderDelivered[] | undefined;
    ordersNotDelivered: OrderNotDelivered[] | undefined;
}

export class ShipmentDto implements IShipmentDto {
    shipmentDate: moment.Moment;
    status: string | undefined;
    carrierId: number;
    carrierDriverId: number;
    shipmentTypeGroupName: string | undefined;
    carrierName: string | undefined;
    carrierDriverName: string | undefined;
    orders: ShipmentOrderDto[] | undefined;
    readonly ordersQuantity: number;
    storeCode: string | undefined;
    shipmentRegisterPartialSavedId: number | undefined;
    shipmentRegisterRequest: ShipmentRegisterRequest;
    id: number;

    constructor(data?: IShipmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shipmentDate = _data["shipmentDate"] ? moment(_data["shipmentDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.carrierId = _data["carrierId"];
            this.carrierDriverId = _data["carrierDriverId"];
            this.shipmentTypeGroupName = _data["shipmentTypeGroupName"];
            this.carrierName = _data["carrierName"];
            this.carrierDriverName = _data["carrierDriverName"];
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders.push(ShipmentOrderDto.fromJS(item));
            }
            (<any>this).ordersQuantity = _data["ordersQuantity"];
            this.storeCode = _data["storeCode"];
            this.shipmentRegisterPartialSavedId = _data["shipmentRegisterPartialSavedId"];
            this.shipmentRegisterRequest = _data["shipmentRegisterRequest"] ? ShipmentRegisterRequest.fromJS(_data["shipmentRegisterRequest"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ShipmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShipmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shipmentDate"] = this.shipmentDate ? this.shipmentDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["carrierId"] = this.carrierId;
        data["carrierDriverId"] = this.carrierDriverId;
        data["shipmentTypeGroupName"] = this.shipmentTypeGroupName;
        data["carrierName"] = this.carrierName;
        data["carrierDriverName"] = this.carrierDriverName;
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        data["ordersQuantity"] = this.ordersQuantity;
        data["storeCode"] = this.storeCode;
        data["shipmentRegisterPartialSavedId"] = this.shipmentRegisterPartialSavedId;
        data["shipmentRegisterRequest"] = this.shipmentRegisterRequest ? this.shipmentRegisterRequest.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): ShipmentDto {
        const json = this.toJSON();
        let result = new ShipmentDto();
        result.init(json);
        return result;
    }
}

export interface IShipmentDto {
    shipmentDate: moment.Moment;
    status: string | undefined;
    carrierId: number;
    carrierDriverId: number;
    shipmentTypeGroupName: string | undefined;
    carrierName: string | undefined;
    carrierDriverName: string | undefined;
    orders: ShipmentOrderDto[] | undefined;
    ordersQuantity: number;
    storeCode: string | undefined;
    shipmentRegisterPartialSavedId: number | undefined;
    shipmentRegisterRequest: ShipmentRegisterRequest;
    id: number;
}

export class ShipmentDtoPagedResultDto implements IShipmentDtoPagedResultDto {
    totalCount: number;
    items: ShipmentDto[] | undefined;

    constructor(data?: IShipmentDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ShipmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShipmentDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShipmentDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ShipmentDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ShipmentDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IShipmentDtoPagedResultDto {
    totalCount: number;
    items: ShipmentDto[] | undefined;
}

export class ShippingTypeDtoPagedResultDto implements IShippingTypeDtoPagedResultDto {
    totalCount: number;
    items: ShippingTypeDto[] | undefined;

    constructor(data?: IShippingTypeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ShippingTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShippingTypeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingTypeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ShippingTypeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ShippingTypeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IShippingTypeDtoPagedResultDto {
    totalCount: number;
    items: ShippingTypeDto[] | undefined;
}

export class ShippingTypeGroupDto implements IShippingTypeGroupDto {
    code: string | undefined;
    name: string | undefined;
    color: string | undefined;
    icon: string | undefined;
    id: number;

    constructor(data?: IShippingTypeGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.color = _data["color"];
            this.icon = _data["icon"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ShippingTypeGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingTypeGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["color"] = this.color;
        data["icon"] = this.icon;
        data["id"] = this.id;
        return data; 
    }

    clone(): ShippingTypeGroupDto {
        const json = this.toJSON();
        let result = new ShippingTypeGroupDto();
        result.init(json);
        return result;
    }
}

export interface IShippingTypeGroupDto {
    code: string | undefined;
    name: string | undefined;
    color: string | undefined;
    icon: string | undefined;
    id: number;
}

export class ShippingTypeGroupDtoPagedResultDto implements IShippingTypeGroupDtoPagedResultDto {
    totalCount: number;
    items: ShippingTypeGroupDto[] | undefined;

    constructor(data?: IShippingTypeGroupDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ShippingTypeGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShippingTypeGroupDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingTypeGroupDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ShippingTypeGroupDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ShippingTypeGroupDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IShippingTypeGroupDtoPagedResultDto {
    totalCount: number;
    items: ShippingTypeGroupDto[] | undefined;
}

export class ShippingTypeMappingDto implements IShippingTypeMappingDto {
    sourceName: string | undefined;
    shippingTypeSourceCode: string | undefined;
    shippingTypeCode: string | undefined;
    deliveryTypeId: number;
    deliveryType: string | undefined;
    id: number;

    constructor(data?: IShippingTypeMappingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceName = _data["sourceName"];
            this.shippingTypeSourceCode = _data["shippingTypeSourceCode"];
            this.shippingTypeCode = _data["shippingTypeCode"];
            this.deliveryTypeId = _data["deliveryTypeId"];
            this.deliveryType = _data["deliveryType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ShippingTypeMappingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingTypeMappingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceName"] = this.sourceName;
        data["shippingTypeSourceCode"] = this.shippingTypeSourceCode;
        data["shippingTypeCode"] = this.shippingTypeCode;
        data["deliveryTypeId"] = this.deliveryTypeId;
        data["deliveryType"] = this.deliveryType;
        data["id"] = this.id;
        return data; 
    }

    clone(): ShippingTypeMappingDto {
        const json = this.toJSON();
        let result = new ShippingTypeMappingDto();
        result.init(json);
        return result;
    }
}

export interface IShippingTypeMappingDto {
    sourceName: string | undefined;
    shippingTypeSourceCode: string | undefined;
    shippingTypeCode: string | undefined;
    deliveryTypeId: number;
    deliveryType: string | undefined;
    id: number;
}

export class ShippingTypeMappingDtoPagedResultDto implements IShippingTypeMappingDtoPagedResultDto {
    totalCount: number;
    items: ShippingTypeMappingDto[] | undefined;

    constructor(data?: IShippingTypeMappingDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ShippingTypeMappingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShippingTypeMappingDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingTypeMappingDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ShippingTypeMappingDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ShippingTypeMappingDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IShippingTypeMappingDtoPagedResultDto {
    totalCount: number;
    items: ShippingTypeMappingDto[] | undefined;
}

export class SourceData implements ISourceData {
    code: string | undefined;
    source: SourceValue;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ISourceData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.source = _data["source"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SourceData {
        data = typeof data === 'object' ? data : {};
        let result = new SourceData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["source"] = this.source;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): SourceData {
        const json = this.toJSON();
        let result = new SourceData();
        result.init(json);
        return result;
    }
}

export interface ISourceData {
    code: string | undefined;
    source: SourceValue;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Customer implements ICustomer {
    sourceCode: SourceData[] | undefined;
    code: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    documentType: string | undefined;
    documentNumber: string | undefined;
    phoneNumber: string | undefined;
    phoneNumberAlternative: string | undefined;
    email: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sourceCode"])) {
                this.sourceCode = [] as any;
                for (let item of _data["sourceCode"])
                    this.sourceCode.push(SourceData.fromJS(item));
            }
            this.code = _data["code"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.documentType = _data["documentType"];
            this.documentNumber = _data["documentNumber"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberAlternative = _data["phoneNumberAlternative"];
            this.email = _data["email"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Customer {
        data = typeof data === 'object' ? data : {};
        let result = new Customer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sourceCode)) {
            data["sourceCode"] = [];
            for (let item of this.sourceCode)
                data["sourceCode"].push(item.toJSON());
        }
        data["code"] = this.code;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["documentType"] = this.documentType;
        data["documentNumber"] = this.documentNumber;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberAlternative"] = this.phoneNumberAlternative;
        data["email"] = this.email;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): Customer {
        const json = this.toJSON();
        let result = new Customer();
        result.init(json);
        return result;
    }
}

export interface ICustomer {
    sourceCode: SourceData[] | undefined;
    code: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    documentType: string | undefined;
    documentNumber: string | undefined;
    phoneNumber: string | undefined;
    phoneNumberAlternative: string | undefined;
    email: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export enum DocumentType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class OrderDocument implements IOrderDocument {
    number: string | undefined;
    documentCreationTime: moment.Moment | undefined;
    type: DocumentType;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.documentCreationTime = _data["documentCreationTime"] ? moment(_data["documentCreationTime"].toString()) : <any>undefined;
            this.type = _data["type"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderDocument {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["documentCreationTime"] = this.documentCreationTime ? this.documentCreationTime.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderDocument {
        const json = this.toJSON();
        let result = new OrderDocument();
        result.init(json);
        return result;
    }
}

export interface IOrderDocument {
    number: string | undefined;
    documentCreationTime: moment.Moment | undefined;
    type: DocumentType;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class IEventData implements IIEventData {
    eventTime: moment.Moment;
    eventSource: any | undefined;

    constructor(data?: IIEventData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventTime = _data["eventTime"] ? moment(_data["eventTime"].toString()) : <any>undefined;
            this.eventSource = _data["eventSource"];
        }
    }

    static fromJS(data: any): IEventData {
        data = typeof data === 'object' ? data : {};
        let result = new IEventData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventTime"] = this.eventTime ? this.eventTime.toISOString() : <any>undefined;
        data["eventSource"] = this.eventSource;
        return data; 
    }

    clone(): IEventData {
        const json = this.toJSON();
        let result = new IEventData();
        result.init(json);
        return result;
    }
}

export interface IIEventData {
    eventTime: moment.Moment;
    eventSource: any | undefined;
}

export class CustomValue implements ICustomValue {
    reference: string | undefined;
    value: string | undefined;
    countryCode: string | undefined;
    deliverySchedules: DeliverySchedule[] | undefined;
    id: number;

    constructor(data?: ICustomValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reference = _data["reference"];
            this.value = _data["value"];
            this.countryCode = _data["countryCode"];
            if (Array.isArray(_data["deliverySchedules"])) {
                this.deliverySchedules = [] as any;
                for (let item of _data["deliverySchedules"])
                    this.deliverySchedules.push(DeliverySchedule.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CustomValue {
        data = typeof data === 'object' ? data : {};
        let result = new CustomValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reference"] = this.reference;
        data["value"] = this.value;
        data["countryCode"] = this.countryCode;
        if (Array.isArray(this.deliverySchedules)) {
            data["deliverySchedules"] = [];
            for (let item of this.deliverySchedules)
                data["deliverySchedules"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): CustomValue {
        const json = this.toJSON();
        let result = new CustomValue();
        result.init(json);
        return result;
    }
}

export interface ICustomValue {
    reference: string | undefined;
    value: string | undefined;
    countryCode: string | undefined;
    deliverySchedules: DeliverySchedule[] | undefined;
    id: number;
}

export class DeliverySchedule implements IDeliverySchedule {
    label: string | undefined;
    hourFrom: string | undefined;
    offset: string | undefined;
    customValueId: number;
    customValue: CustomValue;
    countryCode: string | undefined;
    deliveryScheduleShippingTypes: DeliveryScheduleShippingType[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IDeliverySchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.hourFrom = _data["hourFrom"];
            this.offset = _data["offset"];
            this.customValueId = _data["customValueId"];
            this.customValue = _data["customValue"] ? CustomValue.fromJS(_data["customValue"]) : <any>undefined;
            this.countryCode = _data["countryCode"];
            if (Array.isArray(_data["deliveryScheduleShippingTypes"])) {
                this.deliveryScheduleShippingTypes = [] as any;
                for (let item of _data["deliveryScheduleShippingTypes"])
                    this.deliveryScheduleShippingTypes.push(DeliveryScheduleShippingType.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeliverySchedule {
        data = typeof data === 'object' ? data : {};
        let result = new DeliverySchedule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["hourFrom"] = this.hourFrom;
        data["offset"] = this.offset;
        data["customValueId"] = this.customValueId;
        data["customValue"] = this.customValue ? this.customValue.toJSON() : <any>undefined;
        data["countryCode"] = this.countryCode;
        if (Array.isArray(this.deliveryScheduleShippingTypes)) {
            data["deliveryScheduleShippingTypes"] = [];
            for (let item of this.deliveryScheduleShippingTypes)
                data["deliveryScheduleShippingTypes"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): DeliverySchedule {
        const json = this.toJSON();
        let result = new DeliverySchedule();
        result.init(json);
        return result;
    }
}

export interface IDeliverySchedule {
    label: string | undefined;
    hourFrom: string | undefined;
    offset: string | undefined;
    customValueId: number;
    customValue: CustomValue;
    countryCode: string | undefined;
    deliveryScheduleShippingTypes: DeliveryScheduleShippingType[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class DeliveryScheduleShippingType implements IDeliveryScheduleShippingType {
    deliveryScheduleId: number;
    shippingTypeId: number;
    deliverySchedule: DeliverySchedule;
    shippingType: ShippingType;
    id: number;

    constructor(data?: IDeliveryScheduleShippingType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deliveryScheduleId = _data["deliveryScheduleId"];
            this.shippingTypeId = _data["shippingTypeId"];
            this.deliverySchedule = _data["deliverySchedule"] ? DeliverySchedule.fromJS(_data["deliverySchedule"]) : <any>undefined;
            this.shippingType = _data["shippingType"] ? ShippingType.fromJS(_data["shippingType"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeliveryScheduleShippingType {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryScheduleShippingType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliveryScheduleId"] = this.deliveryScheduleId;
        data["shippingTypeId"] = this.shippingTypeId;
        data["deliverySchedule"] = this.deliverySchedule ? this.deliverySchedule.toJSON() : <any>undefined;
        data["shippingType"] = this.shippingType ? this.shippingType.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): DeliveryScheduleShippingType {
        const json = this.toJSON();
        let result = new DeliveryScheduleShippingType();
        result.init(json);
        return result;
    }
}

export interface IDeliveryScheduleShippingType {
    deliveryScheduleId: number;
    shippingTypeId: number;
    deliverySchedule: DeliverySchedule;
    shippingType: ShippingType;
    id: number;
}

export class ShippingType implements IShippingType {
    code: string | undefined;
    name: string | undefined;
    shippingTypeGroupId: number | undefined;
    shippingTypeGroup: ShippingTypeGroup;
    countryCode: string | undefined;
    deliveryScheduleShippingTypes: DeliveryScheduleShippingType[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IShippingType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.shippingTypeGroupId = _data["shippingTypeGroupId"];
            this.shippingTypeGroup = _data["shippingTypeGroup"] ? ShippingTypeGroup.fromJS(_data["shippingTypeGroup"]) : <any>undefined;
            this.countryCode = _data["countryCode"];
            if (Array.isArray(_data["deliveryScheduleShippingTypes"])) {
                this.deliveryScheduleShippingTypes = [] as any;
                for (let item of _data["deliveryScheduleShippingTypes"])
                    this.deliveryScheduleShippingTypes.push(DeliveryScheduleShippingType.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ShippingType {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["shippingTypeGroupId"] = this.shippingTypeGroupId;
        data["shippingTypeGroup"] = this.shippingTypeGroup ? this.shippingTypeGroup.toJSON() : <any>undefined;
        data["countryCode"] = this.countryCode;
        if (Array.isArray(this.deliveryScheduleShippingTypes)) {
            data["deliveryScheduleShippingTypes"] = [];
            for (let item of this.deliveryScheduleShippingTypes)
                data["deliveryScheduleShippingTypes"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): ShippingType {
        const json = this.toJSON();
        let result = new ShippingType();
        result.init(json);
        return result;
    }
}

export interface IShippingType {
    code: string | undefined;
    name: string | undefined;
    shippingTypeGroupId: number | undefined;
    shippingTypeGroup: ShippingTypeGroup;
    countryCode: string | undefined;
    deliveryScheduleShippingTypes: DeliveryScheduleShippingType[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ShippingTypeGroup implements IShippingTypeGroup {
    code: string | undefined;
    name: string | undefined;
    color: string | undefined;
    icon: string | undefined;
    shippingTypes: ShippingType[] | undefined;
    countryCode: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IShippingTypeGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.color = _data["color"];
            this.icon = _data["icon"];
            if (Array.isArray(_data["shippingTypes"])) {
                this.shippingTypes = [] as any;
                for (let item of _data["shippingTypes"])
                    this.shippingTypes.push(ShippingType.fromJS(item));
            }
            this.countryCode = _data["countryCode"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ShippingTypeGroup {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingTypeGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["color"] = this.color;
        data["icon"] = this.icon;
        if (Array.isArray(this.shippingTypes)) {
            data["shippingTypes"] = [];
            for (let item of this.shippingTypes)
                data["shippingTypes"].push(item.toJSON());
        }
        data["countryCode"] = this.countryCode;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): ShippingTypeGroup {
        const json = this.toJSON();
        let result = new ShippingTypeGroup();
        result.init(json);
        return result;
    }
}

export interface IShippingTypeGroup {
    code: string | undefined;
    name: string | undefined;
    color: string | undefined;
    icon: string | undefined;
    shippingTypes: ShippingType[] | undefined;
    countryCode: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class StoreCarrier implements IStoreCarrier {
    carrierId: number;
    storeCode: string | undefined;
    carrier: Carrier;
    id: number;

    constructor(data?: IStoreCarrier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.carrierId = _data["carrierId"];
            this.storeCode = _data["storeCode"];
            this.carrier = _data["carrier"] ? Carrier.fromJS(_data["carrier"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StoreCarrier {
        data = typeof data === 'object' ? data : {};
        let result = new StoreCarrier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["carrierId"] = this.carrierId;
        data["storeCode"] = this.storeCode;
        data["carrier"] = this.carrier ? this.carrier.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): StoreCarrier {
        const json = this.toJSON();
        let result = new StoreCarrier();
        result.init(json);
        return result;
    }
}

export interface IStoreCarrier {
    carrierId: number;
    storeCode: string | undefined;
    carrier: Carrier;
    id: number;
}

export class Carrier implements ICarrier {
    readonly domainEvents: IEventData[] | undefined;
    shippingTypeGroupId: number | undefined;
    shippingTypeGroup: ShippingTypeGroup;
    countryCode: string | undefined;
    stores: StoreCarrier[] | undefined;
    apiToken: string | undefined;
    carrierGroup: string | undefined;
    name: string | undefined;
    description: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICarrier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["domainEvents"])) {
                (<any>this).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (<any>this).domainEvents.push(IEventData.fromJS(item));
            }
            this.shippingTypeGroupId = _data["shippingTypeGroupId"];
            this.shippingTypeGroup = _data["shippingTypeGroup"] ? ShippingTypeGroup.fromJS(_data["shippingTypeGroup"]) : <any>undefined;
            this.countryCode = _data["countryCode"];
            if (Array.isArray(_data["stores"])) {
                this.stores = [] as any;
                for (let item of _data["stores"])
                    this.stores.push(StoreCarrier.fromJS(item));
            }
            this.apiToken = _data["apiToken"];
            this.carrierGroup = _data["carrierGroup"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Carrier {
        data = typeof data === 'object' ? data : {};
        let result = new Carrier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item.toJSON());
        }
        data["shippingTypeGroupId"] = this.shippingTypeGroupId;
        data["shippingTypeGroup"] = this.shippingTypeGroup ? this.shippingTypeGroup.toJSON() : <any>undefined;
        data["countryCode"] = this.countryCode;
        if (Array.isArray(this.stores)) {
            data["stores"] = [];
            for (let item of this.stores)
                data["stores"].push(item.toJSON());
        }
        data["apiToken"] = this.apiToken;
        data["carrierGroup"] = this.carrierGroup;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): Carrier {
        const json = this.toJSON();
        let result = new Carrier();
        result.init(json);
        return result;
    }
}

export interface ICarrier {
    domainEvents: IEventData[] | undefined;
    shippingTypeGroupId: number | undefined;
    shippingTypeGroup: ShippingTypeGroup;
    countryCode: string | undefined;
    stores: StoreCarrier[] | undefined;
    apiToken: string | undefined;
    carrierGroup: string | undefined;
    name: string | undefined;
    description: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class SourceOrderItem implements ISourceOrderItem {
    sourceName: SourceValue;
    sourceCode: string | undefined;
    sku: string | undefined;
    sourceProductCode: string | undefined;
    description: string | undefined;
    imageUrl: string | undefined;
    quantity: number;
    grossAmount: number;
    netAmount: number;
    discount: number;
    taxes: number;
    length: number | undefined;
    weight: number | undefined;
    height: number | undefined;
    width: number | undefined;
    selfPurchaseFrequency: number;
    isExclusiveOnline: boolean;
    orderId: number;
    order: Order;
    isPromotion: boolean;
    promotionId: number | undefined;
    promotion: SourceOrderItem;
    barCode: string | undefined;
    notInventory: boolean | undefined;
    id: number;

    constructor(data?: ISourceOrderItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceName = _data["sourceName"];
            this.sourceCode = _data["sourceCode"];
            this.sku = _data["sku"];
            this.sourceProductCode = _data["sourceProductCode"];
            this.description = _data["description"];
            this.imageUrl = _data["imageUrl"];
            this.quantity = _data["quantity"];
            this.grossAmount = _data["grossAmount"];
            this.netAmount = _data["netAmount"];
            this.discount = _data["discount"];
            this.taxes = _data["taxes"];
            this.length = _data["length"];
            this.weight = _data["weight"];
            this.height = _data["height"];
            this.width = _data["width"];
            this.selfPurchaseFrequency = _data["selfPurchaseFrequency"];
            this.isExclusiveOnline = _data["isExclusiveOnline"];
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.isPromotion = _data["isPromotion"];
            this.promotionId = _data["promotionId"];
            this.promotion = _data["promotion"] ? SourceOrderItem.fromJS(_data["promotion"]) : <any>undefined;
            this.barCode = _data["barCode"];
            this.notInventory = _data["notInventory"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SourceOrderItem {
        data = typeof data === 'object' ? data : {};
        let result = new SourceOrderItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceName"] = this.sourceName;
        data["sourceCode"] = this.sourceCode;
        data["sku"] = this.sku;
        data["sourceProductCode"] = this.sourceProductCode;
        data["description"] = this.description;
        data["imageUrl"] = this.imageUrl;
        data["quantity"] = this.quantity;
        data["grossAmount"] = this.grossAmount;
        data["netAmount"] = this.netAmount;
        data["discount"] = this.discount;
        data["taxes"] = this.taxes;
        data["length"] = this.length;
        data["weight"] = this.weight;
        data["height"] = this.height;
        data["width"] = this.width;
        data["selfPurchaseFrequency"] = this.selfPurchaseFrequency;
        data["isExclusiveOnline"] = this.isExclusiveOnline;
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["isPromotion"] = this.isPromotion;
        data["promotionId"] = this.promotionId;
        data["promotion"] = this.promotion ? this.promotion.toJSON() : <any>undefined;
        data["barCode"] = this.barCode;
        data["notInventory"] = this.notInventory;
        data["id"] = this.id;
        return data; 
    }

    clone(): SourceOrderItem {
        const json = this.toJSON();
        let result = new SourceOrderItem();
        result.init(json);
        return result;
    }
}

export interface ISourceOrderItem {
    sourceName: SourceValue;
    sourceCode: string | undefined;
    sku: string | undefined;
    sourceProductCode: string | undefined;
    description: string | undefined;
    imageUrl: string | undefined;
    quantity: number;
    grossAmount: number;
    netAmount: number;
    discount: number;
    taxes: number;
    length: number | undefined;
    weight: number | undefined;
    height: number | undefined;
    width: number | undefined;
    selfPurchaseFrequency: number;
    isExclusiveOnline: boolean;
    orderId: number;
    order: Order;
    isPromotion: boolean;
    promotionId: number | undefined;
    promotion: SourceOrderItem;
    barCode: string | undefined;
    notInventory: boolean | undefined;
    id: number;
}

export enum StockStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class OrderItem implements IOrderItem {
    sourceCode: string | undefined;
    sku: string | undefined;
    description: string | undefined;
    imageUrl: string | undefined;
    deliveryIssue: string | undefined;
    quantity: number;
    quantityDelivered: number;
    quantityInConflict: number;
    grossAmount: number;
    netAmount: number;
    discount: number;
    taxes: number;
    cancelled: boolean;
    length: number | undefined;
    weight: number | undefined;
    height: number | undefined;
    width: number | undefined;
    sourceOrderItemId: number | undefined;
    selfPurchaseFrequency: number;
    isExclusiveOnline: boolean;
    orderId: number;
    order: Order;
    sourceOrderItem: SourceOrderItem;
    isPromotion: boolean;
    promotionId: number | undefined;
    promotion: OrderItem;
    barCode: string | undefined;
    supplierCatalogNumber: string | undefined;
    stock: number;
    stockStatus: StockStatus;
    logisticAuditStockInWarehouse: boolean | undefined;
    notInventory: boolean | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceCode = _data["sourceCode"];
            this.sku = _data["sku"];
            this.description = _data["description"];
            this.imageUrl = _data["imageUrl"];
            this.deliveryIssue = _data["deliveryIssue"];
            this.quantity = _data["quantity"];
            this.quantityDelivered = _data["quantityDelivered"];
            this.quantityInConflict = _data["quantityInConflict"];
            this.grossAmount = _data["grossAmount"];
            this.netAmount = _data["netAmount"];
            this.discount = _data["discount"];
            this.taxes = _data["taxes"];
            this.cancelled = _data["cancelled"];
            this.length = _data["length"];
            this.weight = _data["weight"];
            this.height = _data["height"];
            this.width = _data["width"];
            this.sourceOrderItemId = _data["sourceOrderItemId"];
            this.selfPurchaseFrequency = _data["selfPurchaseFrequency"];
            this.isExclusiveOnline = _data["isExclusiveOnline"];
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.sourceOrderItem = _data["sourceOrderItem"] ? SourceOrderItem.fromJS(_data["sourceOrderItem"]) : <any>undefined;
            this.isPromotion = _data["isPromotion"];
            this.promotionId = _data["promotionId"];
            this.promotion = _data["promotion"] ? OrderItem.fromJS(_data["promotion"]) : <any>undefined;
            this.barCode = _data["barCode"];
            this.supplierCatalogNumber = _data["supplierCatalogNumber"];
            this.stock = _data["stock"];
            this.stockStatus = _data["stockStatus"];
            this.logisticAuditStockInWarehouse = _data["logisticAuditStockInWarehouse"];
            this.notInventory = _data["notInventory"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderItem {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceCode"] = this.sourceCode;
        data["sku"] = this.sku;
        data["description"] = this.description;
        data["imageUrl"] = this.imageUrl;
        data["deliveryIssue"] = this.deliveryIssue;
        data["quantity"] = this.quantity;
        data["quantityDelivered"] = this.quantityDelivered;
        data["quantityInConflict"] = this.quantityInConflict;
        data["grossAmount"] = this.grossAmount;
        data["netAmount"] = this.netAmount;
        data["discount"] = this.discount;
        data["taxes"] = this.taxes;
        data["cancelled"] = this.cancelled;
        data["length"] = this.length;
        data["weight"] = this.weight;
        data["height"] = this.height;
        data["width"] = this.width;
        data["sourceOrderItemId"] = this.sourceOrderItemId;
        data["selfPurchaseFrequency"] = this.selfPurchaseFrequency;
        data["isExclusiveOnline"] = this.isExclusiveOnline;
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["sourceOrderItem"] = this.sourceOrderItem ? this.sourceOrderItem.toJSON() : <any>undefined;
        data["isPromotion"] = this.isPromotion;
        data["promotionId"] = this.promotionId;
        data["promotion"] = this.promotion ? this.promotion.toJSON() : <any>undefined;
        data["barCode"] = this.barCode;
        data["supplierCatalogNumber"] = this.supplierCatalogNumber;
        data["stock"] = this.stock;
        data["stockStatus"] = this.stockStatus;
        data["logisticAuditStockInWarehouse"] = this.logisticAuditStockInWarehouse;
        data["notInventory"] = this.notInventory;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderItem {
        const json = this.toJSON();
        let result = new OrderItem();
        result.init(json);
        return result;
    }
}

export interface IOrderItem {
    sourceCode: string | undefined;
    sku: string | undefined;
    description: string | undefined;
    imageUrl: string | undefined;
    deliveryIssue: string | undefined;
    quantity: number;
    quantityDelivered: number;
    quantityInConflict: number;
    grossAmount: number;
    netAmount: number;
    discount: number;
    taxes: number;
    cancelled: boolean;
    length: number | undefined;
    weight: number | undefined;
    height: number | undefined;
    width: number | undefined;
    sourceOrderItemId: number | undefined;
    selfPurchaseFrequency: number;
    isExclusiveOnline: boolean;
    orderId: number;
    order: Order;
    sourceOrderItem: SourceOrderItem;
    isPromotion: boolean;
    promotionId: number | undefined;
    promotion: OrderItem;
    barCode: string | undefined;
    supplierCatalogNumber: string | undefined;
    stock: number;
    stockStatus: StockStatus;
    logisticAuditStockInWarehouse: boolean | undefined;
    notInventory: boolean | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Payment implements IPayment {
    sourceCode: string | undefined;
    paymentSystemName: string | undefined;
    installments: number;
    value: number;
    binCode: string | undefined;
    status: string | undefined;
    order: Order;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceCode = _data["sourceCode"];
            this.paymentSystemName = _data["paymentSystemName"];
            this.installments = _data["installments"];
            this.value = _data["value"];
            this.binCode = _data["binCode"];
            this.status = _data["status"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Payment {
        data = typeof data === 'object' ? data : {};
        let result = new Payment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceCode"] = this.sourceCode;
        data["paymentSystemName"] = this.paymentSystemName;
        data["installments"] = this.installments;
        data["value"] = this.value;
        data["binCode"] = this.binCode;
        data["status"] = this.status;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): Payment {
        const json = this.toJSON();
        let result = new Payment();
        result.init(json);
        return result;
    }
}

export interface IPayment {
    sourceCode: string | undefined;
    paymentSystemName: string | undefined;
    installments: number;
    value: number;
    binCode: string | undefined;
    status: string | undefined;
    order: Order;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export enum DeliveryType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class DeliveryData implements IDeliveryData {
    sourceName: SourceValue;
    sourceCode: string | undefined;
    sourceOrderCode: string | undefined;
    sourceStatus: string | undefined;
    shippingCost: number;
    estimatedDeliveryDateFrom: moment.Moment | undefined;
    estimatedDeliveryDateTo: moment.Moment | undefined;
    deliveryType: DeliveryType;
    pointOfDelivery: string | undefined;
    addressTypeCode: string | undefined;
    street: string | undefined;
    number: string | undefined;
    complement: string | undefined;
    postalCode: string | undefined;
    neighborhood: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    geoLat: number | undefined;
    geoLong: number | undefined;
    trackingMethod: string | undefined;
    trackingNumber: string | undefined;
    deliveryCompany: string | undefined;
    shippingTypeId: number | undefined;
    shippingType: ShippingType;
    shippingTypeSourceCode: string | undefined;
    receiverName: string | undefined;
    carrierEsimatedDeliveryDate: moment.Moment | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IDeliveryData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceName = _data["sourceName"];
            this.sourceCode = _data["sourceCode"];
            this.sourceOrderCode = _data["sourceOrderCode"];
            this.sourceStatus = _data["sourceStatus"];
            this.shippingCost = _data["shippingCost"];
            this.estimatedDeliveryDateFrom = _data["estimatedDeliveryDateFrom"] ? moment(_data["estimatedDeliveryDateFrom"].toString()) : <any>undefined;
            this.estimatedDeliveryDateTo = _data["estimatedDeliveryDateTo"] ? moment(_data["estimatedDeliveryDateTo"].toString()) : <any>undefined;
            this.deliveryType = _data["deliveryType"];
            this.pointOfDelivery = _data["pointOfDelivery"];
            this.addressTypeCode = _data["addressTypeCode"];
            this.street = _data["street"];
            this.number = _data["number"];
            this.complement = _data["complement"];
            this.postalCode = _data["postalCode"];
            this.neighborhood = _data["neighborhood"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.geoLat = _data["geoLat"];
            this.geoLong = _data["geoLong"];
            this.trackingMethod = _data["trackingMethod"];
            this.trackingNumber = _data["trackingNumber"];
            this.deliveryCompany = _data["deliveryCompany"];
            this.shippingTypeId = _data["shippingTypeId"];
            this.shippingType = _data["shippingType"] ? ShippingType.fromJS(_data["shippingType"]) : <any>undefined;
            this.shippingTypeSourceCode = _data["shippingTypeSourceCode"];
            this.receiverName = _data["receiverName"];
            this.carrierEsimatedDeliveryDate = _data["carrierEsimatedDeliveryDate"] ? moment(_data["carrierEsimatedDeliveryDate"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeliveryData {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceName"] = this.sourceName;
        data["sourceCode"] = this.sourceCode;
        data["sourceOrderCode"] = this.sourceOrderCode;
        data["sourceStatus"] = this.sourceStatus;
        data["shippingCost"] = this.shippingCost;
        data["estimatedDeliveryDateFrom"] = this.estimatedDeliveryDateFrom ? this.estimatedDeliveryDateFrom.toISOString() : <any>undefined;
        data["estimatedDeliveryDateTo"] = this.estimatedDeliveryDateTo ? this.estimatedDeliveryDateTo.toISOString() : <any>undefined;
        data["deliveryType"] = this.deliveryType;
        data["pointOfDelivery"] = this.pointOfDelivery;
        data["addressTypeCode"] = this.addressTypeCode;
        data["street"] = this.street;
        data["number"] = this.number;
        data["complement"] = this.complement;
        data["postalCode"] = this.postalCode;
        data["neighborhood"] = this.neighborhood;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["geoLat"] = this.geoLat;
        data["geoLong"] = this.geoLong;
        data["trackingMethod"] = this.trackingMethod;
        data["trackingNumber"] = this.trackingNumber;
        data["deliveryCompany"] = this.deliveryCompany;
        data["shippingTypeId"] = this.shippingTypeId;
        data["shippingType"] = this.shippingType ? this.shippingType.toJSON() : <any>undefined;
        data["shippingTypeSourceCode"] = this.shippingTypeSourceCode;
        data["receiverName"] = this.receiverName;
        data["carrierEsimatedDeliveryDate"] = this.carrierEsimatedDeliveryDate ? this.carrierEsimatedDeliveryDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): DeliveryData {
        const json = this.toJSON();
        let result = new DeliveryData();
        result.init(json);
        return result;
    }
}

export interface IDeliveryData {
    sourceName: SourceValue;
    sourceCode: string | undefined;
    sourceOrderCode: string | undefined;
    sourceStatus: string | undefined;
    shippingCost: number;
    estimatedDeliveryDateFrom: moment.Moment | undefined;
    estimatedDeliveryDateTo: moment.Moment | undefined;
    deliveryType: DeliveryType;
    pointOfDelivery: string | undefined;
    addressTypeCode: string | undefined;
    street: string | undefined;
    number: string | undefined;
    complement: string | undefined;
    postalCode: string | undefined;
    neighborhood: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    geoLat: number | undefined;
    geoLong: number | undefined;
    trackingMethod: string | undefined;
    trackingNumber: string | undefined;
    deliveryCompany: string | undefined;
    shippingTypeId: number | undefined;
    shippingType: ShippingType;
    shippingTypeSourceCode: string | undefined;
    receiverName: string | undefined;
    carrierEsimatedDeliveryDate: moment.Moment | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class OrderNote implements IOrderNote {
    readed: boolean;
    notify: boolean;
    description: string | undefined;
    orderId: number;
    order: Order;
    creatorName: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.readed = _data["readed"];
            this.notify = _data["notify"];
            this.description = _data["description"];
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.creatorName = _data["creatorName"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderNote {
        data = typeof data === 'object' ? data : {};
        let result = new OrderNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["readed"] = this.readed;
        data["notify"] = this.notify;
        data["description"] = this.description;
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["creatorName"] = this.creatorName;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderNote {
        const json = this.toJSON();
        let result = new OrderNote();
        result.init(json);
        return result;
    }
}

export interface IOrderNote {
    readed: boolean;
    notify: boolean;
    description: string | undefined;
    orderId: number;
    order: Order;
    creatorName: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class AssignedToStore implements IAssignedToStore {
    storeCode: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IAssignedToStore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeCode = _data["storeCode"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AssignedToStore {
        data = typeof data === 'object' ? data : {};
        let result = new AssignedToStore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeCode"] = this.storeCode;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): AssignedToStore {
        const json = this.toJSON();
        let result = new AssignedToStore();
        result.init(json);
        return result;
    }
}

export interface IAssignedToStore {
    storeCode: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export enum OverallStatusValue {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class OverallStatus implements IOverallStatus {
    value: OverallStatusValue;
    reason: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOverallStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.reason = _data["reason"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OverallStatus {
        data = typeof data === 'object' ? data : {};
        let result = new OverallStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["reason"] = this.reason;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): OverallStatus {
        const json = this.toJSON();
        let result = new OverallStatus();
        result.init(json);
        return result;
    }
}

export interface IOverallStatus {
    value: OverallStatusValue;
    reason: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export enum CommercialStatusValue {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export class CommercialStatus implements ICommercialStatus {
    value: CommercialStatusValue;
    reason: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICommercialStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.reason = _data["reason"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CommercialStatus {
        data = typeof data === 'object' ? data : {};
        let result = new CommercialStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["reason"] = this.reason;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): CommercialStatus {
        const json = this.toJSON();
        let result = new CommercialStatus();
        result.init(json);
        return result;
    }
}

export interface ICommercialStatus {
    value: CommercialStatusValue;
    reason: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export enum FinancialStatusValue {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export class FinancialStatus implements IFinancialStatus {
    value: FinancialStatusValue;
    reason: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IFinancialStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.reason = _data["reason"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FinancialStatus {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["reason"] = this.reason;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): FinancialStatus {
        const json = this.toJSON();
        let result = new FinancialStatus();
        result.init(json);
        return result;
    }
}

export interface IFinancialStatus {
    value: FinancialStatusValue;
    reason: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export enum LogisticStatusValue {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
    _13 = 13,
    _14 = 14,
    _15 = 15,
    _16 = 16,
    _17 = 17,
    _18 = 18,
}

export class LogisticStatus implements ILogisticStatus {
    value: LogisticStatusValue;
    reason: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ILogisticStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.reason = _data["reason"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LogisticStatus {
        data = typeof data === 'object' ? data : {};
        let result = new LogisticStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["reason"] = this.reason;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): LogisticStatus {
        const json = this.toJSON();
        let result = new LogisticStatus();
        result.init(json);
        return result;
    }
}

export interface ILogisticStatus {
    value: LogisticStatusValue;
    reason: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export enum LogisticAuditStatusValue {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class LogisticAuditStatus implements ILogisticAuditStatus {
    value: LogisticAuditStatusValue;
    reason: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ILogisticAuditStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.reason = _data["reason"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LogisticAuditStatus {
        data = typeof data === 'object' ? data : {};
        let result = new LogisticAuditStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["reason"] = this.reason;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): LogisticAuditStatus {
        const json = this.toJSON();
        let result = new LogisticAuditStatus();
        result.init(json);
        return result;
    }
}

export interface ILogisticAuditStatus {
    value: LogisticAuditStatusValue;
    reason: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class EventLog implements IEventLog {
    creatorUserId: number | undefined;
    creatorName: string | undefined;
    creationTime: moment.Moment;
    description: string | undefined;
    orderId: number | undefined;
    order: Order;
    id: number;

    constructor(data?: IEventLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creatorUserId = _data["creatorUserId"];
            this.creatorName = _data["creatorName"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EventLog {
        data = typeof data === 'object' ? data : {};
        let result = new EventLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creatorUserId"] = this.creatorUserId;
        data["creatorName"] = this.creatorName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): EventLog {
        const json = this.toJSON();
        let result = new EventLog();
        result.init(json);
        return result;
    }
}

export interface IEventLog {
    creatorUserId: number | undefined;
    creatorName: string | undefined;
    creationTime: moment.Moment;
    description: string | undefined;
    orderId: number | undefined;
    order: Order;
    id: number;
}

export enum PreparationStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class Package implements IPackage {
    code: string | undefined;
    preparationId: number;
    preparation: Preparation;
    preparedItems: PreparedItem[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IPackage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.preparationId = _data["preparationId"];
            this.preparation = _data["preparation"] ? Preparation.fromJS(_data["preparation"]) : <any>undefined;
            if (Array.isArray(_data["preparedItems"])) {
                this.preparedItems = [] as any;
                for (let item of _data["preparedItems"])
                    this.preparedItems.push(PreparedItem.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Package {
        data = typeof data === 'object' ? data : {};
        let result = new Package();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["preparationId"] = this.preparationId;
        data["preparation"] = this.preparation ? this.preparation.toJSON() : <any>undefined;
        if (Array.isArray(this.preparedItems)) {
            data["preparedItems"] = [];
            for (let item of this.preparedItems)
                data["preparedItems"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): Package {
        const json = this.toJSON();
        let result = new Package();
        result.init(json);
        return result;
    }
}

export interface IPackage {
    code: string | undefined;
    preparationId: number;
    preparation: Preparation;
    preparedItems: PreparedItem[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class PreparedItem implements IPreparedItem {
    discount: number;
    grossAmount: number;
    imageUrl: string | undefined;
    netAmount: number;
    orderId: number;
    order: Order;
    orderItemId: number;
    orderItem: OrderItem;
    quantity: number;
    sku: string | undefined;
    description: string | undefined;
    taxes: number;
    packageId: number;
    package: Package;
    preparationId: number;
    preparation: Preparation;
    barCode: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IPreparedItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discount = _data["discount"];
            this.grossAmount = _data["grossAmount"];
            this.imageUrl = _data["imageUrl"];
            this.netAmount = _data["netAmount"];
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.orderItemId = _data["orderItemId"];
            this.orderItem = _data["orderItem"] ? OrderItem.fromJS(_data["orderItem"]) : <any>undefined;
            this.quantity = _data["quantity"];
            this.sku = _data["sku"];
            this.description = _data["description"];
            this.taxes = _data["taxes"];
            this.packageId = _data["packageId"];
            this.package = _data["package"] ? Package.fromJS(_data["package"]) : <any>undefined;
            this.preparationId = _data["preparationId"];
            this.preparation = _data["preparation"] ? Preparation.fromJS(_data["preparation"]) : <any>undefined;
            this.barCode = _data["barCode"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PreparedItem {
        data = typeof data === 'object' ? data : {};
        let result = new PreparedItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discount"] = this.discount;
        data["grossAmount"] = this.grossAmount;
        data["imageUrl"] = this.imageUrl;
        data["netAmount"] = this.netAmount;
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["orderItemId"] = this.orderItemId;
        data["orderItem"] = this.orderItem ? this.orderItem.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["sku"] = this.sku;
        data["description"] = this.description;
        data["taxes"] = this.taxes;
        data["packageId"] = this.packageId;
        data["package"] = this.package ? this.package.toJSON() : <any>undefined;
        data["preparationId"] = this.preparationId;
        data["preparation"] = this.preparation ? this.preparation.toJSON() : <any>undefined;
        data["barCode"] = this.barCode;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): PreparedItem {
        const json = this.toJSON();
        let result = new PreparedItem();
        result.init(json);
        return result;
    }
}

export interface IPreparedItem {
    discount: number;
    grossAmount: number;
    imageUrl: string | undefined;
    netAmount: number;
    orderId: number;
    order: Order;
    orderItemId: number;
    orderItem: OrderItem;
    quantity: number;
    sku: string | undefined;
    description: string | undefined;
    taxes: number;
    packageId: number;
    package: Package;
    preparationId: number;
    preparation: Preparation;
    barCode: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Preparation implements IPreparation {
    storeCode: string | undefined;
    responsible: string | undefined;
    countryCode: string | undefined;
    status: PreparationStatus;
    orderId: number;
    order: Order;
    preparedItems: PreparedItem[] | undefined;
    packages: Package[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IPreparation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeCode = _data["storeCode"];
            this.responsible = _data["responsible"];
            this.countryCode = _data["countryCode"];
            this.status = _data["status"];
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            if (Array.isArray(_data["preparedItems"])) {
                this.preparedItems = [] as any;
                for (let item of _data["preparedItems"])
                    this.preparedItems.push(PreparedItem.fromJS(item));
            }
            if (Array.isArray(_data["packages"])) {
                this.packages = [] as any;
                for (let item of _data["packages"])
                    this.packages.push(Package.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Preparation {
        data = typeof data === 'object' ? data : {};
        let result = new Preparation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeCode"] = this.storeCode;
        data["responsible"] = this.responsible;
        data["countryCode"] = this.countryCode;
        data["status"] = this.status;
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        if (Array.isArray(this.preparedItems)) {
            data["preparedItems"] = [];
            for (let item of this.preparedItems)
                data["preparedItems"].push(item.toJSON());
        }
        if (Array.isArray(this.packages)) {
            data["packages"] = [];
            for (let item of this.packages)
                data["packages"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): Preparation {
        const json = this.toJSON();
        let result = new Preparation();
        result.init(json);
        return result;
    }
}

export interface IPreparation {
    storeCode: string | undefined;
    responsible: string | undefined;
    countryCode: string | undefined;
    status: PreparationStatus;
    orderId: number;
    order: Order;
    preparedItems: PreparedItem[] | undefined;
    packages: Package[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class OrderBillingInfo implements IOrderBillingInfo {
    documentType: string | undefined;
    documentNumber: string | undefined;
    taxPayerType: string | undefined;
    order: Order;
    orderId: number;
    billedTo: string | undefined;
    id: number;

    constructor(data?: IOrderBillingInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentType = _data["documentType"];
            this.documentNumber = _data["documentNumber"];
            this.taxPayerType = _data["taxPayerType"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.orderId = _data["orderId"];
            this.billedTo = _data["billedTo"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderBillingInfo {
        data = typeof data === 'object' ? data : {};
        let result = new OrderBillingInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType;
        data["documentNumber"] = this.documentNumber;
        data["taxPayerType"] = this.taxPayerType;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["orderId"] = this.orderId;
        data["billedTo"] = this.billedTo;
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderBillingInfo {
        const json = this.toJSON();
        let result = new OrderBillingInfo();
        result.init(json);
        return result;
    }
}

export interface IOrderBillingInfo {
    documentType: string | undefined;
    documentNumber: string | undefined;
    taxPayerType: string | undefined;
    order: Order;
    orderId: number;
    billedTo: string | undefined;
    id: number;
}

export enum PickingGroupStatusValue {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class PickingGroupShippingType implements IPickingGroupShippingType {
    pickingGroupId: number;
    pickingGroup: PickingGroup;
    shippingTypeId: number;
    shippingType: ShippingType;
    isDeleted: boolean;
    id: number;

    constructor(data?: IPickingGroupShippingType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pickingGroupId = _data["pickingGroupId"];
            this.pickingGroup = _data["pickingGroup"] ? PickingGroup.fromJS(_data["pickingGroup"]) : <any>undefined;
            this.shippingTypeId = _data["shippingTypeId"];
            this.shippingType = _data["shippingType"] ? ShippingType.fromJS(_data["shippingType"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PickingGroupShippingType {
        data = typeof data === 'object' ? data : {};
        let result = new PickingGroupShippingType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pickingGroupId"] = this.pickingGroupId;
        data["pickingGroup"] = this.pickingGroup ? this.pickingGroup.toJSON() : <any>undefined;
        data["shippingTypeId"] = this.shippingTypeId;
        data["shippingType"] = this.shippingType ? this.shippingType.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        return data; 
    }

    clone(): PickingGroupShippingType {
        const json = this.toJSON();
        let result = new PickingGroupShippingType();
        result.init(json);
        return result;
    }
}

export interface IPickingGroupShippingType {
    pickingGroupId: number;
    pickingGroup: PickingGroup;
    shippingTypeId: number;
    shippingType: ShippingType;
    isDeleted: boolean;
    id: number;
}

export class PickingGroupItem implements IPickingGroupItem {
    sku: string | undefined;
    description: string | undefined;
    imageUrl: string | undefined;
    quantity: number;
    quantityPicked: number;
    barCode: string | undefined;
    orderNumber: number;
    aisle: string | undefined;
    location: string | undefined;
    locationId: number | undefined;
    weight: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IPickingGroupItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sku = _data["sku"];
            this.description = _data["description"];
            this.imageUrl = _data["imageUrl"];
            this.quantity = _data["quantity"];
            this.quantityPicked = _data["quantityPicked"];
            this.barCode = _data["barCode"];
            this.orderNumber = _data["orderNumber"];
            this.aisle = _data["aisle"];
            this.location = _data["location"];
            this.locationId = _data["locationId"];
            this.weight = _data["weight"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PickingGroupItem {
        data = typeof data === 'object' ? data : {};
        let result = new PickingGroupItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["description"] = this.description;
        data["imageUrl"] = this.imageUrl;
        data["quantity"] = this.quantity;
        data["quantityPicked"] = this.quantityPicked;
        data["barCode"] = this.barCode;
        data["orderNumber"] = this.orderNumber;
        data["aisle"] = this.aisle;
        data["location"] = this.location;
        data["locationId"] = this.locationId;
        data["weight"] = this.weight;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): PickingGroupItem {
        const json = this.toJSON();
        let result = new PickingGroupItem();
        result.init(json);
        return result;
    }
}

export interface IPickingGroupItem {
    sku: string | undefined;
    description: string | undefined;
    imageUrl: string | undefined;
    quantity: number;
    quantityPicked: number;
    barCode: string | undefined;
    orderNumber: number;
    aisle: string | undefined;
    location: string | undefined;
    locationId: number | undefined;
    weight: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class PickingGroup implements IPickingGroup {
    storeCode: string | undefined;
    responsible: string | undefined;
    pickingGroupStatus: PickingGroupStatusValue;
    alias: string | undefined;
    dispatchDate: moment.Moment | undefined;
    dispatchTag: string | undefined;
    pickingGroupShippingTypes: PickingGroupShippingType[] | undefined;
    pickingGroupItems: PickingGroupItem[] | undefined;
    ordersToPick: OrderPickingGroup[] | undefined;
    countryCode: string | undefined;
    weight: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IPickingGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeCode = _data["storeCode"];
            this.responsible = _data["responsible"];
            this.pickingGroupStatus = _data["pickingGroupStatus"];
            this.alias = _data["alias"];
            this.dispatchDate = _data["dispatchDate"] ? moment(_data["dispatchDate"].toString()) : <any>undefined;
            this.dispatchTag = _data["dispatchTag"];
            if (Array.isArray(_data["pickingGroupShippingTypes"])) {
                this.pickingGroupShippingTypes = [] as any;
                for (let item of _data["pickingGroupShippingTypes"])
                    this.pickingGroupShippingTypes.push(PickingGroupShippingType.fromJS(item));
            }
            if (Array.isArray(_data["pickingGroupItems"])) {
                this.pickingGroupItems = [] as any;
                for (let item of _data["pickingGroupItems"])
                    this.pickingGroupItems.push(PickingGroupItem.fromJS(item));
            }
            if (Array.isArray(_data["ordersToPick"])) {
                this.ordersToPick = [] as any;
                for (let item of _data["ordersToPick"])
                    this.ordersToPick.push(OrderPickingGroup.fromJS(item));
            }
            this.countryCode = _data["countryCode"];
            this.weight = _data["weight"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PickingGroup {
        data = typeof data === 'object' ? data : {};
        let result = new PickingGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeCode"] = this.storeCode;
        data["responsible"] = this.responsible;
        data["pickingGroupStatus"] = this.pickingGroupStatus;
        data["alias"] = this.alias;
        data["dispatchDate"] = this.dispatchDate ? this.dispatchDate.toISOString() : <any>undefined;
        data["dispatchTag"] = this.dispatchTag;
        if (Array.isArray(this.pickingGroupShippingTypes)) {
            data["pickingGroupShippingTypes"] = [];
            for (let item of this.pickingGroupShippingTypes)
                data["pickingGroupShippingTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.pickingGroupItems)) {
            data["pickingGroupItems"] = [];
            for (let item of this.pickingGroupItems)
                data["pickingGroupItems"].push(item.toJSON());
        }
        if (Array.isArray(this.ordersToPick)) {
            data["ordersToPick"] = [];
            for (let item of this.ordersToPick)
                data["ordersToPick"].push(item.toJSON());
        }
        data["countryCode"] = this.countryCode;
        data["weight"] = this.weight;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): PickingGroup {
        const json = this.toJSON();
        let result = new PickingGroup();
        result.init(json);
        return result;
    }
}

export interface IPickingGroup {
    storeCode: string | undefined;
    responsible: string | undefined;
    pickingGroupStatus: PickingGroupStatusValue;
    alias: string | undefined;
    dispatchDate: moment.Moment | undefined;
    dispatchTag: string | undefined;
    pickingGroupShippingTypes: PickingGroupShippingType[] | undefined;
    pickingGroupItems: PickingGroupItem[] | undefined;
    ordersToPick: OrderPickingGroup[] | undefined;
    countryCode: string | undefined;
    weight: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class OrderPickingGroup implements IOrderPickingGroup {
    order: Order;
    pickingGroup: PickingGroup;
    orderId: number;
    pickingGroupId: number;
    id: number;

    constructor(data?: IOrderPickingGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.pickingGroup = _data["pickingGroup"] ? PickingGroup.fromJS(_data["pickingGroup"]) : <any>undefined;
            this.orderId = _data["orderId"];
            this.pickingGroupId = _data["pickingGroupId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderPickingGroup {
        data = typeof data === 'object' ? data : {};
        let result = new OrderPickingGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["pickingGroup"] = this.pickingGroup ? this.pickingGroup.toJSON() : <any>undefined;
        data["orderId"] = this.orderId;
        data["pickingGroupId"] = this.pickingGroupId;
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderPickingGroup {
        const json = this.toJSON();
        let result = new OrderPickingGroup();
        result.init(json);
        return result;
    }
}

export interface IOrderPickingGroup {
    order: Order;
    pickingGroup: PickingGroup;
    orderId: number;
    pickingGroupId: number;
    id: number;
}

export enum DocType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum DocumentStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class DocumentNotification implements IDocumentNotification {
    orderId: number;
    documentType: DocType;
    amount: number;
    documentRequest: string | undefined;
    relatedDocument: number | undefined;
    processed: boolean;
    processTime: moment.Moment | undefined;
    failed: boolean;
    processMessage: string | undefined;
    processAttempts: number;
    countryCode: string | undefined;
    id: number;

    constructor(data?: IDocumentNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.documentType = _data["documentType"];
            this.amount = _data["amount"];
            this.documentRequest = _data["documentRequest"];
            this.relatedDocument = _data["relatedDocument"];
            this.processed = _data["processed"];
            this.processTime = _data["processTime"] ? moment(_data["processTime"].toString()) : <any>undefined;
            this.failed = _data["failed"];
            this.processMessage = _data["processMessage"];
            this.processAttempts = _data["processAttempts"];
            this.countryCode = _data["countryCode"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DocumentNotification {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["documentType"] = this.documentType;
        data["amount"] = this.amount;
        data["documentRequest"] = this.documentRequest;
        data["relatedDocument"] = this.relatedDocument;
        data["processed"] = this.processed;
        data["processTime"] = this.processTime ? this.processTime.toISOString() : <any>undefined;
        data["failed"] = this.failed;
        data["processMessage"] = this.processMessage;
        data["processAttempts"] = this.processAttempts;
        data["countryCode"] = this.countryCode;
        data["id"] = this.id;
        return data; 
    }

    clone(): DocumentNotification {
        const json = this.toJSON();
        let result = new DocumentNotification();
        result.init(json);
        return result;
    }
}

export interface IDocumentNotification {
    orderId: number;
    documentType: DocType;
    amount: number;
    documentRequest: string | undefined;
    relatedDocument: number | undefined;
    processed: boolean;
    processTime: moment.Moment | undefined;
    failed: boolean;
    processMessage: string | undefined;
    processAttempts: number;
    countryCode: string | undefined;
    id: number;
}

export class Document implements IDocument {
    readonly draftNumber: string | undefined;
    readonly number: string | undefined;
    readonly folioNumber: string | undefined;
    readonly amount: number;
    type: DocType;
    readonly additionalInfo: string | undefined;
    orderId: number;
    documentUrl: string | undefined;
    order: Order;
    status: DocumentStatus;
    processAttemp: number;
    nextAttemp: moment.Moment | undefined;
    documentNotificationId: number | undefined;
    documentNotification: DocumentNotification;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).draftNumber = _data["draftNumber"];
            (<any>this).number = _data["number"];
            (<any>this).folioNumber = _data["folioNumber"];
            (<any>this).amount = _data["amount"];
            this.type = _data["type"];
            (<any>this).additionalInfo = _data["additionalInfo"];
            this.orderId = _data["orderId"];
            this.documentUrl = _data["documentUrl"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.status = _data["status"];
            this.processAttemp = _data["processAttemp"];
            this.nextAttemp = _data["nextAttemp"] ? moment(_data["nextAttemp"].toString()) : <any>undefined;
            this.documentNotificationId = _data["documentNotificationId"];
            this.documentNotification = _data["documentNotification"] ? DocumentNotification.fromJS(_data["documentNotification"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Document {
        data = typeof data === 'object' ? data : {};
        let result = new Document();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["draftNumber"] = this.draftNumber;
        data["number"] = this.number;
        data["folioNumber"] = this.folioNumber;
        data["amount"] = this.amount;
        data["type"] = this.type;
        data["additionalInfo"] = this.additionalInfo;
        data["orderId"] = this.orderId;
        data["documentUrl"] = this.documentUrl;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["processAttemp"] = this.processAttemp;
        data["nextAttemp"] = this.nextAttemp ? this.nextAttemp.toISOString() : <any>undefined;
        data["documentNotificationId"] = this.documentNotificationId;
        data["documentNotification"] = this.documentNotification ? this.documentNotification.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): Document {
        const json = this.toJSON();
        let result = new Document();
        result.init(json);
        return result;
    }
}

export interface IDocument {
    draftNumber: string | undefined;
    number: string | undefined;
    folioNumber: string | undefined;
    amount: number;
    type: DocType;
    additionalInfo: string | undefined;
    orderId: number;
    documentUrl: string | undefined;
    order: Order;
    status: DocumentStatus;
    processAttemp: number;
    nextAttemp: moment.Moment | undefined;
    documentNotificationId: number | undefined;
    documentNotification: DocumentNotification;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export enum ClaimType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export enum ReturnStatus {
    _0 = 0,
    _1 = 1,
}

export class ReturnItem implements IReturnItem {
    sku: string | undefined;
    quantity: number;
    description: string | undefined;
    imageUrl: string | undefined;
    returnId: number;
    return: Return;
    id: number;

    constructor(data?: IReturnItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sku = _data["sku"];
            this.quantity = _data["quantity"];
            this.description = _data["description"];
            this.imageUrl = _data["imageUrl"];
            this.returnId = _data["returnId"];
            this.return = _data["return"] ? Return.fromJS(_data["return"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ReturnItem {
        data = typeof data === 'object' ? data : {};
        let result = new ReturnItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["quantity"] = this.quantity;
        data["description"] = this.description;
        data["imageUrl"] = this.imageUrl;
        data["returnId"] = this.returnId;
        data["return"] = this.return ? this.return.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): ReturnItem {
        const json = this.toJSON();
        let result = new ReturnItem();
        result.init(json);
        return result;
    }
}

export interface IReturnItem {
    sku: string | undefined;
    quantity: number;
    description: string | undefined;
    imageUrl: string | undefined;
    returnId: number;
    return: Return;
    id: number;
}

export class Return implements IReturn {
    withdrawTime: moment.Moment;
    deliveryDataId: number;
    deliveryData: DeliveryData;
    status: ReturnStatus;
    claimId: number;
    claim: Claim;
    returnItems: ReturnItem[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IReturn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : <any>undefined;
            this.deliveryDataId = _data["deliveryDataId"];
            this.deliveryData = _data["deliveryData"] ? DeliveryData.fromJS(_data["deliveryData"]) : <any>undefined;
            this.status = _data["status"];
            this.claimId = _data["claimId"];
            this.claim = _data["claim"] ? Claim.fromJS(_data["claim"]) : <any>undefined;
            if (Array.isArray(_data["returnItems"])) {
                this.returnItems = [] as any;
                for (let item of _data["returnItems"])
                    this.returnItems.push(ReturnItem.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Return {
        data = typeof data === 'object' ? data : {};
        let result = new Return();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : <any>undefined;
        data["deliveryDataId"] = this.deliveryDataId;
        data["deliveryData"] = this.deliveryData ? this.deliveryData.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["claimId"] = this.claimId;
        data["claim"] = this.claim ? this.claim.toJSON() : <any>undefined;
        if (Array.isArray(this.returnItems)) {
            data["returnItems"] = [];
            for (let item of this.returnItems)
                data["returnItems"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): Return {
        const json = this.toJSON();
        let result = new Return();
        result.init(json);
        return result;
    }
}

export interface IReturn {
    withdrawTime: moment.Moment;
    deliveryDataId: number;
    deliveryData: DeliveryData;
    status: ReturnStatus;
    claimId: number;
    claim: Claim;
    returnItems: ReturnItem[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ClaimItem implements IClaimItem {
    sku: string | undefined;
    description: string | undefined;
    quantity: number;
    claimedQuantity: number;
    netAmount: number;
    deliveryIssue: string | undefined;
    observation: string | undefined;
    action: string | undefined;
    claim: Claim;
    id: number;

    constructor(data?: IClaimItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sku = _data["sku"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.claimedQuantity = _data["claimedQuantity"];
            this.netAmount = _data["netAmount"];
            this.deliveryIssue = _data["deliveryIssue"];
            this.observation = _data["observation"];
            this.action = _data["action"];
            this.claim = _data["claim"] ? Claim.fromJS(_data["claim"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ClaimItem {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["claimedQuantity"] = this.claimedQuantity;
        data["netAmount"] = this.netAmount;
        data["deliveryIssue"] = this.deliveryIssue;
        data["observation"] = this.observation;
        data["action"] = this.action;
        data["claim"] = this.claim ? this.claim.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): ClaimItem {
        const json = this.toJSON();
        let result = new ClaimItem();
        result.init(json);
        return result;
    }
}

export interface IClaimItem {
    sku: string | undefined;
    description: string | undefined;
    quantity: number;
    claimedQuantity: number;
    netAmount: number;
    deliveryIssue: string | undefined;
    observation: string | undefined;
    action: string | undefined;
    claim: Claim;
    id: number;
}

export class Claim implements IClaim {
    description: string | undefined;
    type: ClaimType;
    withdrawTime: moment.Moment | undefined;
    orderId: number;
    order: Order;
    returnId: number | undefined;
    return: Return;
    claimItems: ClaimItem[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.type = _data["type"];
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : <any>undefined;
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.returnId = _data["returnId"];
            this.return = _data["return"] ? Return.fromJS(_data["return"]) : <any>undefined;
            if (Array.isArray(_data["claimItems"])) {
                this.claimItems = [] as any;
                for (let item of _data["claimItems"])
                    this.claimItems.push(ClaimItem.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Claim {
        data = typeof data === 'object' ? data : {};
        let result = new Claim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["type"] = this.type;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : <any>undefined;
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["returnId"] = this.returnId;
        data["return"] = this.return ? this.return.toJSON() : <any>undefined;
        if (Array.isArray(this.claimItems)) {
            data["claimItems"] = [];
            for (let item of this.claimItems)
                data["claimItems"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): Claim {
        const json = this.toJSON();
        let result = new Claim();
        result.init(json);
        return result;
    }
}

export interface IClaim {
    description: string | undefined;
    type: ClaimType;
    withdrawTime: moment.Moment | undefined;
    orderId: number;
    order: Order;
    returnId: number | undefined;
    return: Return;
    claimItems: ClaimItem[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export enum ShipmentStatus {
    _0 = 0,
    _1 = 1,
}

export class CarrierDriver implements ICarrierDriver {
    name: string | undefined;
    carrierId: number;
    carrier: Carrier;
    countryCode: string | undefined;
    userId: number | undefined;
    isActive: boolean;
    id: number;

    constructor(data?: ICarrierDriver) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.carrierId = _data["carrierId"];
            this.carrier = _data["carrier"] ? Carrier.fromJS(_data["carrier"]) : <any>undefined;
            this.countryCode = _data["countryCode"];
            this.userId = _data["userId"];
            this.isActive = _data["isActive"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CarrierDriver {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierDriver();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["carrierId"] = this.carrierId;
        data["carrier"] = this.carrier ? this.carrier.toJSON() : <any>undefined;
        data["countryCode"] = this.countryCode;
        data["userId"] = this.userId;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }

    clone(): CarrierDriver {
        const json = this.toJSON();
        let result = new CarrierDriver();
        result.init(json);
        return result;
    }
}

export interface ICarrierDriver {
    name: string | undefined;
    carrierId: number;
    carrier: Carrier;
    countryCode: string | undefined;
    userId: number | undefined;
    isActive: boolean;
    id: number;
}

export enum ShippingStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class ShippingPackage implements IShippingPackage {
    address: string | undefined;
    status: ShippingStatus;
    package: Package;
    shipmentId: number | undefined;
    id: number;

    constructor(data?: IShippingPackage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.status = _data["status"];
            this.package = _data["package"] ? Package.fromJS(_data["package"]) : <any>undefined;
            this.shipmentId = _data["shipmentId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ShippingPackage {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingPackage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["status"] = this.status;
        data["package"] = this.package ? this.package.toJSON() : <any>undefined;
        data["shipmentId"] = this.shipmentId;
        data["id"] = this.id;
        return data; 
    }

    clone(): ShippingPackage {
        const json = this.toJSON();
        let result = new ShippingPackage();
        result.init(json);
        return result;
    }
}

export interface IShippingPackage {
    address: string | undefined;
    status: ShippingStatus;
    package: Package;
    shipmentId: number | undefined;
    id: number;
}

export class OrderNotDeliveredPartialSaved implements IOrderNotDeliveredPartialSaved {
    orderId: number;
    shipmentIssue: string | undefined;

    constructor(data?: IOrderNotDeliveredPartialSaved) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.shipmentIssue = _data["shipmentIssue"];
        }
    }

    static fromJS(data: any): OrderNotDeliveredPartialSaved {
        data = typeof data === 'object' ? data : {};
        let result = new OrderNotDeliveredPartialSaved();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["shipmentIssue"] = this.shipmentIssue;
        return data; 
    }

    clone(): OrderNotDeliveredPartialSaved {
        const json = this.toJSON();
        let result = new OrderNotDeliveredPartialSaved();
        result.init(json);
        return result;
    }
}

export interface IOrderNotDeliveredPartialSaved {
    orderId: number;
    shipmentIssue: string | undefined;
}

export class ShipmentRegisterPartialSaved implements IShipmentRegisterPartialSaved {
    orderDeliveredIds: number[] | undefined;
    ordersNotDelivered: OrderNotDeliveredPartialSaved[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IShipmentRegisterPartialSaved) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orderDeliveredIds"])) {
                this.orderDeliveredIds = [] as any;
                for (let item of _data["orderDeliveredIds"])
                    this.orderDeliveredIds.push(item);
            }
            if (Array.isArray(_data["ordersNotDelivered"])) {
                this.ordersNotDelivered = [] as any;
                for (let item of _data["ordersNotDelivered"])
                    this.ordersNotDelivered.push(OrderNotDeliveredPartialSaved.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ShipmentRegisterPartialSaved {
        data = typeof data === 'object' ? data : {};
        let result = new ShipmentRegisterPartialSaved();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderDeliveredIds)) {
            data["orderDeliveredIds"] = [];
            for (let item of this.orderDeliveredIds)
                data["orderDeliveredIds"].push(item);
        }
        if (Array.isArray(this.ordersNotDelivered)) {
            data["ordersNotDelivered"] = [];
            for (let item of this.ordersNotDelivered)
                data["ordersNotDelivered"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): ShipmentRegisterPartialSaved {
        const json = this.toJSON();
        let result = new ShipmentRegisterPartialSaved();
        result.init(json);
        return result;
    }
}

export interface IShipmentRegisterPartialSaved {
    orderDeliveredIds: number[] | undefined;
    ordersNotDelivered: OrderNotDeliveredPartialSaved[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Shipment implements IShipment {
    shipmentDate: moment.Moment;
    status: ShipmentStatus;
    carrierId: number;
    carrier: Carrier;
    carrierDriverId: number | undefined;
    carrierDriver: CarrierDriver;
    shippingPackages: ShippingPackage[] | undefined;
    shipmentOrders: ShipmentOrder[] | undefined;
    countryCode: string | undefined;
    storeCode: string | undefined;
    carrierSourceCode: string | undefined;
    carrierRequestData: string | undefined;
    isIntegrated: boolean;
    shipmentRegisterPartialSavedId: number | undefined;
    shipmentRegisterPartialSaved: ShipmentRegisterPartialSaved;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IShipment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shipmentDate = _data["shipmentDate"] ? moment(_data["shipmentDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.carrierId = _data["carrierId"];
            this.carrier = _data["carrier"] ? Carrier.fromJS(_data["carrier"]) : <any>undefined;
            this.carrierDriverId = _data["carrierDriverId"];
            this.carrierDriver = _data["carrierDriver"] ? CarrierDriver.fromJS(_data["carrierDriver"]) : <any>undefined;
            if (Array.isArray(_data["shippingPackages"])) {
                this.shippingPackages = [] as any;
                for (let item of _data["shippingPackages"])
                    this.shippingPackages.push(ShippingPackage.fromJS(item));
            }
            if (Array.isArray(_data["shipmentOrders"])) {
                this.shipmentOrders = [] as any;
                for (let item of _data["shipmentOrders"])
                    this.shipmentOrders.push(ShipmentOrder.fromJS(item));
            }
            this.countryCode = _data["countryCode"];
            this.storeCode = _data["storeCode"];
            this.carrierSourceCode = _data["carrierSourceCode"];
            this.carrierRequestData = _data["carrierRequestData"];
            this.isIntegrated = _data["isIntegrated"];
            this.shipmentRegisterPartialSavedId = _data["shipmentRegisterPartialSavedId"];
            this.shipmentRegisterPartialSaved = _data["shipmentRegisterPartialSaved"] ? ShipmentRegisterPartialSaved.fromJS(_data["shipmentRegisterPartialSaved"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Shipment {
        data = typeof data === 'object' ? data : {};
        let result = new Shipment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shipmentDate"] = this.shipmentDate ? this.shipmentDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["carrierId"] = this.carrierId;
        data["carrier"] = this.carrier ? this.carrier.toJSON() : <any>undefined;
        data["carrierDriverId"] = this.carrierDriverId;
        data["carrierDriver"] = this.carrierDriver ? this.carrierDriver.toJSON() : <any>undefined;
        if (Array.isArray(this.shippingPackages)) {
            data["shippingPackages"] = [];
            for (let item of this.shippingPackages)
                data["shippingPackages"].push(item.toJSON());
        }
        if (Array.isArray(this.shipmentOrders)) {
            data["shipmentOrders"] = [];
            for (let item of this.shipmentOrders)
                data["shipmentOrders"].push(item.toJSON());
        }
        data["countryCode"] = this.countryCode;
        data["storeCode"] = this.storeCode;
        data["carrierSourceCode"] = this.carrierSourceCode;
        data["carrierRequestData"] = this.carrierRequestData;
        data["isIntegrated"] = this.isIntegrated;
        data["shipmentRegisterPartialSavedId"] = this.shipmentRegisterPartialSavedId;
        data["shipmentRegisterPartialSaved"] = this.shipmentRegisterPartialSaved ? this.shipmentRegisterPartialSaved.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): Shipment {
        const json = this.toJSON();
        let result = new Shipment();
        result.init(json);
        return result;
    }
}

export interface IShipment {
    shipmentDate: moment.Moment;
    status: ShipmentStatus;
    carrierId: number;
    carrier: Carrier;
    carrierDriverId: number | undefined;
    carrierDriver: CarrierDriver;
    shippingPackages: ShippingPackage[] | undefined;
    shipmentOrders: ShipmentOrder[] | undefined;
    countryCode: string | undefined;
    storeCode: string | undefined;
    carrierSourceCode: string | undefined;
    carrierRequestData: string | undefined;
    isIntegrated: boolean;
    shipmentRegisterPartialSavedId: number | undefined;
    shipmentRegisterPartialSaved: ShipmentRegisterPartialSaved;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ShipmentOrder implements IShipmentOrder {
    order: Order;
    shipment: Shipment;
    orderId: number;
    shipmentId: number;
    shippingStatus: ShippingStatus;
    shipmentIssue: string | undefined;
    carrierTrackingLink: string | undefined;
    shippingFinishDate: moment.Moment | undefined;
    deliveredOn: moment.Moment | undefined;
    notDeliveredOn: moment.Moment | undefined;
    proofFiles: string[] | undefined;
    proofNote: string | undefined;
    id: number;

    constructor(data?: IShipmentOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.shipment = _data["shipment"] ? Shipment.fromJS(_data["shipment"]) : <any>undefined;
            this.orderId = _data["orderId"];
            this.shipmentId = _data["shipmentId"];
            this.shippingStatus = _data["shippingStatus"];
            this.shipmentIssue = _data["shipmentIssue"];
            this.carrierTrackingLink = _data["carrierTrackingLink"];
            this.shippingFinishDate = _data["shippingFinishDate"] ? moment(_data["shippingFinishDate"].toString()) : <any>undefined;
            this.deliveredOn = _data["deliveredOn"] ? moment(_data["deliveredOn"].toString()) : <any>undefined;
            this.notDeliveredOn = _data["notDeliveredOn"] ? moment(_data["notDeliveredOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["proofFiles"])) {
                this.proofFiles = [] as any;
                for (let item of _data["proofFiles"])
                    this.proofFiles.push(item);
            }
            this.proofNote = _data["proofNote"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ShipmentOrder {
        data = typeof data === 'object' ? data : {};
        let result = new ShipmentOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["shipment"] = this.shipment ? this.shipment.toJSON() : <any>undefined;
        data["orderId"] = this.orderId;
        data["shipmentId"] = this.shipmentId;
        data["shippingStatus"] = this.shippingStatus;
        data["shipmentIssue"] = this.shipmentIssue;
        data["carrierTrackingLink"] = this.carrierTrackingLink;
        data["shippingFinishDate"] = this.shippingFinishDate ? this.shippingFinishDate.toISOString() : <any>undefined;
        data["deliveredOn"] = this.deliveredOn ? this.deliveredOn.toISOString() : <any>undefined;
        data["notDeliveredOn"] = this.notDeliveredOn ? this.notDeliveredOn.toISOString() : <any>undefined;
        if (Array.isArray(this.proofFiles)) {
            data["proofFiles"] = [];
            for (let item of this.proofFiles)
                data["proofFiles"].push(item);
        }
        data["proofNote"] = this.proofNote;
        data["id"] = this.id;
        return data; 
    }

    clone(): ShipmentOrder {
        const json = this.toJSON();
        let result = new ShipmentOrder();
        result.init(json);
        return result;
    }
}

export interface IShipmentOrder {
    order: Order;
    shipment: Shipment;
    orderId: number;
    shipmentId: number;
    shippingStatus: ShippingStatus;
    shipmentIssue: string | undefined;
    carrierTrackingLink: string | undefined;
    shippingFinishDate: moment.Moment | undefined;
    deliveredOn: moment.Moment | undefined;
    notDeliveredOn: moment.Moment | undefined;
    proofFiles: string[] | undefined;
    proofNote: string | undefined;
    id: number;
}

export class OrderBalance implements IOrderBalance {
    orderId: number;
    order: Order;
    amount: number;
    sku: string | undefined;
    description: string | undefined;
    quantity: number;
    movementType: MovementType;
    documentId: number | undefined;
    document: Document;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderBalance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.amount = _data["amount"];
            this.sku = _data["sku"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.movementType = _data["movementType"];
            this.documentId = _data["documentId"];
            this.document = _data["document"] ? Document.fromJS(_data["document"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderBalance {
        data = typeof data === 'object' ? data : {};
        let result = new OrderBalance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["amount"] = this.amount;
        data["sku"] = this.sku;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["movementType"] = this.movementType;
        data["documentId"] = this.documentId;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderBalance {
        const json = this.toJSON();
        let result = new OrderBalance();
        result.init(json);
        return result;
    }
}

export interface IOrderBalance {
    orderId: number;
    order: Order;
    amount: number;
    sku: string | undefined;
    description: string | undefined;
    quantity: number;
    movementType: MovementType;
    documentId: number | undefined;
    document: Document;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export enum ReplacementCriteria {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum IncludedGiftCard {
    _0 = 0,
    _1 = 1,
}

export class Order implements IOrder {
    sourceName: SourceValue;
    sourceCode: string | undefined;
    sourceCreationTime: moment.Moment | undefined;
    sourceGrossAmount: number;
    sourceNetAmount: number;
    grossAmount: number;
    netAmount: number;
    discount: number;
    taxes: number;
    countryCode: string | undefined;
    readonly highlighted: boolean;
    sourceStoreCode: string | undefined;
    customer: Customer;
    relatedDocuments: OrderDocument[] | undefined;
    carrierId: number | undefined;
    carrier: Carrier;
    sourceOrderItems: SourceOrderItem[] | undefined;
    readonly orderItems: OrderItem[] | undefined;
    payments: Payment[] | undefined;
    deliveryData: DeliveryData;
    notes: OrderNote[] | undefined;
    currentAssignedToStore: AssignedToStore;
    readonly historicAssignedToStore: AssignedToStore[] | undefined;
    currentOverallStatus: OverallStatus;
    readonly historicOverallStatus: OverallStatus[] | undefined;
    currentCommercialStatus: CommercialStatus;
    readonly historicCommercialStatus: CommercialStatus[] | undefined;
    currentFinancialStatus: FinancialStatus;
    readonly historicFinancialStatus: FinancialStatus[] | undefined;
    currentLogisticStatus: LogisticStatus;
    readonly historicLogisticStatus: LogisticStatus[] | undefined;
    currentLogisticAuditStatus: LogisticAuditStatus;
    readonly historicLogisticAuditStatus: LogisticAuditStatus[] | undefined;
    readonly invoiceNumber: string | undefined;
    sourceStatus: string | undefined;
    sourceStatusDetail: string | undefined;
    dispatchDate: moment.Moment | undefined;
    readonly eventLogs: EventLog[] | undefined;
    isPackOrder: boolean;
    isPackItemOrder: boolean;
    packOrder: Order;
    packOrderId: number | undefined;
    sourcePackCode: string | undefined;
    preparations: Preparation[] | undefined;
    orderBillingInfo: OrderBillingInfo;
    orderPickingGroups: OrderPickingGroup[] | undefined;
    readonly documents: Document[] | undefined;
    claims: Claim[] | undefined;
    shipmentOrder: ShipmentOrder;
    orderBalances: OrderBalance[] | undefined;
    balance: number;
    routeOrder: number | undefined;
    dispatchTag: string | undefined;
    pickupStoreCode: string | undefined;
    modified: boolean;
    stockStatus: StockStatus;
    carrierDriverId: number | undefined;
    carrierDriver: CarrierDriver;
    delayAlertSent: boolean;
    secureId: string | undefined;
    interest: number;
    notificationSended: string | undefined;
    openTextField: string | undefined;
    replacementCriteria: ReplacementCriteria;
    carrierInfo: string | undefined;
    includedGiftCard: IncludedGiftCard;
    readonly giftCard: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceName = _data["sourceName"];
            this.sourceCode = _data["sourceCode"];
            this.sourceCreationTime = _data["sourceCreationTime"] ? moment(_data["sourceCreationTime"].toString()) : <any>undefined;
            this.sourceGrossAmount = _data["sourceGrossAmount"];
            this.sourceNetAmount = _data["sourceNetAmount"];
            this.grossAmount = _data["grossAmount"];
            this.netAmount = _data["netAmount"];
            this.discount = _data["discount"];
            this.taxes = _data["taxes"];
            this.countryCode = _data["countryCode"];
            (<any>this).highlighted = _data["highlighted"];
            this.sourceStoreCode = _data["sourceStoreCode"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            if (Array.isArray(_data["relatedDocuments"])) {
                this.relatedDocuments = [] as any;
                for (let item of _data["relatedDocuments"])
                    this.relatedDocuments.push(OrderDocument.fromJS(item));
            }
            this.carrierId = _data["carrierId"];
            this.carrier = _data["carrier"] ? Carrier.fromJS(_data["carrier"]) : <any>undefined;
            if (Array.isArray(_data["sourceOrderItems"])) {
                this.sourceOrderItems = [] as any;
                for (let item of _data["sourceOrderItems"])
                    this.sourceOrderItems.push(SourceOrderItem.fromJS(item));
            }
            if (Array.isArray(_data["orderItems"])) {
                (<any>this).orderItems = [] as any;
                for (let item of _data["orderItems"])
                    (<any>this).orderItems.push(OrderItem.fromJS(item));
            }
            if (Array.isArray(_data["payments"])) {
                this.payments = [] as any;
                for (let item of _data["payments"])
                    this.payments.push(Payment.fromJS(item));
            }
            this.deliveryData = _data["deliveryData"] ? DeliveryData.fromJS(_data["deliveryData"]) : <any>undefined;
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes.push(OrderNote.fromJS(item));
            }
            this.currentAssignedToStore = _data["currentAssignedToStore"] ? AssignedToStore.fromJS(_data["currentAssignedToStore"]) : <any>undefined;
            if (Array.isArray(_data["historicAssignedToStore"])) {
                (<any>this).historicAssignedToStore = [] as any;
                for (let item of _data["historicAssignedToStore"])
                    (<any>this).historicAssignedToStore.push(AssignedToStore.fromJS(item));
            }
            this.currentOverallStatus = _data["currentOverallStatus"] ? OverallStatus.fromJS(_data["currentOverallStatus"]) : <any>undefined;
            if (Array.isArray(_data["historicOverallStatus"])) {
                (<any>this).historicOverallStatus = [] as any;
                for (let item of _data["historicOverallStatus"])
                    (<any>this).historicOverallStatus.push(OverallStatus.fromJS(item));
            }
            this.currentCommercialStatus = _data["currentCommercialStatus"] ? CommercialStatus.fromJS(_data["currentCommercialStatus"]) : <any>undefined;
            if (Array.isArray(_data["historicCommercialStatus"])) {
                (<any>this).historicCommercialStatus = [] as any;
                for (let item of _data["historicCommercialStatus"])
                    (<any>this).historicCommercialStatus.push(CommercialStatus.fromJS(item));
            }
            this.currentFinancialStatus = _data["currentFinancialStatus"] ? FinancialStatus.fromJS(_data["currentFinancialStatus"]) : <any>undefined;
            if (Array.isArray(_data["historicFinancialStatus"])) {
                (<any>this).historicFinancialStatus = [] as any;
                for (let item of _data["historicFinancialStatus"])
                    (<any>this).historicFinancialStatus.push(FinancialStatus.fromJS(item));
            }
            this.currentLogisticStatus = _data["currentLogisticStatus"] ? LogisticStatus.fromJS(_data["currentLogisticStatus"]) : <any>undefined;
            if (Array.isArray(_data["historicLogisticStatus"])) {
                (<any>this).historicLogisticStatus = [] as any;
                for (let item of _data["historicLogisticStatus"])
                    (<any>this).historicLogisticStatus.push(LogisticStatus.fromJS(item));
            }
            this.currentLogisticAuditStatus = _data["currentLogisticAuditStatus"] ? LogisticAuditStatus.fromJS(_data["currentLogisticAuditStatus"]) : <any>undefined;
            if (Array.isArray(_data["historicLogisticAuditStatus"])) {
                (<any>this).historicLogisticAuditStatus = [] as any;
                for (let item of _data["historicLogisticAuditStatus"])
                    (<any>this).historicLogisticAuditStatus.push(LogisticAuditStatus.fromJS(item));
            }
            (<any>this).invoiceNumber = _data["invoiceNumber"];
            this.sourceStatus = _data["sourceStatus"];
            this.sourceStatusDetail = _data["sourceStatusDetail"];
            this.dispatchDate = _data["dispatchDate"] ? moment(_data["dispatchDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["eventLogs"])) {
                (<any>this).eventLogs = [] as any;
                for (let item of _data["eventLogs"])
                    (<any>this).eventLogs.push(EventLog.fromJS(item));
            }
            this.isPackOrder = _data["isPackOrder"];
            this.isPackItemOrder = _data["isPackItemOrder"];
            this.packOrder = _data["packOrder"] ? Order.fromJS(_data["packOrder"]) : <any>undefined;
            this.packOrderId = _data["packOrderId"];
            this.sourcePackCode = _data["sourcePackCode"];
            if (Array.isArray(_data["preparations"])) {
                this.preparations = [] as any;
                for (let item of _data["preparations"])
                    this.preparations.push(Preparation.fromJS(item));
            }
            this.orderBillingInfo = _data["orderBillingInfo"] ? OrderBillingInfo.fromJS(_data["orderBillingInfo"]) : <any>undefined;
            if (Array.isArray(_data["orderPickingGroups"])) {
                this.orderPickingGroups = [] as any;
                for (let item of _data["orderPickingGroups"])
                    this.orderPickingGroups.push(OrderPickingGroup.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                (<any>this).documents = [] as any;
                for (let item of _data["documents"])
                    (<any>this).documents.push(Document.fromJS(item));
            }
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims.push(Claim.fromJS(item));
            }
            this.shipmentOrder = _data["shipmentOrder"] ? ShipmentOrder.fromJS(_data["shipmentOrder"]) : <any>undefined;
            if (Array.isArray(_data["orderBalances"])) {
                this.orderBalances = [] as any;
                for (let item of _data["orderBalances"])
                    this.orderBalances.push(OrderBalance.fromJS(item));
            }
            this.balance = _data["balance"];
            this.routeOrder = _data["routeOrder"];
            this.dispatchTag = _data["dispatchTag"];
            this.pickupStoreCode = _data["pickupStoreCode"];
            this.modified = _data["modified"];
            this.stockStatus = _data["stockStatus"];
            this.carrierDriverId = _data["carrierDriverId"];
            this.carrierDriver = _data["carrierDriver"] ? CarrierDriver.fromJS(_data["carrierDriver"]) : <any>undefined;
            this.delayAlertSent = _data["delayAlertSent"];
            this.secureId = _data["secureId"];
            this.interest = _data["interest"];
            this.notificationSended = _data["notificationSended"];
            this.openTextField = _data["openTextField"];
            this.replacementCriteria = _data["replacementCriteria"];
            this.carrierInfo = _data["carrierInfo"];
            this.includedGiftCard = _data["includedGiftCard"];
            (<any>this).giftCard = _data["giftCard"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Order {
        data = typeof data === 'object' ? data : {};
        let result = new Order();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceName"] = this.sourceName;
        data["sourceCode"] = this.sourceCode;
        data["sourceCreationTime"] = this.sourceCreationTime ? this.sourceCreationTime.toISOString() : <any>undefined;
        data["sourceGrossAmount"] = this.sourceGrossAmount;
        data["sourceNetAmount"] = this.sourceNetAmount;
        data["grossAmount"] = this.grossAmount;
        data["netAmount"] = this.netAmount;
        data["discount"] = this.discount;
        data["taxes"] = this.taxes;
        data["countryCode"] = this.countryCode;
        data["highlighted"] = this.highlighted;
        data["sourceStoreCode"] = this.sourceStoreCode;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        if (Array.isArray(this.relatedDocuments)) {
            data["relatedDocuments"] = [];
            for (let item of this.relatedDocuments)
                data["relatedDocuments"].push(item.toJSON());
        }
        data["carrierId"] = this.carrierId;
        data["carrier"] = this.carrier ? this.carrier.toJSON() : <any>undefined;
        if (Array.isArray(this.sourceOrderItems)) {
            data["sourceOrderItems"] = [];
            for (let item of this.sourceOrderItems)
                data["sourceOrderItems"].push(item.toJSON());
        }
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        data["deliveryData"] = this.deliveryData ? this.deliveryData.toJSON() : <any>undefined;
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        data["currentAssignedToStore"] = this.currentAssignedToStore ? this.currentAssignedToStore.toJSON() : <any>undefined;
        if (Array.isArray(this.historicAssignedToStore)) {
            data["historicAssignedToStore"] = [];
            for (let item of this.historicAssignedToStore)
                data["historicAssignedToStore"].push(item.toJSON());
        }
        data["currentOverallStatus"] = this.currentOverallStatus ? this.currentOverallStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.historicOverallStatus)) {
            data["historicOverallStatus"] = [];
            for (let item of this.historicOverallStatus)
                data["historicOverallStatus"].push(item.toJSON());
        }
        data["currentCommercialStatus"] = this.currentCommercialStatus ? this.currentCommercialStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.historicCommercialStatus)) {
            data["historicCommercialStatus"] = [];
            for (let item of this.historicCommercialStatus)
                data["historicCommercialStatus"].push(item.toJSON());
        }
        data["currentFinancialStatus"] = this.currentFinancialStatus ? this.currentFinancialStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.historicFinancialStatus)) {
            data["historicFinancialStatus"] = [];
            for (let item of this.historicFinancialStatus)
                data["historicFinancialStatus"].push(item.toJSON());
        }
        data["currentLogisticStatus"] = this.currentLogisticStatus ? this.currentLogisticStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.historicLogisticStatus)) {
            data["historicLogisticStatus"] = [];
            for (let item of this.historicLogisticStatus)
                data["historicLogisticStatus"].push(item.toJSON());
        }
        data["currentLogisticAuditStatus"] = this.currentLogisticAuditStatus ? this.currentLogisticAuditStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.historicLogisticAuditStatus)) {
            data["historicLogisticAuditStatus"] = [];
            for (let item of this.historicLogisticAuditStatus)
                data["historicLogisticAuditStatus"].push(item.toJSON());
        }
        data["invoiceNumber"] = this.invoiceNumber;
        data["sourceStatus"] = this.sourceStatus;
        data["sourceStatusDetail"] = this.sourceStatusDetail;
        data["dispatchDate"] = this.dispatchDate ? this.dispatchDate.toISOString() : <any>undefined;
        if (Array.isArray(this.eventLogs)) {
            data["eventLogs"] = [];
            for (let item of this.eventLogs)
                data["eventLogs"].push(item.toJSON());
        }
        data["isPackOrder"] = this.isPackOrder;
        data["isPackItemOrder"] = this.isPackItemOrder;
        data["packOrder"] = this.packOrder ? this.packOrder.toJSON() : <any>undefined;
        data["packOrderId"] = this.packOrderId;
        data["sourcePackCode"] = this.sourcePackCode;
        if (Array.isArray(this.preparations)) {
            data["preparations"] = [];
            for (let item of this.preparations)
                data["preparations"].push(item.toJSON());
        }
        data["orderBillingInfo"] = this.orderBillingInfo ? this.orderBillingInfo.toJSON() : <any>undefined;
        if (Array.isArray(this.orderPickingGroups)) {
            data["orderPickingGroups"] = [];
            for (let item of this.orderPickingGroups)
                data["orderPickingGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        data["shipmentOrder"] = this.shipmentOrder ? this.shipmentOrder.toJSON() : <any>undefined;
        if (Array.isArray(this.orderBalances)) {
            data["orderBalances"] = [];
            for (let item of this.orderBalances)
                data["orderBalances"].push(item.toJSON());
        }
        data["balance"] = this.balance;
        data["routeOrder"] = this.routeOrder;
        data["dispatchTag"] = this.dispatchTag;
        data["pickupStoreCode"] = this.pickupStoreCode;
        data["modified"] = this.modified;
        data["stockStatus"] = this.stockStatus;
        data["carrierDriverId"] = this.carrierDriverId;
        data["carrierDriver"] = this.carrierDriver ? this.carrierDriver.toJSON() : <any>undefined;
        data["delayAlertSent"] = this.delayAlertSent;
        data["secureId"] = this.secureId;
        data["interest"] = this.interest;
        data["notificationSended"] = this.notificationSended;
        data["openTextField"] = this.openTextField;
        data["replacementCriteria"] = this.replacementCriteria;
        data["carrierInfo"] = this.carrierInfo;
        data["includedGiftCard"] = this.includedGiftCard;
        data["giftCard"] = this.giftCard;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): Order {
        const json = this.toJSON();
        let result = new Order();
        result.init(json);
        return result;
    }
}

export interface IOrder {
    sourceName: SourceValue;
    sourceCode: string | undefined;
    sourceCreationTime: moment.Moment | undefined;
    sourceGrossAmount: number;
    sourceNetAmount: number;
    grossAmount: number;
    netAmount: number;
    discount: number;
    taxes: number;
    countryCode: string | undefined;
    highlighted: boolean;
    sourceStoreCode: string | undefined;
    customer: Customer;
    relatedDocuments: OrderDocument[] | undefined;
    carrierId: number | undefined;
    carrier: Carrier;
    sourceOrderItems: SourceOrderItem[] | undefined;
    orderItems: OrderItem[] | undefined;
    payments: Payment[] | undefined;
    deliveryData: DeliveryData;
    notes: OrderNote[] | undefined;
    currentAssignedToStore: AssignedToStore;
    historicAssignedToStore: AssignedToStore[] | undefined;
    currentOverallStatus: OverallStatus;
    historicOverallStatus: OverallStatus[] | undefined;
    currentCommercialStatus: CommercialStatus;
    historicCommercialStatus: CommercialStatus[] | undefined;
    currentFinancialStatus: FinancialStatus;
    historicFinancialStatus: FinancialStatus[] | undefined;
    currentLogisticStatus: LogisticStatus;
    historicLogisticStatus: LogisticStatus[] | undefined;
    currentLogisticAuditStatus: LogisticAuditStatus;
    historicLogisticAuditStatus: LogisticAuditStatus[] | undefined;
    invoiceNumber: string | undefined;
    sourceStatus: string | undefined;
    sourceStatusDetail: string | undefined;
    dispatchDate: moment.Moment | undefined;
    eventLogs: EventLog[] | undefined;
    isPackOrder: boolean;
    isPackItemOrder: boolean;
    packOrder: Order;
    packOrderId: number | undefined;
    sourcePackCode: string | undefined;
    preparations: Preparation[] | undefined;
    orderBillingInfo: OrderBillingInfo;
    orderPickingGroups: OrderPickingGroup[] | undefined;
    documents: Document[] | undefined;
    claims: Claim[] | undefined;
    shipmentOrder: ShipmentOrder;
    orderBalances: OrderBalance[] | undefined;
    balance: number;
    routeOrder: number | undefined;
    dispatchTag: string | undefined;
    pickupStoreCode: string | undefined;
    modified: boolean;
    stockStatus: StockStatus;
    carrierDriverId: number | undefined;
    carrierDriver: CarrierDriver;
    delayAlertSent: boolean;
    secureId: string | undefined;
    interest: number;
    notificationSended: string | undefined;
    openTextField: string | undefined;
    replacementCriteria: ReplacementCriteria;
    carrierInfo: string | undefined;
    includedGiftCard: IncludedGiftCard;
    giftCard: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class StateDto implements IStateDto {
    name: string | undefined;
    cities: CityDto[] | undefined;
    countryCode: string | undefined;
    id: number;

    constructor(data?: IStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["cities"])) {
                this.cities = [] as any;
                for (let item of _data["cities"])
                    this.cities.push(CityDto.fromJS(item));
            }
            this.countryCode = _data["countryCode"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StateDto {
        data = typeof data === 'object' ? data : {};
        let result = new StateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.cities)) {
            data["cities"] = [];
            for (let item of this.cities)
                data["cities"].push(item.toJSON());
        }
        data["countryCode"] = this.countryCode;
        data["id"] = this.id;
        return data; 
    }

    clone(): StateDto {
        const json = this.toJSON();
        let result = new StateDto();
        result.init(json);
        return result;
    }
}

export interface IStateDto {
    name: string | undefined;
    cities: CityDto[] | undefined;
    countryCode: string | undefined;
    id: number;
}

export class StateDtoPagedResultDto implements IStateDtoPagedResultDto {
    totalCount: number;
    items: StateDto[] | undefined;

    constructor(data?: IStateDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(StateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StateDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StateDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): StateDtoPagedResultDto {
        const json = this.toJSON();
        let result = new StateDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IStateDtoPagedResultDto {
    totalCount: number;
    items: StateDto[] | undefined;
}

export class ProductStock implements IProductStock {
    name: string | undefined;
    sku: string | undefined;
    stock: number;
    quantity: number;
    storeCode: string | undefined;
    isDanger: boolean;
    isWarning: boolean;
    isSafe: boolean;
    id: number;

    constructor(data?: IProductStock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.sku = _data["sku"];
            this.stock = _data["stock"];
            this.quantity = _data["quantity"];
            this.storeCode = _data["storeCode"];
            this.isDanger = _data["isDanger"];
            this.isWarning = _data["isWarning"];
            this.isSafe = _data["isSafe"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductStock {
        data = typeof data === 'object' ? data : {};
        let result = new ProductStock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sku"] = this.sku;
        data["stock"] = this.stock;
        data["quantity"] = this.quantity;
        data["storeCode"] = this.storeCode;
        data["isDanger"] = this.isDanger;
        data["isWarning"] = this.isWarning;
        data["isSafe"] = this.isSafe;
        data["id"] = this.id;
        return data; 
    }

    clone(): ProductStock {
        const json = this.toJSON();
        let result = new ProductStock();
        result.init(json);
        return result;
    }
}

export interface IProductStock {
    name: string | undefined;
    sku: string | undefined;
    stock: number;
    quantity: number;
    storeCode: string | undefined;
    isDanger: boolean;
    isWarning: boolean;
    isSafe: boolean;
    id: number;
}

export class StoreDistanceAndStockDto implements IStoreDistanceAndStockDto {
    storeName: string | undefined;
    distance: number | undefined;
    stock: ProductStock[] | undefined;
    isDanger: boolean;
    isWarning: boolean;
    isSafe: boolean;
    storeId: number;
    storeCode: string | undefined;
    storeIsHub: boolean;
    clusterId: number | undefined;
    assignations: number;

    constructor(data?: IStoreDistanceAndStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeName = _data["storeName"];
            this.distance = _data["distance"];
            if (Array.isArray(_data["stock"])) {
                this.stock = [] as any;
                for (let item of _data["stock"])
                    this.stock.push(ProductStock.fromJS(item));
            }
            this.isDanger = _data["isDanger"];
            this.isWarning = _data["isWarning"];
            this.isSafe = _data["isSafe"];
            this.storeId = _data["storeId"];
            this.storeCode = _data["storeCode"];
            this.storeIsHub = _data["storeIsHub"];
            this.clusterId = _data["clusterId"];
            this.assignations = _data["assignations"];
        }
    }

    static fromJS(data: any): StoreDistanceAndStockDto {
        data = typeof data === 'object' ? data : {};
        let result = new StoreDistanceAndStockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeName"] = this.storeName;
        data["distance"] = this.distance;
        if (Array.isArray(this.stock)) {
            data["stock"] = [];
            for (let item of this.stock)
                data["stock"].push(item.toJSON());
        }
        data["isDanger"] = this.isDanger;
        data["isWarning"] = this.isWarning;
        data["isSafe"] = this.isSafe;
        data["storeId"] = this.storeId;
        data["storeCode"] = this.storeCode;
        data["storeIsHub"] = this.storeIsHub;
        data["clusterId"] = this.clusterId;
        data["assignations"] = this.assignations;
        return data; 
    }

    clone(): StoreDistanceAndStockDto {
        const json = this.toJSON();
        let result = new StoreDistanceAndStockDto();
        result.init(json);
        return result;
    }
}

export interface IStoreDistanceAndStockDto {
    storeName: string | undefined;
    distance: number | undefined;
    stock: ProductStock[] | undefined;
    isDanger: boolean;
    isWarning: boolean;
    isSafe: boolean;
    storeId: number;
    storeCode: string | undefined;
    storeIsHub: boolean;
    clusterId: number | undefined;
    assignations: number;
}

export class StoreNameAndCodeDto implements IStoreNameAndCodeDto {
    id: string | undefined;
    name: string | undefined;

    constructor(data?: IStoreNameAndCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): StoreNameAndCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new StoreNameAndCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): StoreNameAndCodeDto {
        const json = this.toJSON();
        let result = new StoreNameAndCodeDto();
        result.init(json);
        return result;
    }
}

export interface IStoreNameAndCodeDto {
    id: string | undefined;
    name: string | undefined;
}

export class UploadStorePostalCodesRequestDto implements IUploadStorePostalCodesRequestDto {
    url: string | undefined;
    stores: StoreNameAndCodeDto[] | undefined;

    constructor(data?: IUploadStorePostalCodesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            if (Array.isArray(_data["stores"])) {
                this.stores = [] as any;
                for (let item of _data["stores"])
                    this.stores.push(StoreNameAndCodeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UploadStorePostalCodesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadStorePostalCodesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        if (Array.isArray(this.stores)) {
            data["stores"] = [];
            for (let item of this.stores)
                data["stores"].push(item.toJSON());
        }
        return data; 
    }

    clone(): UploadStorePostalCodesRequestDto {
        const json = this.toJSON();
        let result = new UploadStorePostalCodesRequestDto();
        result.init(json);
        return result;
    }
}

export interface IUploadStorePostalCodesRequestDto {
    url: string | undefined;
    stores: StoreNameAndCodeDto[] | undefined;
}

export class StorePostalCodeDto implements IStorePostalCodeDto {
    storeCode: string | undefined;
    postalCode: string | undefined;
    id: number;

    constructor(data?: IStorePostalCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeCode = _data["storeCode"];
            this.postalCode = _data["postalCode"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StorePostalCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new StorePostalCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeCode"] = this.storeCode;
        data["postalCode"] = this.postalCode;
        data["id"] = this.id;
        return data; 
    }

    clone(): StorePostalCodeDto {
        const json = this.toJSON();
        let result = new StorePostalCodeDto();
        result.init(json);
        return result;
    }
}

export interface IStorePostalCodeDto {
    storeCode: string | undefined;
    postalCode: string | undefined;
    id: number;
}

export class StorePostalCodeDtoPagedResultDto implements IStorePostalCodeDtoPagedResultDto {
    totalCount: number;
    items: StorePostalCodeDto[] | undefined;

    constructor(data?: IStorePostalCodeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(StorePostalCodeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StorePostalCodeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StorePostalCodeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): StorePostalCodeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new StorePostalCodeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IStorePostalCodeDtoPagedResultDto {
    totalCount: number;
    items: StorePostalCodeDto[] | undefined;
}

export class SapTransfersDto implements ISapTransfersDto {
    countryCode: string | undefined;
    separationId: number;
    alias: string | undefined;
    orders: OrderDto[] | undefined;

    constructor(data?: ISapTransfersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryCode = _data["countryCode"];
            this.separationId = _data["separationId"];
            this.alias = _data["alias"];
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders.push(OrderDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SapTransfersDto {
        data = typeof data === 'object' ? data : {};
        let result = new SapTransfersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryCode"] = this.countryCode;
        data["separationId"] = this.separationId;
        data["alias"] = this.alias;
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        return data; 
    }

    clone(): SapTransfersDto {
        const json = this.toJSON();
        let result = new SapTransfersDto();
        result.init(json);
        return result;
    }
}

export interface ISapTransfersDto {
    countryCode: string | undefined;
    separationId: number;
    alias: string | undefined;
    orders: OrderDto[] | undefined;
}

export class TransferRequestDto implements ITransferRequestDto {
    orderId: number;
    transferId: number | undefined;
    codes: string[] | undefined;
    shipments: number[] | undefined;
    hasFailure: boolean;
    notReceived: boolean;
    notAccepted: boolean;
    note: string | undefined;
    id: number;

    constructor(data?: ITransferRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.transferId = _data["transferId"];
            if (Array.isArray(_data["codes"])) {
                this.codes = [] as any;
                for (let item of _data["codes"])
                    this.codes.push(item);
            }
            if (Array.isArray(_data["shipments"])) {
                this.shipments = [] as any;
                for (let item of _data["shipments"])
                    this.shipments.push(item);
            }
            this.hasFailure = _data["hasFailure"];
            this.notReceived = _data["notReceived"];
            this.notAccepted = _data["notAccepted"];
            this.note = _data["note"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TransferRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransferRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["transferId"] = this.transferId;
        if (Array.isArray(this.codes)) {
            data["codes"] = [];
            for (let item of this.codes)
                data["codes"].push(item);
        }
        if (Array.isArray(this.shipments)) {
            data["shipments"] = [];
            for (let item of this.shipments)
                data["shipments"].push(item);
        }
        data["hasFailure"] = this.hasFailure;
        data["notReceived"] = this.notReceived;
        data["notAccepted"] = this.notAccepted;
        data["note"] = this.note;
        data["id"] = this.id;
        return data; 
    }

    clone(): TransferRequestDto {
        const json = this.toJSON();
        let result = new TransferRequestDto();
        result.init(json);
        return result;
    }
}

export interface ITransferRequestDto {
    orderId: number;
    transferId: number | undefined;
    codes: string[] | undefined;
    shipments: number[] | undefined;
    hasFailure: boolean;
    notReceived: boolean;
    notAccepted: boolean;
    note: string | undefined;
    id: number;
}

export class SupplyingOrderStoreDto implements ISupplyingOrderStoreDto {
    addressCity: string | undefined;
    addressGeoLat: number | undefined;
    addressGeoLong: number | undefined;
    addressPostalCode: string | undefined;
    addressState: string | undefined;
    addressStreetName: string | undefined;
    addressStreetNumber: string | undefined;
    email: string | undefined;
    erpCode: string | undefined;
    isHub: boolean;
    name: string | undefined;
    phoneNumber: string | undefined;
    storeCode: string | undefined;
    id: number;

    constructor(data?: ISupplyingOrderStoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressCity = _data["addressCity"];
            this.addressGeoLat = _data["addressGeoLat"];
            this.addressGeoLong = _data["addressGeoLong"];
            this.addressPostalCode = _data["addressPostalCode"];
            this.addressState = _data["addressState"];
            this.addressStreetName = _data["addressStreetName"];
            this.addressStreetNumber = _data["addressStreetNumber"];
            this.email = _data["email"];
            this.erpCode = _data["erpCode"];
            this.isHub = _data["isHub"];
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.storeCode = _data["storeCode"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SupplyingOrderStoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyingOrderStoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressCity"] = this.addressCity;
        data["addressGeoLat"] = this.addressGeoLat;
        data["addressGeoLong"] = this.addressGeoLong;
        data["addressPostalCode"] = this.addressPostalCode;
        data["addressState"] = this.addressState;
        data["addressStreetName"] = this.addressStreetName;
        data["addressStreetNumber"] = this.addressStreetNumber;
        data["email"] = this.email;
        data["erpCode"] = this.erpCode;
        data["isHub"] = this.isHub;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["storeCode"] = this.storeCode;
        data["id"] = this.id;
        return data; 
    }

    clone(): SupplyingOrderStoreDto {
        const json = this.toJSON();
        let result = new SupplyingOrderStoreDto();
        result.init(json);
        return result;
    }
}

export interface ISupplyingOrderStoreDto {
    addressCity: string | undefined;
    addressGeoLat: number | undefined;
    addressGeoLong: number | undefined;
    addressPostalCode: string | undefined;
    addressState: string | undefined;
    addressStreetName: string | undefined;
    addressStreetNumber: string | undefined;
    email: string | undefined;
    erpCode: string | undefined;
    isHub: boolean;
    name: string | undefined;
    phoneNumber: string | undefined;
    storeCode: string | undefined;
    id: number;
}

export class SupplyingOrderItemDto implements ISupplyingOrderItemDto {
    sourceCode: string | undefined;
    sku: string | undefined;
    description: string | undefined;
    imageUrl: string | undefined;
    quantity: number;
    id: number;

    constructor(data?: ISupplyingOrderItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceCode = _data["sourceCode"];
            this.sku = _data["sku"];
            this.description = _data["description"];
            this.imageUrl = _data["imageUrl"];
            this.quantity = _data["quantity"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SupplyingOrderItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyingOrderItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceCode"] = this.sourceCode;
        data["sku"] = this.sku;
        data["description"] = this.description;
        data["imageUrl"] = this.imageUrl;
        data["quantity"] = this.quantity;
        data["id"] = this.id;
        return data; 
    }

    clone(): SupplyingOrderItemDto {
        const json = this.toJSON();
        let result = new SupplyingOrderItemDto();
        result.init(json);
        return result;
    }
}

export interface ISupplyingOrderItemDto {
    sourceCode: string | undefined;
    sku: string | undefined;
    description: string | undefined;
    imageUrl: string | undefined;
    quantity: number;
    id: number;
}

export class SupplyingOrderDto implements ISupplyingOrderDto {
    orderId: number;
    sourceCode: string | undefined;
    store: SupplyingOrderStoreDto;
    customerId: number;
    receiverName: string | undefined;
    isFlashShipping: boolean;
    items: SupplyingOrderItemDto[] | undefined;
    countryCode: string | undefined;
    id: number;

    constructor(data?: ISupplyingOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.sourceCode = _data["sourceCode"];
            this.store = _data["store"] ? SupplyingOrderStoreDto.fromJS(_data["store"]) : <any>undefined;
            this.customerId = _data["customerId"];
            this.receiverName = _data["receiverName"];
            this.isFlashShipping = _data["isFlashShipping"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(SupplyingOrderItemDto.fromJS(item));
            }
            this.countryCode = _data["countryCode"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SupplyingOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyingOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["sourceCode"] = this.sourceCode;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["customerId"] = this.customerId;
        data["receiverName"] = this.receiverName;
        data["isFlashShipping"] = this.isFlashShipping;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["countryCode"] = this.countryCode;
        data["id"] = this.id;
        return data; 
    }

    clone(): SupplyingOrderDto {
        const json = this.toJSON();
        let result = new SupplyingOrderDto();
        result.init(json);
        return result;
    }
}

export interface ISupplyingOrderDto {
    orderId: number;
    sourceCode: string | undefined;
    store: SupplyingOrderStoreDto;
    customerId: number;
    receiverName: string | undefined;
    isFlashShipping: boolean;
    items: SupplyingOrderItemDto[] | undefined;
    countryCode: string | undefined;
    id: number;
}

export class TransferItemDto implements ITransferItemDto {
    sku: string | undefined;
    name: string | undefined;
    unitPrice: number;
    quantity: number;
    id: number;

    constructor(data?: ITransferItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sku = _data["sku"];
            this.name = _data["name"];
            this.unitPrice = _data["unitPrice"];
            this.quantity = _data["quantity"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TransferItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransferItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["name"] = this.name;
        data["unitPrice"] = this.unitPrice;
        data["quantity"] = this.quantity;
        data["id"] = this.id;
        return data; 
    }

    clone(): TransferItemDto {
        const json = this.toJSON();
        let result = new TransferItemDto();
        result.init(json);
        return result;
    }
}

export interface ITransferItemDto {
    sku: string | undefined;
    name: string | undefined;
    unitPrice: number;
    quantity: number;
    id: number;
}

export class TransferDto implements ITransferDto {
    orderId: number;
    trxSrcCode: string | undefined;
    sourceStoreCode: string | undefined;
    destinationStoreCode: string | undefined;
    deliveryDate: moment.Moment | undefined;
    transferItems: TransferItemDto[] | undefined;
    id: number;

    constructor(data?: ITransferDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.trxSrcCode = _data["trxSrcCode"];
            this.sourceStoreCode = _data["sourceStoreCode"];
            this.destinationStoreCode = _data["destinationStoreCode"];
            this.deliveryDate = _data["deliveryDate"] ? moment(_data["deliveryDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["transferItems"])) {
                this.transferItems = [] as any;
                for (let item of _data["transferItems"])
                    this.transferItems.push(TransferItemDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TransferDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransferDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["trxSrcCode"] = this.trxSrcCode;
        data["sourceStoreCode"] = this.sourceStoreCode;
        data["destinationStoreCode"] = this.destinationStoreCode;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        if (Array.isArray(this.transferItems)) {
            data["transferItems"] = [];
            for (let item of this.transferItems)
                data["transferItems"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): TransferDto {
        const json = this.toJSON();
        let result = new TransferDto();
        result.init(json);
        return result;
    }
}

export interface ITransferDto {
    orderId: number;
    trxSrcCode: string | undefined;
    sourceStoreCode: string | undefined;
    destinationStoreCode: string | undefined;
    deliveryDate: moment.Moment | undefined;
    transferItems: TransferItemDto[] | undefined;
    id: number;
}

export class CreateTransfersDto implements ICreateTransfersDto {
    supplyingOrder: SupplyingOrderDto;
    transfers: TransferDto[] | undefined;
    countryCode: string | undefined;
    storeCode: string | undefined;
    erpStoreCode: string | undefined;

    constructor(data?: ICreateTransfersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplyingOrder = _data["supplyingOrder"] ? SupplyingOrderDto.fromJS(_data["supplyingOrder"]) : <any>undefined;
            if (Array.isArray(_data["transfers"])) {
                this.transfers = [] as any;
                for (let item of _data["transfers"])
                    this.transfers.push(TransferDto.fromJS(item));
            }
            this.countryCode = _data["countryCode"];
            this.storeCode = _data["storeCode"];
            this.erpStoreCode = _data["erpStoreCode"];
        }
    }

    static fromJS(data: any): CreateTransfersDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTransfersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplyingOrder"] = this.supplyingOrder ? this.supplyingOrder.toJSON() : <any>undefined;
        if (Array.isArray(this.transfers)) {
            data["transfers"] = [];
            for (let item of this.transfers)
                data["transfers"].push(item.toJSON());
        }
        data["countryCode"] = this.countryCode;
        data["storeCode"] = this.storeCode;
        data["erpStoreCode"] = this.erpStoreCode;
        return data; 
    }

    clone(): CreateTransfersDto {
        const json = this.toJSON();
        let result = new CreateTransfersDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTransfersDto {
    supplyingOrder: SupplyingOrderDto;
    transfers: TransferDto[] | undefined;
    countryCode: string | undefined;
    storeCode: string | undefined;
    erpStoreCode: string | undefined;
}

export class TransferOrderInfoDto implements ITransferOrderInfoDto {
    trxSrcCode: string | undefined;
    sourceStoreCode: string | undefined;
    destinationStoreCode: string | undefined;
    deliveryDate: moment.Moment | undefined;
    transferItemsSkus: string[] | undefined;
    orderCompleteAdress: string | undefined;
    orderShippingType: string | undefined;

    constructor(data?: ITransferOrderInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trxSrcCode = _data["trxSrcCode"];
            this.sourceStoreCode = _data["sourceStoreCode"];
            this.destinationStoreCode = _data["destinationStoreCode"];
            this.deliveryDate = _data["deliveryDate"] ? moment(_data["deliveryDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["transferItemsSkus"])) {
                this.transferItemsSkus = [] as any;
                for (let item of _data["transferItemsSkus"])
                    this.transferItemsSkus.push(item);
            }
            this.orderCompleteAdress = _data["orderCompleteAdress"];
            this.orderShippingType = _data["orderShippingType"];
        }
    }

    static fromJS(data: any): TransferOrderInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransferOrderInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trxSrcCode"] = this.trxSrcCode;
        data["sourceStoreCode"] = this.sourceStoreCode;
        data["destinationStoreCode"] = this.destinationStoreCode;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        if (Array.isArray(this.transferItemsSkus)) {
            data["transferItemsSkus"] = [];
            for (let item of this.transferItemsSkus)
                data["transferItemsSkus"].push(item);
        }
        data["orderCompleteAdress"] = this.orderCompleteAdress;
        data["orderShippingType"] = this.orderShippingType;
        return data; 
    }

    clone(): TransferOrderInfoDto {
        const json = this.toJSON();
        let result = new TransferOrderInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITransferOrderInfoDto {
    trxSrcCode: string | undefined;
    sourceStoreCode: string | undefined;
    destinationStoreCode: string | undefined;
    deliveryDate: moment.Moment | undefined;
    transferItemsSkus: string[] | undefined;
    orderCompleteAdress: string | undefined;
    orderShippingType: string | undefined;
}

export class TransferRequestDtoPagedResultDto implements ITransferRequestDtoPagedResultDto {
    totalCount: number;
    items: TransferRequestDto[] | undefined;

    constructor(data?: ITransferRequestDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TransferRequestDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransferRequestDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransferRequestDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): TransferRequestDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TransferRequestDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITransferRequestDtoPagedResultDto {
    totalCount: number;
    items: TransferRequestDto[] | undefined;
}

export class VtexAccountDto implements IVtexAccountDto {
    name: string | undefined;
    baseUrl: string | undefined;
    appKey: string | undefined;
    appToken: string | undefined;
    isListening: boolean;
    storeCode: string | undefined;
    isMaster: boolean;
    id: number;

    constructor(data?: IVtexAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.baseUrl = _data["baseUrl"];
            this.appKey = _data["appKey"];
            this.appToken = _data["appToken"];
            this.isListening = _data["isListening"];
            this.storeCode = _data["storeCode"];
            this.isMaster = _data["isMaster"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): VtexAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new VtexAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["baseUrl"] = this.baseUrl;
        data["appKey"] = this.appKey;
        data["appToken"] = this.appToken;
        data["isListening"] = this.isListening;
        data["storeCode"] = this.storeCode;
        data["isMaster"] = this.isMaster;
        data["id"] = this.id;
        return data; 
    }

    clone(): VtexAccountDto {
        const json = this.toJSON();
        let result = new VtexAccountDto();
        result.init(json);
        return result;
    }
}

export interface IVtexAccountDto {
    name: string | undefined;
    baseUrl: string | undefined;
    appKey: string | undefined;
    appToken: string | undefined;
    isListening: boolean;
    storeCode: string | undefined;
    isMaster: boolean;
    id: number;
}

export class VtexAccountDtoPagedResultDto implements IVtexAccountDtoPagedResultDto {
    totalCount: number;
    items: VtexAccountDto[] | undefined;

    constructor(data?: IVtexAccountDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(VtexAccountDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VtexAccountDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new VtexAccountDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): VtexAccountDtoPagedResultDto {
        const json = this.toJSON();
        let result = new VtexAccountDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IVtexAccountDtoPagedResultDto {
    totalCount: number;
    items: VtexAccountDto[] | undefined;
}

export class ZohoStadisticUrlDto implements IZohoStadisticUrlDto {
    title: string | undefined;
    url: string | undefined;
    isPublic: boolean;
    countryCode: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IZohoStadisticUrlDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.url = _data["url"];
            this.isPublic = _data["isPublic"];
            this.countryCode = _data["countryCode"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ZohoStadisticUrlDto {
        data = typeof data === 'object' ? data : {};
        let result = new ZohoStadisticUrlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["url"] = this.url;
        data["isPublic"] = this.isPublic;
        data["countryCode"] = this.countryCode;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): ZohoStadisticUrlDto {
        const json = this.toJSON();
        let result = new ZohoStadisticUrlDto();
        result.init(json);
        return result;
    }
}

export interface IZohoStadisticUrlDto {
    title: string | undefined;
    url: string | undefined;
    isPublic: boolean;
    countryCode: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ZohoStadisticUrlDtoPagedResultDto implements IZohoStadisticUrlDtoPagedResultDto {
    totalCount: number;
    items: ZohoStadisticUrlDto[] | undefined;

    constructor(data?: IZohoStadisticUrlDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ZohoStadisticUrlDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ZohoStadisticUrlDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ZohoStadisticUrlDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ZohoStadisticUrlDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ZohoStadisticUrlDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IZohoStadisticUrlDtoPagedResultDto {
    totalCount: number;
    items: ZohoStadisticUrlDto[] | undefined;
}

export class ZubaleNotificationDto implements IZubaleNotificationDto {
    orderId: string | undefined;
    oldStatus: string | undefined;
    newStatus: string | undefined;
    trackingUrl: string | undefined;
    name: string | undefined;
    description: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IZubaleNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.oldStatus = _data["oldStatus"];
            this.newStatus = _data["newStatus"];
            this.trackingUrl = _data["trackingUrl"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ZubaleNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ZubaleNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["oldStatus"] = this.oldStatus;
        data["newStatus"] = this.newStatus;
        data["trackingUrl"] = this.trackingUrl;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): ZubaleNotificationDto {
        const json = this.toJSON();
        let result = new ZubaleNotificationDto();
        result.init(json);
        return result;
    }
}

export interface IZubaleNotificationDto {
    orderId: string | undefined;
    oldStatus: string | undefined;
    newStatus: string | undefined;
    trackingUrl: string | undefined;
    name: string | undefined;
    description: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CreateDeliveryOrdersDto implements ICreateDeliveryOrdersDto {
    storeCode: string | undefined;
    deliveryOrders: number[] | undefined;

    constructor(data?: ICreateDeliveryOrdersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeCode = _data["storeCode"];
            if (Array.isArray(_data["deliveryOrders"])) {
                this.deliveryOrders = [] as any;
                for (let item of _data["deliveryOrders"])
                    this.deliveryOrders.push(item);
            }
        }
    }

    static fromJS(data: any): CreateDeliveryOrdersDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDeliveryOrdersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeCode"] = this.storeCode;
        if (Array.isArray(this.deliveryOrders)) {
            data["deliveryOrders"] = [];
            for (let item of this.deliveryOrders)
                data["deliveryOrders"].push(item);
        }
        return data; 
    }

    clone(): CreateDeliveryOrdersDto {
        const json = this.toJSON();
        let result = new CreateDeliveryOrdersDto();
        result.init(json);
        return result;
    }
}

export interface ICreateDeliveryOrdersDto {
    storeCode: string | undefined;
    deliveryOrders: number[] | undefined;
}

export class CreateDeliveryOrderResponseModel implements ICreateDeliveryOrderResponseModel {
    message: string | undefined;
    success: boolean;
    externalDeliveryId: string | undefined;
    externalOrderId: string | undefined;
    internalId: string | undefined;
    status: string | undefined;
    jsonRequest: string | undefined;

    constructor(data?: ICreateDeliveryOrderResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.success = _data["success"];
            this.externalDeliveryId = _data["externalDeliveryId"];
            this.externalOrderId = _data["externalOrderId"];
            this.internalId = _data["internalId"];
            this.status = _data["status"];
            this.jsonRequest = _data["jsonRequest"];
        }
    }

    static fromJS(data: any): CreateDeliveryOrderResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDeliveryOrderResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["success"] = this.success;
        data["externalDeliveryId"] = this.externalDeliveryId;
        data["externalOrderId"] = this.externalOrderId;
        data["internalId"] = this.internalId;
        data["status"] = this.status;
        data["jsonRequest"] = this.jsonRequest;
        return data; 
    }

    clone(): CreateDeliveryOrderResponseModel {
        const json = this.toJSON();
        let result = new CreateDeliveryOrderResponseModel();
        result.init(json);
        return result;
    }
}

export interface ICreateDeliveryOrderResponseModel {
    message: string | undefined;
    success: boolean;
    externalDeliveryId: string | undefined;
    externalOrderId: string | undefined;
    internalId: string | undefined;
    status: string | undefined;
    jsonRequest: string | undefined;
}

export class ZubaleNotificationDtoPagedResultDto implements IZubaleNotificationDtoPagedResultDto {
    totalCount: number;
    items: ZubaleNotificationDto[] | undefined;

    constructor(data?: IZubaleNotificationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ZubaleNotificationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ZubaleNotificationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ZubaleNotificationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ZubaleNotificationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ZubaleNotificationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IZubaleNotificationDtoPagedResultDto {
    totalCount: number;
    items: ZubaleNotificationDto[] | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader(); 
            reader.onload = event => { 
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob); 
        }
    });
}